webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);




var view = { index: 1, create: 2, edit: 3 };
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      view: view.index,
      dialog: false,
      search: '',
      items: [],
      editedIndex: -1,
      editedItem: {},
      beforeEditedItem: {},
      defaultItem: {},
      resBody: {},
      saving: false
    };
  },
  methods: {
    initialize: function initialize() {
      var _this = this;

      this.beforeInitialize();
      this.$store.commit('loader/change_dialog', true);
      this.$http.get('api/' + this.entity).then(function (res) {
        _this.resBody = res.body;
        _this.items = res.body.dados;
        _this.afterInitialize();
        _this.$store.commit('loader/change_dialog', false);
      }, function (err) {
        _this.afterInitialize();
        _this.$store.commit('loader/change_dialog', false);
      });
    },
    create: function create() {
      this.beforeCreate();
      this.dialog = true;
      this.view = view.create;
      this.editedIndex = 0;
      this.afterCreate();
      this.afterDialog();
    },
    editItem: function editItem(item) {
      this.beforeEdit(item);
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.editedItem, JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item)));
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.beforeEditedItem, JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item)));
      this.dialog = true;
      this.view = view.edit;
      this.editedIndex = this.items.indexOf(item);
      this.$store.commit('loader/change_dialog', false);
      this.afterEdit();
      this.afterDialog();
    },
    deleteItem: function deleteItem(item) {
      var _this2 = this;

      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : item.id;
      var confirmation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (confirmation) {
        confirmation = prompt('Esta a\xE7\xE3o pode levar \xE0 perda de dados. Para evitar a\xE7\xF5es acidentais, solicitamos que voc\xEA confirme sua inten\xE7\xE3o.\nDigite "' + (item.id_texto || item.name) + '" para prosseguir ou feche este modal para cancelar.');

        if (!confirmation) {
          return;
        } else if (confirmation !== (item.id_texto || item.name)) {
          alert('Palavra informada inválida');
          return;
        }

        var already_confirmed = true;
      }

      var index = this.items.indexOf(item);
      if (already_confirmed || confirm(this.translate('system.alert.delete'))) {
        if (this.saving) return;
        this.saving = true;
        this.beforeDelete();
        this.$store.commit('loader/change_dialog', true);
        this.$http.delete('api/' + this.entity + '/' + id).then(function (res) {
          _this2.items.splice(index, 1);
          _this2.afterDelete();
          _this2.saving = false;
          _this2.$store.commit('loader/change_dialog', false);
          _this2.$store.commit('snackbar/change_values', {
            text: 'Registro de ' + _this2.translate('table.' + _this2.entity + '.title')[0] + ' deletado com sucesso!',
            color: 'success',
            dialog: true
          });
        }, function (error) {
          _this2.saving = false;
          _this2.$store.commit('loader/change_dialog', false);

          var text = 'Não foi possível deletar o registro de ' + _this2.translate('table.' + _this2.entity + '.title')[0] + ', reporte o erro.';
          var timeout = 3000;
          if (error.body.message.includes('23000-1451')) {
            text = error.body.message;
            timeout = 10000;
          }

          _this2.$store.commit('snackbar/change_values', {
            text: text,
            timeout: timeout,
            color: 'error',
            dialog: true
          });
        });
      }
    },
    close: function close() {
      var _this3 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this.beforeClose();
      this.dialog = to !== 1;
      this.$store.commit('loader/change_dialog', false);
      setTimeout(function () {
        if (to !== 3) {
          _this3.editedItem = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this3.defaultItem)));
          _this3.editedIndex = -1;
        }
        _this3.view = to;
        _this3.afterClose();
      }, time);
    },
    _collectPDateValidators: function _collectPDateValidators() {
      var validators = [];
      var traverse = function traverse(vm) {
        vm.$children.forEach(function (child) {
          if (child.$refs && child.$refs.menu !== undefined) {
            validators.push(child.$validator);
          }
          traverse(child);
        });
      };
      traverse(this);
      return validators;
    },
    save: function save() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.entity;
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.editedItem.id;
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.editedItem;

      var _this4 = this;

      var to = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var unshift = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (this.saving) return;
      this.saving = true;
      var childValidators = this._collectPDateValidators();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$validator.validateAll()].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(childValidators.map(function (v) {
        return v.validateAll();
      })))).then(function (results) {
        var result = results.every(Boolean);
        if (!result) {
          _this4.saving = false;
          _this4.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          });
        } else {
          _this4.$store.commit('loader/change_dialog', true);

          if (_this4.beforeSave() === false) {
            _this4.saving = false;
            _this4.$store.commit('loader/change_dialog', false);
            return;
          }

          if (_this4.view === 2) {
            _this4.$http.post('api/' + route, data).then(function (res) {
              console.log('res.body', res.body);
              console.log('this.items', _this4.items);
              if (unshift) {
                _this4.items.unshift(res.body.dados);
              } else {
                _this4.items.push(res.body.dados);
              }
              _this4.resBody = res.body;
              _this4.afterSave(res);
              _this4.saving = false;

              // this.$store.commit('loader/change_dialog', false)
              _this4.$store.commit('snackbar/change_values', {
                text: 'Registro de ' + _this4.translate('table.' + _this4.entity + '.title')[0] + ' incluído com sucesso!',
                color: 'success',
                dialog: true
              });

              _this4.close(0, to);
            }, function (err) {
              _this4.saving = false;
              _this4.$store.commit('loader/change_dialog', false);
              _this4.$store.commit('snackbar/change_values', {
                text: 'Não foi possível incluir o registro de ' + _this4.translate('table.' + _this4.entity + '.title')[0] + ', reporte o erro.',
                color: 'error',
                dialog: true
              });
              _this4.close(0, to);
            });
          } else if (_this4.view === 3) {
            var index = _this4.editedIndex;
            _this4.$http.put('api/' + route + '/' + id, data).then(function (res) {
              var item = _this4.items.find(function (val) {
                return val['id'] == res.body.dados['id'];
              });

              if (item) {
                // Adicionada verificação pois ao criar um novo contribuinte da tela de pessoas os itens aparecem com o filtro inicial, portanto nem sempre o novo contribuinte estará presente nos primeiros 25 itens
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(item, res.body.dados);
                _this4.resBody = res.body;
              }

              _this4.afterSave();
              _this4.saving = false;

              _this4.$store.commit('loader/change_dialog', false);
              _this4.$store.commit('snackbar/change_values', {
                text: 'Registro de ' + _this4.translate('table.' + _this4.entity + '.title')[0] + ' editado com sucesso!',
                color: 'success',
                dialog: true
              });

              _this4.close(0, to);
            }, function (err) {
              _this4.saving = false;
              _this4.$store.commit('loader/change_dialog', false);
              _this4.$store.commit('snackbar/change_values', {
                text: 'Não foi possível editar o registro de ' + _this4.translate('table.' + _this4.entity + '.title')[0] + ', reporte o erro.',
                color: 'error',
                dialog: true
              });
              _this4.close(0, to);
            });
          } else {
            _this4.saving = false;
          }
        }
      }, function () {
        _this4.saving = false;
      });
    },
    saveNew: function saveNew() {
      var _this5 = this;

      var childValidators = this._collectPDateValidators();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$validator.validateAll()].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(childValidators.map(function (v) {
        return v.validateAll();
      })))).then(function (results) {
        var result = results.every(Boolean);
        if (!result) {
          _this5.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          });
        } else {
          _this5.save(_this5.entity, _this5.editedItem.id, _this5.editedItem, 2);
          setTimeout(function () {
            _this5.create();
          }, 0);
        }
      });
    },
    saveEdit: function saveEdit() {
      var _this6 = this;

      var childValidators = this._collectPDateValidators();
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.$validator.validateAll()].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(childValidators.map(function (v) {
        return v.validateAll();
      })))).then(function (results) {
        var result = results.every(Boolean);
        if (!result) {
          _this6.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          });
        } else {
          _this6.save(_this6.entity, _this6.editedItem.id, _this6.editedItem, 3);
          setTimeout(function () {
            _this6.editItem(_this6.resBody);
          }, 1000);
        }
      });
    },
    editValue: function editValue(route, id, value) {
      var _this7 = this;

      this.$store.commit('loader/change_dialog', true);
      this.$http.put('api/' + route + '/' + id, value).then(function (res) {
        _this7.$store.commit('loader/change_dialog', false);
        _this7.$store.commit('snackbar/change_values', {
          text: 'Registro' + (name === '' ? name : ' de ' + name) + ' editado com sucesso!',
          color: 'success',
          dialog: true
        });
      }, function () {
        return function () {
          this.$store.commit('loader/change_dialog', false);
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível editar o registro' + (name === '' ? ' de ' + name : name) + ', reporte o erro.',
            color: 'error',
            dialog: true
          });
        };
      });
    },
    beforeEdit: function beforeEdit(item) {},
    afterEdit: function afterEdit() {},
    beforeCreate: function beforeCreate() {},
    afterCreate: function afterCreate() {},
    beforeSave: function beforeSave() {},
    afterSave: function afterSave() {},
    beforeInitialize: function beforeInitialize() {},
    afterInitialize: function afterInitialize() {},
    beforeDelete: function beforeDelete() {},
    afterDelete: function afterDelete() {},
    afterDialog: function afterDialog() {},
    afterClose: function afterClose() {},
    beforeClose: function beforeClose() {}
  },
  computed: {
    formTitle: function formTitle() {
      switch (this.view) {
        case 1:
          return this.translate('system.title.consult') + this.translate('table.' + this.entity + '.title')[1];
        case 2:
          return this.translate('system.title.include') + this.translate('table.' + this.entity + '.title')[0];
        case 3:
          return this.translate('system.title.edit') + this.translate('table.' + this.entity + '.title')[0];
      }
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
      methods: {
            hasAccess: function hasAccess(permissionRequested, operation) {
                  // Verifica se os parâmetros são fornecidos
                  if (!permissionRequested || !operation) {
                        return false;
                  }

                  // Se tiver acesso de Desenvolvedor ou Administrador, consequentemente tem acesso a todas telas
                  if (['dev', 'admin'].includes(this.$auth.user().acesso_interno)) {
                        return true;
                  }

                  // Se não tiver nenhum acesso relacionado ao usuário, consequentemente não tem acesso a nenhuma tela
                  if (!this.$auth.user().acesso) {
                        return false;
                  }

                  // Tenta analisar as permissões, se falhar, retorna falso
                  var permissions = void 0;
                  try {
                        permissions = JSON.parse(this.$auth.user().acesso.permissoes);
                  } catch (e) {
                        return false;
                  }

                  // Encontra a permissão solicitada
                  var permission = permissions.find(function (item) {
                        return item.key === permissionRequested;
                  });

                  // Verifica se a permissão e a operação existem
                  return permission && (permission[operation] === true || permission[operation] === 1);
            },
            hasCondominioAccess: function hasCondominioAccess(permissionRequested, operation) {
                  var condominio_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.editedItem.condominio_id;

                  // Se tiver acesso de Desenvolvedor ou Administrador, consequentemente tem acesso a todas telas
                  if (['dev', 'admin'].includes(this.$auth.user().acesso_interno)) {
                        return true;
                  }

                  var condominio_user = this.$auth.user().acessos_condominios.find(function (item) {
                        return item.condominio_id === condominio_id;
                  });

                  // Se não encontrar nenhum acesso, retorna falso e bloqueia o acesso
                  if (!condominio_user) {
                        return false;
                  }

                  var permissions = JSON.parse(condominio_user.acesso.permissoes);

                  var permission = permissions.find(function (item) {
                        return item.key === permissionRequested;
                  });

                  if (!permission) {
                        return false;
                  }

                  return permission[operation] === true || permission[operation] === 1;
            }
      }
});

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMoney_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b2baf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMoney_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMoney_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b2baf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMoney_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDate_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec5dc6be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDate_vue__ = __webpack_require__(332);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec5dc6be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PCpfCnpj_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b145fc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PCpfCnpj_vue__ = __webpack_require__(345);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PCpfCnpj_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b145fc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PCpfCnpj_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Helper = function () {
  function Helper() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Helper);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Helper, null, [{
    key: 'isCpfValid',

    // Função para verificar se um CPF é válido
    value: function isCpfValid(cpf) {
      cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
      if (cpf.length !== 11) {
        return false;
      }
      // Verifica se todos os dígitos são iguais (CPF inválido)
      if (/^(\d)\1+$/.test(cpf)) {
        return false;
      }
      // Validação do primeiro dígito verificador
      var soma = 0;
      for (var i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      var resto = 11 - soma % 11;
      var digitoVerificador1 = resto === 10 || resto === 11 ? 0 : resto;
      if (digitoVerificador1 !== parseInt(cpf.charAt(9))) {
        return false;
      }
      // Validação do segundo dígito verificador
      soma = 0;
      for (var _i = 0; _i < 10; _i++) {
        soma += parseInt(cpf.charAt(_i)) * (11 - _i);
      }
      resto = 11 - soma % 11;
      var digitoVerificador2 = resto === 10 || resto === 11 ? 0 : resto;
      if (digitoVerificador2 !== parseInt(cpf.charAt(10))) {
        return false;
      }
      return true; // CPF válido
    }
  }, {
    key: 'generateSequenciaIr0',
    value: function generateSequenciaIr0(first, second, values) {
      var maiorNumero = 0;

      if (values.length > 0) {
        values.forEach(function (item) {
          var sequencia = item.sequencia_ir;
          var ultimoHifen = sequencia.lastIndexOf('-');
          var numero = parseInt(sequencia.substring(ultimoHifen + 1));
          if (numero > maiorNumero) {
            maiorNumero = numero;
          }
        });
      }

      return '' + (first ? first + '-' : '') + second + '-' + this.pad(++maiorNumero, 5);
    }
  }, {
    key: 'generateSequenciaIr',
    value: function generateSequenciaIr(first, second, values) {
      var numeros = values.map(function (item) {
        return parseInt(item.sequencia_ir.split('-').pop());
      });
      var maiorNumero = numeros.reduce(function (a, b) {
        return Math.max(a, b);
      }, 0);

      return '' + (first ? first + '-' : '') + second + '-' + this.pad(maiorNumero + 1, 5);
    }
  }, {
    key: 'pad',
    value: function pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
  }]);

  return Helper;
}();

/* harmony default export */ __webpack_exports__["a"] = (Helper);

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    maskField: function maskField(val, mask) {
      var str = val.split('');
      var countValue = 0;
      var countMask = 0;
      for (var i = 0; i < mask.length; i++) {
        if (val.charAt(countValue)) {
          if (mask.charAt(i) === '#') {
            countValue++;
            mask = mask.substr(0, i) + str.shift() + mask.substr(i + 1);
          } else {
            countMask++;
          }
        } else {
          return mask.substr(0, countMask + countValue);
        }
      }
      return mask;
    },
    maskMoney: function maskMoney(val) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var fixed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

      return type === 1 ? 'R$ ' + parseFloat(val).toFixed(fixed).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '$ ' + parseFloat(val).toFixed(fixed).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b29561_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(428);
function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78b29561"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b29561_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_In__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layouts_Out__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_crud_Pessoa__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_crud_Usuario__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_crud_Suporte__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_crud_Acesso__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_crud_Condominio__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_crud_AnoBase__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_auth_Login__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_auth_Register__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_auth_Forgot__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_auth_Reset__ = __webpack_require__(436);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_3__components_layouts_Out__["a" /* default */],
    children: [{
      path: '/',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_10__components_auth_Login__["a" /* default */],
      alias: '/login',
      meta: { title: 'Seja bem vindo!' }
    }, {
      path: '/register',
      name: 'Register',
      component: __WEBPACK_IMPORTED_MODULE_11__components_auth_Register__["a" /* default */],
      meta: { title: 'Registrar' }
    }, {
      path: '/forgot',
      name: 'Forgot',
      component: __WEBPACK_IMPORTED_MODULE_12__components_auth_Forgot__["a" /* default */],
      meta: { title: 'Esqueci minha Senha' }
    }, {
      path: '/reset/:token',
      name: 'Reset',
      component: __WEBPACK_IMPORTED_MODULE_13__components_auth_Reset__["a" /* default */],
      meta: { title: 'Resetar Senha' }
    }]
  }, {
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_2__components_layouts_In__["a" /* default */],
    meta: { auth: true },
    children: [
    // {
    //   path: '/home',
    //   name: 'Dashboard',
    //   component: Dashboard,
    //   meta: { title: 'Página Inicial' }
    // },
    {
      path: '/pessoa',
      name: 'Pessoa',
      component: __WEBPACK_IMPORTED_MODULE_4__components_crud_Pessoa__["a" /* default */],
      meta: { title: 'Pessoa', access: true }
    }, {
      path: '/condominio',
      name: 'Condominio',
      component: __WEBPACK_IMPORTED_MODULE_8__components_crud_Condominio__["a" /* default */],
      alias: ['/home'],
      meta: { title: 'Condominio', access: true }
    }, {
      path: '/contribuinte',
      name: 'Contribuinte',
      component: __WEBPACK_IMPORTED_MODULE_8__components_crud_Condominio__["a" /* default */],
      meta: { title: 'Contribuinte', access: true }
    }, {
      path: '/anobase',
      name: 'AnoBase',
      component: __WEBPACK_IMPORTED_MODULE_9__components_crud_AnoBase__["a" /* default */],
      meta: { title: 'Ano Base', access: true }
    }, {
      path: '/suporte',
      name: 'Suporte',
      component: __WEBPACK_IMPORTED_MODULE_6__components_crud_Suporte__["a" /* default */],
      meta: { title: 'Suporte', access: true }
    }, {
      path: '/usuario',
      name: 'Usuario',
      component: __WEBPACK_IMPORTED_MODULE_5__components_crud_Usuario__["a" /* default */],
      meta: { title: 'Usuário', access: true }
    }, {
      path: '/acesso',
      name: 'Acesso',
      component: __WEBPACK_IMPORTED_MODULE_7__components_crud_Acesso__["a" /* default */],
      meta: { title: 'Acesso', access: true }
    }]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_PLoader__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PSnackbar__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PChangePassword__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crud_Atualizacao_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_acl__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      drawer: false,
      years: [],
      items: [{
        icon: "bubble_chart",
        title: "Pessoas",
        route: "pessoa"
      }, {
        icon: "bubble_chart",
        title: "Condominio",
        route: "condominio"
      }, {
        icon: "bubble_chart",
        title: "Ano Base",
        route: "anobase"
      }, {
        icon: "bubble_chart",
        title: "Usuários",
        route: "usuario"
      }],
      title: "ContTech"
    };
  },

  name: "App",
  components: { PLoader: __WEBPACK_IMPORTED_MODULE_0__shared_PLoader__["a" /* default */], PSnackbar: __WEBPACK_IMPORTED_MODULE_1__shared_PSnackbar__["a" /* default */], PChangePassword: __WEBPACK_IMPORTED_MODULE_2__shared_PChangePassword__["a" /* default */], Atualizacao: __WEBPACK_IMPORTED_MODULE_3__crud_Atualizacao_vue__["a" /* default */] },
  methods: {
    para: function para(route) {
      if (this.$router.currentRoute.path !== route) {
        this.$router.push(route);
        location.reload();
      }
    },

    changePassword: function changePassword() {
      this.$refs.changePassword.dialogChangePassword = true;
    },
    changeYear: function changeYear(anobase_id) {
      var _$auth$user = this.$auth.user(),
          id = _$auth$user.id;

      this.$http.put("auth/users/" + id, { anobase_id: anobase_id }).then(function (res) {
        location.reload();
      }, function (err) {
        return function () {
          console.log(err);
        };
      });
    },
    changeCompany: function changeCompany(empresa_id) {
      var _$auth$user2 = this.$auth.user(),
          id = _$auth$user2.id;

      this.$http.put("auth/users/" + id, { empresa_id: empresa_id }).then(function (res) {
        location.reload();
      }, function (err) {
        return function () {
          console.log(err);
        };
      });
    },
    changeUser: function changeUser(user_id) {
      var _$auth$user3 = this.$auth.user(),
          id = _$auth$user3.id;

      this.$http.put("auth/users/" + id, { user_id: user_id }).then(function (res) {
        localStorage.setItem("default_auth_token", res.body);
        location.reload();
      }, function (err) {
        return function () {
          console.log(err);
        };
      });
    },
    logout: function logout() {
      this.$auth.logout({
        makeRequest: true
      });
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loader',
  computed: {
    dialog: function dialog() {
      return this.$store.getters['loader/dialog'] || false;
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'snackbar',
  computed: {
    values: function values() {
      return this.$store.getters['snackbar/values'] || '';
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PChangePassword',
  data: function data() {
    return {
      dialogChangePassword: false,
      editedItem: { newPassword: '', oldPassword: '', newPasswordConfirm: '' }
    };
  },

  methods: {

    confirm: function confirm() {
      var _this = this;

      if (this.editedItem.newPassword !== this.editedItem.newPasswordConfirm) {
        return alert('A senha nova não confere com sua confirmação.');
      }

      this.$http.post('api/change_password', this.editedItem).then(function (res) {
        alert(res.body);
        _this.editedItem.newPassword = '';
        _this.editedItem.oldPassword = '';
        _this.editedItem.newPasswordConfirm = '';
      });
      this.dialogChangePassword = false;
    },
    close: function close() {
      this.dialogChangePassword = false;
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AtualizacaoMatriz_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AtualizacaoUser_vue__ = __webpack_require__(311);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AtualizacaoMatriz: __WEBPACK_IMPORTED_MODULE_0__AtualizacaoMatriz_vue__["a" /* default */], AtualizacaoUser: __WEBPACK_IMPORTED_MODULE_1__AtualizacaoUser_vue__["a" /* default */] },
  data: function data() {
    return {
      entity: "atualizacao",
      dialogIndex: false,
      quantidade_atualizacao_nao_visualizada: ""
    };
  },

  methods: {
    abrirDialog: function abrirDialog() {
      this.$refs.atualizacaoMatriz.$emit("dialog_opened");
      this.dialogIndex = true;
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_crud__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixin_crud__["a" /* default */]],
  data: function data() {
    return {
      entity: "atualizacao_matriz",
      dialogIndex: false,
      dialogCreateEdit: false,
      date: null,
      dateFormatted: null,
      time: null,
      menu1: false,
      menu2: false,
      content: "",
      disabled: false,
      toolbarOptions: [["bold", "italic", "underline", "strike"], // Negrito, itálico, sublinhado, tachado
      ["blockquote", "code-block"], // Citação, bloco de código
      [{ header: 1 }, { header: 2 }], // Título 1, Título 2
      [{ list: "ordered" }, { list: "bullet" }], // Lista ordenada, lista com marcadores
      [{ script: "sub" }, { script: "super" }], // Subscrito, sobrescrito
      [{ indent: "-1" }, { indent: "+1" }], // Recuo para esquerda, recuo para direita
      [{ direction: "rtl" }], // Texto da direita para a esquerda
      [{ size: ["small", false, "large", "huge"] }], // Tamanho do texto
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // Tamanhos de cabeçalho
      [{ color: [] }, { background: [] }], // Cor do texto, cor de fundo
      [{ font: [] }], // Família da fonte
      [{ align: [] }], // Alinhamento do texto
      ["clean"], // Limpar formatação
      ["link", "image", "video"]]
    };
  },
  created: function created() {
    this.initialize();
  },
  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split("/"),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");
    },
    formatarData: function formatarData(dataHora) {
      var data = this.moment(dataHora).format("DD/MM/YYYY - HH:mm:ss");
      return data.toLocaleString();
    },
    save: function save() {
      var _this = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.editedItem.id;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.editedItem;

      if (this.saving) return;
      this.saving = true;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.saving = false;
          _this.$store.commit("snackbar/change_values", {
            text: "Por favor, corrija as validações antes de salvar!",
            color: "error",
            dialog: true
          });
        } else {
          // this.$store.commit("loader/change_dialog", true);
          var apiUrl = _this.view == 2 ? "api/" + _this.entity : "api/" + _this.entity + "/" + id;

          _this.$http[_this.view == 2 ? "post" : "put"](apiUrl, data).then(function (res) {
            var responseData = res.body;
            if (_this.view == 2) {
              _this.items.push(responseData.dados);
            } else {
              var itemIndex = _this.items.findIndex(function (item) {
                return item.id == responseData.dados.id;
              });
              if (itemIndex !== -1) {
                _this.$set(_this.items, itemIndex, responseData.dados);
              }
            }

            _this.items.sort(function (a, b) {
              var dateA = new Date(a.data_hora);
              var dateB = new Date(b.data_hora);
              return dateB - dateA;
            });

            _this.$store.commit("snackbar/change_values", {
              text: "Registro de Atualiza\xE7\xE3o " + (_this.view == 2 ? "incluído" : "editado") + " com sucesso!",
              color: "success",
              dialog: true
            });
          }, function (err) {
            _this.$store.commit("snackbar/change_values", {
              text: "N\xE3o foi poss\xEDvel " + (_this.view == 2 ? "incluir" : "editar") + " o registro de Atualiza\xE7\xE3o, reporte o erro.",
              color: "error",
              dialog: true
            });
          }).finally(function () {
            _this.saving = false;
            // this.$store.commit("loader/change_dialog", false);
            _this.close();
          });
        }
      }, function () {
        _this.saving = false;
      });
    },
    editItem: function editItem(item) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.editedItem, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)));
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.beforeEditedItem, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)));
      this.dialogCreateEdit = true;
      this.view = 3;
      this.editedIndex = this.items.indexOf(item);
      // this.$store.commit("loader/change_dialog", false);
    },
    close: function close() {
      var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.dialogCreateEdit = to !== 1;
      // this.$store.commit("loader/change_dialog", false);

      if (to != 3) {
        this.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.defaultItem)));
        this.editedIndex = -1;
      }
      this.view = 1;
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */]],
  data: function data() {
    return {
      entity: "atualizacao_user"
    };
  },
  mounted: function mounted() {
    // Adicionar um listener para o evento
    this.$parent.$on("dialog_opened", this.initialize());
  },
  beforeDestroy: function beforeDestroy() {
    // Remover o listener quando o componente for destruído para evitar vazamentos de memória
    this.$parent.$off("dialog_opened", this.executarEvento);
  },

  methods: {
    executarEvento: function executarEvento() {
      // Lógica a ser executada quando o evento for acionado
      console.log("Evento acionado no componente filho");
    },
    formatarData: function formatarData(dataHora) {
      var data = this.moment(dataHora).format("DD/MM/YYYY - HH:mm:ss");
      return data.toLocaleString();
    },
    save: function save() {
      var _this = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.editedItem.id;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.editedItem;

      if (this.saving) return;
      this.saving = true;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.saving = false;
          _this.$store.commit("snackbar/change_values", {
            text: "Por favor, corrija as validações antes de salvar!",
            color: "error",
            dialog: true
          });
        } else {
          // this.$store.commit("loader/change_dialog", true);

          _this.$http.put("api/" + _this.entity + "/" + id, data).then(function (res) {
            console.log("id", id);
            console.log("data", data);
            var item = _this.items.find(function (item) {
              return item["id"] == res.body.dados["id"];
            });
            console.log("item", item);
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, res.body.dados);
            _this.resBody = res.body;

            _this.$store.commit("snackbar/change_values", {
              text: "Registro de Atualiza\xE7\xE3o " + (_this.view == 2 ? "incluído" : "editado") + " com sucesso!",
              color: "success",
              dialog: true
            });
          }, function (err) {
            _this.$store.commit("snackbar/change_values", {
              text: "N\xE3o foi poss\xEDvel " + (_this.view == 2 ? "incluir" : "editar") + " o registro de Atualiza\xE7\xE3o, reporte o erro.",
              color: "error",
              dialog: true
            });
          }).finally(function () {
            _this.saving = false;
            // this.$store.commit("loader/change_dialog", false);
            _this.close();
          });
        }
      }, function () {
        _this.saving = false;
      });
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "out",
  data: function data() {
    return {
      backgroundImage: ""
    };
  },
  mounted: function mounted() {
    this.backgroundImage = {};
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__details_Contato__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__details_Empresa__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__details_PessoaDependente__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_PExportLCDPR__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_PExportCaixaGeral__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_PRelatorioConferencia__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_PCpfCnpj__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__classes_helper__ = __webpack_require__(12);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixin_acl__["a" /* default */]],
  components: {
    contatos: __WEBPACK_IMPORTED_MODULE_6__details_Contato__["a" /* default */],
    empresas: __WEBPACK_IMPORTED_MODULE_7__details_Empresa__["a" /* default */],
    PessoaDependente: __WEBPACK_IMPORTED_MODULE_8__details_PessoaDependente__["a" /* default */],
    PDate: __WEBPACK_IMPORTED_MODULE_9__shared_PDate__["a" /* default */],
    PExportLcdpr: __WEBPACK_IMPORTED_MODULE_10__shared_PExportLCDPR__["a" /* default */],
    PExportCaixaGeral: __WEBPACK_IMPORTED_MODULE_11__shared_PExportCaixaGeral__["a" /* default */],
    PRelatorioConferencia: __WEBPACK_IMPORTED_MODULE_12__shared_PRelatorioConferencia__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_13__shared_PCpfCnpj__["a" /* default */]
  },
  data: function data() {
    return {
      entity: "pessoa",
      tab: null,
      beforeCpf: null,
      fab: null,
      cidades: [],
      paises: [],
      conjuges: [],
      empresas: [],
      rgie_label: "RG",
      name_label: "Nome",
      cpf_cnpj: "",
      selectedFile: null,
      changeCompany: {
        dialog: false,
        empresas: []
      },
      loadingCpf: false,
      dialog_log: false,
      dialog_settings: false,
      dialogLogImportacao: false,
      log_file: "",
      dbk_file: "",
      file_import_error: "",
      checkboxes: {}
    };
  },
  created: function created() {
    this.initialize();
    this.editedItem = {
      ativo: true,
      empresa_id: this.$auth.user().empresa_id,
      endereco_brasil: true,
      possui_conjuge: false,
      cpf_cnpj: ""
    };
    this.defaultItem = {
      ativo: true,
      empresa_id: this.$auth.user().empresa_id,
      endereco_brasil: true,
      possui_conjuge: false,
      cpf_cnpj: ""
    };
  },

  methods: {
    openDialogDBK: function openDialogDBK(item) {
      var _this = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.get("export/dbk", {
        params: {
          condominio_id: item.id,
          is_consolidado: true
        }
      }).then(function (res) {
        _this.$store.commit("loader/change_dialog", false);
        _this.log_file = res.body.log_file;
        _this.dbk_file = res.body.dbk_file;
        if (_this.log_file) _this.dialog_log = true;else _this.downloadDBK();
      }).catch(function (error) {
        // console.log(error);
        _this.$store.commit("loader/change_dialog", false);
        _this.$store.commit("snackbar/change_values", {
          text: error.body.message,
          color: "error",
          dialog: true
        });
      });
    },
    openDialogSettings: function openDialogSettings() {
      this.checkboxes.bem_direito = true;
      this.checkboxes.bem_atividade_rural = true;
      this.checkboxes.divida_onus_real = true;
      this.checkboxes.divida_atividade_rural = true;
      this.checkboxes.rendimento_tributavel_pj = true;
      this.checkboxes.rendimento_isento_nao_tributavel = true;
      this.checkboxes.rendimento_tributacao_exclusiva = true;
      this.checkboxes.pagamento_efetuado = true;
      this.checkboxes.movimentacao_financeira = true;

      this.dialog_settings = true;
    },
    viewLOG: function viewLOG() {
      window.open("https://app.api.conttech.com.br/" + ("validacoes/" + this.log_file), "_blank");
      this.dialog = false;
    },
    downloadDBK: function downloadDBK() {
      window.open("https://app.api.conttech.com.br/" + ("dbks/" + this.dbk_file), "_blank");
      this.dialog_log = false;
    },
    updateValue: function updateValue(value) {
      this.inputValue = value.replace(/[^0-9]/g, "").substring(0, 14);
    },
    showMenu: function showMenu(event, item) {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.get("api/get_condominios_pessoa/" + item.id).then(function (response) {
        var participacoesArray = response.body.map(function (objeto) {
          return objeto.id_texto;
        });
        var participacoes = participacoesArray.join(", ");

        var textarea = document.createElement("textarea");
        textarea.value = participacoes;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);

        _this2.$store.commit("snackbar/change_values", {
          text: participacoes,
          color: "info",
          dialog: true,
          timeout: 10000
        });
        _this2.$store.commit("loader/change_dialog", false);
      }).catch(function (error) {
        _this2.$store.commit("loader/change_dialog", false);
      });
    },
    clickCaixaGeral: function clickCaixaGeral(pessoa_id, nome) {
      var _this3 = this;

      this.$refs.caixaGeral.editedItem.pessoa_id = pessoa_id;
      this.$refs.caixaGeral.editedItem.nome = nome;
      this.$store.commit("loader/change_dialog", true);
      // pega todos os condominios da pessoa para o usuário escolher
      this.$http.get("api/get_condominios_pessoa/" + pessoa_id).then(function (res) {
        _this3.$refs.caixaGeral.editedItem.condominios_ids = [];
        _this3.$refs.caixaGeral.condominiosPessoa = res.body;
        _this3.$refs.caixaGeral.condominiosPessoa.push({
          id: "total",
          id_texto: "Total"
        });
        _this3.$refs.caixaGeral.dialogExportCaixaGeral = true;
        _this3.$store.commit("loader/change_dialog", false);
      });
    },
    clickConferencia: function clickConferencia(pessoa_id, nome) {
      var _this4 = this;

      this.$refs.conferencia.editedItem.pessoa_id = pessoa_id;
      this.$refs.conferencia.editedItem.nome = nome;
      this.$store.commit("loader/change_dialog", true);
      // pega todos os condominios da pessoa para o usuário escolher
      this.$http.get("api/get_condominios_pessoa/" + pessoa_id).then(function (res) {
        _this4.$refs.conferencia.editedItem.condominios_ids = [];
        _this4.$refs.conferencia.condominiosPessoa = res.body;
        _this4.$refs.conferencia.dialogRelatorioConferencia = true;
        _this4.$store.commit("loader/change_dialog", false);
      });
    },
    clear_conjuge: function clear_conjuge() {
      if (!this.editedItem.possui_conjuge) this.editedItem.pessoa_id = null;
    },
    clickLCDPR: function clickLCDPR(pessoa_id, nome) {
      var _this5 = this;

      this.$refs.lcdpr.editedItem.pessoa_id = pessoa_id;
      this.$refs.lcdpr.editedItem.nome = nome;
      this.$store.commit("loader/change_dialog", true);
      // pega todos os condominios da pessoa para o usuário escolher
      this.$http.get("api/get_condominios_pessoa/" + pessoa_id).then(function (res) {
        console.log("res.body", res.body);
        _this5.$refs.lcdpr.condominiosPessoa = res.body;
        _this5.$refs.lcdpr.dialogExportLCDPR = true;
        _this5.$store.commit("loader/change_dialog", false);
      });
    },
    downloadItem: function downloadItem(item, event) {
      var _this6 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.get("report/declaracao_ajuste/" + item.id + "/1", {
        responseType: "arraybuffer"
      }).then(function (res) {
        var blob = new Blob([res.data], {
          type: res.headers.get("content-type")
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = item.id_texto + ".pdf";
        link.click();
        _this6.$store.commit("loader/change_dialog", false);
      }, function () {
        return _this6.$store.commit("loader/change_dialog", false);
      });
    },
    isUnlocked: function isUnlocked(item) {
      var _this7 = this;

      var empresa = item.empresas.find(function (a) {
        return a.empresa_id === _this7.$auth.user().empresa_id;
      });

      if (empresa) {
        return empresa.ativo;
      }
    },
    isBlocked: function isBlocked() {
      return this.view === 3 && !this.editedItem.isOwner;
    },
    liberaAcesso: function liberaAcesso(item) {
      var _this8 = this;

      var empresaLiberada = item.empresas.find(function (a) {
        return a.empresa_id === _this8.$auth.user().empresa_id;
      });
      if (confirm("Tem certeza de que deseja " + (empresaLiberada.ativo ? "bloquear" : "liberar") + " o acesso ao compartilhamento de informa\xE7\xF5es desta pessoa?")) {
        empresaLiberada.ativo = !empresaLiberada.ativo;
        item.empresas.find(function (a) {
          return a.empresa_id === _this8.$auth.user().empresa_id;
        }).ativo = empresaLiberada.ativo;

        this.editValue("pessoa_empresa", empresaLiberada.id, empresaLiberada);
      }
    },

    labels: function labels() {
      var _this9 = this;

      setTimeout(function () {
        switch (_this9.editedItem.tipo) {
          case 1:
            _this9.name_label = "Nome";
            _this9.rgie_label = "RG";
            break;
          case 2:
            _this9.name_label = "Razão Social";
            _this9.rgie_label = "IE";
            break;
        }
      }, 10);
    },
    toogleCompanyDialog: function toogleCompanyDialog(item) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.editedItem, JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item)));
      this.changeCompany.dialog = !this.changeCompany.dialog;
    },
    confirmChangeCompany: function confirmChangeCompany(item) {
      var _this10 = this;

      if (this.editedItem.empresa_id == this.$auth.user().empresa_id) {
        alert("A empresa selecionada j\xE1 \xE9 respons\xE1vel pela Pessoa \"" + this.editedItem.id_texto + "\".");
        return;
      }

      this.$store.commit("loader/change_dialog", true);
      this.$http.post("api/pessoa/change_company", this.editedItem).then(function (res) {
        _this10.$store.commit("loader/change_dialog", false);
        _this10.changeCompany.dialog = false;

        alert("Registro transferido com sucesso! A página será atualizada.");
        location.reload();

        // setTimeout(function() {
        //   alert(
        //     "Registro transferido com sucesso! A página será atualizada."
        //   );
        //   location.reload();
        // }, 10);

        // this.$store.commit("snackbar/change_values", {
        //   text:
        //     "Registro transferido com sucesso!",
        //   color: "success",
        //   dialog: true
        // });
      });
    },
    beforeSave: function beforeSave() {
      this.editedItem.cpf_cnpj = this.editedItem.cpf_cnpj.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
    },
    afterInitialize: function afterInitialize() {
      var _this11 = this;

      this.items = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.items), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.resBody.conexoes));
      this.conjuges = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.items));
      this.items.map(function (item) {
        return item.isOwner = _this11.$auth.user().empresa_id == item.empresa_id;
      });
      this.paises = this.resBody.paises;
      this.empresas = this.resBody.empresas;

      this.changeCompany.empresas = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.empresas);
      this.changeCompany.empresas.splice(this.changeCompany.empresas.findIndex(function (company) {
        return company.id_texto === "Empresa de Jackson";
      }), 1);
      this.changeCompany.empresas.splice(this.changeCompany.empresas.findIndex(function (company) {
        return company.id_texto === "Empresa de Rafael";
      }), 1);
      this.cidades = this.resBody.cidades;
      this.cidades.map(function (value) {
        value.id_texto = value.id_texto + " - " + value.uf;
      });
    },
    afterEdit: function afterEdit() {
      var _this12 = this;

      this.beforeCpf = this.editedItem["cpf_cnpj"];
      // Verificar depois se faz sentido o conjugues tirar o item no afterEdit
      var index = this.conjuges.findIndex(function (item) {
        return item.id === _this12.editedItem.id;
      });
      if (index !== -1) this.conjuges.splice(index, 1);
    },
    afterSave: function afterSave() {
      var _this13 = this;

      this.items.map(function (item) {
        return item.isOwner = _this13.$auth.user().empresa_id == item.empresa_id;
      });
    },
    afterClose: function afterClose() {
      this.beforeCpf = null;
    },
    checkCpfExists: function checkCpfExists() {
      var _this14 = this;

      var cpf = (this.editedItem.cpf_cnpj || '').replace(/[.\-\/]/g, '');
      if (!cpf) return;
      var pessoaId = this.editedItem.id || 0;
      this.loadingCpf = true;
      this.$http.get("api/existsCpf/" + cpf + "/" + pessoaId).then(function (res) {
        var cpfExistsError = res.body || null;
        if (cpfExistsError) {
          _this14.editedItem.cpf_cnpj = "";
          alert("CPF " + cpfExistsError.cpf_cnpj + " já cadastrado na empresa: " + cpfExistsError.empresa.id_texto);
        }
      }).finally(function () {
        _this14.loadingCpf = false;
      });
    },
    visualizeFileImportError: function visualizeFileImportError() {
      window.open("https://app.api.conttech.com.br/" + ("logs_importacao/" + this.file_import_error), "_blank");
      this.$store.commit("loader/change_dialog", false);
    },
    onFileChanged: function onFileChanged(e) {
      this.selectedFile = e.target.files[0];
    },
    importDBK: function importDBK(prosseguir) {
      var _this15 = this;

      var formData = new FormData();
      this.$store.commit("loader/change_dialog", true);
      formData.append("dbk_file", this.selectedFile);
      formData.append("prosseguirImportacao", prosseguir);
      formData.append("content", this.checkboxes);

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.checkboxes).map(function (key) {
        return [key, formData.append(key, _this15.checkboxes[key])];
      });

      console.log("check", this.checkboxes);

      var config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.$http.post("import/dbk2026", formData, config).then(function (res) {
        _this15.$store.commit("loader/change_dialog", false);
        _this15.dialogLogImportacao = false;
        // this.initialize();
        _this15.$store.commit("snackbar/change_values", {
          text: "Registro importado com sucesso!",
          color: "success",
          dialog: true
        });
        setTimeout(function () {
          location.reload();
        }, 3000);
      }, function (err) {
        _this15.$store.commit("loader/change_dialog", false);

        // Verificar se o erro é de empresa diferente
        if (err.body && err.body.error_type === "empresa_diferente") {
          var empresaProprietaria = err.body.empresa_proprietaria || "não identificada";
          var nomeContribuinte = err.body.nome_contribuinte || "";
          var cpfContribuinte = err.body.cpf_contribuinte || "";

          var mensagem = "O contribuinte " + nomeContribuinte + " (CPF: " + cpfContribuinte + ") pertence \xE0 contabilidade: \"" + empresaProprietaria + "\".\n\nN\xE3o \xE9 poss\xEDvel importar DBKs de outra contabilidade.";

          alert(mensagem);

          _this15.$store.commit("snackbar/change_values", {
            text: "Contribuinte pertence \xE0 contabilidade: " + empresaProprietaria,
            color: "error",
            dialog: true,
            timeout: 10000
          });

          _this15.dialog_settings = false;
          return;
        }

        // Tratamento de outros erros
        _this15.file_import_error = err.body.error;

        if (err.body.success) {
          _this15.$store.commit("snackbar/change_values", {
            text: "Registro importado com sucesso!",
            color: "success",
            dialog: true
          });
          _this15.dialogLogImportacao = false;
          setTimeout(function () {
            location.reload();
          }, 3000);
        } else {
          _this15.dialogLogImportacao = true;
          _this15.$store.commit("snackbar/change_values", {
            text: "Ocorreu um erro na importação do DBK",
            color: "error",
            dialog: true
          });
        }
      });
    }
  },
  computed: {
    // maskedValue() {
    //   const value = this.inputValue;
    //   if (!value) return "";
    //   const regex = /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2}) - (\d{2})/;
    //   return value.replace(regex, "$1.$2.$3.$4.$5 - $6");
    // },
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto"
      }, {
        text: this.translate("table." + this.entity + ".field.nome_abreviado"),
        value: "nome_abreviado"
      }, {
        text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
        value: "cpf_cnpj"
      }, {
        text: this.translate("table." + this.entity + ".field.rg_ie"),
        value: "rg_ie"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        width: "5%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
  }
});

/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */]],
  data: function data() {
    return {
      entity: "pessoa_contato",
      items: []
    };
  },
  name: "Contato",
  props: ["pessoa_id", "values", "pessoa"],
  created: function created() {
    this.items = this.values;
    this.editedItem = { pessoa_id: this.pessoa_id };
    this.defaultItem = { pessoa_id: this.pessoa_id };
  },

  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.tipo"),
        value: "tipo",
        width: "20%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "60%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */]],
  data: function data() {
    return {
      entity: "pessoa_empresa",
      items: [],
      dynamicEmpresas: []
    };
  },
  name: "Empresa",
  props: ["pessoa", "values", "empresas"],
  created: function created() {
    this.items = this.values;
    this.editedItem = { ativo: false, empresa_id: "", pessoa_id: this.pessoa.id };
    this.defaultItem = { ativo: false, empresa_id: "", pessoa_id: this.pessoa.id };
  },

  methods: {
    refreshEmpresas: function refreshEmpresas(tela) {
      var _this = this;

      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var remove = void 0;
      switch (tela) {
        case 2:
          this.create();
          remove = this.items.map(function (a) {
            return a.empresa_id;
          });
          remove.push(this.$auth.user().empresa_id);
          break;
        case 3:
          {
            this.editItem(obj);
            remove = this.items.map(function (a) {
              if (a.empresa_id !== _this.editedItem.empresa_id) {
                return a.empresa_id;
              }
            });
            remove.push(this.$auth.user().empresa_id);
            break;
          }
      }
      this.dynamicEmpresas = this.empresas.filter(function (item) {
        return !remove.includes(item.id);
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{ text: this.translate("table." + this.entity + ".field.empresa_id"), value: "empresa_id" },
      // { text: this.translate('table.' + this.entity + '.field.ativo'), value: 'ativo', width: '5%' },
      {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
    // computedEmpresas () {
    //   let remove = this.items.map(a => {
    //   //   if (a.empresa_id != this.beforeEditedItem.empresa_id)
    //       return a.empresa_id
    //   })
    //
    //   var empresas = this.empresas.filter(item => !remove.includes(item.id))
    //
    //   return empresas
    // }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PDate__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */]],
  data: function data() {
    return {
      entity: "pessoa_dependente",
      items: []
    };
  },
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_1__shared_PDate__["a" /* default */]
  },
  name: "Dependente",
  props: ["pessoa_id", "values", "pessoa"],
  created: function created() {
    this.items = this.values;
    this.editedItem = { pessoa_id: this.pessoa_id, residencia_com_titular: false };
    this.defaultItem = { pessoa_id: this.pessoa_id, residencia_com_titular: false };
  },

  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.tipo"),
        value: "tipo",
        width: "20%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "40%"
      }, { text: this.translate("table." + this.entity + ".field.cpf"), value: "cpf", width: "15%" }, {
        text: this.translate("table." + this.entity + ".field.nascimento"),
        value: "nascimento",
        width: "10%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      menu: false,
      date: "",
      dateTime: "",
      dateFormatted: "",
      max: null,
      limitedYear: null
    };
  },

  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      default: ""
    },
    errors_collect: {
      type: String,
      default: "data"
    },
    limitPreviousYears: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {},
    name: {
      type: String
    },
    v_validate: {
      type: String
    },
    data_vv_as: {
      type: String
    },
    minvalue: {
      type: String
    },
    maxvalue: {
      type: String
    }
  },
  watch: {
    value: function value(val) {
      this.syncDateFormatted(this.value);
    },
    date: function date(val) {
      this.syncDateFormatted();
    }
  },
  mounted: function mounted() {
    if (this.value) {
      this.dateTime = this.moment(this.value);
      this.date = this.moment(this.value).format("YYYY-MM-DD");
    } else if (this.v_validate && this.v_validate.includes("required")) {
      this.date = this.moment().subtract(1, "years").format("YYYY-MM-DD");
    }

    if (this.limitPreviousYears) {
      this.limitedYear = this.$auth.user().anobase.id_texto;
      this.max = this.limitedYear + "-12-31";
    }
  },

  methods: {
    openMenu: function openMenu(e) {
      this.updateValues(this.dateFormatted, false);

      this.menu = true;
    },
    updateValues: function updateValues(value) {
      var nullable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.dateTime = this.moment(value, "DD/MM/YYYY", true);

      var date = void 0;

      if (this.dateTime.isValid()) {
        date = this.dateTime.format("YYYY-MM-DD");
        if (this.limitPreviousYears && this.dateTime.isAfter(this.max)) {
          this.dateTime = this.moment();
          this.dateTime.set("year", this.limitedYear);

          date = this.dateTime.format("YYYY-MM-DD");
        }
      } else {
        if (this.dateFormatted === "" && nullable) {
          date = "";
        } else {
          this.dateTime = this.moment();
          this.dateTime.set("year", this.limitedYear);

          date = this.dateTime.format("YYYY-MM-DD");
        }
      }

      this.date = date;
      this.$emit("input", date);
      this.dateFormatted = this.dateTime.format("DD/MM/YYYY");
    },
    syncDateFormatted: function syncDateFormatted() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "" + this.date;

      this.dateTime = this.moment(value);

      this.dateFormatted = this.dateTime.isValid() ? this.dateTime.format("DD/MM/YYYY") : "";

      this.updateValues(this.dateFormatted);
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_PDate__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PExportLCDPR',
  components: { PDate: __WEBPACK_IMPORTED_MODULE_0__shared_PDate__["a" /* default */] },
  data: function data() {
    return {
      // condominiosPessoa é preenchido no componente acima (Pessoa.vue)
      condominiosPessoa: [],
      dialogExportLCDPR: false,
      editedItem: { pessoa_id: '', nome: '', ind_sit_ini_per: 0, sit_especial: 0, dt_sit_esp: '', dt_ini: this.$auth.user().anobase.id_texto + '-01-01', dt_fin: this.$auth.user().anobase.id_texto + '-12-31', forma_apur: 1, ident_nom: '', ident_cpf_cnpj: '', ind_crc: '', email: '', fone: '', condominios_ids: [] }
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          });
        } else {
          _this.$store.commit('loader/change_dialog', true);
          _this.$http.post('export/lcdpr', _this.editedItem, { responseType: 'arraybuffer' }).then(function (res) {
            var blob = new Blob([res.data], { type: res.headers.get('content-type') });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'LCDPR-' + _this.editedItem['nome'] + '-' + (_this.$auth.user().anobase.id_texto + 1) + '-' + parseInt(_this.$auth.user().anobase.id_texto) + '.TXT';
            link.click();
            // Detecta arquivo de erros lendo o início do conteúdo (evita depender de header customizado/CORS)
            var inicio = new TextDecoder('utf-8').decode(new Uint8Array(res.data).slice(0, 60));
            if (inicio.indexOf('Ocorreu alguns erros') === 0) {
              var mensagemErro = 'Ocorreram erros ao gerar o LCDPR. Abra o arquivo baixado para visualizar os erros e corrigi-los.';
              _this.$store.commit('snackbar/change_values', {
                text: mensagemErro,
                color: 'error',
                dialog: true,
                timeout: 15000
              });
              window.alert(mensagemErro);
            }
            _this.$store.commit('loader/change_dialog', false);
          }, function () {
            return _this.$store.commit('loader/change_dialog', false);
          });
        }
      });
    },

    // confirm: function () {
    //   console.log('confirm')
    // },
    close: function close() {
      this.dialogExportLCDPR = false;
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_PMoney__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PExportCaixaGeral',
  components: { PMoney: __WEBPACK_IMPORTED_MODULE_0__shared_PMoney__["a" /* default */] },
  data: function data() {
    return {
      // condominiosPessoa é preenchido no componente acima (Pessoa.vue)
      condominiosPessoa: [],
      dialogExportCaixaGeral: false,
      editedItem: { pessoa_id: '', saldo_anterior: 0, condominios_ids: [] }
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      this.$store.commit('loader/change_dialog', true);
      this.$http.post('report/caixa_geral', this.editedItem, { responseType: 'arraybuffer' }).then(function (res) {
        // this.$http.get(`report/caixa_geral/${pessoa_id}`).then(res => {
        console.log('res,', res);
        var blob = new Blob([res.data], { type: res.headers.get('content-type') });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'caixa_geral-' + _this.editedItem['nome'] + '-' + (_this.$auth.user().anobase.id_texto + 1) + '-' + parseInt(_this.$auth.user().anobase.id_texto) + '.pdf';
        link.click();
        _this.$store.commit('loader/change_dialog', false);
      }, function () {
        return _this.$store.commit('loader/change_dialog', false);
      });
    },

    // confirm: function () {
    //   console.log('confirm')
    // },
    close: function close() {
      this.dialogExportCaixaGeral = false;
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PMoney",
  props: {
    name: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: 20
    },
    custom_precision: {
      type: Number,
      default: 2
    },
    custom_preffix: {
      type: String,
      default: "R$"
    },
    customSuffix: {
      type: String,
      default: ""
    },
    value: {
      default: 0
    },
    config: {
      type: Object,
      default: function _default() {
        return {
          decimal: ",",
          thousands: ".",
          prefix: this.custom_preffix ? this.custom_preffix + " " : "",
          suffix: this.customSuffix + "",
          precision: this.custom_precision,
          masked: false
        };
      }
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    v_validate: {
      type: String,
      default: ""
    },
    data_vv_as: {
      type: String
    }
  },
  data: function data() {
    return {
      teste: true,
      valueM: 0
    };
  },
  methods: {
    blurValue: function blurValue(val) {
      // Emitir o blur para pegar a validação
      this.$refs["moneyValidate"].$emit("blur");
    },
    sendValue: function sendValue(val) {
      this.valueM = parseFloat(val);
      // Converte o valor que vem com mascara, para um valor float
      this.$emit("input", this.valueM);
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_PMoney__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PRelatorioConferencia',
  components: { PMoney: __WEBPACK_IMPORTED_MODULE_0__shared_PMoney__["a" /* default */] },
  data: function data() {
    return {
      // condominiosPessoa é preenchido no componente acima (Pessoa.vue)
      condominiosPessoa: [],
      dialogRelatorioConferencia: false,
      editedItem: { pessoa_id: '', anobase_id: '', condominios_ids: [] }
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      this.$store.commit('loader/change_dialog', true);
      this.$http.post('report/conferencia', this.editedItem, { responseType: 'arraybuffer' }).then(function (res) {
        var blob = new Blob([res.data], { type: res.headers.get('content-type') });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var anobaseSelecionada = _this.$auth.user().anosbases.find(function (a) {
          return a.id === _this.editedItem.anobase_id;
        });
        var anoCalendario = parseInt(anobaseSelecionada.id_texto);
        link.download = 'conferencia-' + _this.editedItem['nome'] + '-' + (anoCalendario + 1) + '-' + anoCalendario + '.pdf';
        link.click();
        _this.$store.commit('loader/change_dialog', false);
      }, function () {
        return _this.$store.commit('loader/change_dialog', false);
      });
    },

    // confirm: function () {
    //   console.log('confirm')
    // },
    close: function close() {
      this.dialogRelatorioConferencia = false;
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PCpfCnpj",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    v_validate: {
      type: String,
      default: ""
    },
    data_vv_as: {
      type: String
    }
  },
  data: function data() {
    return {
      cpfcnpj_validate: "",
      complemento: ""
    };
  },

  methods: {
    sendValue: function sendValue(value) {
      this.cpfcnpj_validate = value && value.length > 11 ? "validCnpj|" + this.v_validate : "validCpf|" + this.v_validate;
      this.$emit("input", value);
    }
  },
  computed: {
    cpfcnpj_label: function cpfcnpj_label() {
      this.complemento = this.label ? " " + this.label : "";
      return this.value && this.value.length > 11 ? "CNPJ" + this.complemento : "CPF" + this.complemento;
    },
    cpfcnpj_mask: function cpfcnpj_mask() {
      return this.value && this.value.length > 11 ? "##.###.###/####-##" : "###.###.###-###";
    }
  }
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_acl__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixin_acl__["a" /* default */]],
  components: {},
  data: function data() {
    return {
      entity: "users",
      tab: null,
      fab: null,
      acessos: [],
      acessos_internos: [],
      usuario_acesso: []
    };
  },
  created: function created() {
    this.initialize();
    this.editedItem = { ativo: true };
    this.defaultItem = { ativo: true };
    this.usuario_acesso = this.translate("value.usuario_acesso");
    if (this.$auth.user().acesso_interno !== "dev") {
      this.usuario_acesso.pop();
    }
  },

  computed: {
    headers: function headers() {
      return [{ text: this.translate("table." + this.entity + ".field.name"), value: "name" }, { text: this.translate("table." + this.entity + ".field.email"), value: "email" }, { text: this.translate("table." + this.entity + ".field.acesso_id"), value: "acesso_id" }, {
        text: this.translate("table." + this.entity + ".field.acesso_interno"),
        value: "acesso_id",
        align: "center"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
  },
  methods: {
    afterInitialize: function afterInitialize() {
      this.acessos = this.resBody.acessos;
      this.acessos_internos = [{ id: "admin", id_texto: "Administrador" }, { id: "user", id_texto: "Usuário Comun" }];
      if (this.$auth.user().acesso_interno === "dev") {
        this.acessos_internos.push({ id: "dev", id_texto: "Desenvolvedor" });
      }
      console.log(this.acessos_internos);
    },
    afterSave: function afterSave() {
      if (this.$auth.user().acesso && this.$auth.user().id === this.editedItem.id) {
        window.location.reload(false);
      }
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_core_css__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_snow_css__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_bubble_css__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_bubble_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      fab: null,
      entity: "suporte",
      editorOption: {
        // Algumas opções de configuração
      }
    };
  },
  methods: {
    getRGBColor: function getRGBColor(value) {
      var startColor = [251, 221, 221]; // RGB de #fbdddd
      var endColor = [253, 117, 117]; // RGB de #fd7575
      var diffColor = endColor.map(function (end, index) {
        return end - startColor[index];
      });
      var increment = diffColor.map(function (diff) {
        return diff / 9;
      });
      var color = startColor.map(function (start, index) {
        return Math.round(start + increment[index] * value);
      });
      return "rgb(" + color[0] + ", " + color[1] + ", " + color[2] + ")";
    },
    uploadFiles: function uploadFiles(index) {
      var fieldName = "file" + index;
      var formData = new FormData();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$refs[fieldName].files).forEach(function (file) {
        formData.append("files[]", file);
      });

      this.$http.post("api/upload_suporte", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (response) {
        console.log(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    this.initialize();
    this.editedItem = { empresa_id: this.$auth.user().empresa_id, user_id: this.$auth.user().id };
    this.defaultItem = { empresa_id: this.$auth.user().empresa_id, user_id: this.$auth.user().id };
  },

  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.id"),
        value: "id",
        width: "5%",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.titulo"),
        value: "titulo",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.descricao"),
        value: "descricao",
        width: "25%"
      }, {
        text: this.translate("table." + this.entity + ".field.status"),
        value: "status",
        width: "10%",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.tipo"),
        value: "tipo",
        width: "10%",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.urgencia"),
        value: "urgencia",
        width: "5%",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.user_id"),
        value: "user_id",
        width: "10%"
      },
      // { text: this.translate("table." + this.entity + ".field.imagem1"), value: "imagem1" },
      // { text: this.translate("table." + this.entity + ".field.imagem2"), value: "imagem2" },
      // { text: this.translate("table." + this.entity + ".field.imagem3"), value: "imagem3" },
      // { text: this.translate("table." + this.entity + ".field.imagem4"), value: "imagem4" },
      // { text: this.translate("table." + this.entity + ".field.imagem5"), value: "imagem5" },
      {
        text: this.translate("table." + this.entity + ".field.created_at"),
        value: "created_at",
        width: "10%",
        align: "center"
      }, {
        text: this.translate("system.table.action"),
        sortable: false,
        align: "center",
        width: "10%"
      }];
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(75);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase */




// Sempre que adicionar um novo filho nos condomínios, adicionar respectivamenteseu entity neste array
var condominio_filhos = ["condominio_pessoa", "condominio_transacao", "condominio_bemdireito", "condominio_bemdireitorural", "condominio_dividaonus", "condominio_dividaonusrural", "condominio_rendimentorecebidopj", "condominio_rendimentoisento", "condominio_rendimentotributacao", "condominio_rendimentoacumuladamente", "condominio_pagamento", "condominio_imovelexplorado", "condominio_movimentacaofinanceira", "condominio_movimentacaorebanho", "condominio_users", "condominio_controlecaixa"];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "acesso",
      tab: null,
      fab: null,
      permissoes: [],
      permissoes_padroes: {}
    };
  },
  created: function created() {
    var _this = this;

    this.editedItem = { empresa_id: this.$auth.user().empresa_id };
    this.defaultItem = { empresa_id: this.$auth.user().empresa_id };

    this.permissoes_padroes.sistema = __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].options.routes[1].children.map(function (item) {
      return {
        id_texto: item.meta.title,
        key: item.path.substr(1),
        read: false,
        create: false,
        update: false,
        delete: false,
        enabled: false,
        import: false,
        export: false
      };
    });
    this.permissoes_padroes.condominio = condominio_filhos.map(function (id_texto) {
      return {
        id_texto: _this.translate("table." + id_texto + ".title")[0],
        key: id_texto,
        read: false,
        create: false,
        update: false,
        delete: false,
        enabled: false,
        import: false,
        export: false
      };
    });

    this.initialize();
  },

  methods: {
    add: function add() {
      var tipo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "sistema";

      this.editedItem.tipo = tipo;
      this.permissoes = this.permissoes_padroes[tipo];

      this.permissoes = this.permissoes.map(function (item) {
        return {
          id_texto: item.id_texto,
          key: item.key,
          read: false,
          create: false,
          update: false,
          delete: false
        };
      });

      this.create();
    },
    edit: function edit() {
      var tipo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "sistema";
      var item = arguments[1];

      var permissoes = JSON.parse(item.permissoes);
      var permissoes_padroes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.permissoes_padroes[tipo]));

      this.permissoes = this.$root.merge(permissoes_padroes, permissoes, "id_texto");

      this.editItem(item);
    },
    beforeSave: function beforeSave() {
      this.editedItem.permissoes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.permissoes);
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto"
      }, {
        text: this.translate("table." + this.entity + ".field.descricao"),
        value: "descricao"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    permissions_sistema_headers: function permissions_sistema_headers() {
      var array = [{
        text: "Tela",
        value: "name",
        align: "center"
      }, {
        text: "Consultar",
        value: "read",
        align: "center"
      }, {
        text: "Incluir",
        value: "create",
        align: "center"
      }, {
        text: "Editar",
        value: "update",
        align: "center"
      }, {
        text: "Excluir",
        value: "delete",
        align: "center"
      }, {
        text: "Ativar",
        value: "enabled",
        align: "center"
      }, {
        text: "Emitir DBK",
        value: "dbk",
        align: "center"
      }];

      return array;
    },
    permissions_condominio_headers: function permissions_condominio_headers() {
      var array = [{
        text: "Tela",
        value: "name",
        align: "center"
      }, {
        text: "Consultar",
        value: "read",
        align: "center"
      }, {
        text: "Incluir",
        value: "create",
        align: "center"
      }, {
        text: "Editar",
        value: "update",
        align: "center"
      }, {
        text: "Excluir",
        value: "delete",
        align: "center"
      }];

      return array;
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__details_Pessoa__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__details_BemDireito__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__details_BemDireitoRural__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__details_DividaOnus__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__details_DividaOnusRural__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__details_ImovelExplorado__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__details_Pagamento__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__details_RendimentoIsento__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__details_RendimentoTributacao__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__details_RendimentoRecebidoPj__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__details_MovimentacaoFinanceira__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__details_MovimentacaoRebanho__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__details_Transacao__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__details_Usuario__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__details_ControleCaixa__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__details_RendimentoAcumuladamente__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_PCpfCnpj__ = __webpack_require__(10);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixin_acl__["a" /* default */]],
  components: {
    Pessoa: __WEBPACK_IMPORTED_MODULE_5__details_Pessoa__["a" /* default */],
    BemDireito: __WEBPACK_IMPORTED_MODULE_6__details_BemDireito__["a" /* default */],
    BemDireitoRural: __WEBPACK_IMPORTED_MODULE_7__details_BemDireitoRural__["a" /* default */],
    DividaOnus: __WEBPACK_IMPORTED_MODULE_8__details_DividaOnus__["a" /* default */],
    DividaOnusRural: __WEBPACK_IMPORTED_MODULE_9__details_DividaOnusRural__["a" /* default */],
    ImovelExplorado: __WEBPACK_IMPORTED_MODULE_10__details_ImovelExplorado__["a" /* default */],
    Pagamento: __WEBPACK_IMPORTED_MODULE_11__details_Pagamento__["a" /* default */],
    RendimentoIsento: __WEBPACK_IMPORTED_MODULE_12__details_RendimentoIsento__["a" /* default */],
    RendimentoTributacao: __WEBPACK_IMPORTED_MODULE_13__details_RendimentoTributacao__["a" /* default */],
    RendimentoRecebidoPj: __WEBPACK_IMPORTED_MODULE_14__details_RendimentoRecebidoPj__["a" /* default */],
    MovimentacaoFinanceira: __WEBPACK_IMPORTED_MODULE_15__details_MovimentacaoFinanceira__["a" /* default */],
    MovimentacaoRebanho: __WEBPACK_IMPORTED_MODULE_16__details_MovimentacaoRebanho__["a" /* default */],
    Transacao: __WEBPACK_IMPORTED_MODULE_17__details_Transacao__["a" /* default */],
    Usuario: __WEBPACK_IMPORTED_MODULE_18__details_Usuario__["a" /* default */],
    ControleCaixa: __WEBPACK_IMPORTED_MODULE_19__details_ControleCaixa__["a" /* default */],
    RendimentoAcumuladamente: __WEBPACK_IMPORTED_MODULE_20__details_RendimentoAcumuladamente__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_21__shared_PCpfCnpj__["a" /* default */]
  },
  data: function data() {
    return {
      entity: "condominio",
      tab: null,
      fab: null,
      particular: false,
      pagination: { rowsPerPage: 25, sortBy: "id_texto", descending: false },
      page: 1,
      setKeyup: null,
      acessos: [],
      cidades: [],
      conexoes: [],
      paises: [],
      pessoas: [],
      users: [],
      cities: [],
      permissoes: [],
      dependente_items: [],
      finished: true,
      showDialog: false,
      report: {
        selectedItem: null,
        type: null,
        sendEmail: 0
      },
      api: "https://app.api.conttech.com.br/",
      dialog_dbk: false,
      dialog_log: false,

      log_file: "",
      dbk_file: ""
    };
  },
  created: function created() {
    this.editedItem.condominio_transacao = 0;
    this.editedItem = { user_id: this.$auth.user().user_id, cpf: "", ativo: true };
    this.defaultItem = { user_id: this.$auth.user().user_id, cpf: "", ativo: true };
    // this.pagination['rowsPerPage'] = 25
    // this.pagination['sortBy'] = 'id_texto'
    this.initialize();
    this.getComplementValues();
  },
  methods: {
    openDialogDBK: function openDialogDBK(item, event) {
      var _this = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.get("export/dbk", {
        params: {
          condominio_id: item.id,
          is_contribuinte: true
        }
      }).then(function (res) {
        _this.$store.commit("loader/change_dialog", false);
        _this.log_file = res.body.log_file;
        _this.dbk_file = res.body.dbk_file;
        if (_this.log_file) _this.dialog_dbk = true;else _this.downloadDBK();
      }).catch(function (error) {
        // console.log(error);
        _this.$store.commit("loader/change_dialog", false);
        _this.$store.commit("snackbar/change_values", {
          text: error.body.message,
          color: "error",
          dialog: true
        });
      });
    },
    openDialogLog: function openDialogLog(item, event) {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.get("export/dbk", {
        params: {
          condominio_id: item.id,
          is_contribuinte: false
        }
      }).then(function (res) {
        _this2.$store.commit("loader/change_dialog", false);
        _this2.log_file = res.body.log_file;
        _this2.dialog_log = true;
      }).catch(function (error) {
        // console.log(error);
        _this2.$store.commit("loader/change_dialog", false);
        _this2.$store.commit("snackbar/change_values", {
          text: error.body.message,
          color: "error",
          dialog: true
        });
      });
    },
    viewLOG: function viewLOG() {
      window.open("https://app.api.conttech.com.br/" + ("validacoes/" + this.log_file), "_blank");
      this.dialog = false;
    },
    downloadDBK: function downloadDBK() {
      window.open("https://app.api.conttech.com.br/" + ("dbks/" + this.dbk_file), "_blank");
      this.dialog = false;
    },
    initialize: function initialize() {
      var _this3 = this;

      this.beforeInitialize();
      this.$store.commit("loader/change_dialog", true);
      var params = {
        search: this.search,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "id_texto",
        particular: this.particular ? this.particular : 0
      };
      this.$http.post("api/paginate_condominio", params).then(function (res) {
        _this3.items = res.body.data;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this3.pagination, {
          total: res.body.total,
          rowsPerPage: res.body.per_page,
          current_page: res.body.current_page,
          last_page: res.body.last_page,
          from: res.body.from,
          to: res.body.to
        });
        _this3.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this3.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os dados.",
          color: "error",
          dialog: true
        });
        _this3.$store.commit("loader/change_dialog", false);
      });
    },
    beforeInitialize: function beforeInitialize() {
      var _this4 = this;

      this.particular = this.$route.path === "/contribuinte";

      if (this.particular) {
        this.entity = "contribuinte";

        if (this.$route.params.pessoa) {
          this.finished = false;
          this.$store.commit("loader/change_dialog", true);
          var id = this.$route.params.pessoa.id;


          this.editedItem.pessoa_id = id;
          this.editedItem.particular = true;

          this.$http.post("api/" + this.entity, this.editedItem).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this4.editedItem, JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.body.dados)));

            _this4.getDependentes(_this4.editedItem.pessoa_id);

            _this4.$auth.user().acessos_condominios.push(res.body.acesso_condominio);

            _this4.$store.commit("loader/change_dialog", false);

            _this4.view = 3;
            _this4.dialog = true;

            _this4.finished = true;
          }, function () {
            return _this4.$store.commit("loader/change_dialog", false);
          });
        }
      }
    },
    keyupSearch: function keyupSearch() {
      var _this5 = this;

      // caso o usuario fique 1 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      this.setKeyup = setTimeout(function () {
        _this5.initialize();
      }, 1000);
    },
    changePage: function changePage() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.pagination["current_page"] = page;
      this.initialize();
    },
    update_values: function update_values(route) {
      var _this6 = this;

      var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : route;
      var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      this.$store.commit("loader/change_dialog", true);

      this.$http.get("api/" + route + filter).then(function (res) {
        _this6.editedItem[array] = res.body.dados;
        _this6.$store.commit("loader/change_dialog", false);
      });
    },
    getDependentes: function getDependentes(pessoa_id) {
      var _this7 = this;

      // Antes de editar verifica se é contribuinte para já buscar os dependentes que são usados nas abas
      if (this.entity === "contribuinte") {
        this.$http.get("api/pessoa_dependente?where=pessoa_id=" + pessoa_id).then(function (res) {
          _this7.dependente_items = res.body.dados;
          _this7.$store.commit("loader/change_dialog", false);
        }, function (err) {
          _this7.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar os dependentes.",
            color: "error",
            dialog: true
          });
          _this7.$store.commit("loader/change_dialog", false);
        });
      }
    },
    editItemProcess: function editItemProcess(item_id) {
      var _this8 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.get("api/condominio/" + item_id).then(function (res) {
        _this8.editItem(res.body);
        _this8.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this8.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os dados.",
          color: "error",
          dialog: true
        });
        _this8.$store.commit("loader/change_dialog", false);
      });
    },
    beforeEdit: function beforeEdit(item) {
      this.getDependentes(item["pessoa_id"]);
    },
    getComplementValues: function getComplementValues() {
      var _this9 = this;

      this.$http.get("api/get_complement_values").then(function (res) {
        var resBody = res.body;
        // this.items = [...this.items, ...this.resBody.conexoes]
        _this9.pessoas = resBody["pessoas"];
        _this9.acessos = resBody["acessos"];
        _this9.cidades = resBody["cidades"];
        _this9.conexoes = resBody["conexoes"];
        _this9.full_pessoas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this9.pessoas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this9.conexoes));
        _this9.paises = resBody["paises"];
        _this9.users = resBody["users"];
        _this9.cidades.map(function (value) {
          value.id_texto = value.id_texto + " - " + value.uf;
        });
        _this9.editedIndex = _this9.items.findIndex(function (x) {
          return x.id === _this9.editedItem.id;
        }); // Necessário para atualizar o datatable após uma edição de contribuinte vinda da tela de pessoa
        _this9.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this9.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os valores complementares.",
          color: "error",
          dialog: true
        });
        _this9.$store.commit("loader/change_dialog", false);
      });
    },
    afterCreate: function afterCreate(res) {
      if (this.particular && res.body.acesso_condominio) {
        this.$auth.user().acessos_condominios.push(res.body.acesso_condominio);
      }
    },
    handleClick: function handleClick(selectedItem, type) {
      this.report.selectedItem = selectedItem;
      this.report.type = type;
      this.showDialog = true;
    },
    downloadItem: function downloadItem() {
      var _this10 = this;

      if (!this.report.sendEmail) this.$store.commit("loader/change_dialog", true);else {
        this.showDialog = false;

        this.$store.commit("snackbar/change_values", {
          text: "O relatório solicitado está sendo gerado e será enviado para seu e-mail assim que finalizado.",
          color: "info",
          dialog: true,
          timeout: 5000
        });
      }

      this.$http.get("report/declaracao_ajuste/" + this.report.selectedItem.id + "/1/" + this.report.type + "/" + +this.particular + "/" + this.report.sendEmail).then(function (res) {
        var pdfname = res.data.pdfname;

        window.open("https://app.api.conttech.com.br/" + ("reports/" + pdfname), "_blank");

        _this10.$store.commit("loader/change_dialog", false);

        if (_this10.report.sendEmail && "Notification" in window) {
          Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
              var notification = new Notification("Renderização concluído", {
                body: "Seu relatório está pronto! Confira agora mesmo em seu e-mail.",
                icon: "/static/img/logo.png"
              });
            }
          });
        }

        _this10.report.sendEmail = 0;
      }, function (error) {
        _this10.$store.commit("loader/change_dialog", false);
        _this10.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    },
    resumoCaixa: function resumoCaixa(item) {
      var _this11 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.get("report/resumo_caixa/" + item.id).then(function (res) {
        console.log("res.data", res.data);
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this11.$store.commit("loader/change_dialog", false);
      }, function () {
        return _this11.$store.commit("loader/change_dialog", false);
      });
    },
    toggleAtivo: function toggleAtivo(item) {
      var _this12 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("api/" + this.entity + "/" + item.id, { ativo: item.ativo }).then(function (res) {
        _this12.$store.commit("loader/change_dialog", false);
        _this12.$store.commit("snackbar/change_values", {
          text: "Registro de " + _this12.translate("table." + _this12.entity + ".title")[0] + " editado com sucesso!",
          color: "success",
          dialog: true
        });
      }, function (err) {
        _this12.$store.commit("loader/change_dialog", false);
        _this12.$store.commit("snackbar/change_values", {
          text: "N\xE3o foi poss\xEDvel editar o registro de " + _this12.translate("table." + _this12.entity + ".title")[0] + ", reporte o erro.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  watch: {
    pagination: {
      handler: function handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },

      deep: true
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto"
      }, {
        text: this.translate("table." + this.entity + ".field.sigla"),
        value: "sigla"
      }, {
        text: this.translate("table." + this.entity + ".field.razao_social"),
        value: "razao_social"
      }, {
        text: this.translate("table." + this.entity + ".field.cpf"),
        value: "cpf"
      }, {
        text: this.translate("table." + this.entity + ".field.cidade_id"),
        value: "cidade.id_texto"
      }, {
        text: this.translate("table." + this.entity + ".field.endereco"),
        value: "endereco"
      }, {
        text: this.translate("table." + this.entity + ".field.pessoa_id"),
        value: "responsavel.id_texto"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        align: "center"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "210px"
      }];
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuadroSocietario__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_decimal_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_decimal_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_decimal_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_2__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__["a" /* default */],
    QuadroSocietario: __WEBPACK_IMPORTED_MODULE_5__QuadroSocietario__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_pessoa",
      full_pessoas: [],
      dynamicPessoas: [],
      items: [],
      itemsQuadro: [],
      pagination: {
        rowsPerPage: -1
      },
      dialogEmailVisible: false,
      report: {
        selectedItem: null,
        type: null,
        sendEmail: 0
      },
      api: "https://app.api.conttech.com.br/",
      apenasAtivos: true
    };
  },
  name: "Pessoa",
  props: ["condominio_id", "values", "quadro_societario", "pessoas", "conexoes"],
  created: function created() {
    this.items = this.values;
    this.full_pessoas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pessoas), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.conexoes));
    this.editedItem = {
      condominio_id: this.condominio_id,
      porcentagem_inicial: 0,
      ativo: true,
      data: ""
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      porcentagem_inicial: 0,
      ativo: true,
      data: ""
    };
    this.itensOriginais = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.items));
    this.filtrarItens();
  },

  methods: {
    filtrarItens: function filtrarItens() {
      if (this.apenasAtivos) {
        this.items = this.items.filter(function (item) {
          return item.ativo;
        });
      } else {
        this.items = this.itensOriginais;
      }
    },
    updateSocios: function updateSocios(socios) {
      this.items = socios;
    },
    openDialogQuadro: function openDialogQuadro() {
      this.dialogQuadroVisible = true;
    },
    closeDialogQuadro: function closeDialogQuadro() {
      this.dialogQuadroVisible = false;
    },
    handleDialogButtonClick: function handleDialogButtonClick() {
      // Lógica para lidar com o clique do botão no diálogo
    },
    handleDialogFooterButtonClick: function handleDialogFooterButtonClick() {
      // Lógica para lidar com o clique do botão no footer do diálogo
    },
    handleClick: function handleClick(selectedItem, type) {
      this.report.selectedItem = selectedItem;
      this.report.type = type;
      this.dialogEmailVisible = true;
    },
    refreshEmpresas: function refreshEmpresas(tela) {
      var _this2 = this;

      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var remove = void 0;
      switch (tela) {
        case 2:
          this.create();
          remove = this.items.map(function (a) {
            return a.pessoa_id;
          });
          break;
        case 3:
          {
            this.editItem(obj);
            remove = this.items.map(function (a) {
              if (a.pessoa_id !== _this2.editedItem.pessoa_id) {
                return a.pessoa_id;
              }
            });
            remove.push(this.$auth.user().pessoa_id);
            break;
          }
      }
      this.dynamicPessoas = this.full_pessoas.filter(function (item) {
        return !remove.includes(item.id);
      });
    },
    downloadItem: function downloadItem(item) {
      var _this3 = this;

      var bemdireito_completo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var event = arguments[2];

      if (!this.report.sendEmail) this.$store.commit("loader/change_dialog", true);else {
        this.dialogEmailVisible = false;

        this.$store.commit("snackbar/change_values", {
          text: "O relatório solicitado está sendo gerado e será enviado para seu e-mail assim que finalizado.",
          color: "info",
          dialog: true,
          timeout: 5000
        });
      }

      this.$http.get("report/declaracao_ajuste/" + this.report.selectedItem.id + "/0/" + this.report.type + "/0/" + this.report.sendEmail).then(function (res) {
        var pdfname = res.data.pdfname;


        window.open("https://app.api.conttech.com.br/" + "reports/" + pdfname, "_blank");

        _this3.$store.commit("loader/change_dialog", false);

        if (_this3.report.sendEmail && "Notification" in window) {
          Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
              var notification = new Notification("Renderização concluído", {
                body: "Seu relatório está pronto! Confira agora mesmo em seu e-mail.",
                icon: "/static/img/logo.png"
              });
            }
          });
        }

        _this3.report.sendEmail = 0;
      }, function (error) {
        _this3.$store.commit("loader/change_dialog", false);
        _this3.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    },

    // exportDbk (item, event) {
    //   this.$store.commit('loader/change_dialog', true)
    //   this.$http.get(`export/dbk/${item.id}/0`, {responseType: 'arraybuffer'}).then(res => {
    //     let blob = new Blob([res.data], {type: res.headers.get('content-type')})
    //     let link = document.createElement('a')
    //     link.href = window.URL.createObjectURL(blob)
    //     link.download = `${item.pessoa.cpf_cnpj.replace(/\D/g, '')}-IRPF-A-${this.$auth.user().anobase.id_texto + 1}-${parseInt(this.$auth.user().anobase.id_texto)}-ORIGI.DBK`
    //     link.click()
    //     this.$store.commit('loader/change_dialog', false)
    //   }, () => this.$store.commit('loader/change_dialog', false)
    //   )
    // }
    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this4 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_pessoa", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this4.$store.commit("loader/change_dialog", false);
        var _this = _this4;
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this4.$store.commit("loader/change_dialog", false);
        _this4.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.pessoa_id"),
        value: "pessoa.id_texto",
        width: "40%"
      }, {
        text: this.translate("table." + this.entity + ".field.porcentagem_inicial") + " " + this.$auth.user().anobase.id_texto + " %",
        value: "inicialporcentagem",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.porcentagem") + " " + this.$auth.user().anobase.id_texto + " %",
        value: "porcentagem",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.data"),
        value: "data",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        width: "5%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "15%"
      }];
    },
    headersQuadro: function headersQuadro() {
      return [{ text: "Data" }, { text: "Descrição" }];
    },
    somatorios: function somatorios() {
      return this.items.reduce(function (acc, item) {
        acc.inicialporcentagem = __WEBPACK_IMPORTED_MODULE_6_decimal_js___default()(acc.inicialporcentagem).plus(item.inicialporcentagem).toDP(15);
        acc.porcentagem = __WEBPACK_IMPORTED_MODULE_6_decimal_js___default()(acc.porcentagem).plus(item.porcentagem).toDP(15);
        return acc;
      }, { inicialporcentagem: 0, porcentagem: 0 });
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_decimal_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_decimal_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_decimal_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PDate: __WEBPACK_IMPORTED_MODULE_2__shared_PDate__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_quadrosocietario",
      dialogQuadroVisible: false
    };
  },
  name: "QuadroSocietario",
  props: ["condominio_id", "socios", "values"],
  created: function created() {
    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      data: "",
      id_texto: "",
      socios: []
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      data: "",
      id_texto: "",
      socios: []
    };
  },

  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.data"),
        value: "data",
        align: "center",
        width: "30%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "70%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "10%"
      }];
    },
    sub_headers: function sub_headers() {
      return [{
        text: "Sócio",
        value: "socio.pessoa.id_texto"
      }, {
        text: "Participação",
        value: "porcentagem",
        sortable: false,
        width: "20%"
      }];
    },
    somatorioPorcentagem: function somatorioPorcentagem() {
      var soma = this.editedItem.socios.reduce(function (total, socio) {
        return __WEBPACK_IMPORTED_MODULE_3_decimal_js___default()(total).plus(__WEBPACK_IMPORTED_MODULE_3_decimal_js___default()(socio.porcentagem));
      }, __WEBPACK_IMPORTED_MODULE_3_decimal_js___default()(0));

      soma = __WEBPACK_IMPORTED_MODULE_3_decimal_js___default()(soma.toFixed(15));

      return soma.toString();
    }
  },
  methods: {
    beforeCreate: function beforeCreate() {
      this.editedItem.socios = this.socios.map(function (item) {
        return {
          porcentagem: item.inicialporcentagem,
          condominio_pessoa_id: item.id,
          socio: {
            pessoa: item.pessoa
          }
        };
      });
    },
    beforeSave: function beforeSave() {
      if (this.somatorioPorcentagem != 100) {
        alert("O somatório da porcentagem deve ser igual a 100.");
        return false;
      }
    },
    afterSave: function afterSave() {
      this.$emit("updateSocios");
    },
    closeDialog: function closeDialog() {
      this.dialogQuadroVisible = false;
      this.close();
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_PCpfCnpj__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_mask__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixin_acl__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_2__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_5__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_3__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixin_mask__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      entity: "condominio_bemdireito",
      subItemTipos: [{ id: "pagamento", id_texto: "Pagamento/Acréscimo" }, { id: "liberacao", id_texto: "Alienação/Redução" }],
      items: [],
      temDependente: [],
      pagination: { rowsPerPage: 25, sortBy: "", descending: false },
      page: 1,
      setKeyup: null,
      total_situacao_anobase: 0,
      total_situacao_anoanterior: 0,
      limitarCaracteres: true,
      maxCaracteres: 0,
      sequencia_ir_duplicated: false,
      apenasAtivos: true
    };
  },
  name: "BemDireito",
  props: ["condominio_id", "paises", "cidades", "initials", "dependente_items", "particular", "item"],
  created: function created() {
    var anobaseId = this.$auth.user().anobase.id;

    this.initialize();

    this.editedItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      unidade: "m2",
      grupo: null,
      codigo: null,
      anobase_id: anobaseId,
      cpf_cnpj: "",
      cpf_cnpj_fornecedor: "",
      cpf_cnpj_adquirente: "",
      valor_adquirente: "0",
      valor_fornecedor: "0",
      pais_id: 105,
      sub_items: [],
      pessoa_dependente_id: null,
      motivo_baixa: null,
      id_texto: "",
      area_imovel: 0
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      unidade: "m2",
      grupo: null,
      codigo: null,
      anobase_id: anobaseId,
      cpf_cnpj: "",
      cpf_cnpj_fornecedor: "",
      cpf_cnpj_adquirente: "",
      valor_adquirente: "0",
      valor_fornecedor: "0",
      pais_id: 105,
      sub_items: [],
      pessoa_dependente_id: null,
      motivo_baixa: null,
      id_texto: "",
      area_imovel: 0
    };
  },

  methods: {
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    verificarValoresNegativos: function verificarValoresNegativos() {
      // Use some para verificar se pelo menos um item tem valor negativo
      var hasNegativeValue = this.editedItem.sub_items.some(function (subItem) {
        return subItem.valor < 0;
      });

      // Se tiver algum valor negativo, mostre uma mensagem de erro
      if (hasNegativeValue || this.editedItem.situacao_anobase < 0) {
        this.$store.commit("snackbar/change_values", {
          text: "Por favor, verifique os valores inseridos. Não é permitido informar valores negativos",
          color: "error",
          dialog: true,
          timeout: 5000
        });
        return false;
      }

      // Se não houver nenhum valor negativo, retorne true
      return true;
    },
    removeMask: function removeMask() {
      // Remove a máscara ao perder o foco
      if (this.item.valor) {
        this.item.valor = this.item.valor.replace(/\D/g, "");
      }
    },

    // The method below returns true if the edited item's text length is greater than the max number of characters.
    afterSave: function afterSave() {
      this.initialize();
    },
    afterDelete: function afterDelete() {
      this.initialize();
    },
    beforeSave: function beforeSave() {
      // Defina editedItem.motivo_baixa como null se for undefined
      if (typeof this.editedItem.motivo_baixa === "undefined") {
        this.editedItem.motivo_baixa = null;
      }

      // Verifique se há valores negativos
      if (!this.verificarValoresNegativos()) {
        this.$store.commit("loader/change_dialog", false);
        throw new Error("Não é possível salvar devido a valores negativos.");
      }
    },
    initialize: function initialize() {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      var params = {
        search: this.search,
        apenasAtivos: this.apenasAtivos,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "sequencia_ir",
        condominio_id: this.condominio_id ? this.condominio_id : 0
      };
      this.$http.post("api/paginate_bemdireito", params).then(function (res) {
        _this2.total_situacao_anoanterior = res.body.total_situacao_anoanterior;
        _this2.total_situacao_anobase = res.body.total_situacao_anobase;
        var resbody = res.body.dados;
        _this2.items = resbody.data;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.pagination, {
          total: resbody.total,
          rowsPerPage: resbody.per_page,
          current_page: resbody.current_page,
          last_page: resbody.last_page,
          from: resbody.from,
          to: resbody.to
        });
        _this2.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this2.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os dados.",
          color: "error",
          dialog: true
        });
        _this2.$store.commit("loader/change_dialog", false);
      });
    },
    keyupSearch: function keyupSearch(key) {
      var _this3 = this;

      // caso o usuario fique 2 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      if (key["key"] === "Enter") {
        this.initialize();
      } else {
        this.setKeyup = setTimeout(function () {
          _this3.initialize();
        }, 2000);
      }
    },
    changePage: function changePage() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.pagination["current_page"] = page;
      this.initialize();
    },
    beforeCreate: function beforeCreate() {
      var _this4 = this;

      this.$http.post("api/get_max_sequence_bemdireito/" + this.condominio_id).then(function (res) {
        var maxSequence = res.body;
        maxSequence = __WEBPACK_IMPORTED_MODULE_6__classes_helper__["a" /* default */].pad(++maxSequence, 5);
        _this4.editedItem.sequencia_ir = (_this4.initials ? _this4.initials + "-" : "") + "BD-" + maxSequence;
      }, function (err) {
        _this4.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar a sequencia.",
          color: "error",
          dialog: true
        });
      });

      this.$validator.reset();
    },
    afterEdit: function afterEdit() {
      this.limitarCaracteres = this.editedItem.id_texto.length <= 150;
      if (typeof this.editedItem.situacao_atual[0] !== "undefined" && this.editedItem.situacao_atual[0] !== null) this.editedItem.sub_items = this.editedItem.situacao_atual[0].distribuicoes;
    },
    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    processSituacao: function processSituacao() {
      var _sum = this.sum,
          liberacao = _sum.liberacao,
          pagamento = _sum.pagamento;

      this.editedItem.situacao_anobase = this.editedItem.situacao_anoanterior - liberacao + pagamento;
    },
    getGrupoText: function getGrupoText(value) {
      var item = this.translate('value.bem_direito_grupo').find(function (g) {
        return g.value === value;
      });
      return item ? item.text : '';
    },
    getCodigoText: function getCodigoText(grupo, codigo) {
      var item = this.translate('value.bem_direito_codigo').find(function (c) {
        return c.grupo === grupo && c.value === codigo;
      });
      return item ? item.text : '';
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this5 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_bemdireito", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this5.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this5.$store.commit("loader/change_dialog", false);
        _this5.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  computed: {
    formattedValue: {
      get: function get() {
        // Retorna o valor formatado com a máscara
        return this.item.valor;
      },
      set: function set(value) {
        // Remove a máscara e atualiza o valor no estado do Vue.js
        this.item.valor = value.replace(/\D/g, "");
      }
    },
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.sequencia_ir"),
        value: "sequencia_ir",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "40%"
      }, {
        text: this.translate("table." + this.entity + ".field.grupo"),
        value: "grupo",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.codigo"),
        value: "codigo",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anoanterior") + (this.$auth.user().anobase.id_texto - 1),
        value: "situacao_anoanterior",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anobase") + this.$auth.user().anobase.id_texto,
        value: "situacao_anobase",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        width: "5%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.tipo"),
        sortable: false,
        value: "tipo"
      }, {
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor"),
        sortable: false,
        value: "valor"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sum: function sum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc[cur.tipo] += cur.valor;
        return acc;
      }, { pagamento: 0, liberacao: 0 });
    }
  },
  watch: {
    pagination: {
      handler: function handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_mask__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_PCpfCnpj__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_2__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_7__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixin_mask__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_bemdireitorural",
      subItemTipos: [{ id: "pagamento", id_texto: "Pagamento/Acréscimo" }, { id: "liberacao", id_texto: "Alienação/Redução" }],
      items: [],
      pagination: { rowsPerPage: 25, sortBy: "", descending: false },
      page: 1,
      setKeyup: null,
      total_situacao_anobase: 0,
      total_situacao_anoanterior: 0,
      limitarCaracteres: true,
      sequencia_ir_duplicated: false,
      apenasAtivos: true
    };
  },
  name: "BemDireitoRural",
  props: ["condominio_id", "initials", "cidades", "paises"],
  created: function created() {
    this.initialize();
    var anobaseId = this.$auth.user().anobase.id;
    this.editedItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      cpf_cnpj_fornecedor: "",
      cpf_cnpj_adquirente: "",
      pais_id: 105,
      sub_items: []
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      cpf_cnpj_fornecedor: "",
      cpf_cnpj_adquirente: "",
      pais_id: 105,
      sub_items: []
    };
  },

  methods: {
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    verificarValoresNegativos: function verificarValoresNegativos() {
      // Use some para verificar se pelo menos um item tem valor negativo
      var hasNegativeValue = this.editedItem.sub_items.some(function (subItem) {
        return subItem.valor < 0;
      });

      // Se tiver algum valor negativo, mostre uma mensagem de erro
      if (hasNegativeValue || this.editedItem.situacao_anobase < 0) {
        this.$store.commit("snackbar/change_values", {
          text: "Por favor, verifique os valores inseridos. Não é permitido informar valores negativos",
          color: "error",
          dialog: true,
          timeout: 5000
        });
        return false;
      }

      // Se não houver nenhum valor negativo, retorne true
      return true;
    },
    afterSave: function afterSave() {
      this.initialize();
    },
    afterDelete: function afterDelete() {
      this.initialize();
    },
    beforeSave: function beforeSave() {
      // Defina editedItem.motivo_baixa como null se for undefined
      if (typeof this.editedItem.motivo_baixa === "undefined") {
        this.editedItem.motivo_baixa = null;
      }

      // Verifique se há valores negativos
      if (!this.verificarValoresNegativos()) {
        this.$store.commit("loader/change_dialog", false);
        throw new Error("Não é possível salvar devido a valores negativos.");
      }
    },
    initialize: function initialize() {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      var params = {
        search: this.search,
        apenasAtivos: this.apenasAtivos,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "sequencia_ir",
        condominio_id: this.condominio_id ? this.condominio_id : 0
      };
      this.$http.post("api/paginate_bemdireitorural", params).then(function (res) {
        _this2.total_situacao_anoanterior = res.body.total_situacao_anoanterior;
        _this2.total_situacao_anobase = res.body.total_situacao_anobase;

        var resbody = res.body.dados;

        _this2.items = resbody.data;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.pagination, {
          total: resbody.total,
          rowsPerPage: resbody.per_page,
          current_page: resbody.current_page,
          last_page: resbody.last_page,
          from: resbody.from,
          to: resbody.to
        });
        _this2.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this2.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os dados.",
          color: "error",
          dialog: true
        });
        _this2.$store.commit("loader/change_dialog", false);
      });
    },
    keyupSearch: function keyupSearch(key) {
      var _this3 = this;

      // caso o usuario fique 2 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      if (key["key"] === "Enter") {
        this.initialize();
      } else {
        this.setKeyup = setTimeout(function () {
          _this3.initialize();
        }, 2000);
      }
    },
    changePage: function changePage() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.pagination["current_page"] = page;
      this.initialize();
    },
    afterInitialize: function afterInitialize() {
      this.paises = this.resBody.paises;
    },
    afterEdit: function afterEdit() {
      this.limitarCaracteres = this.editedItem.id_texto.length <= 150;
      if (typeof this.editedItem.situacao_atual[0] !== "undefined" && this.editedItem.situacao_atual[0] !== null) this.editedItem.sub_items = this.editedItem.situacao_atual[0].distribuicoes;
    },
    beforeCreate: function beforeCreate() {
      var _this4 = this;

      this.limitarCaracteres = true;
      this.$http.post("api/get_max_sequence_bemdireitorural/" + this.condominio_id).then(function (res) {
        var maxSequence = res.body;
        maxSequence = __WEBPACK_IMPORTED_MODULE_5__classes_helper__["a" /* default */].pad(++maxSequence, 5);
        _this4.editedItem.sequencia_ir = (_this4.initials ? _this4.initials + "-" : "") + "BR-" + maxSequence;
      }, function (err) {
        _this4.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar a sequencia.",
          color: "error",
          dialog: true
        });
      });
    },
    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    processSituacao: function processSituacao() {
      var _sum = this.sum,
          liberacao = _sum.liberacao,
          pagamento = _sum.pagamento;

      this.editedItem.situacao_anobase = this.editedItem.situacao_anoanterior - liberacao + pagamento;
    },
    getCodigoText: function getCodigoText(codigo) {
      var item = this.translate('value.bem_direito_rural_codigo').find(function (c) {
        return c.value === codigo;
      });
      return item ? item.text : '';
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this5 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_bemdireitorural", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this5.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this5.$store.commit("loader/change_dialog", false);
        _this5.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.sequencia_ir"),
        value: "sequencia_ir",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "50%"
      }, {
        text: this.translate("table." + this.entity + ".field.codigo"),
        value: "codigo",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anoanterior") + (this.$auth.user().anobase.id_texto - 1),
        value: "situacao_anoanterior",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anobase") + this.$auth.user().anobase.id_texto,
        value: "situacao_anobase",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        width: "5%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "10%"
      }];
    },
    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.tipo"),
        sortable: false,
        value: "tipo"
      }, {
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor"),
        sortable: false,
        value: "valor"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sum: function sum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc[cur.tipo] += cur.valor;
        return acc;
      }, { pagamento: 0, liberacao: 0 });
    },

    maskk: function maskk() {
      return this.editedItem.cpf_cnpj_fornecedor && this.editedItem.cpf_cnpj_fornecedor.length > 11 ? "##.###.###/####-##" : "###.###.###-###";
    }
  },
  watch: {
    pagination: {
      handler: function handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_mask__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_PCpfCnpj__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PDate: __WEBPACK_IMPORTED_MODULE_4__shared_PDate__["a" /* default */], PMoney: __WEBPACK_IMPORTED_MODULE_5__shared_PMoney__["a" /* default */], PCpfCnpj: __WEBPACK_IMPORTED_MODULE_8__shared_PCpfCnpj__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixin_mask__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_dividaonus",
      subItemTipos: [{ id: "pagamento", id_texto: "Pagamento/Redução" }, { id: "liberacao", id_texto: "Liberação/Acréscimo" }],
      items: [],
      pagination: { rowsPerPage: 25, sortBy: "", descending: false },
      page: 1,
      setKeyup: null,
      total_situacao_anobase: 0,
      total_situacao_anoanterior: 0,
      sequencia_ir_duplicated: false,
      responsaveis_abreviado: [],
      limitarCaracteres: true,
      apenasAtivos: true
    };
  },
  name: "DividaOnus",
  props: ["condominio_id", "initials", "responsaveis", "particular"],
  created: function created() {
    this.responsaveis_abreviado = this.responsaveis.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
        rosquinha: item.pessoa.nome_abreviado || item.pessoa.id_texto
      });
    });

    console.log(this.responsaveis_abreviado);

    this.initialize();
    var anobaseId = this.$auth.user().anobase.id;
    this.editedItem = {
      condominio_id: this.condominio_id,
      id_texto: "",
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      situacao_anobase: 0,
      situacao_anoanterior: 0,
      valor_contrato: 0,
      valor_pago: 0,
      sub_items: [],
      cpf_cnpj: "",
      pessoa: {
        rosquinha: ""
      }
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      id_texto: "0",
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      situacao_anobase: 0,
      situacao_anoanterior: 0,
      valor_contrato: 0,
      valor_pago: 0,
      sub_items: [],
      cpf_cnpj: "",
      pessoa: {
        rosquinha: ""
      }
    };
  },

  methods: {
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    afterSave: function afterSave() {
      this.initialize();
    },
    afterDelete: function afterDelete() {
      this.initialize();
    },
    initialize: function initialize() {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      var params = {
        search: this.search,
        apenasAtivos: this.apenasAtivos,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "sequencia_ir",
        condominio_id: this.condominio_id ? this.condominio_id : 0
      };
      this.$http.post("api/paginate_dividaonus", params).then(function (res) {
        _this2.total_situacao_anoanterior = res.body.total_situacao_anoanterior;
        _this2.total_situacao_anobase = res.body.total_situacao_anobase;

        var resbody = res.body.dados;

        _this2.items = resbody.data;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.pagination, {
          total: resbody.total,
          rowsPerPage: resbody.per_page,
          current_page: resbody.current_page,
          last_page: resbody.last_page,
          from: resbody.from,
          to: resbody.to
        });
        _this2.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this2.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os dados.",
          color: "error",
          dialog: true
        });
        _this2.$store.commit("loader/change_dialog", false);
      });
    },
    keyupSearch: function keyupSearch(key) {
      var _this3 = this;

      // caso o usuario fique 2 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      if (key["key"] === "Enter") {
        this.initialize();
      } else {
        this.setKeyup = setTimeout(function () {
          _this3.initialize();
        }, 2000);
      }
    },
    changePage: function changePage() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.pagination["current_page"] = page;
      this.initialize();
    },
    afterEdit: function afterEdit() {
      this.limitarCaracteres = this.editedItem.id_texto.length <= 63;
      this.editedItem.sub_items = this.editedItem.situacao_atual[0].distribuicoes;
    },
    beforeCreate: function beforeCreate() {
      var _this4 = this;

      this.$http.post("api/get_max_sequence_dividaonus/" + this.condominio_id).then(function (res) {
        var maxSequence = res.body;
        maxSequence = __WEBPACK_IMPORTED_MODULE_6__classes_helper__["a" /* default */].pad(++maxSequence, 5);
        _this4.editedItem.sequencia_ir = (_this4.initials ? _this4.initials + "-" : "") + "DO-" + maxSequence;
      }, function (err) {
        _this4.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar a sequencia.",
          color: "error",
          dialog: true
        });
      });
    },
    beforeSave: function beforeSave() {
      this.editedItem.valor_pago = this.sum.pagamento;
      this.editedItem.valor_liberado = this.sum.liberacao;

      this.editedItem.sub_items = this.editedItem.sub_items.map(function (item) {
        item.valor_total = item.valor_base + item.juros;
        return item;
      });
    },

    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor_base: 0,
        juros: 0,
        valor_total: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    processSituacao: function processSituacao() {
      var _sum = this.sum,
          liberacao = _sum.liberacao,
          pagamento = _sum.pagamento;

      this.editedItem.situacao_anobase = this.editedItem.situacao_anoanterior + liberacao - pagamento;
    },
    getCodigoText: function getCodigoText(codigo) {
      var item = this.translate('value.divida_onus_codigo').find(function (c) {
        return c.value === codigo;
      });
      return item ? item.text : '';
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this5 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_dividaonus", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this5.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this5.$store.commit("loader/change_dialog", false);
        _this5.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.sequencia_ir"),
        value: "sequencia_ir",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.codigo"),
        value: "codigo",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.banco"),
        value: "banco",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.contrato"),
        value: "contrato",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anoanterior") + (this.$auth.user().anobase.id_texto - 1),
        value: "situacao_anoanterior",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anobase") + this.$auth.user().anobase.id_texto,
        value: "situacao_anobase",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        width: "5%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.tipo"),
        sortable: false,
        value: "tipo"
      }, {
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor_base"),
        sortable: false,
        value: "valor_base"
      }, {
        text: this.translate("table." + this.entity + "_item.field.juros"),
        sortable: false,
        value: "juros"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor_total"),
        sortable: false,
        value: "valor_total"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sum: function sum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc.juros += cur.juros;
        acc[cur.tipo] += cur.valor_base;
        return acc;
      }, { pagamento: 0, liberacao: 0, juros: 0 });
    }
  },
  watch: {
    pagination: {
      handler: function handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_mask__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_PCpfCnpj__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_2__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_3__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_7__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixin_mask__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_dividaonusrural",
      subItemTipos: [{ id: "pagamento", id_texto: "Pagamento" }, { id: "liberacao", id_texto: "Liberação" }],
      items: [],
      pagination: { rowsPerPage: 25, sortBy: "", descending: false },
      page: 1,
      setKeyup: null,
      total_situacao_anobase: 0,
      total_situacao_anoanterior: 0,
      limitarCaracteres: true,
      apenasAtivos: true
    };
  },
  name: "DividaOnusRural",
  props: ["condominio_id", "initials", "responsaveis", "particular"],
  created: function created() {
    this.initialize();
    var anobaseId = this.$auth.user().anobase.id;
    this.editedItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      situacao_anobase: 0,
      situacao_anoanterior: 0,
      valor_contrato: 0,
      valor_pago: 0,
      sub_items: [],
      cpf_cnpj: ""
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      sequencia_ir: "",
      ativo: true,
      anobase_id: anobaseId,
      situacao_anobase: 0,
      situacao_anoanterior: 0,
      valor_contrato: 0,
      valor_pago: 0,
      sub_items: [],
      cpf_cnpj: ""
    };
    sequencia_ir_duplicated: false;
  },

  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.sequencia_ir"),
        value: "sequencia_ir",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "40%"
      }, {
        text: this.translate("table." + this.entity + ".field.codigo"),
        value: "codigo",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.banco"),
        value: "banco",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.contrato"),
        value: "contrato",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.condominio_pessoa_id"),
        value: "contrato"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anoanterior") + (this.$auth.user().anobase.id_texto - 1),
        value: "situacao_anoanterior",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.situacao_anobase") + this.$auth.user().anobase.id_texto,
        value: "situacao_anobase",
        width: "10%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        width: "5%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        width: "5%",
        align: "center"
      }];
    },
    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.tipo"),
        sortable: false,
        value: "tipo"
      }, {
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor_base"),
        sortable: false,
        value: "valor_base"
      }, {
        text: this.translate("table." + this.entity + "_item.field.juros"),
        sortable: false,
        value: "juros"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor_total"),
        sortable: false,
        value: "valor_total"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sum: function sum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc.juros += cur.juros;
        acc[cur.tipo] += cur.valor_base;
        return acc;
      }, { pagamento: 0, liberacao: 0, juros: 0 });
    }
  },
  methods: {
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    afterSave: function afterSave() {
      this.initialize();
    },
    afterDelete: function afterDelete() {
      this.initialize();
    },
    initialize: function initialize() {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      var params = {
        search: this.search,
        apenasAtivos: this.apenasAtivos,
        page: this.pagination["current_page"] ? this.pagination["current_page"] : 1,
        perPage: this.pagination["rowsPerPage"] ? this.pagination["rowsPerPage"] : 25,
        desc: this.pagination["descending"] ? this.pagination["descending"] : false,
        sort: this.pagination["sortBy"] ? this.pagination["sortBy"] : "sequencia_ir",
        condominio_id: this.condominio_id ? this.condominio_id : 0
      };
      this.$http.post("api/paginate_dividaonusrural", params).then(function (res) {
        _this2.total_situacao_anoanterior = res.body.total_situacao_anoanterior;
        _this2.total_situacao_anobase = res.body.total_situacao_anobase;

        var resbody = res.body.dados;

        _this2.items = resbody.data;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.pagination, {
          total: resbody.total,
          rowsPerPage: resbody.per_page,
          current_page: resbody.current_page,
          last_page: resbody.last_page,
          from: resbody.from,
          to: resbody.to
        });
        _this2.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this2.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os dados.",
          color: "error",
          dialog: true
        });
        _this2.$store.commit("loader/change_dialog", false);
      });
    },
    keyupSearch: function keyupSearch(key) {
      var _this3 = this;

      // caso o usuario fique 2 segundo sem digitar e feita uma busca da pagina novamente
      clearTimeout(this.setKeyup);
      if (key["key"] === "Enter") {
        this.initialize();
      } else {
        this.setKeyup = setTimeout(function () {
          _this3.initialize();
        }, 2000);
      }
    },
    changePage: function changePage() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.pagination["current_page"] = page;
      this.initialize();
    },
    afterInitialize: function afterInitialize() {
      this.paises = this.resBody.paises;
    },
    afterEdit: function afterEdit() {
      this.limitarCaracteres = this.editedItem.id_texto.length <= 63;
      this.editedItem.sub_items = this.editedItem.situacao_atual[0].distribuicoes;
    },
    beforeCreate: function beforeCreate() {
      var _this4 = this;

      this.$http.post("api/get_max_sequence_dividaonusrural/" + this.condominio_id).then(function (res) {
        var maxSequence = res.body;
        maxSequence = __WEBPACK_IMPORTED_MODULE_5__classes_helper__["a" /* default */].pad(++maxSequence, 5);
        _this4.editedItem.sequencia_ir = (_this4.initials ? _this4.initials + "-" : "") + "DR-" + maxSequence;
      }, function (err) {
        _this4.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar a sequencia.",
          color: "error",
          dialog: true
        });
      });
    },
    beforeSave: function beforeSave() {
      this.editedItem.valor_pago = this.sum.pagamento;
      this.editedItem.valor_liberado = this.sum.liberacao;

      this.editedItem.sub_items = this.editedItem.sub_items.map(function (item) {
        item.valor_total = item.valor_base + item.juros;
        return item;
      });
    },

    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor_base: 0,
        juros: 0,
        valor_total: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    processSituacao: function processSituacao() {
      var _sum = this.sum,
          liberacao = _sum.liberacao,
          pagamento = _sum.pagamento;

      this.editedItem.situacao_anobase = this.editedItem.situacao_anoanterior + liberacao - pagamento;
    },
    getCodigoText: function getCodigoText(codigo) {
      var item = this.translate('value.divida_onus_codigo').find(function (c) {
        return c.value === codigo;
      });
      return item ? item.text : '';
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this5 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_dividaonusrural", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this5.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this5.$store.commit("loader/change_dialog", false);
        _this5.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  watch: {
    pagination: {
      handler: function handler(a, b) {
        // caso tenha trocado a ordenação busca novamente
        if (a.descending !== b.descending || a.sortBy !== b.sortBy) {
          this.initialize();
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_PCpfCnpj__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PMoney: __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_6__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_imovelexplorado",
      items: [],
      cidades: [],
      sum: {
        area: 0
      },
      sequencia_ir_duplicated: false,
      apenasAtivos: true,
      // Terceiros
      terceirosDialog: false,
      terceirosFormDialog: false,
      terceiros: [],
      terceirosSearch: '',
      terceirosEditedIndex: -1,
      terceirosEditedItem: { nome: '', cpf_cnpj: '', tipo_participante: null },
      terceirosDefaultItem: { nome: '', cpf_cnpj: '', tipo_participante: null },
      tipoParticipanteOptions: [{ value: 1, text: '1 - Condômino' }, { value: 2, text: '2 - Arrendador' }, { value: 3, text: '3 - Parceiro' }, { value: 4, text: '4 - Comodante' }, { value: 5, text: '5 - Outros' }]
    };
  },
  name: "ImovelExplorado",
  props: ["condominio_id", "values", "initials"],
  created: function created() {
    var _this2 = this;

    this.items = this.values;
    this.editedItem = { condominio_id: this.condominio_id, ativo: true };
    this.defaultItem = { condominio_id: this.condominio_id, ativo: true };
    this.$store.commit("loader/change_dialog", false);
    this.$http.get("api/cidade?select=id,CONCAT(id_texto, ' - ', uf) as id_texto ,cidade_id,uf&order=id_texto asc").then(function (res) {
      _this2.cidades = res.body.dados;
      _this2.$store.commit("loader/change_dialog", false);
    }, function () {
      return _this2.$store.commit("loader/change_dialog", false);
    });
  },

  computed: {
    terceirosHeaders: function terceirosHeaders() {
      var t = 'table.condominio_imovelexplorado_terceiros.field';
      return [{ text: this.translate(t + ".nome"), value: 'nome' }, { text: this.translate(t + ".cpf_cnpj"), value: 'cpf_cnpj' }, { text: this.translate(t + ".tipo_participante"), value: 'tipo_participante' }, { text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center', width: '15%' }];
    },

    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.sequencia_ir"),
        value: "sequencia_ir",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: "30%"
      }, {
        text: this.translate("table." + this.entity + ".field.atividade"),
        value: "atividade",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.localizacao"),
        value: "localizacao",
        width: "15%"
      }, {
        text: this.translate("table." + this.entity + ".field.nirf"),
        value: "nirf",
        width: "7%"
      }, {
        text: this.translate("table." + this.entity + ".field.area"),
        value: "area",
        width: "5%",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.participacao"),
        value: "participacao",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.exploracao"),
        value: "exploracao",
        width: "5%"
      }, {
        text: this.translate("table." + this.entity + ".field.ativo"),
        value: "ativo",
        width: "5%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "10%"
      }];
    }
  },
  methods: {
    customFilter: function customFilter(items, search, filter) {
      var filteredItems = items;

      // Filtro de pesquisa geral (em todos os campos)
      if (search) {
        filteredItems = filteredItems.filter(function (item) {
          // Verifica se o termo de pesquisa está em qualquer campo do item
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(item).toString().toLowerCase().includes(search.toLowerCase());
        });
      }
      // Filtro de ativo
      if (this.apenasAtivos) {
        filteredItems = filteredItems.filter(function (item) {
          return item.ativo == true;
        });
      }
      this.updateSum(filteredItems);
      return filteredItems;
    },
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    beforeCreate: function beforeCreate() {
      this.editedItem.sequencia_ir = __WEBPACK_IMPORTED_MODULE_3__classes_helper__["a" /* default */].generateSequenciaIr(this.initials, "IE", this.values);
      this.terceiros = [];
    },
    updateSum: function updateSum(filteredItems) {
      this.sum.area = filteredItems.reduce(function (acumulador, objeto) {
        return acumulador + objeto.area;
      }, 0).toFixed(2);
    },
    getExploracaoText: function getExploracaoText(atividade) {
      var translate = 'value.imovel_exploracao';
      var item = this.translate(translate).find(function (c) {
        return c.value === atividade;
      });
      return item ? item.text : '';
    },
    getAtividadeText: function getAtividadeText(exploracao) {
      var translate = 'value.imovel_atividade';
      var item = this.translate(translate).find(function (c) {
        return c.value === exploracao;
      });
      return item ? item.text : '';
    },
    afterEdit: function afterEdit() {
      var _this3 = this;

      this.terceiros = [];
      if (this.editedItem.id) {
        this.$http.get("api/condominio_imovelexplorado_terceiros?where=condominio_imovelexplorado_id=" + this.editedItem.id).then(function (res) {
          _this3.terceiros = res.body.dados;
        }, function () {});
      }
    },

    // Terceiros
    getTipoParticipanteText: function getTipoParticipanteText(value) {
      var opt = this.tipoParticipanteOptions.find(function (o) {
        return o.value === value;
      });
      return opt ? opt.text : value || '';
    },
    openTerceiros: function openTerceiros() {
      this.terceirosSearch = '';
      this.terceirosDialog = true;
    },
    openTerceirosForm: function openTerceirosForm(item) {
      if (item) {
        this.terceirosEditedIndex = this.terceiros.indexOf(item);
        this.terceirosEditedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      } else {
        this.terceirosEditedIndex = -1;
        this.terceirosEditedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.terceirosDefaultItem);
      }
      this.terceirosFormDialog = true;
    },
    saveTerceiro: function saveTerceiro() {
      var _this4 = this;

      if (this.saving) return;
      this.saving = true;
      this.$store.commit('loader/change_dialog', true);

      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.terceirosEditedItem, {
        condominio_imovelexplorado_id: this.editedItem.id
      });
      if (this.terceirosEditedIndex === -1) {
        this.$http.post('api/condominio_imovelexplorado_terceiros', payload).then(function (res) {
          _this4.saving = false;
          _this4.$store.commit('loader/change_dialog', false);
          _this4.terceiros.push(res.body.dados);
          _this4.terceirosFormDialog = false;
        }, function () {
          _this4.saving = false;
          _this4.$store.commit('loader/change_dialog', false);
        });
      } else {
        this.$http.put("api/condominio_imovelexplorado_terceiros/" + payload.id, payload).then(function (res) {
          _this4.saving = false;
          _this4.$store.commit('loader/change_dialog', false);
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this4.terceiros[_this4.terceirosEditedIndex], res.body.dados);
          _this4.terceirosFormDialog = false;
        }, function () {
          _this4.saving = false;
          _this4.$store.commit('loader/change_dialog', false);
        });
      }
    },
    deleteTerceiro: function deleteTerceiro(item) {
      var _this5 = this;

      if (!confirm('Deseja excluir este registro?')) return;
      this.$store.commit('loader/change_dialog', true);

      this.$http.delete("api/condominio_imovelexplorado_terceiros/" + item.id).then(function () {
        _this5.$store.commit('loader/change_dialog', false);
        var index = _this5.terceiros.indexOf(item);
        _this5.terceiros.splice(index, 1);
      }, function () {
        _this5.$store.commit('loader/change_dialog', false);
      });
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this6 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_imovelexplorado", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this6.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this6.$store.commit("loader/change_dialog", false);
        _this6.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_1__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_pagamento",
      items: [],
      total: {
        total_valor: 0
      },
      sequencia_ir_duplicated: false
    };
  },
  name: "Pagamento",
  props: ["condominio_id", "values", "initials", "temDependente", "dependente_items"],
  created: function created() {
    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      ano: this.$auth.user().anobase.id_texto,
      sub_items: [],
      cpf_cnpj: "",
      pessoa_dependente_id: null
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      ano: this.$auth.user().anobase.id_texto,
      sub_items: [],
      cpf_cnpj: "",
      pessoa_dependente_id: null
    };
  },

  computed: {
    headers: function headers() {
      if (this.temDependente) {
        return [{
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.codigo"),
          value: "codigo",
          width: "5%"
        }, {
          text: this.translate("table." + this.entity + ".field.ano"),
          value: "ano",
          width: "5%"
        }, {
          text: this.translate("table." + this.entity + ".field.beneficiario"),
          value: "beneficiario",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
          value: "cpf_cnpj",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.descricao"),
          value: "descricao",
          width: "25%"
        }, {
          text: this.translate("table." + this.entity + ".field.pessoa_dependente_id"),
          value: "dependente.id_texto",
          width: "15%"
        }, {
          text: this.translate("table." + this.entity + "_item.field.valor"),
          value: "valor",
          width: "10%",
          align: "right"
        }, {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%"
        }];
      } else {
        return [{
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.codigo"),
          value: "codigo",
          width: "5%"
        }, {
          text: this.translate("table." + this.entity + ".field.ano"),
          value: "ano",
          width: "5%"
        }, {
          text: this.translate("table." + this.entity + ".field.beneficiario"),
          value: "beneficiario",
          width: "25%"
        }, {
          text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
          value: "cpf_cnpj",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.descricao"),
          value: "descricao",
          width: "25%"
        }, {
          text: this.translate("table." + this.entity + "_item.field.valor"),
          value: "valor",
          width: "10%",
          align: "right"
        }, {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%"
        }];
      }
    },
    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor"),
        sortable: false,
        value: "valor"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    editedItemSum: function editedItemSum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc["valor"] += cur["valor"];
        return acc;
      }, {
        valor: 0
      });
    }
  },
  watch: {
    items: function items(newValue, oldValue) {
      this.updateSum();
    }
  },
  methods: {
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    beforeCreate: function beforeCreate() {
      this.editedItem.sequencia_ir = __WEBPACK_IMPORTED_MODULE_3__classes_helper__["a" /* default */].generateSequenciaIr(this.initials, "PG", this.values);
    },
    afterSave: function afterSave() {
      this.updateSum();
    },

    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      if (index > -1) {
        this.editedItem.sub_items.splice(index, 1);
      }
    },
    updateSum: function updateSum() {
      this.total = this.$refs.PagamentoTable.filteredItems.reduce(function (acc, item) {
        var sum = item.sub_items.reduce(function (acc2, sub_item) {
          acc2.total_valor += sub_item.valor;
          return acc2;
        }, {
          total_valor: 0
        });
        acc.total_valor += sum.total_valor;

        item.total_valor = sum.total_valor;

        return acc;
      }, {
        total_valor: 0
      });
    },
    getCodigoText: function getCodigoText(codigo) {
      var translate = 'value.pagamento_codigo';
      var item = this.translate(translate).find(function (c) {
        return c.value === codigo;
      });
      return item ? item.text : '';
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_pagamento", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this2.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this2.$store.commit("loader/change_dialog", false);
        _this2.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_1__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      isTextoDisabled: false,
      isCnpjDisabled: false,
      entity: "condominio_rendimentoisento",
      items: [],
      sum: {
        total_valor: 0,
        total_contribuicao_previdenciaria: 0,
        total_irrf: 0,
        total_decimo_terceiro: 0,
        total_irrf_decimo_terceiro: 0
      },
      sequencia_ir_duplicated: false
    };
  },
  name: "RendimentoIsento",
  props: ["condominio_id", "values", "initials", "temDependente", "dependente_items", "particular"],
  watch: {
    items: function items(newValue, oldValue) {
      this.updateSum();
    }
  },
  created: function created() {
    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      sub_items: [],
      pessoa_dependente_id: null,
      cnpj: "",
      codigo: null
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      sub_items: [],
      pessoa_dependente_id: null,
      cnpj: "",
      codigo: null
    };
  },

  computed: {
    headers: function headers() {
      var idTextWidth = 50 - (this.temDependente ? 10 : 0) - (this.particular ? 20 : 0);
      var result = [{
        text: this.translate("table." + this.entity + ".field.sequencia_ir"),
        value: "sequencia_ir",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.id_texto"),
        value: "id_texto",
        width: idTextWidth + "%"
      }, {
        text: this.translate("table." + this.entity + ".field.codigo"),
        value: "codigo",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.cnpj"),
        value: "cnpj",
        width: "10%"
      }, {
        text: this.translate("table." + this.entity + ".field.valor"),
        value: "valor",
        width: "10%",
        align: "right"
      }];

      // Adicionar os valores que so possuem no contribuinte
      if (this.particular) {
        result.push.apply(result, [{
          text: this.translate("table." + this.entity + ".field.decimo_terceiro"),
          value: "decimo_terceiro",
          width: "5%",
          align: "right"
        }, {
          text: this.translate("table." + this.entity + ".field.irrf"),
          value: "irrf",
          width: "5%",
          align: "right"
        }, {
          text: this.translate("table." + this.entity + ".field.irrf_decimo_terceiro"),
          value: "irrf_decimo_terceiro",
          width: "5%",
          align: "right"
        }, {
          text: this.translate("table." + this.entity + ".field.contribuicao_previdenciaria"),
          value: "contribuicao_previdenciaria",
          width: "5%",
          align: "right"
        }]);
      }
      // Adicionar o dependente caso tenha
      if (this.temDependente) {
        result.push.apply(result, [{
          text: this.translate("table." + this.entity + ".field.pessoa_dependente_id"),
          value: "dependente.id_texto",
          width: "10%"
        }]);
      }

      // Adicionar as ações no final
      result.push.apply(result, [{
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "10%"
      }]);

      return result;
    },

    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.rendimento"),
        sortable: false,
        value: "valor"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sub_headers_cod_10: function sub_headers_cod_10() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.rendimento"),
        sortable: false,
        value: "valor"
      }, {
        text: this.translate("table." + this.entity + "_item.field.decimo_terceiro"),
        sortable: false,
        value: "decimo_terceiro"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    sub_headers_cod_11: function sub_headers_cod_11() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.rendimento"),
        sortable: false,
        value: "valor"
      }, {
        text: this.translate("table." + this.entity + "_item.field.decimo_terceiro"),
        sortable: false,
        value: "decimo_terceiro"
      }, {
        text: this.translate("table." + this.entity + "_item.field.irrf"),
        sortable: false,
        value: "irrf"
      }, {
        text: this.translate("table." + this.entity + "_item.field.irrf_decimo_terceiro"),
        sortable: false,
        value: "irrf_decimo_terceiro"
      }, {
        text: this.translate("table." + this.entity + "_item.field.contribuicao_previdenciaria"),
        sortable: false,
        value: "contribuicao_previdenciaria"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    editedItemSum: function editedItemSum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc["valor"] += cur["valor"];
        acc["contribuicao_previdenciaria"] += cur["contribuicao_previdenciaria"];
        acc["irrf"] += cur["irrf"];
        acc["decimo_terceiro"] += cur["decimo_terceiro"];
        acc["irrf_decimo_terceiro"] += cur["irrf_decimo_terceiro"];
        return acc;
      }, {
        valor: 0,
        contribuicao_previdenciaria: 0,
        irrf: 0,
        decimo_terceiro: 0,
        irrf_decimo_terceiro: 0
      });
    }
  },
  methods: {
    processFields: function processFields() {
      if ([20, 21, 23, 24, 25].includes(this.editedItem.codigo)) {
        this.editedItem.id_texto = "";
        this.isTextoDisabled = true;
        this.editedItem.cnpj = "";
        this.isCnpjDisabled = true;
      } else {
        this.isTextoDisabled = false;
        this.isCnpjDisabled = false;
      }
    },
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    beforeCreate: function beforeCreate() {
      this.editedItem.sequencia_ir = __WEBPACK_IMPORTED_MODULE_3__classes_helper__["a" /* default */].generateSequenciaIr(this.initials, "RI", this.values);
    },

    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    afterSave: function afterSave() {
      this.updateSum();
    },
    updateSum: function updateSum() {
      this.sum = this.$refs.RendimentoIsentoTable.filteredItems.reduce(function (acc, item) {
        var total = item.sub_items.reduce(function (acc2, sub_item) {
          acc2.total_valor += sub_item.valor;
          acc2.total_contribuicao_previdenciaria += sub_item.contribuicao_previdenciaria;
          acc2.total_irrf += sub_item.irrf;
          acc2.total_decimo_terceiro += sub_item.decimo_terceiro;
          acc2.total_irrf_decimo_terceiro += sub_item.irrf_decimo_terceiro;
          return acc2;
        }, {
          total_valor: 0,
          total_contribuicao_previdenciaria: 0,
          total_irrf: 0,
          total_decimo_terceiro: 0,
          total_irrf_decimo_terceiro: 0
        });
        acc.total_valor += total.total_valor;
        acc.total_contribuicao_previdenciaria += total.total_contribuicao_previdenciaria;
        acc.total_irrf += total.total_irrf;
        acc.total_decimo_terceiro += total.total_decimo_terceiro;
        acc.total_irrf_decimo_terceiro += total.total_irrf_decimo_terceiro;

        item.total_valor = total.total_valor;
        item.total_contribuicao_previdenciaria = total.total_contribuicao_previdenciaria;
        item.total_irrf = total.total_irrf;
        item.total_decimo_terceiro = total.total_decimo_terceiro;
        item.total_irrf_decimo_terceiro = total.total_irrf_decimo_terceiro;

        return acc;
      }, {
        total_valor: 0,
        total_contribuicao_previdenciaria: 0,
        total_irrf: 0,
        total_decimo_terceiro: 0,
        total_irrf_decimo_terceiro: 0
      });

      console.log(this.sum);
    },
    getCodigoText: function getCodigoText(codigo) {
      var translate = this.particular ? 'value.rend_isento_codigo_particular' : 'value.rend_isento_codigo_condominio';
      var item = this.translate(translate).find(function (c) {
        return c.value === codigo;
      });
      return item ? item.text : '';
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_rendimentoisento", "search": this.search, "apenasAtivos": this.apenasAtivos, "isCondominio": !this.particular }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this2.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this2.$store.commit("loader/change_dialog", false);
        _this2.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_1__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_rendimentotributacao",
      items: [],
      sum: {
        total_valor: 0
      },
      sequencia_ir_duplicated: false
    };
  },
  name: "RendimentoTributacao",
  props: ["condominio_id", "values", "initials", "temDependente", "dependente_items"],
  created: function created() {
    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      sub_items: [],
      pessoa_dependente_id: null
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      sub_items: [],
      pessoa_dependente_id: null
    };
  },

  watch: {
    items: function items(newValue, oldValue) {
      this.updateSum();
    }
  },
  computed: {
    headers: function headers() {
      if (this.temDependente) {
        return [{
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "30%"
        }, {
          text: this.translate("table." + this.entity + ".field.codigo"),
          value: "codigo",
          width: "5%"
        }, {
          text: this.translate("table." + this.entity + ".field.cnpj"),
          value: "cnpj",
          width: "15%"
        }, {
          text: this.translate("table." + this.entity + ".field.pessoa_dependente_id"),
          value: "dependente.id_texto",
          width: "20%"
        }, {
          text: this.translate("table." + this.entity + ".field.valor"),
          value: "valor",
          width: "10%",
          align: "right"
        }, {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%"
        }];
      } else {
        return [{
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "50%"
        }, {
          text: this.translate("table." + this.entity + ".field.codigo"),
          value: "codigo",
          width: "5%"
        }, {
          text: this.translate("table." + this.entity + ".field.cnpj"),
          value: "cnpj",
          width: "15%"
        }, {
          text: this.translate("table." + this.entity + ".field.valor"),
          value: "valor",
          width: "10%",
          align: "right"
        }, {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%"
        }];
      }
    },
    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.valor"),
        sortable: false,
        value: "valor"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    editedItemSum: function editedItemSum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc["valor"] += cur["valor"];
        return acc;
      }, {
        valor: 0
      });
    }
  },
  methods: {
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    beforeCreate: function beforeCreate() {
      this.editedItem.sequencia_ir = __WEBPACK_IMPORTED_MODULE_3__classes_helper__["a" /* default */].generateSequenciaIr(this.initials, "RT", this.values);
    },

    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        tipo: "pagamento",
        data: "",
        valor: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    processSituacao: function processSituacao() {
      this.editedItem.valor = this.editedItem.sub_items.reduce(function (acumulador, valorAtual) {
        return acumulador + valorAtual.valor;
      }, 0);
    },
    updateSum: function updateSum() {
      this.sum = this.$refs.RendimentoTributacaoTable.filteredItems.reduce(function (acc, item) {
        var total = item.sub_items.reduce(function (acc2, sub_item) {
          acc2.total_valor += sub_item.valor;
          return acc2;
        }, {
          total_valor: 0
        });
        acc.total_valor += total.total_valor;
        item.total_valor = total.total_valor;

        return acc;
      }, {
        total_valor: 0
      });

      console.log(this.sum);
    },
    getCodigoText: function getCodigoText(codigo) {
      var translate = 'value.rend_tributacao_codigo';
      var item = this.translate(translate).find(function (c) {
        return c.value === codigo;
      });
      return item ? item.text : '';
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_rendimentotributacao", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this2.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this2.$store.commit("loader/change_dialog", false);
        _this2.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_helper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_1__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_5__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_rendimentorecebidopj",
      items: [],
      total: {
        total_recebido_pj: 0,
        total_contribuicao_previdenciaria: 0,
        total_imposto_retido: 0,
        total_salary_13: 0,
        total_irrf_salary_13: 0
      },
      sequencia_ir_duplicated: false,
      confirmDialogCondominio: false
    };
  },
  name: "RendimentoRecebidoPj",
  props: ["condominio_id", "values", "initials", "temDependente", "dependente_items", "particular"],
  created: function created() {
    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      sub_items: [],
      pessoa_dependente_id: null
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      ativo: true,
      sub_items: [],
      pessoa_dependente_id: null
    };
  },

  watch: {
    items: function items(newValue, oldValue) {
      this.updateSum();
    }
  },
  mounted: function mounted() {
    // Verifica se está em modo condomínio e se o usuário é admin/dev
    if (this.isCondominioMode && this.isAdminAccess) {
      this.confirmDialogCondominio = true;
    }
  },

  computed: {
    // Verifica se está em modo condomínio (particular = false)
    isCondominioMode: function isCondominioMode() {
      return this.particular === false;
    },

    // Verifica se o usuário tem acesso de administrador
    isAdminAccess: function isAdminAccess() {
      var acessoInterno = this.$auth.user().acesso_interno;
      return acessoInterno === 'dev' || acessoInterno === 'admin';
    },

    headers: function headers() {
      if (this.temDependente) {
        return [{
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "30%"
        }, {
          text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
          value: "cpf_cnpj",
          width: "30%"
        }, {
          text: this.translate("table." + this.entity + "_item.field.recebido_pj"),
          sortable: false,
          value: "recebido_pj"
        }, {
          text: this.translate("table." + this.entity + "_item.field.contribuicao_previdenciaria"),
          sortable: false,
          value: "contribuicao_previdenciaria"
        }, {
          text: this.translate("table." + this.entity + "_item.field.imposto_retido"),
          sortable: false,
          value: "imposto_retido"
        }, {
          text: this.translate("table." + this.entity + "_item.field.salary_13"),
          sortable: false,
          value: "salary_13"
        }, {
          text: this.translate("table." + this.entity + "_item.field.irrf_salary_13"),
          sortable: false,
          value: "irrf_salary_13"
        }, {
          text: this.translate("table." + this.entity + ".field.pessoa_dependente_id"),
          value: "dependente.id_texto",
          width: "20%"
        }, {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%"
        }];
      } else {
        return [{
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%"
        }, {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "50%"
        }, {
          text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
          value: "cpf_cnpj",
          width: "30%"
        }, {
          text: this.translate("table." + this.entity + "_item.field.recebido_pj"),
          sortable: false,
          value: "recebido_pj"
        }, {
          text: this.translate("table." + this.entity + "_item.field.contribuicao_previdenciaria"),
          sortable: false,
          value: "contribuicao_previdenciaria"
        }, {
          text: this.translate("table." + this.entity + "_item.field.imposto_retido"),
          sortable: false,
          value: "imposto_retido"
        }, {
          text: this.translate("table." + this.entity + "_item.field.salary_13"),
          sortable: false,
          value: "salary_13"
        }, {
          text: this.translate("table." + this.entity + "_item.field.irrf_salary_13"),
          sortable: false,
          value: "irrf_salary_13"
        }, {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%"
        }];
      }
    },
    sub_headers: function sub_headers() {
      return [{
        text: this.translate("table." + this.entity + "_item.field.data"),
        sortable: false,
        value: "data"
      }, {
        text: this.translate("table." + this.entity + "_item.field.recebido_pj"),
        sortable: false,
        value: "recebido_pj"
      }, {
        text: this.translate("table." + this.entity + "_item.field.contribuicao_previdenciaria"),
        sortable: false,
        value: "contribuicao_previdenciaria"
      }, {
        text: this.translate("table." + this.entity + "_item.field.imposto_retido"),
        sortable: false,
        value: "imposto_retido"
      }, {
        text: this.translate("table." + this.entity + "_item.field.salary_13"),
        sortable: false,
        value: "salary_13"
      }, {
        text: this.translate("table." + this.entity + "_item.field.irrf_salary_13"),
        sortable: false,
        value: "irrf_salary_13"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    editedItemSum: function editedItemSum() {
      return this.editedItem.sub_items.reduce(function (acc, cur) {
        acc["recebido_pj"] += cur["recebido_pj"];
        acc["contribuicao_previdenciaria"] += cur["contribuicao_previdenciaria"];
        acc["imposto_retido"] += cur["imposto_retido"];
        acc["salary_13"] += cur["salary_13"];
        acc["irrf_salary_13"] += cur["irrf_salary_13"];
        return acc;
      }, {
        recebido_pj: 0,
        contribuicao_previdenciaria: 0,
        imposto_retido: 0,
        salary_13: 0,
        irrf_salary_13: 0
      });
    }
  },
  methods: {
    beforeSave: function beforeSave() {
      // Verifica se todas as variáveis estão zeradas em pelo menos um objeto do array
      var allZeros = this.editedItem.sub_items.some(function (item) {
        return item.imposto_retido == 0 && item.irrf_salary_13 == 0 && item.recebido_pj == 0 && item.salary_13 == 0;
      });

      // Se todas as variáveis estiverem zeradas em pelo menos um objeto, mostra a snackbar e interrompe a execução
      if (allZeros) {
        this.$store.commit("snackbar/change_values", {
          text: "Por favor, verifique as Distribuições. Pelo menos um destes campos precisa ser preenchido: Rendimento Recebido de PJ, Contribuição Previdenciária, Imposto Retido na Fonte, 13º Salário e IRRF 13º Salário.",
          color: "error",
          dialog: true,
          timeout: 5000
        });

        this.$store.commit("loader/change_dialog", false);
        throw new Error("Todos os campos estão zerados em pelo menos um objeto.");
      }
    },
    checkDuplicate: function checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    beforeCreate: function beforeCreate() {
      this.editedItem.sequencia_ir = __WEBPACK_IMPORTED_MODULE_3__classes_helper__["a" /* default */].generateSequenciaIr(this.initials, "RPJ", this.values);
    },

    createSubItem: function createSubItem() {
      this.editedItem.sub_items.push({
        data: "",
        recebido_pj: 0,
        contribuicao_previdenciaria: 0,
        imposto_retido: 0,
        salary_13: 0,
        irrf_salary_13: 0
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.sub_items.indexOf(item);
      this.editedItem.sub_items.splice(index, 1);
    },
    updateSum: function updateSum() {
      this.total = this.$refs.RendimentoRecebidoPJTable.filteredItems.reduce(function (acc, item) {
        var sum = item.sub_items.reduce(function (acc2, sub_item) {
          acc2.total_recebido_pj += sub_item.recebido_pj;
          acc2.total_contribuicao_previdenciaria += sub_item.contribuicao_previdenciaria;
          acc2.total_imposto_retido += sub_item.imposto_retido;
          acc2.total_salary_13 += sub_item.salary_13;
          acc2.total_irrf_salary_13 += sub_item.irrf_salary_13;
          return acc2;
        }, {
          total_recebido_pj: 0,
          total_contribuicao_previdenciaria: 0,
          total_imposto_retido: 0,
          total_salary_13: 0,
          total_irrf_salary_13: 0
        });
        acc.total_recebido_pj += sum.total_recebido_pj;
        acc.total_contribuicao_previdenciaria += sum.total_contribuicao_previdenciaria;
        acc.total_imposto_retido += sum.total_imposto_retido;
        acc.total_salary_13 += sum.total_salary_13;
        acc.total_irrf_salary_13 += sum.total_irrf_salary_13;

        item.total_recebido_pj = sum.total_recebido_pj;
        item.total_contribuicao_previdenciaria = sum.total_contribuicao_previdenciaria;
        item.total_imposto_retido = sum.total_imposto_retido;
        item.total_salary_13 = sum.total_salary_13;
        item.total_irrf_salary_13 = sum.total_irrf_salary_13;

        return acc;
      }, {
        total_recebido_pj: 0,
        total_contribuicao_previdenciaria: 0,
        total_imposto_retido: 0,
        total_salary_13: 0,
        total_irrf_salary_13: 0
      });

      console.log(this.total);
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_rendimentorecebidopj", "search": this.search, "apenasAtivos": this.apenasAtivos }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this2.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this2.$store.commit("loader/change_dialog", false);
        _this2.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_v_money___default.a, { precision: 4 });

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PMoney: __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixin_crud__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_movimentacaofinanceira",
      meses: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      items: [],
      form: {
        type: "",
        title: "",
        headers: []
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      editedItem: []
    };
  },
  name: "MovimentacaoFinanceira",
  props: ["condominio_id"],
  created: function created() {
    this.initialize();
  },

  methods: {
    initialize: function initialize() {
      var _this2 = this;

      this.beforeInitialize();
      this.$store.commit("loader/change_dialog", true);
      this.$http.get("api/movimentacaofinanceira" + (this.condominio_id ? "?where=condominio_id=" + this.condominio_id : "")).then(function (res) {
        _this2.resBody = res.body;
        _this2.editedItem = res.body.dados;
        _this2.afterInitialize();
        _this2.$store.commit("loader/change_dialog", false);
      }, function (err) {
        _this2.afterInitialize();
        _this2.$store.commit("loader/change_dialog", false);
      });
    },
    close: function close() {
      var _this3 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this.beforeClose();
      this.dialog = to !== 1;
      this.$store.commit("loader/change_dialog", false);
      setTimeout(function () {
        if (to !== 3) {
          _this3.editedIndex = -1;
        }
        _this3.view = to;
        _this3.afterClose();
      }, time);
    },
    openModal: function openModal(type) {
      this.defaultItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editedItem));
      this.create();
    },
    save: function save() {
      var _this4 = this;

      if (this.saving) return;
      this.saving = true;
      this.$http.put("api/movimentacaofinanceira/update_many", this.editedItem).then(function (res) {
        _this4.editedItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.body));
        _this4.saving = false;
      }, function (err) {
        _this4.saving = false;
        alert("Erro! Falha ao enviar a requisição.");
        console.log(err);
      });

      this.dialog = false;
      this.$store.commit("loader/change_dialog", false);
      setTimeout(function () {
        _this4.editedIndex = -1;
        _this4.view = 1;
      }, 400);
    },
    atualizarValores: function atualizarValores() {
      var _this5 = this;

      console.log("123");
      this.$store.commit("loader/change_dialog", true);
      this.$http.get("api/get_controle_caixa_por_mes/" + this.condominio_id).then(function (res) {
        _this5.$store.commit("loader/change_dialog", false);
        var values = res.body;
        // constrói um índice por mês (1..12)
        var valuesByMes = values.reduce(function (acc, v) {
          acc[v.mes] = v;
          return acc;
        }, {});

        // atualiza receita/despesa em cada linha do editedItem
        _this5.editedItem.forEach(function (row) {
          var match = valuesByMes[row.mes_base];
          if (match) {
            row.receita = Number(match.entrada) || 0;
            row.despesa = Number(match.saida) || 0;
          }
        });
      }, function (err) {
        _this5.$store.commit("snackbar/change_values", {
          text: "Não foi possível carregar os dados.",
          color: "error",
          dialog: true
        });
        _this5.$store.commit("loader/change_dialog", false);
      });
    },

    // type 1 = pdf 2 = excel
    // reportType: 'receita_despesa' ou 'liberacao_pagamento'
    exportReport: function exportReport(type, reportType) {
      var _this6 = this;

      this.$store.commit("loader/change_dialog", true);
      var tableName = reportType === 'receita_despesa' ? 'condominio_movimentacaofinanceira_receita_despesa' : 'condominio_movimentacaofinanceira_liberacao_pagamento';

      this.$http.put("report/report_details/" + this.condominio_id, {
        "type": type,
        "table": tableName
      }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this6.$store.commit("loader/change_dialog", false);
        var _this = _this6;
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this6.$store.commit("loader/change_dialog", false);
        _this6.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  computed: {
    total_receita: function total_receita() {
      // Verifica se this.editedItem é um array
      if (Array.isArray(this.editedItem)) {
        // Se for um array, usa o método reduce()
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.receita;
        }, 0);
      } else {
        // Se não for um array, retorna 0 ou outro valor padrão
        return 0;
      }
    },
    total_despesa: function total_despesa() {
      if (Array.isArray(this.editedItem)) {
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.despesa;
        }, 0);
      } else {
        return 0;
      }
    },
    total_liberacao: function total_liberacao() {
      if (Array.isArray(this.editedItem)) {
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.liberacao_total;
        }, 0);
      } else {
        return 0;
      }
    },
    total_pagamento: function total_pagamento() {
      if (Array.isArray(this.editedItem)) {
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.pagamento_total;
        }, 0);
      } else {
        return 0;
      }
    },
    headers: function headers() {
      return {
        receita_despesa: [{
          text: this.translate("table." + this.entity + ".field.mes_base"),
          sortable: false,
          value: "mes_base"
        }, {
          text: this.translate("table." + this.entity + ".field.receita"),
          sortable: false,
          value: "receita",
          align: "right"
        }, {
          text: this.translate("table." + this.entity + ".field.despesa"),
          sortable: false,
          value: "despesa",
          align: "right"
        }, {
          text: this.translate("table." + this.entity + ".field.resultado"),
          sortable: false,
          value: "resultado",
          align: "right"
        }],
        liberacao_pagamento: [{
          text: this.translate("table." + this.entity + ".field.mes_base"),
          sortable: false,
          value: "mes_base"
        }, {
          text: this.translate("table." + this.entity + ".field.liberacao"),
          sortable: false,
          value: "liberacao",
          align: "right"
        }, {
          text: this.translate("table." + this.entity + ".field.pagamento"),
          sortable: false,
          value: "pagamento",
          align: "right"
        }, {
          text: this.translate("table." + this.entity + ".field.resultado"),
          sortable: false,
          value: "resultado",
          align: "right"
        }]
      };
    }
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_crud__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PMoney: __WEBPACK_IMPORTED_MODULE_1__shared_PMoney__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_crud__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_movimentacaorebanho",
      especie: ["Bonivos e bufalinos", "Suínos", "Caprinos e ovinos", "Asininos, equinos e muares", "Outras"],
      items: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  name: "MovimentacaoRebanho",
  props: ["condominio_id", "values"],
  created: function created() {
    this.values.condominio_id = this.condominio_id;
    this.items = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.values));
    this.editedItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.items));
    this.defaultItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editedItem));
  },

  methods: {
    save: function save() {
      var _this2 = this;

      if (this.saving) return;
      this.saving = true;
      this.$http.put("api/movimentacaorebanho/update_many", this.editedItem).then(function (res) {
        _this2.items = res.body;
        _this2.editedItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.items));
        _this2.saving = false;
      }, function (err) {
        _this2.saving = false;
        alert("Erro! Falha ao enviar a requisição.");
        console.log(err);
      });

      this.dialog = false;
      this.$store.commit("loader/change_dialog", false);
      setTimeout(function () {
        _this2.editedIndex = -1;
        _this2.view = 1;
      }, 400);
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this3 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, {
        "type": type,
        "table": "condominio_movimentacaorebanho"
      }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this3.$store.commit("loader/change_dialog", false);
        var _this = _this3;
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this3.$store.commit("loader/change_dialog", false);
        _this3.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.especie"),
        sortable: false,
        value: "especie"
      }, {
        text: this.translate("table." + this.entity + ".field.estoque_inicial"),
        sortable: false,
        value: "estoque_inicial",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.aquisicao"),
        sortable: false,
        value: "aquisicao",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.nascimento"),
        sortable: false,
        value: "nascimento",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.consumo_e_perda"),
        sortable: false,
        value: "consumo_e_perda",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.venda"),
        sortable: false,
        value: "venda",
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.resultado"),
        sortable: false,
        value: "resultado",
        align: "right"
      }];
    }
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_math__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_big_js__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_big_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_big_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_1__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_4__shared_PMoney__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_transacao",
      items: [],
      dynamic_pessoas: [],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  name: "Transacao",
  props: ["condominio_id", "values", "pessoas"],
  created: function created() {
    this.dynamic_pessoas = this.pessoas.map(function (value) {
      value.pessoa.id_texto_porcentagem = value.pessoa.id_texto + " - " + value.porcentagem + "%";
      return value;
    });

    this.items = this.values;
    this.editedItem = {
      condominio_id: this.condominio_id,
      items: [],
      porcentagem: 0
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      items: [],
      porcentagem: 0
    };
  },

  computed: {
    porcentagemRestante: function porcentagemRestante() {
      return this.getSum().minus(this.editedItem.porcentagem || 0);
    },

    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.condominio_pessoa_id"),
        value: "condominio_pessoa.pessoa.id_texto",
        width: "55%"
      }, {
        text: this.translate("table." + this.entity + ".field.porcentagem"),
        value: "porcentagem",
        width: "20%"
      }, {
        text: this.translate("table." + this.entity + ".field.data"),
        value: "data",
        width: "20%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    },
    headers_items: function headers_items() {
      return [{
        text: this.translate("table." + this.entity + ".field.condominio_pessoa_id"),
        value: "condominio_pessoa.pessoa.id_texto",
        width: "55%"
      }, {
        text: this.translate("table." + this.entity + ".field.porcentagem"),
        value: "porcentagem",
        width: "20%"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
  },
  methods: {
    getSum: function getSum() {
      var total = __WEBPACK_IMPORTED_MODULE_5_big_js___default()(0);
      this.editedItem.items.forEach(function (item) {
        total = total.plus(parseFloat(item.porcentagem || 0));
      });
      return total;
    },
    createSubItem: function createSubItem() {
      this.editedItem.items.push({
        porcentagem: 0,
        condominio_pessoa_id: ""
      });
    },
    deleteSubItem: function deleteSubItem(item) {
      var index = this.editedItem.items.indexOf(item);
      this.editedItem.items.splice(index, 1);
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_acl__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_users",
      items: [],
      dynamicUsers: [],
      apenasAtivos: true
      // acessos: []
    };
  },
  name: "Usuario",
  props: ["condominio_id", "values", "users", "acessos"],
  created: function created() {
    this.items = this.values;
    this.editedItem = { ativo: true, user_id: "", condominio_id: this.condominio_id };
    this.defaultItem = { ativo: true, user_id: "", condominio_id: this.condominio_id };
    // this.acessos = this.access
    this.itensOriginais = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.items));
    this.filtrarItens();
  },

  methods: {
    filtrarItens: function filtrarItens() {
      if (this.apenasAtivos) {
        this.items = this.items.filter(function (item) {
          return item.ativo;
        });
      } else {
        this.items = this.itensOriginais;
      }
    },
    refreshEmpresas: function refreshEmpresas(tela) {
      var _this = this;

      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var remove = void 0;
      switch (tela) {
        case 2:
          this.create();
          remove = this.items.map(function (a) {
            return a.user_id;
          });
          break;
        case 3:
          {
            this.editItem(obj);
            remove = this.items.map(function (a) {
              if (a.user_id !== _this.editedItem.user_id) {
                return a.user_id;
              }
            });
            break;
          }
      }
      this.dynamicUsers = this.users.filter(function (item) {
        return !remove.includes(item.id);
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{ text: this.translate("table." + this.entity + ".field.user_id"), value: "user_id" }, { text: this.translate("table." + this.entity + ".field.acesso_id"), value: "acesso_id" }, { text: this.translate("table." + this.entity + ".field.ativo"), value: "ativo" }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PDate__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_PCpfCnpj__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDate: __WEBPACK_IMPORTED_MODULE_1__shared_PDate__["a" /* default */],
    PMoney: __WEBPACK_IMPORTED_MODULE_2__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_4__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_controlecaixa",
      items: [],
      itemsCodigoConta: [],
      itemsCodigoImovel: [],
      filtros: { dataInicio: "", dataFim: "" },
      filtrosAnterior: { dataInicio: "", dataFim: "" },
      sum: {
        entrada: 0,
        saida: 0
      }
    };
  },
  name: "ControleCaixa",
  props: ["condominio_id"],
  created: function created() {
    var _this2 = this;

    this.$http.get("api/controle_caixa_fields/" + this.condominio_id).then(function (res) {
      _this2.itemsCodigoImovel = res.body["codigoImovel"];
      _this2.itemsCodigoConta = res.body["codigoConta"];
      _this2.itemsCodigoConta.unshift({ id: 0, id_texto: "000 - Em espécie" });
      _this2.itemsCodigoConta.push({ id: 999, id_texto: "999 - Em espécie" });
    }, function (err) {
      alert("Ocorreu um erro para carregar os dados");
    });
    this.initialize();
    this.editedItem = {
      condominio_id: this.condominio_id,
      empresa_id: this.$auth.user().empresa_id,
      cpf_cnpj: ""
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      empresa_id: this.$auth.user().empresa_id,
      cpf_cnpj: ""
    };
  },

  methods: {
    // type 1 = pdf, type 2 = excel
    exportReport: function exportReport(type) {
      var _this3 = this;

      this.$store.commit("loader/change_dialog", true);

      // Monta os filtros para passar ao backend
      var filters = {
        dataInicio: this.filtros.dataInicio || null,
        dataFim: this.filtros.dataFim || null,
        search: this.search || null
      };

      this.$http.put("report/report_details/" + this.condominio_id, {
        "type": type,
        "table": "condominio_controlecaixa",
        "filters": filters
      }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this3.$store.commit("loader/change_dialog", false);
        var _this = _this3;
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this3.$store.commit("loader/change_dialog", false);
        _this3.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    },
    getCodigoImovelText: function getCodigoImovelText(codigo) {
      var item = this.itemsCodigoImovel.find(function (c) {
        return c.id === codigo;
      });
      return item ? item.id_texto : '';
    },
    getCodigoContaText: function getCodigoContaText(codigo) {
      var item = this.itemsCodigoConta.find(function (c) {
        return c.id === codigo;
      });
      return item ? item.id_texto : codigo;
    },
    getTipoDocumentoText: function getTipoDocumentoText(tipo) {
      var item = this.translate('value.controlecaixa_tipo_documento').find(function (c) {
        return c.value === tipo;
      });
      return item ? item.text : '';
    },
    getTipoLancamentoText: function getTipoLancamentoText(tipo) {
      var item = this.translate('value.controlecaixa_tipo_lancamento').find(function (c) {
        return c.value === tipo;
      });
      return item ? item.text : '';
    },
    mudarFiltros: function mudarFiltros(val) {
      if (this.filtrosAnterior["dataInicio"] != this.filtros["dataInicio"] || this.filtrosAnterior["dataFim"] != this.filtros["dataFim"]) {
        this.filtrosAnterior["dataInicio"] = this.filtros["dataInicio"];
        this.filtrosAnterior["dataFim"] = this.filtros["dataFim"];
        this.initialize();
      }
    },
    initialize: function initialize() {
      var _this4 = this;

      var where = "condominio_id=" + this.condominio_id;
      if (this.filtros["dataInicio"] != "") where += " AND data >= \"" + this.filtros["dataInicio"] + "\"";
      if (this.filtros["dataFim"] != "") where += " AND data <= \"" + this.filtros["dataFim"] + "\"";

      this.$http.get("api/condominio_controlecaixa?where=" + where).then(function (res) {
        _this4.items = res.body["dados"];
      }, function (err) {
        alert("Ocorreu um erro para carregar os dados");
      });
    },
    updateSum: function updateSum() {
      var filteredItems = this.$refs.ControleCaixaTable.filteredItems;
      this.sum = filteredItems.reduce(function (total, controleCaixa) {
        return {
          entrada: total.entrada + Number(controleCaixa.entrada),
          saida: total.saida + Number(controleCaixa.saida)
        };
      }, { entrada: 0, saida: 0 });
    }
  },
  watch: {
    items: function items(newValue, oldValue) {
      this.updateSum();
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.data"),
        value: "data",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.codigo_imovel"),
        value: "codigo_imovel",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.codigo_conta"),
        value: "codigo",
        align: "codigo_conta"
      }, {
        text: this.translate("table." + this.entity + ".field.numero"),
        value: "numero",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.tipo_documento"),
        value: "tipo_documento",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.historico"),
        value: "historico",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
        value: "cpf_cnpj",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.tipo_lancamento"),
        value: "tipo_lancamento",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.entrada"),
        value: "entrada",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.saida"),
        value: "saida",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.saldo_final"),
        value: "saldo_final",
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.natureza"),
        value: "natureza",
        align: "center"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "10%"
      }];
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_PMoney__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_acl__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_PCpfCnpj__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PMoney: __WEBPACK_IMPORTED_MODULE_1__shared_PMoney__["a" /* default */],
    PCpfCnpj: __WEBPACK_IMPORTED_MODULE_3__shared_PCpfCnpj__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      entity: "condominio_rendimentoacumuladamente",
      items: [],
      sum: {
        rendimentos_tributaveis: 0,
        imposto_retido_fonte: 0
      },
      formaTributacaoOptions: [{ value: 1, text: "Ajuste Anual" }, { value: 2, text: "Exclusivamente na Fonte" }],
      mesesOptions: [{ value: 1, text: "Janeiro" }, { value: 2, text: "Fevereiro" }, { value: 3, text: "Março" }, { value: 4, text: "Abril" }, { value: 5, text: "Maio" }, { value: 6, text: "Junho" }, { value: 7, text: "Julho" }, { value: 8, text: "Agosto" }, { value: 9, text: "Setembro" }, { value: 10, text: "Outubro" }, { value: 11, text: "Novembro" }, { value: 12, text: "Dezembro" }]
    };
  },
  name: "RendimentoAcumuladamente",
  props: ["condominio_id", "anobase_id", "values", "dependente_items"],
  created: function created() {
    this.items = this.values;
    this.editedItem = this.buildDefault();
    this.defaultItem = this.buildDefault();
  },

  watch: {
    items: function items() {
      this.updateSum();
    }
  },
  computed: {
    totalRendimentos: function totalRendimentos() {
      var rend = parseFloat(this.editedItem.rendimentos_tributaveis) || 0;
      var isenta = parseFloat(this.editedItem.parcela_isenta_65_anos) || 0;
      return this.editedItem.forma_tributacao === 2 ? rend + isenta : rend;
    },
    headers: function headers() {
      return [{
        text: this.translate("table." + this.entity + ".field.forma_tributacao"),
        value: "forma_tributacao"
      }, {
        text: this.translate("table." + this.entity + ".field.nome_fonte_pagadora"),
        value: "nome_fonte_pagadora"
      }, {
        text: this.translate("table." + this.entity + ".field.cpf_cnpj_fonte_pagadora"),
        value: "cpf_cnpj_fonte_pagadora"
      }, {
        text: this.translate("table." + this.entity + ".field.mes_recebimento"),
        value: "mes_recebimento",
        sortable: false,
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.numero_meses"),
        value: "numero_meses",
        sortable: false,
        align: "center"
      }, {
        text: this.translate("table." + this.entity + ".field.rendimentos_tributaveis"),
        value: "rendimentos_tributaveis",
        sortable: false,
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.parcela_isenta_65_anos"),
        value: "parcela_isenta_65_anos",
        sortable: false,
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.contribuicao_previdenciaria_oficial"),
        value: "contribuicao_previdenciaria_oficial",
        sortable: false,
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.imposto_retido_fonte"),
        value: "imposto_retido_fonte",
        sortable: false,
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.valor_recebido_juros"),
        value: "valor_recebido_juros",
        sortable: false,
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.total_rendimentos"),
        value: "total_rendimentos",
        sortable: false,
        align: "right"
      }, {
        text: this.translate("table." + this.entity + ".field.pessoa_dependente_id"),
        value: "dependente.id_texto"
      }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center",
        width: "10%"
      }];
    }
  },
  methods: {
    buildDefault: function buildDefault() {
      return {
        condominio_id: this.condominio_id,
        anobase_id: this.anobase_id,
        registro_tipo: 1,
        forma_tributacao: null,
        cpf_cnpj_fonte_pagadora: "",
        nome_fonte_pagadora: "",
        rendimentos_tributaveis: 0,
        parcela_isenta_65_anos: 0,
        total_rendimentos: 0,
        valor_recebido_juros: 0,
        contribuicao_previdenciaria_oficial: 0,
        imposto_retido_fonte: 0,
        mes_recebimento: null,
        numero_meses: null,
        pessoa_dependente_id: null
      };
    },
    getFormaTributacaoText: function getFormaTributacaoText(value) {
      var opt = this.formaTributacaoOptions.find(function (o) {
        return o.value === value;
      });
      return opt ? opt.text : value;
    },
    getMesText: function getMesText(value) {
      var opt = this.mesesOptions.find(function (o) {
        return o.value === value;
      });
      return opt ? opt.text : value || "";
    },
    updateSum: function updateSum() {
      var table = this.$refs.RendimentoAcumuladamenteTable;
      if (!table) return;
      this.sum = table.filteredItems.reduce(function (acc, item) {
        acc.rendimentos_tributaveis += item.rendimentos_tributaveis || 0;
        acc.parcela_isenta_65_anos += item.parcela_isenta_65_anos || 0;
        acc.contribuicao_previdenciaria_oficial += item.contribuicao_previdenciaria_oficial || 0;
        acc.imposto_retido_fonte += item.imposto_retido_fonte || 0;
        acc.valor_recebido_juros += item.valor_recebido_juros || 0;
        acc.total_rendimentos += item.total_rendimentos || 0;
        return acc;
      }, {
        rendimentos_tributaveis: 0,
        parcela_isenta_65_anos: 0,
        contribuicao_previdenciaria_oficial: 0,
        imposto_retido_fonte: 0,
        valor_recebido_juros: 0,
        total_rendimentos: 0
      });
    },
    beforeSave: function beforeSave() {
      this.editedItem.registro_tipo = this.editedItem.pessoa_dependente_id ? 2 : 1;
      this.editedItem.total_rendimentos = this.totalRendimentos;
    },

    // type 1 = pdf 2 = excel
    exportReport: function exportReport(type) {
      var _this2 = this;

      this.$store.commit("loader/change_dialog", true);
      this.$http.put("report/report_details/" + this.condominio_id, { "type": type, "table": "condominio_rendimentoacumuladamente", "search": this.search }).then(function (res) {
        var fileName = res.data;
        window.open("https://app.api.conttech.com.br/" + "reports/" + fileName, "_blank");
        _this2.$store.commit("loader/change_dialog", false);
        setTimeout(function () {
          _this.$http.delete("report/delete_upload_report/" + fileName);
        }, 5000);
      }, function (error) {
        _this2.$store.commit("loader/change_dialog", false);
        _this2.$store.commit("snackbar/change_values", {
          text: error.body.message || "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
          color: "error",
          dialog: true
        });
      });
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_crud__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixin_acl__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_crud__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixin_acl__["a" /* default */]],
  data: function data() {
    return {
      fab: null,
      entity: "anobase",
      snackbar: {
        active: false,
        text: "Não foi possível excluir o registro"
      }
    };
  },
  created: function created() {
    this.initialize();
  },
  methods: {
    afterSave: function afterSave() {
      location.reload();
    },
    deleteItem: function deleteItem(item) {
      var _this = this;

      var index = this.items.indexOf(item);
      if (confirm(this.translate("system.alert.delete"))) {
        this.$http.delete("api/" + this.entity + "/" + item.id).then(function (response) {
          _this.items.splice(index, 1);
        }, function (response) {
          console.log(response);
          _this.snackbar.active = true;
        });
      }
      setTimeout(function () {
        location.reload();
      }, 1000);
    }
  },
  computed: {
    headers: function headers() {
      return [{ text: this.translate("table." + this.entity + ".field.id_texto"), value: "id_texto" }, { text: this.translate("table." + this.entity + ".field.observacao"), value: "observacao" }, {
        text: this.translate("system.table.action"),
        value: "action",
        sortable: false,
        align: "center"
      }];
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Card__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_0__shared_Card__["a" /* default */] },
  data: function data() {
    return {
      user: {
        email: '',
        password: ''
      },
      rememberMe: false,
      loading: false
    };
  },

  methods: {
    login: function login() {
      this.loading = true;
      this.$auth.login({
        body: this.user,
        fetchUser: true,
        rememberMe: this.rememberMe,
        success: function success(res) {
          this.loading = false;
        },
        error: function error(res) {
          alert('Ocorreu algum problema no login! Favor Confira os dados!');
          this.loading = false;
        },
        redirect: '/home'
      });
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Card__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(122);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_1__shared_Card__["a" /* default */] },
  data: function data() {
    return {
      codigo: "",
      loading: false,
      user: {
        name: "",
        email: "",
        password: "",
        confirmation: ""
      },
      snackbar: {
        active: false,
        text: "Solicitação realizada com sucesso",
        color: "success"
      }
    };
  },
  props: {
    source: String
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend("verify_email", {
      getMessage: function getMessage(field) {
        return "The " + field + " is already registered.";
      },
      validate: function validate(value) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          _this.$http.get("auth/check_user", { params: { email: _this.user.email } }).then(function (res) {
            resolve({
              valid: res.body.length === 0
            });
          });
        });
      }
    });
  },

  methods: {
    register: function register() {
      var _this2 = this;

      if (this.codigo !== "codigoimpostoderenda123") {
        alert("Código errado!");
        return 0;
      }
      if (this.user.password !== this.user.confirmation) {
        alert("A senha e a confirmação devem ser iguais!");
        return 0;
      }
      this.loading = true;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.snackbar.active = true;
          _this2.$auth.register({
            body: _this2.user,
            autoLogin: true,
            rememberMe: true,
            success: function success(res) {
              this.snackbar = {
                active: true,
                text: "Solicitação realizada com sucesso",
                color: "success"
              };
              this.loading = false;
            },
            error: function error(res) {
              this.snackbar = {
                active: true,
                text: "Solicitação falhou",
                color: "error"
              };
              this.loading = false;
            },
            redirect: "/home"
          });
        }
      });
    }
  }
});

/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Card__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_0__shared_Card__["a" /* default */] },
  data: function data() {
    return {
      email: ''
    };
  },

  methods: {
    reset: function reset() {
      this.$http.post('auth/forgot-password', { email: this.email }).then(function () {}, function (res) {});
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Card__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_0__shared_Card__["a" /* default */] },
  data: function data() {
    return {
      user: {
        password: '',
        confirmation: '',
        token: this.$route.params.token
      }
    };
  },

  methods: {
    reset: function reset() {
      this.$http.post('auth/reset-password/', this.user).then(function () {}, function (res) {});
    }
  }
});

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_resource__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multilanguage__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multilanguage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_util_colors__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translate_index__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_google_autocomplete__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_pt_BR__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_pt_BR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_pt_BR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_decimal_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_decimal_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_decimal_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_editor__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_quill_editor__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_quill_editor__);




// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


















__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_quill_editor___default.a);

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.moment = __WEBPACK_IMPORTED_MODULE_15_moment___default.a;

window.$ = window.jQuery = __webpack_require__(480);
__webpack_require__(481);

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  next();
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vuetify_google_autocomplete__["a" /* default */], {
  apiKey: 'AIzaSyDK8GZ5VV1Wkk6jhFEAvbDL8ajhVDvarCU' // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  // version: '...', // Optional
});
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue2_editor__["a" /* default */]);

// Configuração global de interceptadores
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.interceptors.push(function (request, next) {
  // Antes de enviar a requisição

  // Adicione headers comuns, se necessário
  // request.headers.set('Authorization', 'Bearer seu_token_aqui')

  // Continue com a próxima etapa
  next(function (response) {
    // Após receber a resposta

    // Lógica para tratamento de erros
    if (response.status >= 400) {
      console.error('Erro na requisição:', response.status, response.body);
    }
  });
});

// Configura o VeeValidate com as mensagens em português
__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].localize('pt_BR', { messages: __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_pt_BR__["messages"] });

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_multilanguage___default.a, __WEBPACK_IMPORTED_MODULE_12__translate_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuetify___default.a, {
  theme: {
    primary: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_util_colors___default.a.green.darken3, // #E53935
    secondary: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_util_colors___default.a.blue.darken3, // #FFCDD2
    accent: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_util_colors___default.a.indigo.base // #3F51B5
  }
});
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__webpack_require__(482), {
  refreshData: { enabled: false, interval: 0 },
  auth: __webpack_require__(486),
  http: __webpack_require__(487),
  router: __webpack_require__(488),
  rolesVar: 'type'
});

// Validator.localize('pt_BR', ptBR)
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.options.root = "https://app.api.conttech.com.br/";

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('formatPercentage', function (value) {
  if (value) {
    return new __WEBPACK_IMPORTED_MODULE_18_decimal_js___default.a(value).toDP(15).toString();
  } else if (value === 0) {
    return '0';
  }
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_15_moment___default()(String(value)).format('DD/MM/YYYY');
  }
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('formatDateTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_15_moment___default()(String(value)).format('DD/MM/YYYY hh:mm:ss');
  }
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('formatCPF', function (value) {
  if (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('formatCpfCnpj', function (valor) {
  if (valor && valor.length === 11) {
    // Aplica a máscara de CPF
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (valor && valor.length === 14) {
    // Aplica a máscara de CNPJ
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    return valor;
  }
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('formatCurrency', function (value) {
  if (typeof value !== 'number') {
    return value;
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('formatDouble', function (value) {
  if (!value) return '';
  return parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
});
// -------- Validations -------------------
// Validar se o valor é positivo
__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].extend('positiveNumber', {
  getMessage: function getMessage(field) {
    return 'O campo ' + field + ' deve ter um valor positivo.';
  },
  validate: function validate(value) {
    console.log(value); // Adicionando console.log para depurar o valor
    return {
      valid: value >= 0
    };
  }
});

// Validar se o campo é obrigatório
__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].extend('requiredNumber', {
  getMessage: function getMessage(field) {
    return 'O campo ' + field + ' \xE9 obrigat\xF3rio.';
  },
  validate: function validate(value) {
    return {
      valid: value !== "" && value !== 0
    };
  }
});

__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].extend('currentYear', {
  getMessage: function getMessage(field, _ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
        year = _ref2[0];

    return 'O ano do campo ' + field + ' deve ser igual ao Ano Base ' + year + '.';
  },
  validate: function validate(value, _ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
        year = _ref4[0];

    var dateParts = value.split('/');
    var currentYear = parseInt(dateParts[2]);
    var isValid = !isNaN(currentYear) && currentYear === parseInt(year);

    console.log("dateParts", dateParts, "currentYear", currentYear, "year", year, "isValid", isValid);

    return isValid;
  }
});

__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].extend('validCpf', {
  getMessage: function getMessage(field) {
    return 'O campo ' + field + ' \xE9 inv\xE1lido.';
  },
  validate: function validate(cpf) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      var numericCpf = cpf.replace(/\D/g, '');
      var result = true;
      if (!numericCpf || numericCpf.length != 11 || numericCpf == "00000000000" || numericCpf == "11111111111" || numericCpf == "22222222222" || numericCpf == "33333333333" || numericCpf == "44444444444" || numericCpf == "55555555555" || numericCpf == "66666666666" || numericCpf == "77777777777" || numericCpf == "88888888888" || numericCpf == "99999999999") result = false;
      var soma = 0;
      var resto = void 0;
      for (var i = 1; i <= 9; i++) {
        soma = soma + parseInt(numericCpf.substring(i - 1, i)) * (11 - i);
      }resto = soma * 10 % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(numericCpf.substring(9, 10))) result = false;
      soma = 0;
      for (var _i = 1; _i <= 10; _i++) {
        soma = soma + parseInt(numericCpf.substring(_i - 1, _i)) * (12 - _i);
      }resto = soma * 10 % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(numericCpf.substring(10, 11))) result = false;

      resolve({
        valid: result
      });
    });
  }
});

__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].extend('validCnpj', {
  getMessage: function getMessage(field) {
    return 'O campo ' + field + ' \xE9 inv\xE1lido.';
  },
  validate: function validate(cnpj) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      var numericCnpj = cnpj.replace(/\D/g, '');
      var result = true;
      if (!numericCnpj || numericCnpj.length != 14 || numericCnpj == "00000000000000" || numericCnpj == "11111111111111" || numericCnpj == "22222222222222" || numericCnpj == "33333333333333" || numericCnpj == "44444444444444" || numericCnpj == "55555555555555" || numericCnpj == "66666666666666" || numericCnpj == "77777777777777" || numericCnpj == "88888888888888" || numericCnpj == "99999999999999") result = false;
      var tamanho = numericCnpj.length - 2;
      var numeros = numericCnpj.substring(0, tamanho);
      var digitos = numericCnpj.substring(tamanho);
      var soma = 0;
      var pos = tamanho - 7;
      for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0)) result = false;
      tamanho = tamanho + 1;
      numeros = numericCnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (var _i2 = tamanho; _i2 >= 1; _i2--) {
        soma += numeros.charAt(tamanho - _i2) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) result = false;
      resolve({
        valid: result
      });
    });
  }
});

__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].extend('validCAEPF', {
  getMessage: function getMessage(field, params, data) {
    return data && data.message || 'O campo ' + field + ' \xE9 inv\xE1lido.';
  },

  validate: function validate(value) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      var caepf = String(value).replace(/[^0-9]*/g, "");
      if (caepf.length !== 14) {
        return false;
      }
      var caepfBase = caepf.slice(0, 12);
      var digitosReverse = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(caepfBase)).reverse().reduce(function (previousValue, currentValue) {
        previousValue.push(Number(currentValue));
        return previousValue;
      }, []);
      var calcModuleDV = function calcModuleDV(array) {
        var nModuleInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
        var nModuleMin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

        var nModule = 9;
        var result = 0;
        for (var index = 0; index < array.length; index++) {
          var element = array[index];
          result += element * nModule;
          nModule > nModuleMin ? nModule = nModule - 1 : nModule = nModuleInit;
        }
        result = result % 11;
        if (result === 10) {
          result = 0;
        }
        return result;
      };
      var firstDigitDV = calcModuleDV(digitosReverse);
      var lastDigitDV = calcModuleDV([firstDigitDV].concat(digitosReverse));
      var resultDV = firstDigitDV * 10 + lastDigitDV + 12;
      if (resultDV > 99) {
        resultDV = resultDV - 100;
      }
      var resultDVString = "";
      if (resultDV == 0) {
        resultDVString = "00";
      } else if (resultDV > 0 && resultDV < 10) {
        resultDVString = '0' + resultDV;
      } else {
        resultDVString = String(resultDV);
      }
      var validCAEPF = '' + caepfBase + resultDVString;

      // Verificar se o dígito verificador calculado é igual ao dígito verificador informado
      var isValid = caepf === validCAEPF;

      if (!isValid) {
        resolve({
          valid: false,
          data: { message: 'Por favor, verifique os valores inseridos. O CAEPF informado é inválido.' }
        });
      }

      resolve({ valid: true });
    });
  }
});

__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* Validator */].extend('_validCAEPF', {
  getMessage: function getMessage(field) {
    return 'O campo ' + field + ' \xE9 inv\xE1lido.';
  },
  validate: function validate(caepf) {
    caepf = caepf.replace(/\D/g, ""); // Remover caracteres não numéricos
    var primeiros12Digitos = caepf.substring(0, 12);

    // Verificar se o CAEPF possui 12 dígitos
    if (primeiros12Digitos.length !== 12) {
      return {
        valid: false,
        data: { message: 'O CAEPF deve conter exatamente 12 dígitos.' }
      };
    }

    // Calcular o dígito verificador
    var soma = 0;
    for (var i = 0; i < 10; i++) {
      soma += parseInt(caepf.charAt(i)) * (11 - i);
    }
    var resto = soma * 10 % 11;
    if (resto === 10) {
      resto = 0;
    }

    // Verificar se o dígito verificador calculado é igual ao dígito verificador informado
    var isValid = parseInt(caepf.charAt(10)) === resto;

    if (!isValid) {
      return {
        valid: false,
        data: { message: 'Por favor, verifique os valores inseridos. O CAEPF informado é inválido.' }
      };
    }

    return { valid: true };
  }
});

// ---------------------------------


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] },
  template: '<App/>',
  methods: {
    merge: function merge(a, b, prop) {
      var reduced = a.filter(function (aitem) {
        return !b.find(function (bitem) {
          return aitem[prop] === bitem[prop];
        });
      });
      return reduced.concat(b);
    },
    cloneObject: function cloneObject(object) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    }
  }
});

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dab84d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(292);
function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dab84d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */,
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$auth.ready())?_c('v-content',[_c('router-view')],1):_c('v-content',[_c('v-container',{staticClass:"background",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","width":5,"color":"white"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 293 */,
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_In_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5fd707_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_In_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_In_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5fd707_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_In_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PLoader_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd4a2c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PLoader_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dd4a2c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd4a2c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"value":_vm.dialog,"persistent":"","max-width":"250"}},[_c('v-card',{attrs:{"id":"tranparency"}},[_c('v-card-text',{staticClass:"center",staticStyle:{"overflow-y":"hidden !important"}},[_c('v-progress-circular',{attrs:{"size":170,"width":7,"color":"primary","indeterminate":""}},[_c('div',{staticClass:"center"},[_c('img',{attrs:{"src":"static/img/line.svg","width":"90px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Carregando")])])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PSnackbar_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9df8c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PSnackbar_vue__ = __webpack_require__(301);
function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d9df8c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PSnackbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9df8c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PSnackbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-snackbar',{attrs:{"auto-height":"","color":_vm.values.color || 'info',"timeout":_vm.values.timeout || 3000,"left":"","bottom":""},model:{value:(_vm.values.dialog),callback:function ($$v) {_vm.$set(_vm.values, "dialog", $$v)},expression:"values.dialog"}},[_vm._v("\n      "+_vm._s(_vm.values.text || '')+"\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){return _vm.$store.commit('snackbar/change_values', {dialog: false})}}},[_c('v-icon',[_vm._v(_vm._s(this.translate('system.button.close.icon')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PChangePassword_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8179cb26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PChangePassword_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8179cb26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8179cb26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","justify-left":"","align-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"380"},model:{value:(_vm.dialogChangePassword),callback:function ($$v) {_vm.dialogChangePassword=$$v},expression:"dialogChangePassword"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Alterar Senha")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"240px"}},[_c('v-form',{nativeOn:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.customFilter(null, _vm.postFilter)}]}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"lock","autocomplete":"current-password","name":"oldPassword","label":"Senha Atual","type":"password","autofocus":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm($event)}},model:{value:(_vm.editedItem.oldPassword),callback:function ($$v) {_vm.$set(_vm.editedItem, "oldPassword", $$v)},expression:"editedItem.oldPassword"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"lock","autocomplete":"new-password","name":"newPassword","label":"Senha Nova","id":"newPassword","type":"password"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm($event)}},model:{value:(_vm.editedItem.newPassword),callback:function ($$v) {_vm.$set(_vm.editedItem, "newPassword", $$v)},expression:"editedItem.newPassword"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"lock","autocomplete":"new-password","name":"newPasswordConfirm","label":"Confirmação de Senha","id":"newPasswordConfirm","type":"password"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm($event)}},model:{value:(_vm.editedItem.newPasswordConfirm),callback:function ($$v) {_vm.$set(_vm.editedItem, "newPasswordConfirm", $$v)},expression:"editedItem.newPasswordConfirm"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.confirm}},[_vm._v("Confirmar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.close}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Atualizacao_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c715efd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Atualizacao_vue__ = __webpack_require__(314);
function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c715efd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Atualizacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c715efd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Atualizacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtualizacaoMatriz_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93e2c49c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AtualizacaoMatriz_vue__ = __webpack_require__(310);
function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93e2c49c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtualizacaoMatriz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93e2c49c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AtualizacaoMatriz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */,
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"1150px","persistent":""},model:{value:(_vm.dialogCreateEdit),callback:function ($$v) {_vm.dialogCreateEdit=$$v},expression:"dialogCreateEdit"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v("\n                "+_vm._s(_vm.view == 2 ? "Inclusão" : _vm.view == 3 ? "Edição" : "Consulta")+" de Atualização\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Título"},model:{value:(_vm.editedItem.titulo),callback:function ($$v) {_vm.$set(_vm.editedItem, "titulo", $$v)},expression:"editedItem.titulo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Data da Atualização","prepend-icon":"event"},on:{"blur":function($event){_vm.date = _vm.parseDate(_vm.dateFormatted)}},model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v},expression:"dateFormatted"}},on))]}}]),model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","locale":"pt-BR"},on:{"input":function($event){_vm.menu1 = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.time,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.time=$event},"update:return-value":function($event){_vm.time=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Hora da Atualização","prepend-icon":"access_time","readonly":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},on))]}}]),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),(_vm.menu2)?_c('v-time-picker',{attrs:{"full-width":"","format":"24hr"},on:{"click:minute":function($event){return _vm.$refs.menu.save(_vm.time)}},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('vue-editor',{attrs:{"disabled":_vm.disabled,"editorToolbar":_vm.toolbarOptions},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}}),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Descrição"},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close()}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Consulta de Atualizações Matriz")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',{attrs:{"color":"primary","fab":"","small":"","dark":""},on:{"click":function () {
                  _vm.view = '2';
                  _vm.dialogCreateEdit = true;
                }}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v("Adicionar")])])],1)],1),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('v-card-text',{key:index},[_c('div',{staticClass:"custom-v-card-text"},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('span',{staticClass:"headline font-weight-bold"},[_vm._v("\n            "+_vm._s(item.titulo)+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$auth.user().acesso_interno == 'dev')?_c('v-btn',{attrs:{"flat":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.editItem(item)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$auth.user().acesso_interno == 'dev')?_c('v-btn',{attrs:{"flat":"","icon":"","color":"red"},on:{"click":function($event){return _vm.deleteItem(item)}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-chip',{attrs:{"color":"grey darken-1","text-color":"white"}},[_vm._v("\n            "+_vm._s(_vm.formatarData(item.data_hora))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"caption",domProps:{"innerHTML":_vm._s(item.descricao)}})],1)])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtualizacaoUser_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f94e94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AtualizacaoUser_vue__ = __webpack_require__(313);
function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44f94e94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtualizacaoUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f94e94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AtualizacaoUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Consulta de Atualizações")])])],1)],1),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('v-card-text',{key:index},[_c('div',{class:{ 'custom-v-card-text': !item.visualizada }},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('span',{staticClass:"headline font-weight-bold"},[_vm._v("\n            "+_vm._s(item.atualizacao.titulo)+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","color":"blue"}},[(item.visualizada)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":function () {
                      _vm.editedItem.atualizacao_id = item.id;
                      _vm.save(item.id);
                    }}},on),[_vm._v("\n                  visibility\n                ")])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Marcar como não visualizada")])]):_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                    var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":function () {
                      _vm.editedItem.visualizada = true;
                      _vm.editedItem.user_id = _vm.$auth.user().id;
                      _vm.editedItem.atualizacao_id = item.id;
                      _vm.save(item.id);
                    }}},on),[_vm._v("\n                  visibility_off\n                ")])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Marcar como visualizada")])])],1),_vm._v(" "),_c('v-chip',{attrs:{"color":"grey darken-1","text-color":"white"}},[_vm._v("\n            "+_vm._s(_vm.formatarData(item.atualizacao.data_hora))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"caption",domProps:{"innerHTML":_vm._s(item.atualizacao.descricao)}})],1)])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"0"},attrs:{"fluid":""}},[_c('v-dialog',{attrs:{"max-width":"1200"},model:{value:(_vm.dialogIndex),callback:function ($$v) {_vm.dialogIndex=$$v},expression:"dialogIndex"}},[_c('v-card',[_c('v-card-text',[_c('v-tabs',{attrs:{"color":"primary","dark":"","slider-color":"white"}},[(_vm.$auth.user().acesso_interno == 'dev')?_c('v-tab',[_vm._v("Atualizações Matriz")]):_vm._e(),_vm._v(" "),(_vm.$auth.user().acesso_interno == 'dev')?_c('v-tab-item',[_c('atualizacao-matriz',{ref:"atualizacaoMatriz"})],1):_vm._e(),_vm._v(" "),_c('v-tab',[_vm._v("Atualizações")]),_vm._v(" "),_c('v-tab-item',[_c('atualizacao-user')],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function () { return (_vm.dialogIndex = false); }}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","dark":""},on:{"click":_vm.abrirDialog}},[_c('v-badge',{attrs:{"color":"purple","left":"","overlap":""},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_vm._v("\n        "+_vm._s(_vm.quantidade_atualizacao_nao_visualizada)+"\n      ")]},proxy:true}])},[_vm._v(" "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("notifications")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('p-loader'),_vm._v(" "),_c('p-snackbar'),_vm._v(" "),_c('p-change-password',{ref:"changePassword"}),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","dark":"","color":"primary"}},[_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{attrs:{"id":"top-menu"}},[_c('v-menu',{attrs:{"transition":"scale-transition","origin":"left"}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_vm._v("\n          Ano Base: "+_vm._s(this.$auth.user().anobase.id_texto || "Não definido")+"\n          "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('v-list',_vm._l((this.$auth.user().anosbases),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){return _vm.changeYear(item.id)}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.id_texto)}})],1)}),1)],1),_vm._v(" "),(this.$auth.user().acesso_interno == 'dev')?_c('v-menu',{attrs:{"transition":"scale-transition","origin":"left"}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_vm._v("\n          "+_vm._s(this.$auth.user().empresa.id_texto)+"\n          "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('v-list',_vm._l((this.$auth.user().empresas),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){return _vm.changeCompany(item.id)}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.id_texto)}})],1)}),1)],1):_vm._e(),_vm._v(" "),_c('span'),_vm._v(" "),_c('v-btn',{attrs:{"to":"/pessoa","flat":"","disabled":!_vm.hasAccess('pessoa', 'read')}},[_vm._v("Pessoa")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":!_vm.hasAccess('contribuinte', 'read')},on:{"click":function($event){return _vm.para('/contribuinte')}}},[_vm._v("\n        Contribuinte\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.hasAccess('condominio', 'read'),"flat":""},on:{"click":function($event){return _vm.para('/condominio')}}},[_vm._v("\n        Condominio\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/anobase","disabled":!_vm.hasAccess('anobase', 'read'),"flat":""}},[_vm._v("Ano base")]),_vm._v(" "),(
          this.$auth.user().acesso_interno == 'dev' || this.$auth.user().acesso_interno == 'admin'
        )?_c('v-btn',{attrs:{"to":"/usuario","disabled":!_vm.hasAccess('usuario', 'read'),"flat":""}},[_vm._v("\n        Usuario\n      ")]):_vm._e(),_vm._v(" "),(
          this.$auth.user().acesso_interno == 'dev' || this.$auth.user().acesso_interno == 'admin'
        )?_c('v-btn',{attrs:{"to":"/acesso","disabled":!_vm.hasAccess('acesso', 'read'),"flat":""}},[_vm._v("\n        Acesso\n      ")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"to":"/suporte","flat":"","disabled":!_vm.hasAccess('suporte', 'read')}},[_vm._v("Suporte")]),_vm._v(" "),_c('v-menu',{attrs:{"origin":"center center","transition":"scale-transition"}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_vm._v("\n          "+_vm._s(this.$auth.user().name)+"\n          "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.changePassword()}}},[_c('v-list-tile-title',[_vm._v("Alterar Senha")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.logout()}}},[_c('v-list-tile-title',[_vm._v("Sair")])],1)],1)],1),_vm._v(" "),(this.$auth.user().acesso_interno == 'dev')?_c('v-menu',{attrs:{"transition":"scale-transition","origin":"left"}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("manage_accounts")])],1),_vm._v(" "),_c('v-list',_vm._l((this.$auth.user().users),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){return _vm.changeUser(item.id)}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.name)}})],1)}),1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"app":""}},[_c('v-flex',{attrs:{"xs12":"","py-3":"","text-xs-center":""}},[_c('span',[_vm._v("\n        © "+_vm._s(new Date().getFullYear())+" -\n        "),_c('strong',[_vm._v(_vm._s(_vm.title))])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Out_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455ac8da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Out_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-455ac8da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Out_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455ac8da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Out_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container",style:({
    backgroundImage: ("url('static/img/wallpapers/wp" + (1 + Math.floor(Math.random() * 7)) + ".jpg')"),
  }),attrs:{"fill-height":"","fluid":""}},[_c('div',{staticClass:"overlay",staticStyle:{"z-index":"1000"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pessoa_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fabd94a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pessoa_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fabd94a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pessoa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fabd94a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pessoa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contato_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b378dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contato_vue__ = __webpack_require__(326);
function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73b378dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b378dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.pessoa.isOwner},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(_vm.translate("value.contato_tipo").filter(function (a) { return a.value == props.item.tipo; })[0].text)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.pessoa.isOwner},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.pessoa.isOwner},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.tipo'),"items":_vm.translate('value.contato_tipo'),"name":"tipo","error-messages":_vm.errors.collect('tipo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.tipo')},model:{value:(_vm.editedItem.tipo),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo", $$v)},expression:"editedItem.tipo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"name":"id_texto","counter":"","maxlength":"60","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Empresa_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982d200_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Empresa_vue__ = __webpack_require__(329);
function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1982d200"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Empresa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982d200_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Empresa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Compartilhamento de Pessoas")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.pessoa.isOwner},on:{"click":function($event){return _vm.refreshEmpresas(2)}}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[(props.item.ativo)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",staticStyle:{"cursor":"default"},attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("lock_open")])],1),_vm._v(" "),_c('span',[_vm._v("Acesso Liberado")])],1):_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",staticStyle:{"cursor":"default"},attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("lock")])],1),_vm._v(" "),_c('span',[_vm._v("Acesso Bloqueado")])],1),_vm._v("\n            "+_vm._s(props.item.empresa.id_texto)+"\n          ")],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.pessoa.isOwner,"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Compartilhamento de Pessoas")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.empresa_id'),"item-text":"id_texto","item-value":"id","items":_vm.dynamicEmpresas,"name":"empresa_id","error-messages":_vm.errors.collect('empresa_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.empresa_id')},model:{value:(_vm.editedItem.empresa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "empresa_id", $$v)},expression:"editedItem.empresa_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PessoaDependente_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b0d387_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PessoaDependente_vue__ = __webpack_require__(333);
function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46b0d387"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PessoaDependente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b0d387_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PessoaDependente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.v_validate),expression:"v_validate"}],ref:"textfield",attrs:{"label":_vm.label,"disabled":_vm.disabled,"rules":_vm.rules,"return-masked-value":"","mask":"##/##/####","error-messages":_vm.errors.collect(_vm.errors_collect),"data-vv-as":_vm.data_vv_as,"min":"minvalue","max":"maxvalue","name":_vm.name},on:{"blur":function($event){return _vm.updateValues(_vm.dateFormatted)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"h",undefined,$event.key,undefined)){ return null; }return _vm.updateValues(_vm.dateFormatted, false)}},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{on:{"click":function($event){return _vm.openMenu()}}},[_vm._v("event")])]},proxy:true}],null,true),model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v},expression:"dateFormatted"}})]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{ref:"teste",staticStyle:{"display":"table-cell"},attrs:{"locale":"pt-br","max":_vm.max},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.pessoa.isOwner},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(_vm.translate("value.pessoa_dependente_tipo").filter(
                function (a) { return a.value == props.item.tipo; }
              )[0].text)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.cpf))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(props.item.nascimento)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.residencia_com_titular ? "Sim" : "Não"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.telefone))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.pessoa.isOwner},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.pessoa.isOwner},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.tipo'),"items":_vm.translate('value.pessoa_dependente_tipo'),"name":"tipo","error-messages":_vm.errors.collect('tipo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.tipo')},model:{value:(_vm.editedItem.tipo),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo", $$v)},expression:"editedItem.tipo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"counter":"","maxlength":"60","name":"id_texto","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"C.P.F","required":"","return-masked-value":"","mask":"###.###.###-##","name":"cpf","error-messages":_vm.errors.collect('cpf'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.cpf')},model:{value:(_vm.editedItem.cpf),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf", $$v)},expression:"editedItem.cpf"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-date',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.nascimento'),"name":"nascimento","v_validate":'required',"as":_vm.translate('table.' + _vm.entity + '.field.nascimento'),"errors_collect":"nascimento"},model:{value:(_vm.editedItem.nascimento),callback:function ($$v) {_vm.$set(_vm.editedItem, "nascimento", $$v)},expression:"editedItem.nascimento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.e_mail'),"counter":"","maxlength":"60","name":"e_mail","error-messages":_vm.errors.collect('e_mail')},model:{value:(_vm.editedItem.e_mail),callback:function ($$v) {_vm.$set(_vm.editedItem, "e_mail", $$v)},expression:"editedItem.e_mail"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.telefone'),"counter":"","maxlength":"15","name":"telefone","error-messages":_vm.errors.collect('telefone')},model:{value:(_vm.editedItem.telefone),callback:function ($$v) {_vm.$set(_vm.editedItem, "telefone", $$v)},expression:"editedItem.telefone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.residencia_com_titular'),"name":"residencia_com_titular","error-messages":_vm.errors.collect('residencia_com_titular'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.residencia_com_titular')},model:{value:(_vm.editedItem.residencia_com_titular),callback:function ($$v) {_vm.$set(_vm.editedItem, "residencia_com_titular", $$v)},expression:"editedItem.residencia_com_titular"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PExportLCDPR_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1021fb98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PExportLCDPR_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1021fb98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PExportLCDPR_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1021fb98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PExportLCDPR_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","justify-left":"","align-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"600"},model:{value:(_vm.dialogExportLCDPR),callback:function ($$v) {_vm.dialogExportLCDPR=$$v},expression:"dialogExportLCDPR"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Gerar LCDPR")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"500px"}},[_c('v-form',{nativeOn:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm()}]}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.condominiosPessoa,"label":"Condominios","multiple":"","item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.condominios_ids),callback:function ($$v) {_vm.$set(_vm.editedItem, "condominios_ids", $$v)},expression:"editedItem.condominios_ids"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":[{value: 0,text:'Regular(Início no primeiro dia do ano)'},{value:1 ,text:'Abertura (Início de atividades no ano-calendário)'},{value:2 ,text:'Inicio de obrigatoriedade da escritura no curso do ano calendário'}],"label":"Indicador de Início do Período"},model:{value:(_vm.editedItem.ind_sit_ini_per),callback:function ($$v) {_vm.$set(_vm.editedItem, "ind_sit_ini_per", $$v)},expression:"editedItem.ind_sit_ini_per"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":[{value:0,text:'Normal'},{value:1,text:'Falecimento'},{value:2,text:'Espólio'},{value:3,text:'Saída definitica do País'}],"label":"Indicador de Situação Especial e Outros Eventos"},model:{value:(_vm.editedItem.sit_especial),callback:function ($$v) {_vm.$set(_vm.editedItem, "sit_especial", $$v)},expression:"editedItem.sit_especial"}})],1),_vm._v(" "),(_vm.editedItem.sit_especial !== 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('p-date',{attrs:{"label":"Data da Situação Especial"},model:{value:(_vm.editedItem.dt_sit_esp),callback:function ($$v) {_vm.$set(_vm.editedItem, "dt_sit_esp", $$v)},expression:"editedItem.dt_sit_esp"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"required":"","name":"dt_ini","error-messages":_vm.errors.collect('dt_ini'),"data-vv-as":"Data do Início","label":"Data do Início do Período"},model:{value:(_vm.editedItem.dt_ini),callback:function ($$v) {_vm.$set(_vm.editedItem, "dt_ini", $$v)},expression:"editedItem.dt_ini"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"dt_fin","error-messages":_vm.errors.collect('dt_fin'),"data-vv-as":"Data do Fim","label":"Data do Início do Período"},model:{value:(_vm.editedItem.dt_fin),callback:function ($$v) {_vm.$set(_vm.editedItem, "dt_fin", $$v)},expression:"editedItem.dt_fin"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":[{value:1,text:'Livro Caixa'},{value:2,text:'Apuração do lucro pelo disposto no art. 5º da Lei nº 8.023, de 1990'}],"label":"Indicador de Situação Especial e Outros Eventos"},model:{value:(_vm.editedItem.forma_apur),callback:function ($$v) {_vm.$set(_vm.editedItem, "forma_apur", $$v)},expression:"editedItem.forma_apur"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nome contador"},model:{value:(_vm.editedItem.ident_nom),callback:function ($$v) {_vm.$set(_vm.editedItem, "ident_nom", $$v)},expression:"editedItem.ident_nom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"cpf/cnpj do contador"},model:{value:(_vm.editedItem.ident_cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "ident_cpf_cnpj", $$v)},expression:"editedItem.ident_cpf_cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Número de inscrição do contador"},model:{value:(_vm.editedItem.ind_crc),callback:function ($$v) {_vm.$set(_vm.editedItem, "ind_crc", $$v)},expression:"editedItem.ind_crc"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"email do contador"},model:{value:(_vm.editedItem.email),callback:function ($$v) {_vm.$set(_vm.editedItem, "email", $$v)},expression:"editedItem.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Telefone do contador"},model:{value:(_vm.editedItem.fone),callback:function ($$v) {_vm.$set(_vm.editedItem, "fone", $$v)},expression:"editedItem.fone"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.confirm}},[_vm._v("Confirmar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.close}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PExportCaixaGeral_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92a17318_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PExportCaixaGeral_vue__ = __webpack_require__(341);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-92a17318"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PExportCaixaGeral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92a17318_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PExportCaixaGeral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-height"},[_c('div',{staticClass:"custom-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('money',_vm._b({staticClass:"money_input",attrs:{"readonly":_vm.readonly,"disabled":_vm.disabled,"value":parseFloat(_vm.value),"maxlength":_vm.maxLength},on:{"input":_vm.sendValue},nativeOn:{"blur":function($event){return _vm.blurValue($event)}}},'money',_vm.config,false)),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.v_validate),expression:"v_validate"}],ref:"moneyValidate",staticClass:"money_validate",attrs:{"id":"display-none","name":_vm.name,"value":_vm.valueM,"error-messages":_vm.errors.collect(_vm.name),"data-vv-as":_vm.data_vv_as ? _vm.data_vv_as : _vm.label,"data-vv-validate-on":"blur"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","justify-left":"","align-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"600"},model:{value:(_vm.dialogExportCaixaGeral),callback:function ($$v) {_vm.dialogExportCaixaGeral=$$v},expression:"dialogExportCaixaGeral"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Gerar Caixa Geral")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"500px"}},[_c('v-form',{nativeOn:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm()}]}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.condominiosPessoa,"label":"Condominios","multiple":"","item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.condominios_ids),callback:function ($$v) {_vm.$set(_vm.editedItem, "condominios_ids", $$v)},expression:"editedItem.condominios_ids"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p-money',{attrs:{"label":"Saldo Anterior"},model:{value:(_vm.editedItem.saldo_anterior),callback:function ($$v) {_vm.$set(_vm.editedItem, "saldo_anterior", $$v)},expression:"editedItem.saldo_anterior"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.confirm}},[_vm._v("Confirmar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.close}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PRelatorioConferencia_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a1ce10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PRelatorioConferencia_vue__ = __webpack_require__(344);
function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40a1ce10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PRelatorioConferencia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a1ce10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PRelatorioConferencia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","justify-left":"","align-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"600"},model:{value:(_vm.dialogRelatorioConferencia),callback:function ($$v) {_vm.dialogRelatorioConferencia=$$v},expression:"dialogRelatorioConferencia"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Relatório de Conferência")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"500px"}},[_c('v-form',{nativeOn:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirm()}]}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.condominiosPessoa,"label":"Condominios","multiple":"","item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.condominios_ids),callback:function ($$v) {_vm.$set(_vm.editedItem, "condominios_ids", $$v)},expression:"editedItem.condominios_ids"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.$auth.user().anosbases,"label":"Ano Base","item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.anobase_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "anobase_id", $$v)},expression:"editedItem.anobase_id"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.confirm}},[_vm._v("Confirmar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.close}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.cpfcnpj_validate),expression:"cpfcnpj_validate"}],attrs:{"name":_vm.name,"value":_vm.value,"mask":_vm.cpfcnpj_mask,"label":_vm.cpfcnpj_label,"disabled":_vm.disabled,"error-messages":_vm.errors.collect(_vm.name),"data-vv-as":_vm.data_vv_as ? _vm.data_vv_as : _vm.cpfcnpj_label,"data-vv-validate-on":"blur"},on:{"input":_vm.sendValue,"blur":function($event){return _vm.$emit('blur')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('p-export-lcdpr',{ref:"lcdpr"}),_vm._v(" "),_c('p-export-caixa-geral',{ref:"caixaGeral"}),_vm._v(" "),_c('p-relatorio-conferencia',{ref:"conferencia"}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"scrollable":"","width":"800"},model:{value:(_vm.dialog_settings),callback:function ($$v) {_vm.dialog_settings=$$v},expression:"dialog_settings"}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Importação do Arquivo DBK")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":""},on:{"click":function($event){_vm.dialog_settings = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-subheader',[_vm._v("Escolha um arquivo para ser importado:")]),_vm._v(" "),_c('div',[_c('input',{ref:"uploader",attrs:{"type":"file","accept":".dbk, .dec","id":"file"},on:{"change":_vm.onFileChanged}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Selecione as abas que gostaria de importar:")]),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-checkbox',{attrs:{"label":"Bem e Direito"},model:{value:(_vm.checkboxes['bem_direito']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'bem_direito', $$v)},expression:"checkboxes['bem_direito']"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Bem da Atividade Rural"},model:{value:(_vm.checkboxes['bem_atividade_rural']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'bem_atividade_rural', $$v)},expression:"checkboxes['bem_atividade_rural']"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Dívida e Ônus Real"},model:{value:(_vm.checkboxes['divida_onus_real']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'divida_onus_real', $$v)},expression:"checkboxes['divida_onus_real']"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Dívida da Atividade Rural"},model:{value:(_vm.checkboxes['divida_atividade_rural']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'divida_atividade_rural', $$v)},expression:"checkboxes['divida_atividade_rural']"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Rendimento Tributável Recebido de PJ"},model:{value:(_vm.checkboxes['rendimento_tributavel_pj']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'rendimento_tributavel_pj', $$v)},expression:"checkboxes['rendimento_tributavel_pj']"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-checkbox',{attrs:{"label":"Rendimento Isento Não Tributável"},model:{value:(_vm.checkboxes['rendimento_isento_nao_tributavel']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'rendimento_isento_nao_tributavel', $$v)},expression:"checkboxes['rendimento_isento_nao_tributavel']"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Rendimento Tributação Exclusiva"},model:{value:(_vm.checkboxes['rendimento_tributacao_exclusiva']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'rendimento_tributacao_exclusiva', $$v)},expression:"checkboxes['rendimento_tributacao_exclusiva']"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Pagamento Efetuado"},model:{value:(_vm.checkboxes['pagamento_efetuado']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'pagamento_efetuado', $$v)},expression:"checkboxes['pagamento_efetuado']"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Movimentação Financeira"},model:{value:(_vm.checkboxes['movimentacao_financeira']),callback:function ($$v) {_vm.$set(_vm.checkboxes, 'movimentacao_financeira', $$v)},expression:"checkboxes['movimentacao_financeira']"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.selectedFile},on:{"click":function($event){return _vm.importDBK(false)}}},[_vm._v("\n            Confirmar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function () {
                _vm.dialog_settings = false;
              }}},[_vm._v("\n            Fechar\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog_log),callback:function ($$v) {_vm.dialog_log=$$v},expression:"dialog_log"}},[_c('v-card',[_c('v-card-text',[_vm._v("\n          O sistema encontrou algumas inconsistências durante o processo de geração das\n          informações.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Deseja prosseguir e gerar o arquivo DBK mesmo assim, ou prefere visualizar o arquivo de\n          log para verificar as inconsistências encontradas?\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.downloadDBK}},[_vm._v("Gerar DBK")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":_vm.viewLOG}},[_vm._v("Visualizar Arquivo de Log")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialogLogImportacao),callback:function ($$v) {_vm.dialogLogImportacao=$$v},expression:"dialogLogImportacao"}},[_c('v-card',[_c('v-card-text',[_vm._v("\n          Foi encontrado algumas inconsistências durante o processo de importação das informações.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Deseja importar as informações e visualizar o log, ou prefere apenas visualizar o log\n          para verificar as inconsistências encontradas?\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.importDBK(true)}}},[_vm._v("Importar DBK")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){return _vm.visualizeFileImportError()}}},[_vm._v("\n            Apenas Visualizar Log\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700px","persistent":""},model:{value:(_vm.changeCompany.dialog),callback:function ($$v) {_vm.$set(_vm.changeCompany, "dialog", $$v)},expression:"changeCompany.dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Alterar Empresa Responsável")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.empresa_id'),"items":_vm.changeCompany.empresas,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.empresa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "empresa_id", $$v)},expression:"editedItem.empresa_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2"},nativeOn:{"click":function($event){return _vm.confirmChangeCompany($event)}}},[_vm._v("\n                Confirmar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.toogleCompanyDialog($event)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.view === 1)?_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('span',{staticClass:"display-1"},[_vm._v("\n        "+_vm._s(this.translate("system.title.consult") +
          this.translate("table." + this.entity + ".title")[1])+"\n      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(_vm.$auth.user().acesso_interno == 'dev')?_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.showMenu($event, props.item)}}},[_vm._v("\n            "+_vm._s(props.item.id_texto)+"\n          ")]):_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.nome_abreviado))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(props.item.cpf_cnpj)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rg_ie))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"disabled":!props.item.isOwner || !_vm.hasAccess(_vm.entity, 'enabled'),"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, props.item)}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v(_vm._s(props.item.isOwner ? "edit" : "remove_red_eye"))])],1),_vm._v(" "),(props.item.isOwner)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item, props.item.id, true)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),(!props.item.isOwner)?_c('span',[(_vm.isUnlocked(props.item))?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.liberaAcesso(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("lock_open")])],1),_vm._v(" "),_c('span',[_vm._v("Acesso Liberado")])],1):_vm._e(),_vm._v(" "),(!_vm.isUnlocked(props.item))?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.liberaAcesso(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("lock")])],1),_vm._v(" "),_c('span',[_vm._v("Acesso Bloqueado")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('router-link',{attrs:{"slot":"activator","to":{
                  name: 'Contribuinte',
                  params: {
                    pessoa: {
                      id: props.item.id,
                      id_texto: props.item.id_texto,
                    },
                  },
                },"tag":"button"},slot:"activator"},[(
                    props.item.isOwner &&
                    (_vm.$auth.user().acesso_interno == 'dev' ||
                      _vm.$auth.user().acesso_interno == 'admin')
                  )?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("attach_money")])],1):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v("Contribuinte")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                  props.item.isOwner &&
                  (_vm.$auth.user().acesso_interno == 'dev' || _vm.$auth.user().acesso_interno == 'admin')
                )?_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.toogleCompanyDialog(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("sync")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Alterar Empresa Responsável")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","disabled":!_vm.hasAccess(_vm.entity, 'dbk')},on:{"click":function($event){return _vm.openDialogDBK(props.item, $event)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"purple"}},[_vm._v("share")])],1),_vm._v(" "),_c('span',[_vm._v("Exportar DBK")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.clickLCDPR(props.item.id, props.item.id_texto)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"blue lighten-2"}},[_vm._v("request_quote")])],1),_vm._v(" "),_c('span',[_vm._v("Gerar LCDPR")])],1),_vm._v(" "),_c('v-menu',{attrs:{"open-on-hover":"","offset-y":"","origin":"center center","transition":"scale-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"color":"orange"}},[_vm._v("library_books")])],1)]}}],null,true)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.clickCaixaGeral(props.item.id, props.item.id_texto)}}},[_c('v-list-tile-title',[_vm._v("Relatório Caixa Geral")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.clickConferencia(props.item.id, props.item.id_texto)}}},[_c('v-list-tile-title',[_vm._v("Relatório de Conferência")])],1)],1)],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n          "+_vm._s(props.itemsLength)+"\n        ")]}}],null,false,3411744767)})],1)],1):_c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.isBlocked() ? "Visualização de Pessoa" : _vm.formTitle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('min:10|max:10'),expression:"'min:10|max:10'"}],attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.ultimo_numero_recibo'),"mask":'##########',"name":"ultimo_numero_recibo","counter":"","maxlength":"10","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('ultimo_numero_recibo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.ultimo_numero_recibo')},model:{value:(_vm.editedItem.ultimo_numero_recibo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ultimo_numero_recibo", $$v)},expression:"editedItem.ultimo_numero_recibo"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"name":"id_texto","label":_vm.name_label,"counter":"","maxlength":"60","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"counter":"","maxlength":"38","name":"nome_abreviado","label":"Nome Abreviado","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('nome_abreviado'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.nome_abreviado')},model:{value:(_vm.editedItem.nome_abreviado),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome_abreviado", $$v)},expression:"editedItem.nome_abreviado"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-cpf-cnpj',{attrs:{"disabled":_vm.isBlocked(),"name":"cpf_cnpj","v_validate":"required","data_vv_as":_vm.translate('table.' + _vm.entity + '.field.cpf_cnpj')},on:{"blur":_vm.checkCpfExists},model:{value:(_vm.editedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj", $$v)},expression:"editedItem.cpf_cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"rg_ie","label":_vm.rgie_label,"return-masked-value":"","counter":"","maxlength":"30"},model:{value:(_vm.editedItem.rg_ie),callback:function ($$v) {_vm.$set(_vm.editedItem, "rg_ie", $$v)},expression:"editedItem.rg_ie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-date',{attrs:{"disabled":_vm.isBlocked(),"label":_vm.translate('table.' + _vm.entity + '.field.nascimento'),"name":"nascimento","v_validate":'required',"as":_vm.translate('table.' + _vm.entity + '.field.nascimento'),"errors_collect":"nascimento"},model:{value:(_vm.editedItem.nascimento),callback:function ($$v) {_vm.$set(_vm.editedItem, "nascimento", $$v)},expression:"editedItem.nascimento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"titulo_eleitoral","label":_vm.translate('table.' + _vm.entity + '.field.titulo_eleitoral'),"counter":"","maxlength":"13"},model:{value:(_vm.editedItem.titulo_eleitoral),callback:function ($$v) {_vm.$set(_vm.editedItem, "titulo_eleitoral", $$v)},expression:"editedItem.titulo_eleitoral"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-switch',{attrs:{"disabled":_vm.isBlocked(),"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.doenca_deficiencia')},model:{value:(_vm.editedItem.doenca_deficiencia),callback:function ($$v) {_vm.$set(_vm.editedItem, "doenca_deficiencia", $$v)},expression:"editedItem.doenca_deficiencia"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-switch',{attrs:{"disabled":_vm.isBlocked(),"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.possui_conjuge')},on:{"change":_vm.clear_conjuge},model:{value:(_vm.editedItem.possui_conjuge),callback:function ($$v) {_vm.$set(_vm.editedItem, "possui_conjuge", $$v)},expression:"editedItem.possui_conjuge"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[(_vm.editedItem.possui_conjuge)?_c('v-autocomplete',{attrs:{"disabled":_vm.isBlocked(),"name":"pessoa_id","label":_vm.translate('table.' + _vm.entity + '.field.pessoa_id'),"items":_vm.conjuges,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.pessoa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_id", $$v)},expression:"editedItem.pessoa_id"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"natureza_ocupacao","disabled":_vm.isBlocked(),"label":_vm.translate('table.' + _vm.entity + '.field.natureza_ocupacao'),"items":_vm.translate('value.pessoa_natureza_ocupacao'),"error-messages":_vm.errors.collect('natureza_ocupacao'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.natureza_ocupacao')},model:{value:(_vm.editedItem.natureza_ocupacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "natureza_ocupacao", $$v)},expression:"editedItem.natureza_ocupacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"ocupacao_principal","disabled":_vm.isBlocked(),"label":_vm.translate('table.' + _vm.entity + '.field.ocupacao_principal'),"items":_vm.translate('value.pessoa_ocupacao_principal'),"error-messages":_vm.errors.collect('ocupacao_principal'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.ocupacao_principal')},model:{value:(_vm.editedItem.ocupacao_principal),callback:function ($$v) {_vm.$set(_vm.editedItem, "ocupacao_principal", $$v)},expression:"editedItem.ocupacao_principal"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-switch',{attrs:{"disabled":_vm.isBlocked(),"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.endereco_brasil')},model:{value:(_vm.editedItem.endereco_brasil),callback:function ($$v) {_vm.$set(_vm.editedItem, "endereco_brasil", $$v)},expression:"editedItem.endereco_brasil"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[(!_vm.editedItem.endereco_brasil)?_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"cpf_procurador","label":_vm.translate('table.' + _vm.entity + '.field.cpf_procurador')},model:{value:(_vm.editedItem.cpf_procurador),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_procurador", $$v)},expression:"editedItem.cpf_procurador"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.isBlocked(),"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.mudanca')},model:{value:(_vm.editedItem.mudanca),callback:function ($$v) {_vm.$set(_vm.editedItem, "mudanca", $$v)},expression:"editedItem.mudanca"}})],1),_vm._v(" "),(_vm.editedItem.endereco_brasil)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"tipo_logradouro","disabled":_vm.isBlocked(),"label":_vm.translate('table.' + _vm.entity + '.field.tipo_logradouro'),"items":_vm.translate('value.pessoa_tipo_logradouro'),"error-messages":_vm.errors.collect('tipo_logradouro'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.tipo_logradouro')},model:{value:(_vm.editedItem.tipo_logradouro),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo_logradouro", $$v)},expression:"editedItem.tipo_logradouro"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{class:_vm.editedItem.endereco_brasil ? 'md4' : 'md7',attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"name":"endereco","label":_vm.translate('table.' + _vm.entity + '.field.endereco'),"error-messages":_vm.errors.collect('endereco'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.endereco'),"counter":"","maxlength":"40"},model:{value:(_vm.editedItem.endereco),callback:function ($$v) {_vm.$set(_vm.editedItem, "endereco", $$v)},expression:"editedItem.endereco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"name":"numero","label":_vm.translate('table.' + _vm.entity + '.field.numero'),"error-messages":_vm.errors.collect('numero'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.numero'),"counter":"","maxlength":"6"},model:{value:(_vm.editedItem.numero),callback:function ($$v) {_vm.$set(_vm.editedItem, "numero", $$v)},expression:"editedItem.numero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"complemento","label":_vm.translate('table.' + _vm.entity + '.field.complemento'),"counter":"","maxlength":"21"},model:{value:(_vm.editedItem.complemento),callback:function ($$v) {_vm.$set(_vm.editedItem, "complemento", $$v)},expression:"editedItem.complemento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"name":"bairro","label":_vm.translate('table.' + _vm.entity + '.field.bairro'),"error-messages":_vm.errors.collect('bairro'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.bairro'),"counter":"","maxlength":"19"},model:{value:(_vm.editedItem.bairro),callback:function ($$v) {_vm.$set(_vm.editedItem, "bairro", $$v)},expression:"editedItem.bairro"}})],1),_vm._v(" "),(_vm.editedItem.endereco_brasil)?_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"name":"cidade_id","label":_vm.translate('table.' + _vm.entity + '.field.cidade_id'),"items":_vm.cidades,"item-text":"id_texto","item-value":"id","error-messages":_vm.errors.collect('cidade_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.cidade_id')},model:{value:(_vm.editedItem.cidade_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "cidade_id", $$v)},expression:"editedItem.cidade_id"}})],1):_vm._e(),_vm._v(" "),(!_vm.editedItem.endereco_brasil)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"name":"pais_id","label":_vm.translate('table.' + _vm.entity + '.field.pais_id'),"items":_vm.paises,"item-text":"id_texto","item-value":"id","error-messages":_vm.errors.collect('pais_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.pais_id')},model:{value:(_vm.editedItem.pais_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pais_id", $$v)},expression:"editedItem.pais_id"}})],1):_vm._e(),_vm._v(" "),(!_vm.editedItem.endereco_brasil)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.isBlocked(),"label":_vm.translate('table.' + _vm.entity + '.field.codigo_ext'),"items":_vm.translate('value.pessoa_codigo_ext')},model:{value:(_vm.editedItem.codigo_ext),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo_ext", $$v)},expression:"editedItem.codigo_ext"}})],1):_vm._e(),_vm._v(" "),(!_vm.editedItem.endereco_brasil)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"cidade_ext","label":_vm.translate('table.' + _vm.entity + '.field.cidade_ext')},model:{value:(_vm.editedItem.cidade_ext),callback:function ($$v) {_vm.$set(_vm.editedItem, "cidade_ext", $$v)},expression:"editedItem.cidade_ext"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"disabled":_vm.isBlocked(),"name":"cep","label":_vm.translate('table.' + _vm.entity + '.field.cep'),"error-messages":_vm.errors.collect('cep'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.cep'),"counter":"","maxlength":"9"},model:{value:(_vm.editedItem.cep),callback:function ($$v) {_vm.$set(_vm.editedItem, "cep", $$v)},expression:"editedItem.cep"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"ddd_ddi_telefone","label":_vm.translate('table.' + _vm.entity + '.field.ddd_ddi_telefone'),"mask":'##'},model:{value:(_vm.editedItem.ddd_ddi_telefone),callback:function ($$v) {_vm.$set(_vm.editedItem, "ddd_ddi_telefone", $$v)},expression:"editedItem.ddd_ddi_telefone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"telefone","label":_vm.translate('table.' + _vm.entity + '.field.telefone'),"return-masked-value":"","mask":'####-####'},model:{value:(_vm.editedItem.telefone),callback:function ($$v) {_vm.$set(_vm.editedItem, "telefone", $$v)},expression:"editedItem.telefone"}})],1),_vm._v(" "),(_vm.editedItem.endereco_brasil)?_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"ddd_celular","label":_vm.translate('table.' + _vm.entity + '.field.ddd_celular'),"mask":'##'},model:{value:(_vm.editedItem.ddd_celular),callback:function ($$v) {_vm.$set(_vm.editedItem, "ddd_celular", $$v)},expression:"editedItem.ddd_celular"}})],1):_vm._e(),_vm._v(" "),(_vm.editedItem.endereco_brasil)?_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"celular","label":_vm.translate('table.' + _vm.entity + '.field.celular'),"mask":'# ####-####',"return-masked-value":true},model:{value:(_vm.editedItem.celular),callback:function ($$v) {_vm.$set(_vm.editedItem, "celular", $$v)},expression:"editedItem.celular"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{class:_vm.editedItem.endereco_brasil ? 'md4' : 'md8',attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.isBlocked(),"name":"email","label":_vm.translate('table.' + _vm.entity + '.field.email'),"counter":"","maxlength":"60"},model:{value:(_vm.editedItem.email),callback:function ($$v) {_vm.$set(_vm.editedItem, "email", $$v)},expression:"editedItem.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"disabled":_vm.isBlocked(),"name":"observacao","label":_vm.translate('table.' + _vm.entity + '.field.observacao'),"counter":"","maxlength":"190"},model:{value:(_vm.editedItem.observacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "observacao", $$v)},expression:"editedItem.observacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"disabled":_vm.isBlocked() || !_vm.hasAccess(_vm.entity, 'enabled'),"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.view === 3)?_c('v-tabs',{staticClass:"elevation-1",attrs:{"color":"green lighten-4","grow":"","show-arrows":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"primary"}}),_vm._v(" "),_c('v-tab',{key:"0"},[_vm._v("\n            "+_vm._s(this.translate("table.pessoa_contato.title")[1])+"\n          ")]),_vm._v(" "),_c('v-tab',{key:"1"},[_vm._v("\n            "+_vm._s(this.translate("table.pessoa_dependente.title")[1])+"\n          ")]),_vm._v(" "),_c('v-tab',{key:"2"},[_vm._v("\n            "+_vm._s(this.translate("table.pessoa_empresa.title")[1])+"\n          ")]),_vm._v(" "),_c('v-tabs-items',{attrs:{"touchless":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:"0"},[_c('v-card',[_c('v-card-text',[_c('contatos',{attrs:{"pessoa_id":_vm.editedItem.id,"values":_vm.editedItem.contatos,"pessoa":_vm.editedItem}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"1"},[_c('v-card',[_c('v-card-text',[_c('pessoa-dependente',{attrs:{"pessoa_id":_vm.editedItem.id,"values":_vm.editedItem.dependentes,"pessoa":_vm.editedItem}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2"},[_c('v-card',[_c('v-card-text',[_c('empresas',{attrs:{"pessoa":_vm.editedItem,"values":_vm.editedItem.empresas,"empresas":_vm.empresas}})],1)],1)],1)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.view === 1)?_c('v-layout',{staticClass:"fab-container",attrs:{"align-center":""}},[_c('v-speed-dial',{attrs:{"open-on-hover":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"primary","dark":"","disabled":!_vm.hasAccess(_vm.entity, 'create')},on:{"click":_vm.create},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),(_vm.view === 3 && this.$auth.user().empresa_id == this.editedItem.empresa_id)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","disabled":_vm.saving,"loading":_vm.loadingCpf || _vm.saving},on:{"click":function($event){return _vm.save()}}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.done.icon")))])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"secondary"},on:{"click":_vm.openDialogSettings},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.import.icon")))])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.close.icon")))])],1)],1):_c('v-layout',{staticClass:"fab-container",attrs:{"align-center":""}},[(_vm.view === 2)?_c('v-speed-dial',{attrs:{"open-on-hover":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"primary","dark":"","disabled":_vm.saving,"loading":_vm.loadingCpf || _vm.saving},on:{"click":function($event){return _vm.save()}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))]),_vm._v(" "),_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save.icon")))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"secondary","disabled":_vm.saving,"loading":_vm.loadingCpf || _vm.saving},on:{"click":function($event){return _vm.saveNew()}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save_new.icon")))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.translate("system.button.save_new.title")))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"accent","disabled":_vm.saving,"loading":_vm.loadingCpf || _vm.saving},on:{"click":function($event){return _vm.saveEdit()}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save_manage.icon")))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.translate("system.button.save_manage.title")))])],1)],1):_vm._e(),_vm._v(" "),(_vm.view === 3 && this.$auth.user().empresa_id == this.editedItem.empresa_id)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","disabled":_vm.saving,"loading":_vm.loadingCpf || _vm.saving},on:{"click":function($event){return _vm.save()}}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.done.icon")))])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.close.icon")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae005eb0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae005eb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae005eb0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[(_vm.view === 1)?_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('span',{staticClass:"display-1"},[_vm._v("\n        "+_vm._s(this.translate("system.title.consult") +
          this.translate("table." + this.entity + ".title")[1])+"\n      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acesso ? props.item.acesso.id_texto : ""))]),_vm._v(" "),(props.item.acesso_interno === 'user')?_c('td',{attrs:{"align":"center"}},[_vm._v("Usuário Comun")]):(props.item.acesso_interno === 'dev')?_c('td',{attrs:{"align":"center"}},[_vm._v("Desenvolvedor")]):(props.item.acesso_interno === 'admin')?_c('td',{attrs:{"align":"center"}},[_vm._v("Administrador")]):_vm._e(),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(props.item.acesso_interno !== 'dev' || _vm.$auth.user().acesso_interno === 'dev')?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess('usuario', 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(props.item.acesso_interno !== 'dev' && props.item.id != _vm.$auth.user().id)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess('usuario', 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item, props.item.id, true)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1):_vm._e()],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}],null,false,104166097)})],1)],1):_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"name","required":"","label":_vm.translate('table.' + _vm.entity + '.field.name'),"error-messages":_vm.errors.collect('name'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.name')},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"email","required":"","label":_vm.translate('table.' + _vm.entity + '.field.email'),"error-messages":_vm.errors.collect('email'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.email')},model:{value:(_vm.editedItem.email),callback:function ($$v) {_vm.$set(_vm.editedItem, "email", $$v)},expression:"editedItem.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"acesso_id","label":_vm.translate('table.' + _vm.entity + '.field.acesso_id'),"required":"","items":_vm.acessos,"error-messages":_vm.errors.collect('acesso_id'),"item-text":"id_texto","item-value":"id","data-vv-as":_vm.translate('table.' + _vm.entity + '.field.acesso_id')},model:{value:(_vm.editedItem.acesso_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "acesso_id", $$v)},expression:"editedItem.acesso_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{attrs:{"disabled":this.$auth.user().id === _vm.editedItem.id,"name":"acesso_interno","label":_vm.translate('table.' + _vm.entity + '.field.acesso_interno'),"items":_vm.acessos_internos,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.acesso_interno),callback:function ($$v) {_vm.$set(_vm.editedItem, "acesso_interno", $$v)},expression:"editedItem.acesso_interno"}})],1)],1),_vm._v(" "),(_vm.view === 1)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","fixed":"","bottom":"","right":"","disabled":!_vm.hasAccess('usuario', 'create')},on:{"click":_vm.create}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1):_c('v-layout',{staticClass:"fab-container",attrs:{"align-center":""}},[(_vm.view === 2)?_c('v-speed-dial',{attrs:{"open-on-hover":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"primary","dark":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.save()}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))]),_vm._v(" "),_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save.icon")))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"secondary","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.saveNew()}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save_new.icon")))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.translate("system.button.save_new.title")))])],1)],1):_vm._e(),_vm._v(" "),(_vm.view === 3)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.save()}}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.done.icon")))])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.close.icon")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suporte_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c212cac8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suporte_vue__ = __webpack_require__(358);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c212cac8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Suporte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c212cac8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Suporte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[(!_vm.dialog)?_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:({ backgroundColor: _vm.getRGBColor(props.item.urgencia) })},[_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.titulo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.descricao))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.tipo))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.urgencia))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.user.name))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm._f("formatDateTime")(props.item.created_at)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),(props.item.id_texto != _vm.$auth.user().anobase.id_texto)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item, props.item.id, true)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1):_vm._e()],1)])]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}],null,false,1080375507)})],1)],1):_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([(_vm.view == 3)?{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"headline"},on),[_vm._v("#"+_vm._s(_vm.editedItem.id)+"-")])]}}:null],null,true)},[_vm._v(" "),_c('span',[_vm._v("Identificador")])]),_vm._v(" "),_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"titulo","label":_vm.translate('table.' + _vm.entity + '.field.titulo'),"error-messages":_vm.errors.collect('titulo'),"data-vv-as":"Título"},model:{value:(_vm.editedItem.titulo),callback:function ($$v) {_vm.$set(_vm.editedItem, "titulo", $$v)},expression:"editedItem.titulo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"descricao","multi-line":"","label":_vm.translate('table.' + _vm.entity + '.field.descricao'),"error-messages":_vm.errors.collect('descricao'),"data-vv-as":"Descrição"},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"status","items":['Aberto', 'Em andamento', 'Fechado'],"label":_vm.translate('table.' + _vm.entity + '.field.status'),"error-messages":_vm.errors.collect('status'),"data-vv-as":"Status"},model:{value:(_vm.editedItem.status),callback:function ($$v) {_vm.$set(_vm.editedItem, "status", $$v)},expression:"editedItem.status"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"tipo","items":['Implementação Corretiva', 'Implementação Evolutiva'],"label":_vm.translate('table.' + _vm.entity + '.field.tipo'),"error-messages":_vm.errors.collect('tipo'),"data-vv-as":"Tipo"},model:{value:(_vm.editedItem.tipo),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo", $$v)},expression:"editedItem.tipo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{attrs:{"name":"urgencia","label":"Urgência","max":10,"thumb-label":"","ticks":"always"},model:{value:(_vm.editedItem.urgencia),callback:function ($$v) {_vm.$set(_vm.editedItem, "urgencia", $$v)},expression:"editedItem.urgencia"}})],1)],1),_vm._v(" "),(_vm.view === 1)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","fixed":"","bottom":"","right":""},on:{"click":_vm.create}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1):_c('v-layout',{staticClass:"fab-container",attrs:{"align-center":""}},[(_vm.view === 2)?_c('v-speed-dial',{attrs:{"open-on-hover":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"primary","dark":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.save()}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))]),_vm._v(" "),_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save.icon")))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"secondary","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.saveNew()}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save_new.icon")))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.translate("system.button.save_new.title")))])],1)],1):_vm._e(),_vm._v(" "),(_vm.view === 3)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.save()}}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.done.icon")))])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.close.icon")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Acesso_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3970d840_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Acesso_vue__ = __webpack_require__(361);
function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3970d840"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Acesso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3970d840_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Acesso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.user().acesso_interno == 'dev' || _vm.$auth.user().acesso_interno == 'admin')?_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('span',{staticClass:"display-1"},[_vm._v("\n            "+_vm._s(this.translate("system.title.consult") +
              this.translate("table." + this.entity + ".title")[1])+"\n            de Sistema\n          ")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md3":""}},[_c('v-btn',{staticClass:"mb-4 text-xs-right",attrs:{"color":"primary","disabled":!_vm.hasAccess(_vm.entity, 'create')},on:{"click":function($event){return _vm.add('sistema')}}},[_vm._v("\n            "+_vm._s(this.translate("system.button.add.title"))+"\n            "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items.filter(function (item) { return item.tipo == 'sistema'; }),"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.descricao))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.edit('sistema', props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}],null,false,2199062219)})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('span',{staticClass:"display-1"},[_vm._v("\n            "+_vm._s(this.translate("system.title.consult") +
              this.translate("table." + this.entity + ".title")[1])+"\n            de Condomínio\n          ")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md3":""}},[_c('v-btn',{staticClass:"mb-4 text-xs-right",attrs:{"color":"primary","disabled":!_vm.hasAccess(_vm.entity, 'create')},on:{"click":function($event){return _vm.add('condominio')}}},[_vm._v("\n            "+_vm._s(this.translate("system.button.add.title"))+"\n            "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items.filter(function (item) { return item.tipo == 'condominio'; }),"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.descricao))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.edit('condominio', props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),(
                    !(
                      props.item.tipo == 'condominio' &&
                      props.item.id_texto == 'Visualização, Adição, Edição e Exclusão'
                    )
                  )?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1):_vm._e()],1)]}}],null,false,3533830364)})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v("\n                "+_vm._s(_vm.formTitle)+"\n                "+_vm._s(_vm.editedItem.tipo == "sistema" ? "de Sistema" : "de Condomínio")+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{ref:"autofocus",attrs:{"maxlength":"190","counter":"190","label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"type":"text"},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.descricao'),"type":"text","maxlength":"190","counter":"190"},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.permissoes,"headers":_vm.editedItem.tipo == 'sistema'
                    ? _vm.permissions_sistema_headers
                    : _vm.permissions_condominio_headers,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(props.item.read),callback:function ($$v) {_vm.$set(props.item, "read", $$v)},expression:"props.item.read"}})],1),_vm._v(" "),_c('td',[(props.item.key != 'suporte')?_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(props.item.create),callback:function ($$v) {_vm.$set(props.item, "create", $$v)},expression:"props.item.create"}}):_vm._e()],1),_vm._v(" "),_c('td',[(props.item.key != 'suporte')?_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(props.item.update),callback:function ($$v) {_vm.$set(props.item, "update", $$v)},expression:"props.item.update"}}):_vm._e()],1),_vm._v(" "),_c('td',[(props.item.key != 'suporte')?_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(props.item.delete),callback:function ($$v) {_vm.$set(props.item, "delete", $$v)},expression:"props.item.delete"}}):_vm._e()],1),_vm._v(" "),_c('td',[(['pessoa', 'condominio', 'contribuinte'].includes(props.item.key))?_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(props.item.enabled),callback:function ($$v) {_vm.$set(props.item, "enabled", $$v)},expression:"props.item.enabled"}}):_vm._e()],1),_vm._v(" "),_c('td',[(['pessoa', 'contribuinte'].includes(props.item.key))?_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(props.item.dbk),callback:function ($$v) {_vm.$set(props.item, "dbk", $$v)},expression:"props.item.dbk"}}):_vm._e()],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n                  "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n                ")]}}],null,false,4154088441)})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Condominio_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1173ab35_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Condominio_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1173ab35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Condominio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1173ab35_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Condominio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pessoa_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de90d31_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pessoa_vue__ = __webpack_require__(368);
function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3de90d31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pessoa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de90d31_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pessoa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuadroSocietario_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299f726f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuadroSocietario_vue__ = __webpack_require__(367);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuadroSocietario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299f726f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuadroSocietario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"p-0",staticStyle:{"padding-top":"0px"},attrs:{"grid-list-md":"","fluid":""}},[_c('v-btn',{attrs:{"dark":"","color":"blue-grey darken-1"},on:{"click":function($event){_vm.dialogQuadroVisible = true}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v("\n      "+_vm._s(this.translate("table.condominio_quadrosocietario.icon"))+"\n    ")]),_vm._v("\n    "+_vm._s(this.translate("table.condominio_quadrosocietario.title")[0])+"\n  ")],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},on:{"input":function($event){_vm.dialog = false}},model:{value:(_vm.dialogQuadroVisible),callback:function ($$v) {_vm.dialogQuadroVisible=$$v},expression:"dialogQuadroVisible"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{staticClass:"p-0",attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"justify-start":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.dialog)?_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                "+_vm._s(this.translate("system.button.close.icon"))+"\n              ")])],1):_vm._e()],1),_vm._v(" "),(!_vm.dialog)?_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-btn',{staticClass:"ml-0",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess('condominio_pessoa', 'create')},on:{"click":_vm.create}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  "+_vm._s(this.translate("system.button.add.icon"))+"\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(props.item.data)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess('condominio_pessoa', 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess('condominio_pessoa', 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n                  "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n                  "+_vm._s(props.itemsLength)+"\n                ")]}}],null,false,2543336366)})],1)],1):_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-date',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.data'),"limitPreviousYears":"","name":"data","v_validate":'required',"as":_vm.translate('table.' + _vm.entity + '.field.data')},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-text-field',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"headline"},[_vm._v("Sócios")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.sub_headers,"items":this.editedItem.socios,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n                    "+_vm._s(props.item.socio.pessoa.id_texto)+"\n                  ")]),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"type":"number","label":_vm.translate('table.' + _vm.entity + '.field.porcentagem')},model:{value:(props.item.porcentagem),callback:function ($$v) {_vm.$set(props.item, "porcentagem", $$v)},expression:"props.item.porcentagem"}})],1)]}},{key:"footer",fn:function(){return [_c('td',{staticClass:"body-2"},[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.somatorioPorcentagem))])]},proxy:true}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"ml-0 mr-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("\n                Salvar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogEmailVisible),callback:function ($$v) {_vm.dialogEmailVisible=$$v},expression:"dialogEmailVisible"}},[_c('v-card',[_c('v-card-text',[_c('v-checkbox',{attrs:{"true-value":1,"false-value":0,"label":"Enviar o Relatório por e-mail ao final do processamento?"},model:{value:(_vm.report.sendEmail),callback:function ($$v) {_vm.$set(_vm.report, "sendEmail", $$v)},expression:"report.sendEmail"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.downloadItem}},[_vm._v("Confirmar")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.dialogEmailVisible = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":function($event){return _vm.refreshEmpresas(2)}}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('quadro-societario',{attrs:{"condominio_id":_vm.condominio_id,"values":_vm.quadro_societario,"socios":_vm.items},on:{"updateSocios":_vm.updateSocios}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-left":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Apenas Ativos"},on:{"change":_vm.filtrarItens},model:{value:(_vm.apenasAtivos),callback:function ($$v) {_vm.apenasAtivos=$$v},expression:"apenasAtivos"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-text":"Registros por página","rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado","pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.pessoa ? props.item.pessoa.id_texto : " "))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatPercentage")(props.item.inicialporcentagem))+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatPercentage")(props.item.porcentagem))+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(props.item.data)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, props.item)}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.refreshEmpresas(3, props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-menu',{attrs:{"slot":"activator","offset-y":""},slot:"activator"},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("library_books")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.handleClick(props.item, 0)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório Simples")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Apresentar apenas os bens rurais que sofreram alteração no ano-calendário")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.handleClick(props.item, 1)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório Completo")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Apresentar todos os bens rurais, independentemente de alteração no ano")])],1)],1),_vm._v(" "),(props.item.has_report)?_c('v-list-tile',{attrs:{"href":(_vm.api + "reports/" + (props.item.pessoa.id_texto) + ".pdf"),"target":"_blank"}},[_c('v-list-tile-title',[_vm._v("Visualizar o último Relatório gerado")])],1):_vm._e()],1)],1),_vm._v(" "),_c('span',[_vm._v("Relatório para Declaração de Ajuste")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n        "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n        "+_vm._s(props.itemsLength)+"\n      ")]}}])},[_vm._v(" "),_c('template',{slot:"footer"},[_c('td',{attrs:{"colspan":"1"}},[_c('strong',[_vm._v("Porcentagem Total")])]),_vm._v(" "),_c('td',{attrs:{"colspan":"1"}},[_c('strong',[_vm._v(_vm._s(_vm.somatorios.inicialporcentagem)+"%")])]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_c('strong',[_vm._v(_vm._s(_vm.somatorios.porcentagem)+"%")])])])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"pessoa_id","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('pessoa_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.pessoa_id'),"label":_vm.translate('table.' + _vm.entity + '.field.pessoa_id'),"items":_vm.dynamicPessoas,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.pessoa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_id", $$v)},expression:"editedItem.pessoa_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-money',{attrs:{"disabled":this.view == 2,"name":"porcentagem_inicial","label":_vm.translate('table.' + _vm.entity + '.field.porcentagem_inicial') + ' (Usar quadro societário)',"v_validate":'positiveNumber|max_value:100',"custom_preffix":""},model:{value:(_vm.editedItem.porcentagem_inicial),callback:function ($$v) {_vm.$set(_vm.editedItem, "porcentagem_inicial", $$v)},expression:"editedItem.porcentagem_inicial"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-date',{attrs:{"name":"data","label":_vm.translate('table.' + _vm.entity + '.field.data'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('data'),"v_validate":'required|currentYear:' + _vm.$auth.user().anobase.id_texto,"data_vv_as":_vm.translate('table.' + _vm.entity + '.field.data')},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BemDireito_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4422674a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BemDireito_vue__ = __webpack_require__(371);
function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4422674a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BemDireito_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4422674a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BemDireito_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-left":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},nativeOn:{"keyup":function($event){return _vm.keyupSearch($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Apenas Ativos"},on:{"change":function($event){return _vm.initialize()}},model:{value:(_vm.apenasAtivos),callback:function ($$v) {_vm.apenasAtivos=$$v},expression:"apenasAtivos"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"disable-initial-sort":"","pagination":_vm.pagination,"hide-actions":"","rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getGrupoText(props.item.grupo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCodigoText(props.item.grupo, props.item.codigo)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.situacao_anoanterior))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.situacao_anobase))+"\n          ")]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, {
                  id: props.item['id'],
                  ativo: props.item['ativo'],
                })}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"4"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anoanterior)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anobase)))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])}),_vm._v(" "),_c('div',{staticClass:"v-datatable v-table theme--light",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.12) !important","border-left":"1px solid rgba(0, 0, 0, 0.12) !important","border-right":"1px solid rgba(0, 0, 0, 0.12) !important"}},[_c('div',{staticClass:"v-datatable__actions"},[_c('div',{staticClass:"v-datatable__actions__select"},[_vm._v("\n            Registros por página\n            "),_c('v-select',{staticClass:"v-select__selection v-select__selection--comma",attrs:{"items":[25, 50, 75, 100]},on:{"change":function($event){return _vm.changePage(_vm.pagination['current_page'])}},model:{value:(_vm.pagination['rowsPerPage']),callback:function ($$v) {_vm.$set(_vm.pagination, 'rowsPerPage', $$v)},expression:"pagination['rowsPerPage']"}})],1),_vm._v(" "),_c('div',{staticClass:"v-datatable__actions__range-controls"},[_c('div',{staticClass:"v-datatable__actions__pagination"},[_vm._v("\n              "+_vm._s(((this.pagination.from) + " - " + (this.pagination.to) + " de " + (this.pagination.total)))+"\n            ")]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === 1
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === 1,"type":"button","aria-label":"Previous page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] - 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_left")])])]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === _vm.pagination.last_page
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === _vm.pagination.last_page,"type":"button","aria-label":"Next page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] + 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_right")])])])])])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-checkbox',{staticClass:"m-0",attrs:{"label":"Limitar a quantidade de caracteres"},model:{value:(_vm.limitarCaracteres),callback:function ($$v) {_vm.limitarCaracteres=$$v},expression:"limitarCaracteres"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required' + (_vm.limitarCaracteres ? '|max:150' : '|max:512')),expression:"'required' + (limitarCaracteres ? '|max:150' : '|max:512')"}],attrs:{"name":"id_texto","label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"maxlength":_vm.limitarCaracteres ? 150 : 512,"counter":"","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"grupo","label":_vm.translate('table.' + _vm.entity + '.field.grupo'),"items":_vm.translate('value.bem_direito_grupo'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('grupo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.grupo')},on:{"change":function($event){_vm.editedItem.codigo = null}},model:{value:(_vm.editedItem.grupo),callback:function ($$v) {_vm.$set(_vm.editedItem, "grupo", $$v)},expression:"editedItem.grupo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo","items":_vm.translate('value.bem_direito_codigo').filter(
                    function (item) { return item['grupo'] === _vm.editedItem.grupo; }
                  ),"label":_vm.translate('table.' + _vm.entity + '.field.codigo'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo')},on:{"change":function($event){_vm.editedItem.iptu_nirf = null}},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}}),_vm._v(" "),(_vm.sequencia_ir_duplicated)?_c('div',{staticStyle:{"color":"#ff5252","font-size":"12px !important","position":"relative","margin-top":"-20px"}},[_vm._v("\n                Este valor já foi inserido anteriormente.\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"pais_id","items":_vm.paises,"item-text":"id_texto","item-value":"id","single-line":"","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('pais_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.pais_id'),"label":_vm.translate('table.' + _vm.entity + '.field.pais_id')},model:{value:(_vm.editedItem.pais_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pais_id", $$v)},expression:"editedItem.pais_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-date',{attrs:{"name":"data","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('data'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.data'),"label":_vm.translate('table.' + _vm.entity + '.field.data')},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(
                  [
                    '1-1',
                    '1-2',
                    '1-3',
                    '1-11',
                    '1-12',
                    '1-13',
                    '1-14',
                    '1-15',
                    '1-18',
                    '1-19',
                    '1-99' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":['1-14'].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                        ? 'NIRF'
                        : 'Inscrição Municipal (IPTU)',"counter":"","maxlength":['1-14'].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                        ? 8
                        : 30},model:{value:(_vm.editedItem.iptu_nirf),callback:function ($$v) {_vm.$set(_vm.editedItem, "iptu_nirf", $$v)},expression:"editedItem.iptu_nirf"}})],1)],1):_vm._e(),_vm._v(" "),(['2-1', '2-2', '2-3'].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo))))?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Registro"},model:{value:(_vm.editedItem.registro_veiculo),callback:function ($$v) {_vm.$set(_vm.editedItem, "registro_veiculo", $$v)},expression:"editedItem.registro_veiculo"}})],1)],1):_vm._e(),_vm._v(" "),(['1-16'].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo))))?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.cei_cno'),"maxlength":"12"},model:{value:(_vm.editedItem.cei_cno),callback:function ($$v) {_vm.$set(_vm.editedItem, "cei_cno", $$v)},expression:"editedItem.cei_cno"}})],1)],1):_vm._e(),_vm._v(" "),(
                  [
                    '3-1',
                    '3-2',
                    '3-3',
                    '3-99',
                    '4-1',
                    '4-2',
                    '4-3',
                    '4-99',
                    '5-1',
                    '5-2',
                    '5-99',
                    '6-1',
                    '6-99',
                    '7-1',
                    '7-2',
                    '7-3',
                    '7-4',
                    '7-5',
                    '7-6',
                    '7-7',
                    '7-8',
                    '7-9',
                    '7-10',
                    '7-11',
                    '7-12',
                    '7-13',
                    '8-3',
                    '99-5',
                    '99-6',
                    '99-7' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p-cpf-cnpj',{model:{value:(_vm.editedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj", $$v)},expression:"editedItem.cpf_cnpj"}})],1)],1):_vm._e(),_vm._v(" "),(['4-1', '6-1'].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo))))?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{attrs:{"label":"Banco","items":_vm.translate('value.bem_direito_banco')},model:{value:(_vm.editedItem.banco),callback:function ($$v) {_vm.$set(_vm.editedItem, "banco", $$v)},expression:"editedItem.banco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Agência"},model:{value:(_vm.editedItem.agencia),callback:function ($$v) {_vm.$set(_vm.editedItem, "agencia", $$v)},expression:"editedItem.agencia"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Conta"},model:{value:(_vm.editedItem.conta),callback:function ($$v) {_vm.$set(_vm.editedItem, "conta", $$v)},expression:"editedItem.conta"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"label":"DV"},model:{value:(_vm.editedItem.dv),callback:function ($$v) {_vm.$set(_vm.editedItem, "dv", $$v)},expression:"editedItem.dv"}})],1)],1):_vm._e(),_vm._v(" "),(
                  [
                    '1-1',
                    '1-2',
                    '1-3',
                    '1-11',
                    '1-12',
                    '1-13',
                    '1-14',
                    '1-15',
                    '1-16',
                    '1-17',
                    '1-18',
                    '1-19',
                    '1-99' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Logradouro"},model:{value:(_vm.editedItem.logradouro),callback:function ($$v) {_vm.$set(_vm.editedItem, "logradouro", $$v)},expression:"editedItem.logradouro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Número"},model:{value:(_vm.editedItem.numero),callback:function ($$v) {_vm.$set(_vm.editedItem, "numero", $$v)},expression:"editedItem.numero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Complemento"},model:{value:(_vm.editedItem.complemento),callback:function ($$v) {_vm.$set(_vm.editedItem, "complemento", $$v)},expression:"editedItem.complemento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Bairro / Distrito"},model:{value:(_vm.editedItem.bairro_distrito),callback:function ($$v) {_vm.$set(_vm.editedItem, "bairro_distrito", $$v)},expression:"editedItem.bairro_distrito"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{attrs:{"label":"Município","items":_vm.cidades,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.cidade_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "cidade_id", $$v)},expression:"editedItem.cidade_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"label":"CEP"},model:{value:(_vm.editedItem.cep),callback:function ($$v) {_vm.$set(_vm.editedItem, "cep", $$v)},expression:"editedItem.cep"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-money',{attrs:{"label":"Área Total do Imóvel","custom_preffix":"","custom_precision":1},model:{value:(_vm.editedItem.area_imovel),callback:function ($$v) {_vm.$set(_vm.editedItem, "area_imovel", $$v)},expression:"editedItem.area_imovel"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('span',{attrs:{"id":"unidade"}},[_c('p',{staticClass:"ma-0"},[_vm._v("Unidade")]),_vm._v(" "),_c('v-btn-toggle',{model:{value:(_vm.editedItem.unidade),callback:function ($$v) {_vm.$set(_vm.editedItem, "unidade", $$v)},expression:"editedItem.unidade"}},[_c('v-btn',{attrs:{"flat":"","value":"m2"}},[_vm._v("m²")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"ha"}},[_vm._v("ha")])],1)],1)])],1):_vm._e(),_vm._v(" "),(
                  _vm.editedItem.pais_id == 105 &&
                  [
                    '1-1',
                    '1-2',
                    '1-3',
                    '1-11',
                    '1-12',
                    '1-13',
                    '1-14',
                    '1-15',
                    '1-18',
                    '1-19',
                    '1-99' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{attrs:{"color":"primary","label":"Registrado no Cartório"},model:{value:(_vm.editedItem.registrado_cartorio),callback:function ($$v) {_vm.$set(_vm.editedItem, "registrado_cartorio", $$v)},expression:"editedItem.registrado_cartorio"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Matrícula do Imóvel","disabled":!_vm.editedItem.registrado_cartorio},model:{value:(_vm.editedItem.matricula_imovel),callback:function ($$v) {_vm.$set(_vm.editedItem, "matricula_imovel", $$v)},expression:"editedItem.matricula_imovel"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-text-field',{attrs:{"label":"Nome do Cartório","disabled":!_vm.editedItem.registrado_cartorio},model:{value:(_vm.editedItem.nome_cartorio),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome_cartorio", $$v)},expression:"editedItem.nome_cartorio"}})],1)],1):_vm._e(),_vm._v(" "),(
                  [
                    '1-1',
                    '1-2',
                    '1-3',
                    '1-11',
                    '1-12',
                    '1-13',
                    '1-14',
                    '1-15',
                    '1-18',
                    '1-19',
                    '1-99',
                    '2-1',
                    '2-2',
                    '2-3',
                    '99-1',
                    '99-2',
                    '99-3',
                    '99-4',
                    '99-5' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-cpf-cnpj',{attrs:{"label":" do Fornecedor"},model:{value:(_vm.editedItem.cpf_cnpj_fornecedor),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj_fornecedor", $$v)},expression:"editedItem.cpf_cnpj_fornecedor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"counter":"","maxlength":"28","label":"Nome do Fornecedor"},model:{value:(_vm.editedItem.nome_fornecedor),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome_fornecedor", $$v)},expression:"editedItem.nome_fornecedor"}})],1)],1):_vm._e(),_vm._v(" "),(
                  [
                    '1-1',
                    '1-2',
                    '1-3',
                    '1-11',
                    '1-12',
                    '1-13',
                    '1-14',
                    '1-15',
                    '1-18',
                    '1-19',
                    '1-99',
                    '2-1',
                    '2-2',
                    '2-3',
                    '2-4',
                    '2-5',
                    '2-6',
                    '2-99',
                    '3-1',
                    '3-2',
                    '3-3',
                    '3-99',
                    '99-1',
                    '99-2',
                    '99-3',
                    '99-4' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p-money',{attrs:{"name":"valor_fornecedor","label":"Valor de Aquisicao","v_validate":'positiveNumber'},model:{value:(_vm.editedItem.valor_fornecedor),callback:function ($$v) {_vm.$set(_vm.editedItem, "valor_fornecedor", $$v)},expression:"editedItem.valor_fornecedor"}})],1)],1):_vm._e(),_vm._v(" "),(
                  [
                    '1-1',
                    '1-2',
                    '1-3',
                    '1-11',
                    '1-12',
                    '1-13',
                    '1-14',
                    '1-15',
                    '1-16',
                    '1-17',
                    '1-18',
                    '1-19',
                    '1-99',
                    '2-1',
                    '2-2',
                    '2-3',
                    '2-4',
                    '2-5',
                    '2-6',
                    '2-99',
                    '3-1',
                    '3-2',
                    '3-3',
                    '3-99',
                    '99-1',
                    '99-2',
                    '99-3',
                    '99-4' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.editedItem.cpf_cnpj_adquirente ? 'required' : ''),expression:"editedItem.cpf_cnpj_adquirente ? 'required' : ''"}],attrs:{"label":"Motivo da Baixa","name":"motivo_baixa","items":_vm.translate('value.bem_direito_motivo_baixa'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('motivo_baixa'),"data-vv-as":"Motivo da Baixa"},model:{value:(_vm.editedItem.motivo_baixa),callback:function ($$v) {_vm.$set(_vm.editedItem, "motivo_baixa", $$v)},expression:"editedItem.motivo_baixa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-date',{attrs:{"name":"baixa","label":"Data da Baixa","errors_collect":"baixa","data_vv_as":"Data da Baixa","v_validate":_vm.editedItem.motivo_baixa ? 'required|currentYear:' + _vm.$auth.user().anobase.id_texto : ''},model:{value:(_vm.editedItem.baixa),callback:function ($$v) {_vm.$set(_vm.editedItem, "baixa", $$v)},expression:"editedItem.baixa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-cpf-cnpj',{attrs:{"label":" do Adquirente"},model:{value:(_vm.editedItem.cpf_cnpj_adquirente),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj_adquirente", $$v)},expression:"editedItem.cpf_cnpj_adquirente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"counter":"","maxlength":"28","label":"Nome do Adquirente"},model:{value:(_vm.editedItem.nome_adquirente),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome_adquirente", $$v)},expression:"editedItem.nome_adquirente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"valor_adquirente","label":"Valor da Baixa/Venda","v_validate":'positiveNumber|requiredNumber',"data_vv_as":"Valor da Baixa/Venda"},model:{value:(_vm.editedItem.valor_adquirente),callback:function ($$v) {_vm.$set(_vm.editedItem, "valor_adquirente", $$v)},expression:"editedItem.valor_adquirente"}})],1)],1):_vm._e(),_vm._v(" "),(
                  _vm.temDependente &&
                  [
                    '3-1',
                    '3-2',
                    '3-3',
                    '3-99',
                    '4-1',
                    '4-2',
                    '5-99',
                    '6-1',
                    '6-9',
                    '7-3',
                    '7-5',
                    '7-6',
                    '7-99',
                    '8-1',
                    '8-2',
                    '8-10',
                    '99-5',
                    '99-6',
                    '99-8',
                    '99-99' ].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo)))
                )?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.pessoa_dependente_id'),"items":_vm.dependente_items,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.pessoa_dependente_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_dependente_id", $$v)},expression:"editedItem.pessoa_dependente_id"}})],1)],1):_vm._e(),_vm._v(" "),(['3-1'].includes(((_vm.editedItem.grupo) + "-" + (_vm.editedItem.codigo))))?_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-checkbox',{staticClass:"m-0",attrs:{"label":"Negociados em Bolsa?"},model:{value:(_vm.editedItem.negociacao_bolsa),callback:function ($$v) {_vm.$set(_vm.editedItem, "negociacao_bolsa", $$v)},expression:"editedItem.negociacao_bolsa"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  "+_vm._s(this.translate("system.button.add.icon"))+"\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-autocomplete',{attrs:{"items":_vm.subItemTipos,"item-text":"id_texto","item-value":"id","name":"tipo"},model:{value:(props.item.tipo),callback:function ($$v) {_vm.$set(props.item, "tipo", $$v)},expression:"props.item.tipo"}})],1),_vm._v(" "),_c('td',[_c('p-date',{attrs:{"limitPreviousYears":"","name":"data","counter":"","maxlength":"8","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('tipo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.tipo'),"label":_vm.translate('table.' + _vm.entity + '.field.tipo')},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor","v_validate":'positiveNumber',"data_vv_as":"Valor"},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_pago'),"value":_vm.sum.pagamento}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_liberado'),"value":_vm.sum.liberacao}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"disabled":"","name":"situacao_anoanterior","label":_vm.translate('table.' + _vm.entity + '.field.situacao_anoanterior') +
                  (_vm.$auth.user().anobase.id_texto - 1),"v_validate":'positiveNumber',"data_vv_as":_vm.translate('table.' + _vm.entity + '.field.situacao_anoanterior') +
                  (_vm.$auth.user().anobase.id_texto - 1)},model:{value:(_vm.editedItem.situacao_anoanterior),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anoanterior", $$v)},expression:"editedItem.situacao_anoanterior"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"situacao_anobase","label":_vm.translate('table.' + _vm.entity + '.field.situacao_anobase') +
                  _vm.$auth.user().anobase.id_texto,"v_validate":'positiveNumber',"data_vv_as":_vm.translate('table.' + _vm.entity + '.field.situacao_anobase') +
                  _vm.$auth.user().anobase.id_texto},model:{value:(_vm.editedItem.situacao_anobase),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anobase", $$v)},expression:"editedItem.situacao_anobase"}}),_vm._v(" "),_c('div',{attrs:{"id":"proccess"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":_vm.processSituacao}},on),[_vm._v("refresh")])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n                    Clique aqui para atualizar este campo com base nos valores já lançados.\n                  ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save(_vm.entity, _vm.editedItem.id, _vm.editedItem, 1, true)}}},[_vm._v("\n                Salvar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BemDireitoRural_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_481e5d1b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BemDireitoRural_vue__ = __webpack_require__(374);
function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-481e5d1b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BemDireitoRural_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_481e5d1b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BemDireitoRural_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-left":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},nativeOn:{"keyup":function($event){return _vm.keyupSearch($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Apenas Ativos"},on:{"change":function($event){return _vm.initialize()}},model:{value:(_vm.apenasAtivos),callback:function ($$v) {_vm.apenasAtivos=$$v},expression:"apenasAtivos"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"disable-initial-sort":"","hide-actions":"","rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCodigoText(props.item.codigo)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.situacao_anoanterior)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.situacao_anobase)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, {
                  id: props.item['id'],
                  ativo: props.item['ativo'],
                })}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"3"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anoanterior)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anobase)))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])}),_vm._v(" "),_c('div',{staticClass:"v-datatable v-table theme--light",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.12) !important","border-left":"1px solid rgba(0, 0, 0, 0.12) !important","border-right":"1px solid rgba(0, 0, 0, 0.12) !important"}},[_c('div',{staticClass:"v-datatable__actions"},[_c('div',{staticClass:"v-datatable__actions__select"},[_vm._v("\n            Registros por página\n            "),_c('v-select',{staticClass:"v-select__selection v-select__selection--comma",attrs:{"items":[25, 50, 75, 100]},on:{"change":function($event){return _vm.changePage(_vm.pagination['current_page'])}},model:{value:(_vm.pagination['rowsPerPage']),callback:function ($$v) {_vm.$set(_vm.pagination, 'rowsPerPage', $$v)},expression:"pagination['rowsPerPage']"}})],1),_vm._v(" "),_c('div',{staticClass:"v-datatable__actions__range-controls"},[_c('div',{staticClass:"v-datatable__actions__pagination"},[_vm._v("\n              "+_vm._s(((this.pagination.from) + " - " + (this.pagination.to) + " de " + (this.pagination.total)))+"\n            ")]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === 1
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === 1,"type":"button","aria-label":"Previous page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] - 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_left")])])]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === _vm.pagination.last_page
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === _vm.pagination.last_page,"type":"button","aria-label":"Next page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] + 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_right")])])])])])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1400px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-checkbox',{staticClass:"m-0",attrs:{"label":"Limitar a quantidade de caracteres"},model:{value:(_vm.limitarCaracteres),callback:function ($$v) {_vm.limitarCaracteres=$$v},expression:"limitarCaracteres"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required' + (_vm.limitarCaracteres == true ? '|max: 150' : '|max: 512')),expression:"'required' + (limitarCaracteres == true ? '|max: 150' : '|max: 512')"}],attrs:{"name":"id_texto","counter":"","data-vv-validate-on":"blur","maxlength":_vm.limitarCaracteres == true ? 150 : 512,"label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo","data-vv-validate-on":"blur","items":_vm.translate('value.bem_direito_rural_codigo'),"label":_vm.translate('table.' + _vm.entity + '.field.codigo'),"error-messages":_vm.errors.collect('codigo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo')},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}}),_vm._v(" "),(_vm.sequencia_ir_duplicated)?_c('div',{staticStyle:{"color":"#ff5252","font-size":"12px !important","position":"relative","margin-top":"-20px"}},[_vm._v("\n                Este valor já foi inserido anteriormente.\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"pais_id","items":_vm.paises,"item-text":"id_texto","item-value":"id","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('pais_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.pais_id'),"label":_vm.translate('table.' + _vm.entity + '.field.pais_id')},model:{value:(_vm.editedItem.pais_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pais_id", $$v)},expression:"editedItem.pais_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-date',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.data'),"limitPreviousYears":"","name":"data"},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf_cnpj_fornecedor","label":" do Fornecedor"},model:{value:(_vm.editedItem.cpf_cnpj_fornecedor),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj_fornecedor", $$v)},expression:"editedItem.cpf_cnpj_fornecedor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.editedItem.cpf_cnpj_adquirente ? 'required' : ''),expression:"editedItem.cpf_cnpj_adquirente ? 'required' : ''"}],attrs:{"counter":"","maxlength":"28","name":"nome_fornecedor","label":"Nome do Fornecedor","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('nome_fornecedor'),"data-vv-as":"Nome do Fornecedor"},model:{value:(_vm.editedItem.nome_fornecedor),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome_fornecedor", $$v)},expression:"editedItem.nome_fornecedor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"valor_fornecedor","label":"Valor de Aquisição","v_validate":'positiveNumber',"data_vv_as":"Valor de Aquisição"},model:{value:(_vm.editedItem.valor_fornecedor),callback:function ($$v) {_vm.$set(_vm.editedItem, "valor_fornecedor", $$v)},expression:"editedItem.valor_fornecedor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.editedItem.cpf_cnpj_adquirente ? 'required' : ''),expression:"editedItem.cpf_cnpj_adquirente ? 'required' : ''"}],attrs:{"label":"Motivo da Baixa","name":"motivo_baixa","items":_vm.translate('value.bem_direito_motivo_baixa'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('motivo_baixa'),"data-vv-as":"Motivo da Baixa"},model:{value:(_vm.editedItem.motivo_baixa),callback:function ($$v) {_vm.$set(_vm.editedItem, "motivo_baixa", $$v)},expression:"editedItem.motivo_baixa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-date',{attrs:{"name":"baixa","label":"Data da Baixa","errors_collect":"baixa","data_vv_as":"Data da Baixa","v_validate":_vm.editedItem.motivo_baixa ? 'required|currentYear:' + _vm.$auth.user().anobase.id_texto : ''},model:{value:(_vm.editedItem.baixa),callback:function ($$v) {_vm.$set(_vm.editedItem, "baixa", $$v)},expression:"editedItem.baixa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-cpf-cnpj',{attrs:{"label":" do Adquirente"},model:{value:(_vm.editedItem.cpf_cnpj_adquirente),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj_adquirente", $$v)},expression:"editedItem.cpf_cnpj_adquirente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.editedItem.cpf_cnpj_adquirente ? 'required' : ''),expression:"editedItem.cpf_cnpj_adquirente ? 'required' : ''"}],attrs:{"counter":"","maxlength":"28","name":"nome_adquirente","label":"Nome do Adquirente","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('nome_adquirente'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.nome_adquirente')},model:{value:(_vm.editedItem.nome_adquirente),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome_adquirente", $$v)},expression:"editedItem.nome_adquirente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"valor_adquirente","label":"Valor da Baixa/Venda","v_validate":'positiveNumber',"data_vv_as":"Valor da Baixa/Venda"},model:{value:(_vm.editedItem.valor_adquirente),callback:function ($$v) {_vm.$set(_vm.editedItem, "valor_adquirente", $$v)},expression:"editedItem.valor_adquirente"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  "+_vm._s(this.translate("system.button.add.icon"))+"\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-autocomplete',{attrs:{"items":_vm.subItemTipos,"item-text":"id_texto","item-value":"id","name":"tipo"},model:{value:(props.item.tipo),callback:function ($$v) {_vm.$set(props.item, "tipo", $$v)},expression:"props.item.tipo"}})],1),_vm._v(" "),_c('td',[_c('p-date',{attrs:{"limitPreviousYears":"","name":"data","counter":"","maxlength":"8","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('tipo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.tipo'),"label":_vm.translate('table.' + _vm.entity + '.field.tipo')},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor","v_validate":'positiveNumber',"data_vv_as":"Valor"},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_pago'),"value":_vm.sum.pagamento}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_liberado'),"value":_vm.sum.liberacao}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"disabled":"","name":"situacao_anoanterior","label":_vm.translate('table.' + _vm.entity + '.field.situacao_anoanterior') + (_vm.$auth.user().anobase.id_texto - 1),"v_validate":'positiveNumber',"data_vv_as":_vm.translate('table.' + _vm.entity + '.field.situacao_anoanterior') + (_vm.$auth.user().anobase.id_texto - 1)},model:{value:(_vm.editedItem.situacao_anoanterior),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anoanterior", $$v)},expression:"editedItem.situacao_anoanterior"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"situacao_anobase","label":_vm.translate('table.' + _vm.entity + '.field.situacao_anobase') + _vm.$auth.user().anobase.id_texto,"v_validate":'positiveNumber',"data_vv_as":_vm.translate('table.' + _vm.entity + '.field.situacao_anobase') + _vm.$auth.user().anobase.id_texto},model:{value:(_vm.editedItem.situacao_anobase),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anobase", $$v)},expression:"editedItem.situacao_anobase"}}),_vm._v(" "),_c('div',{attrs:{"id":"proccess"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":_vm.processSituacao}},on),[_vm._v("refresh")])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n                    Clique aqui para atualizar este campo com base nos valores já lançados.\n                  ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save(_vm.entity, _vm.editedItem.id, _vm.editedItem, 1, true)}}},[_vm._v("\n                Salvar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DividaOnus_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b2fcd0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DividaOnus_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b2fcd0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DividaOnus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b2fcd0e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DividaOnus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */,
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-left":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},nativeOn:{"keyup":function($event){return _vm.keyupSearch($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Apenas Ativos"},on:{"change":function($event){return _vm.initialize()}},model:{value:(_vm.apenasAtivos),callback:function ($$v) {_vm.apenasAtivos=$$v},expression:"apenasAtivos"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"disable-initial-sort":"","hide-actions":"","rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCodigoText(props.item.codigo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.banco))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.contrato))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.situacao_anoanterior)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.situacao_anobase)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, {
                  id: props.item['id'],
                  ativo: props.item['ativo'],
                })}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anoanterior)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anobase)))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])}),_vm._v(" "),_c('div',{staticClass:"v-datatable v-table theme--light",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.12) !important","border-left":"1px solid rgba(0, 0, 0, 0.12) !important","border-right":"1px solid rgba(0, 0, 0, 0.12) !important"}},[_c('div',{staticClass:"v-datatable__actions"},[_c('div',{staticClass:"v-datatable__actions__select"},[_vm._v("\n            Registros por página\n            "),_c('v-select',{staticClass:"v-select__selection v-select__selection--comma",attrs:{"items":[25, 50, 75, 100]},on:{"change":function($event){return _vm.changePage(_vm.pagination['current_page'])}},model:{value:(_vm.pagination['rowsPerPage']),callback:function ($$v) {_vm.$set(_vm.pagination, 'rowsPerPage', $$v)},expression:"pagination['rowsPerPage']"}})],1),_vm._v(" "),_c('div',{staticClass:"v-datatable__actions__range-controls"},[_c('div',{staticClass:"v-datatable__actions__pagination"},[_vm._v("\n              "+_vm._s(((this.pagination.from) + " - " + (this.pagination.to) + " de " + (this.pagination.total)))+"\n            ")]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === 1
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === 1,"type":"button","aria-label":"Previous page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] - 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_left")])])]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === _vm.pagination.last_page
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === _vm.pagination.last_page,"type":"button","aria-label":"Next page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] + 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_right")])])])])])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-checkbox',{staticClass:"m-0",attrs:{"label":"Limitar a quantidade de caracteres"},model:{value:(_vm.limitarCaracteres),callback:function ($$v) {_vm.limitarCaracteres=$$v},expression:"limitarCaracteres"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required' + (_vm.limitarCaracteres == true ? '|max: 63' : '')),expression:"'required' + (limitarCaracteres == true ? '|max: 63' : '')"}],attrs:{"name":"id_texto","counter":"","maxlength":_vm.limitarCaracteres == true ? 63 : null,"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"label":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo'),"label":_vm.translate('table.' + _vm.entity + '.field.codigo'),"items":_vm.translate('value.divida_onus_codigo')},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}}),_vm._v(" "),(_vm.sequencia_ir_duplicated)?_c('div',{staticStyle:{"color":"#ff5252","font-size":"12px !important","position":"relative","margin-top":"-20px"}},[_vm._v("\n                Este valor já foi inserido anteriormente.\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"data","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('data'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.data'),"label":_vm.translate('table.' + _vm.entity + '.field.data'),"v_validate":'required',"as":_vm.translate('table.' + _vm.entity + '.field.data')},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"banco","counter":"","maxlength":"30","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('banco'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.banco'),"label":_vm.translate('table.' + _vm.entity + '.field.banco')},model:{value:(_vm.editedItem.banco),callback:function ($$v) {_vm.$set(_vm.editedItem, "banco", $$v)},expression:"editedItem.banco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf_cnpj","v_validate":"required","label":_vm.translate('table.' + _vm.entity + '.field.cpf_cnpj')},model:{value:(_vm.editedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj", $$v)},expression:"editedItem.cpf_cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"counter":"","maxlength":"10","label":_vm.translate('table.' + _vm.entity + '.field.contrato')},model:{value:(_vm.editedItem.contrato),callback:function ($$v) {_vm.$set(_vm.editedItem, "contrato", $$v)},expression:"editedItem.contrato"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-date',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.contratacao')},model:{value:(_vm.editedItem.contratacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "contratacao", $$v)},expression:"editedItem.contratacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"counter":"","maxlength":"30","label":_vm.translate('table.' + _vm.entity + '.field.vencimento')},model:{value:(_vm.editedItem.vencimento),callback:function ($$v) {_vm.$set(_vm.editedItem, "vencimento", $$v)},expression:"editedItem.vencimento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"condominio_pessoa_id","label":_vm.translate('table.' + _vm.entity + '.field.condominio_pessoa_id'),"items":_vm.responsaveis_abreviado,"item-text":"pessoa.id_texto","item-value":"id","counter":"","maxlength":"38","error-messages":_vm.errors.collect('condominio_pessoa_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.condominio_pessoa_id'),"data-vv-validate-on":"blur"},model:{value:(_vm.editedItem.condominio_pessoa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "condominio_pessoa_id", $$v)},expression:"editedItem.condominio_pessoa_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('v-text-field',{attrs:{"name":"complemento","counter":"","maxlength":"8","label":"Complemento"},model:{value:(_vm.editedItem.complemento),callback:function ($$v) {_vm.$set(_vm.editedItem, "complemento", $$v)},expression:"editedItem.complemento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"valor_contrato","label":_vm.translate('table.' + _vm.entity + '.field.valor_contrato'),"v_validate":'positiveNumber|requiredNumber'},model:{value:(_vm.editedItem.valor_contrato),callback:function ($$v) {_vm.$set(_vm.editedItem, "valor_contrato", $$v)},expression:"editedItem.valor_contrato"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-autocomplete',{attrs:{"items":_vm.subItemTipos,"item-text":"id_texto","item-value":"id"},model:{value:(props.item.tipo),callback:function ($$v) {_vm.$set(props.item, "tipo", $$v)},expression:"props.item.tipo"}})],1),_vm._v(" "),_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor_base","v_validate":'positiveNumber',"data_vv_as":"Pago Principal"},model:{value:(props.item.valor_base),callback:function ($$v) {_vm.$set(props.item, "valor_base", $$v)},expression:"props.item.valor_base"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"juros","v_validate":'positiveNumber',"data_vv_as":"Juros e Acessórios"},model:{value:(props.item.juros),callback:function ($$v) {_vm.$set(props.item, "juros", $$v)},expression:"props.item.juros"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"disabled":"","value":props.item.valor_base + props.item.juros}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_liberado'),"value":_vm.sum.liberacao}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_pago'),"value":_vm.sum.pagamento}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_juros'),"value":_vm.sum.juros}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.total_geral'),"value":_vm.sum.pagamento + _vm.sum.juros}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","readonly":true,"label":_vm.translate('table.' + _vm.entity + '.field.situacao_anoanterior') +
                  (_vm.$auth.user().anobase.id_texto - 1)},model:{value:(_vm.editedItem.situacao_anoanterior),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anoanterior", $$v)},expression:"editedItem.situacao_anoanterior"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"situacao_anobase","label":_vm.translate('table.' + _vm.entity + '.field.situacao_anobase') +
                  _vm.$auth.user().anobase.id_texto,"v_validate":'positiveNumber'},model:{value:(_vm.editedItem.situacao_anobase),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anobase", $$v)},expression:"editedItem.situacao_anobase"}}),_vm._v(" "),_c('div',{attrs:{"id":"proccess"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":_vm.processSituacao}},on),[_vm._v("refresh")])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n                    Clique aqui para atualizar este campo com base nos valores já lançados.\n                  ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{staticClass:"mt-1",attrs:{"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save(_vm.entity, _vm.editedItem.id, _vm.editedItem, 1, true)}}},[_vm._v("\n                Salvar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DividaOnusRural_vue__ = __webpack_require__(106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f7d947_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DividaOnusRural_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62f7d947"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DividaOnusRural_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f7d947_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DividaOnusRural_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-left":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},nativeOn:{"keyup":function($event){return _vm.keyupSearch($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Apenas Ativos"},on:{"change":function($event){return _vm.initialize()}},model:{value:(_vm.apenasAtivos),callback:function ($$v) {_vm.apenasAtivos=$$v},expression:"apenasAtivos"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"disable-initial-sort":"","hide-actions":"","rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCodigoText(props.item.codigo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.banco))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.contrato))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.pessoa && props.item.pessoa.pessoa.id_texto.split(" ")[0]))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.situacao_anoanterior)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.situacao_anobase)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, {
                  id: props.item['id'],
                  ativo: props.item['ativo'],
                })}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anoanterior)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_situacao_anobase)))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])}),_vm._v(" "),_c('div',{staticClass:"v-datatable v-table theme--light",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.12) !important","border-left":"1px solid rgba(0, 0, 0, 0.12) !important","border-right":"1px solid rgba(0, 0, 0, 0.12) !important"}},[_c('div',{staticClass:"v-datatable__actions"},[_c('div',{staticClass:"v-datatable__actions__select"},[_vm._v("\n            Registros por página\n            "),_c('v-select',{staticClass:"v-select__selection v-select__selection--comma",attrs:{"items":[25, 50, 75, 100]},on:{"change":function($event){return _vm.changePage(_vm.pagination['current_page'])}},model:{value:(_vm.pagination['rowsPerPage']),callback:function ($$v) {_vm.$set(_vm.pagination, 'rowsPerPage', $$v)},expression:"pagination['rowsPerPage']"}})],1),_vm._v(" "),_c('div',{staticClass:"v-datatable__actions__range-controls"},[_c('div',{staticClass:"v-datatable__actions__pagination"},[_vm._v("\n              "+_vm._s(((this.pagination.from) + " - " + (this.pagination.to) + " de " + (this.pagination.total)))+"\n            ")]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === 1
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === 1,"type":"button","aria-label":"Previous page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] - 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_left")])])]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === _vm.pagination.last_page
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === _vm.pagination.last_page,"type":"button","aria-label":"Next page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] + 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_right")])])])])])])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-checkbox',{staticClass:"m-0",attrs:{"label":"Limitar a quantidade de caracteres"},model:{value:(_vm.limitarCaracteres),callback:function ($$v) {_vm.limitarCaracteres=$$v},expression:"limitarCaracteres"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required' + (_vm.limitarCaracteres == true ? '|max: 63' : '')),expression:"'required' + (limitarCaracteres == true ? '|max: 63' : '')"}],attrs:{"name":"id_texto","maxlength":_vm.limitarCaracteres == true ? 63 : null,"counter":"","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"label":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo'),"label":_vm.translate('table.' + _vm.entity + '.field.codigo'),"items":_vm.translate('value.divida_onus_codigo')},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"data","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('data'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.data'),"label":_vm.translate('table.' + _vm.entity + '.field.data'),"v_validate":'required',"as":_vm.translate('table.' + _vm.entity + '.field.data')},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"banco","counter":"","maxlength":"30","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('banco'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.banco'),"label":_vm.translate('table.' + _vm.entity + '.field.banco')},model:{value:(_vm.editedItem.banco),callback:function ($$v) {_vm.$set(_vm.editedItem, "banco", $$v)},expression:"editedItem.banco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf_cnpj","v_validate":"required","label":_vm.translate('table.' + _vm.entity + '.field.cpf_cnpj')},model:{value:(_vm.editedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj", $$v)},expression:"editedItem.cpf_cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"counter":"","maxlength":"10","label":_vm.translate('table.' + _vm.entity + '.field.contrato')},model:{value:(_vm.editedItem.contrato),callback:function ($$v) {_vm.$set(_vm.editedItem, "contrato", $$v)},expression:"editedItem.contrato"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"counter":"","maxlength":"30","label":_vm.translate('table.' + _vm.entity + '.field.propriedade')},model:{value:(_vm.editedItem.propriedade),callback:function ($$v) {_vm.$set(_vm.editedItem, "propriedade", $$v)},expression:"editedItem.propriedade"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-date',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.contratacao')},model:{value:(_vm.editedItem.contratacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "contratacao", $$v)},expression:"editedItem.contratacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"counter":"","maxlength":"30","label":_vm.translate('table.' + _vm.entity + '.field.vencimento')},model:{value:(_vm.editedItem.vencimento),callback:function ($$v) {_vm.$set(_vm.editedItem, "vencimento", $$v)},expression:"editedItem.vencimento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"condominio_pessoa_id","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('condominio_pessoa_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.condominio_pessoa_id'),"label":_vm.translate('table.' + _vm.entity + '.field.condominio_pessoa_id'),"items":_vm.responsaveis,"item-text":"pessoa.id_texto","item-value":"id"},model:{value:(_vm.editedItem.condominio_pessoa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "condominio_pessoa_id", $$v)},expression:"editedItem.condominio_pessoa_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"name":"complemento","counter":"","maxlength":"8","label":"Complemento"},model:{value:(_vm.editedItem.complemento),callback:function ($$v) {_vm.$set(_vm.editedItem, "complemento", $$v)},expression:"editedItem.complemento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"valor_contrato","label":_vm.translate('table.' + _vm.entity + '.field.valor_contrato'),"v_validate":'positiveNumber|requiredNumber',"data_vv_as":_vm.translate('table.' + _vm.entity + '.field.valor_contrato')},model:{value:(_vm.editedItem.valor_contrato),callback:function ($$v) {_vm.$set(_vm.editedItem, "valor_contrato", $$v)},expression:"editedItem.valor_contrato"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-autocomplete',{attrs:{"items":_vm.subItemTipos,"item-text":"id_texto","item-value":"id"},model:{value:(props.item.tipo),callback:function ($$v) {_vm.$set(props.item, "tipo", $$v)},expression:"props.item.tipo"}})],1),_vm._v(" "),_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor_base","v_validate":'positiveNumber',"data_vv_as":"Pago Principal"},model:{value:(props.item.valor_base),callback:function ($$v) {_vm.$set(props.item, "valor_base", $$v)},expression:"props.item.valor_base"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"juros","v_validate":'positiveNumber',"data_vv_as":"Juros e Acessórios"},model:{value:(props.item.juros),callback:function ($$v) {_vm.$set(props.item, "juros", $$v)},expression:"props.item.juros"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"disabled":"","value":props.item.valor_base + props.item.juros}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_liberado'),"value":_vm.sum.liberacao}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_pago'),"value":_vm.sum.pagamento}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.valor_juros'),"value":_vm.sum.juros}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.total_geral'),"value":_vm.sum.pagamento + _vm.sum.juros}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","readonly":true,"label":_vm.translate('table.' + _vm.entity + '.field.situacao_anoanterior') +
                  (_vm.$auth.user().anobase.id_texto - 1)},model:{value:(_vm.editedItem.situacao_anoanterior),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anoanterior", $$v)},expression:"editedItem.situacao_anoanterior"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"situacao_anobase","label":_vm.translate('table.' + _vm.entity + '.field.situacao_anobase') +
                  _vm.$auth.user().anobase.id_texto,"v_validate":'positiveNumber'},model:{value:(_vm.editedItem.situacao_anobase),callback:function ($$v) {_vm.$set(_vm.editedItem, "situacao_anobase", $$v)},expression:"editedItem.situacao_anobase"}}),_vm._v(" "),_c('div',{attrs:{"id":"proccess"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":_vm.processSituacao}},on),[_vm._v("refresh")])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n                    Clique aqui para atualizar este campo com base nos valores já lançados.\n                  ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save(_vm.entity, _vm.editedItem.id, _vm.editedItem, 1, true)}}},[_vm._v("\n                Salvar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImovelExplorado_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627fda31_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImovelExplorado_vue__ = __webpack_require__(388);
function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-627fda31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImovelExplorado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627fda31_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImovelExplorado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-left":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Apenas Ativos"},model:{value:(_vm.apenasAtivos),callback:function ($$v) {_vm.apenasAtivos=$$v},expression:"apenasAtivos"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{ref:"imovelExploradoTable",staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"custom-filter":_vm.customFilter,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getAtividadeText(props.item.atividade)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.localizacao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.nirf))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm._f("formatDouble")(props.item.area))+" ha")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDouble")(props.item.participacao)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getExploracaoText(props.item.exploracao)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, {
                  id: props.item['id'],
                  ativo: props.item['ativo'],
                })}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatDouble")(_vm.sum.area))+" ha")])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n          "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"id_texto","counter":"","maxlength":"60","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"label":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}}),_vm._v(" "),(_vm.sequencia_ir_duplicated)?_c('div',{staticStyle:{"color":"#ff5252","font-size":"12px !important","position":"relative","margin-top":"-20px"}},[_vm._v("\n                Este valor já foi inserido anteriormente.\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"atividade","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('atividade'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.atividade'),"label":_vm.translate('table.' + _vm.entity + '.field.atividade'),"items":_vm.translate('value.imovel_atividade')},model:{value:(_vm.editedItem.atividade),callback:function ($$v) {_vm.$set(_vm.editedItem, "atividade", $$v)},expression:"editedItem.atividade"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:55'),expression:"'required|max:55'"}],attrs:{"name":"localizacao","data-vv-validate-on":"blur","counter":"","maxlength":"55","error-messages":_vm.errors.collect('localizacao'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.localizacao'),"label":_vm.translate('table.' + _vm.entity + '.field.localizacao')},model:{value:(_vm.editedItem.localizacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "localizacao", $$v)},expression:"editedItem.localizacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:8'),expression:"'required|max:8'"}],attrs:{"name":"nirf","counter":"","maxlength":"8","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('nirf'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.nirf'),"label":_vm.translate('table.' + _vm.entity + '.field.nirf')},model:{value:(_vm.editedItem.nirf),callback:function ($$v) {_vm.$set(_vm.editedItem, "nirf", $$v)},expression:"editedItem.nirf"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-money',{attrs:{"name":"area","label":_vm.translate('table.' + _vm.entity + '.field.area'),"v_validate":'positiveNumber',"custom_preffix":"ha","custom_precision":1},model:{value:(_vm.editedItem.area),callback:function ($$v) {_vm.$set(_vm.editedItem, "area", $$v)},expression:"editedItem.area"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-money',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.participacao'),"custom_preffix":"%"},model:{value:(_vm.editedItem.participacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "participacao", $$v)},expression:"editedItem.participacao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"exploracao","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('exploracao'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.exploracao'),"label":_vm.translate('table.' + _vm.entity + '.field.exploracao'),"items":_vm.translate('value.imovel_exploracao')},model:{value:(_vm.editedItem.exploracao),callback:function ($$v) {_vm.$set(_vm.editedItem, "exploracao", $$v)},expression:"editedItem.exploracao"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"name":"caepf","label":_vm.translate('table.' + _vm.entity + '.field.caepf'),"counter":"","maxlength":"14","mask":'###.###.###/###-##'},model:{value:(_vm.editedItem.caepf),callback:function ($$v) {_vm.$set(_vm.editedItem, "caepf", $$v)},expression:"editedItem.caepf"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"name":"nirf","counter":"","maxlength":"14","label":_vm.translate('table.' + _vm.entity + '.field.inscr_estadual')},model:{value:(_vm.editedItem.inscr_estadual),callback:function ($$v) {_vm.$set(_vm.editedItem, "inscr_estadual", $$v)},expression:"editedItem.inscr_estadual"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{attrs:{"name":"tipo_exploracao","label":_vm.translate('table.' + _vm.entity + '.field.tipo_exploracao'),"items":_vm.translate('value.controlecaixa_codigo_imovel')},model:{value:(_vm.editedItem.tipo_exploracao),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo_exploracao", $$v)},expression:"editedItem.tipo_exploracao"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"align-self":"center"},attrs:{"xs12":"","md2":""}},[_c('div',[_c('v-badge',{attrs:{"color":"blue darken-1","overlap":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.terceiros.length))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","disabled":!_vm.editedItem.id,"block":""},on:{"click":function($event){return _vm.openTerceiros()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("group")]),_vm._v("\n                    Consulta de Terceiros\n                  ")],1)],1),_vm._v(" "),(!_vm.editedItem.id)?_c('p',{staticStyle:{"font-size":"11px","color":"#999","margin-top":"4px"}},[_vm._v("\n                  Salve o registro antes de gerenciar terceiros.\n                ")]):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"name":"endereco","counter":"","maxlength":"100","label":_vm.translate('table.' + _vm.entity + '.field.endereco')},model:{value:(_vm.editedItem.endereco),callback:function ($$v) {_vm.$set(_vm.editedItem, "endereco", $$v)},expression:"editedItem.endereco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{attrs:{"name":"numero","counter":"","maxlength":"6","label":_vm.translate('table.' + _vm.entity + '.field.numero')},model:{value:(_vm.editedItem.numero),callback:function ($$v) {_vm.$set(_vm.editedItem, "numero", $$v)},expression:"editedItem.numero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"name":"complemento","counter":"","maxlength":"50","label":_vm.translate('table.' + _vm.entity + '.field.complemento')},model:{value:(_vm.editedItem.complemento),callback:function ($$v) {_vm.$set(_vm.editedItem, "complemento", $$v)},expression:"editedItem.complemento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{attrs:{"name":"cidade_id","label":_vm.translate('table.' + _vm.entity + '.field.cidade_id'),"items":_vm.cidades,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.cidade_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "cidade_id", $$v)},expression:"editedItem.cidade_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"name":"bairro","counter":"","maxlength":"50","label":_vm.translate('table.' + _vm.entity + '.field.bairro')},model:{value:(_vm.editedItem.bairro),callback:function ($$v) {_vm.$set(_vm.editedItem, "bairro", $$v)},expression:"editedItem.bairro"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"name":"cep","mask":'#####-###',"counter":"","maxlength":"8","label":_vm.translate('table.' + _vm.entity + '.field.cep')},model:{value:(_vm.editedItem.cep),callback:function ($$v) {_vm.$set(_vm.editedItem, "cep", $$v)},expression:"editedItem.cep"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"900px"},model:{value:(_vm.terceirosDialog),callback:function ($$v) {_vm.terceirosDialog=$$v},expression:"terceirosDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Consulta de Terceiros")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openTerceirosForm()}}},[_vm._v("\n              Adicionar\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.terceirosSearch),callback:function ($$v) {_vm.terceirosSearch=$$v},expression:"terceirosSearch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.terceirosHeaders,"items":_vm.terceiros,"search":_vm.terceirosSearch,"no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(props.item.cpf_cnpj)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getTipoParticipanteText(props.item.tipo_participante)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openTerceirosForm(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteTerceiro(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n                "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n              ")]}}])})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.terceirosDialog = false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px","persistent":""},model:{value:(_vm.terceirosFormDialog),callback:function ($$v) {_vm.terceirosFormDialog=$$v},expression:"terceirosFormDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.terceirosEditedIndex === -1 ? 'Adicionar Terceiro' : 'Editar Terceiro'))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.translate('table.condominio_imovelexplorado_terceiros.field.nome'),"counter":"","maxlength":"100"},model:{value:(_vm.terceirosEditedItem.nome),callback:function ($$v) {_vm.$set(_vm.terceirosEditedItem, "nome", $$v)},expression:"terceirosEditedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p-cpf-cnpj',{attrs:{"label":_vm.translate('table.condominio_imovelexplorado_terceiros.field.cpf_cnpj')},model:{value:(_vm.terceirosEditedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.terceirosEditedItem, "cpf_cnpj", $$v)},expression:"terceirosEditedItem.cpf_cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":_vm.translate('table.condominio_imovelexplorado_terceiros.field.tipo_participante'),"items":_vm.tipoParticipanteOptions},model:{value:(_vm.terceirosEditedItem.tipo_participante),callback:function ($$v) {_vm.$set(_vm.terceirosEditedItem, "tipo_participante", $$v)},expression:"terceirosEditedItem.tipo_participante"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.saveTerceiro()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.terceirosFormDialog = false}}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagamento_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20478a1d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagamento_vue__ = __webpack_require__(391);
function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20478a1d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20478a1d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},on:{"change":_vm.updateSum},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{ref:"PagamentoTable",staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCodigoText(props.item.codigo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.ano))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.beneficiario))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(props.item.cpf_cnpj)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.descricao))]),_vm._v(" "),(_vm.temDependente)?_c('td',[_vm._v("\n            "+_vm._s(props.item.dependente ? props.item.dependente.id_texto : "")+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.total_valor)))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":_vm.temDependente ? 7 : 6}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatDouble")(_vm.total.total_valor)))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo'),"label":_vm.translate('table.' + _vm.entity + '.field.codigo'),"items":_vm.translate('value.pagamento_codigo')},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"ano","counter":"","maxlength":"4","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('ano'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.ano'),"label":_vm.translate('table.' + _vm.entity + '.field.ano')},model:{value:(_vm.editedItem.ano),callback:function ($$v) {_vm.$set(_vm.editedItem, "ano", $$v)},expression:"editedItem.ano"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}}),_vm._v(" "),(_vm.sequencia_ir_duplicated)?_c('div',{staticStyle:{"color":"#ff5252","font-size":"12px !important, position: relative","margin-top":"-20px"}},[_vm._v("\n                Este valor já foi inserido anteriormente.\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"beneficiario","counter":"","maxlength":"60","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('beneficiario'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.beneficiario'),"label":_vm.translate('table.' + _vm.entity + '.field.beneficiario')},model:{value:(_vm.editedItem.beneficiario),callback:function ($$v) {_vm.$set(_vm.editedItem, "beneficiario", $$v)},expression:"editedItem.beneficiario"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf_cnpj","v_validate":"required"},model:{value:(_vm.editedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj", $$v)},expression:"editedItem.cpf_cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"descricao","counter":"","maxlength":"300","error-messages":_vm.errors.collect('descricao'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.descricao'),"label":_vm.translate('table.' + _vm.entity + '.field.descricao')},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1),_vm._v(" "),(_vm.temDependente)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.pessoa_dependente_id'),"items":_vm.dependente_items,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.pessoa_dependente_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_dependente_id", $$v)},expression:"editedItem.pessoa_dependente_id"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor","label":_vm.translate('table.' + _vm.entity + '.field.valor'),"v_validate":'positiveNumber'},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '_item.field.valor'),"value":_vm.editedItemSum.valor}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoIsento_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14e7ef4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoIsento_vue__ = __webpack_require__(394);
function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b14e7ef4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoIsento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14e7ef4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoIsento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},on:{"change":_vm.updateSum},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{ref:"RendimentoIsentoTable",staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCodigoText(props.item.codigo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(_vm._f("formatCpfCnpj")(props.item.cnpj))))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_valor))+"\n          ")]),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_decimo_terceiro))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_irrf))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_irrf_decimo_terceiro))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_contribuicao_previdenciaria))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.temDependente)?_c('td',[_vm._v("\n            "+_vm._s(props.item.dependente ? props.item.dependente.id_texto : "")+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"4"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatDouble")(_vm.sum.total_valor)))])]),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatDouble")(_vm.sum.total_decimo_terceiro)))])]):_vm._e(),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatDouble")(_vm.sum.total_irrf)))])]):_vm._e(),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatDouble")(_vm.sum.total_irrf_decimo_terceiro)))])]):_vm._e(),_vm._v(" "),(_vm.particular)?_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatDouble")(_vm.sum.total_contribuicao_previdenciaria)))])]):_vm._e()]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n          "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-right":"","align-right":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.editedItem.codigo !== 25 ? 'required' : ''),expression:"editedItem.codigo !== 25 ? 'required' : ''"}],attrs:{"name":"id_texto","counter":"","maxlength":"60","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"disabled":_vm.isTextoDisabled},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo'),"label":_vm.translate('table.' + _vm.entity + '.field.codigo'),"items":_vm.particular
                    ? _vm.translate('value.rend_isento_codigo_particular')
                    : _vm.translate('value.rend_isento_codigo_condominio')},on:{"change":_vm.processFields},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cnpj","v_validate":"required","disabled":_vm.isTextoDisabled},model:{value:(_vm.editedItem.cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cnpj", $$v)},expression:"editedItem.cnpj"}})],1),_vm._v(" "),(_vm.temDependente)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.pessoa_dependente_id'),"items":_vm.dependente_items,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.pessoa_dependente_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_dependente_id", $$v)},expression:"editedItem.pessoa_dependente_id"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  "+_vm._s(this.translate("system.button.add.icon"))+"\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:((_vm.editedItem.codigo !== 10) && (_vm.editedItem.codigo !== 11)),expression:"(editedItem.codigo !== 10) && (editedItem.codigo !== 11)"}],attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor","v_validate":'positiveNumber',"data_vv_as":"Valor"},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.editedItem.codigo == 10),expression:"editedItem.codigo == 10"}],attrs:{"headers":_vm.sub_headers_cod_10,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor","v_validate":'positiveNumber',"data_vv_as":"Valor"},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"money-grid",attrs:{"name":"decimo_terceiro","v_validate":'positiveNumber',"data_vv_as":"decimo_terceiro"},model:{value:(props.item.decimo_terceiro),callback:function ($$v) {_vm.$set(props.item, "decimo_terceiro", $$v)},expression:"props.item.decimo_terceiro"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.editedItem.codigo == 11),expression:"editedItem.codigo == 11"}],attrs:{"headers":_vm.sub_headers_cod_11,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor","v_validate":'positiveNumber',"data_vv_as":"valor"},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"money-grid",attrs:{"name":"decimo_terceiro","v_validate":'positiveNumber',"data_vv_as":"decimo_terceiro"},model:{value:(props.item.decimo_terceiro),callback:function ($$v) {_vm.$set(props.item, "decimo_terceiro", $$v)},expression:"props.item.decimo_terceiro"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"money-grid",attrs:{"name":"irrf","v_validate":'positiveNumber',"data_vv_as":"irrf"},model:{value:(props.item.irrf),callback:function ($$v) {_vm.$set(props.item, "irrf", $$v)},expression:"props.item.irrf"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"money-grid",attrs:{"name":"irrf_decimo_terceiro","v_validate":'positiveNumber',"data_vv_as":"irrf_decimo_terceiro"},model:{value:(props.item.irrf_decimo_terceiro),callback:function ($$v) {_vm.$set(props.item, "irrf_decimo_terceiro", $$v)},expression:"props.item.irrf_decimo_terceiro"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"money-grid",attrs:{"name":"contribuicao_previdenciaria","v_validate":'positiveNumber',"data_vv_as":"contribuicao_previdenciaria"},model:{value:(props.item.contribuicao_previdenciaria),callback:function ($$v) {_vm.$set(props.item, "contribuicao_previdenciaria", $$v)},expression:"props.item.contribuicao_previdenciaria"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-money',{attrs:{"name":"valor","label":"Rendimento Total","v_validate":'positiveNumber',"disabled":""},model:{value:(_vm.editedItemSum.valor),callback:function ($$v) {_vm.$set(_vm.editedItemSum, "valor", $$v)},expression:"editedItemSum.valor"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:((_vm.editedItem.codigo == 11) || (_vm.editedItem.codigo == 10)),expression:"(editedItem.codigo == 11) || (editedItem.codigo == 10)"}],attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"decimo_terceiro","label":"Total do 13º","v_validate":'positiveNumber',"disabled":""},model:{value:(_vm.editedItemSum.decimo_terceiro),callback:function ($$v) {_vm.$set(_vm.editedItemSum, "decimo_terceiro", $$v)},expression:"editedItemSum.decimo_terceiro"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.editedItem.codigo == 11),expression:"editedItem.codigo == 11"}],attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"irrf","label":"Total do IRRF","v_validate":'positiveNumber',"disabled":""},model:{value:(_vm.editedItemSum.irrf),callback:function ($$v) {_vm.$set(_vm.editedItemSum, "irrf", $$v)},expression:"editedItemSum.irrf"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.editedItem.codigo == 11),expression:"editedItem.codigo == 11"}],attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"irrf_decimo_terceiro","label":"Total do IRRF sobre o 13º","v_validate":'positiveNumber',"disabled":""},model:{value:(_vm.editedItemSum.irrf_decimo_terceiro),callback:function ($$v) {_vm.$set(_vm.editedItemSum, "irrf_decimo_terceiro", $$v)},expression:"editedItemSum.irrf_decimo_terceiro"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.editedItem.codigo == 11),expression:"editedItem.codigo == 11"}],attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"name":"contribuicao_previdenciaria","label":"Total da Contribuição Previdenciária","v_validate":'positiveNumber',"disabled":""},model:{value:(_vm.editedItemSum.contribuicao_previdenciaria),callback:function ($$v) {_vm.$set(_vm.editedItemSum, "contribuicao_previdenciaria", $$v)},expression:"editedItemSum.contribuicao_previdenciaria"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoTributacao_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09af4a27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoTributacao_vue__ = __webpack_require__(397);
function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09af4a27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoTributacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09af4a27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoTributacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},on:{"change":_vm.updateSum},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{ref:"RendimentoTributacaoTable",staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCodigoText(props.item.codigo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(props.item.cnpj)))]),_vm._v(" "),(_vm.temDependente)?_c('td',[_vm._v("\n            "+_vm._s(props.item.dependente ? props.item.dependente.id_texto : "")+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_valor))+"\n          ")]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":_vm.temDependente ? 5 : 4}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatDouble")(_vm.sum.total_valor)))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n          "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-right":"","align-right":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"id_texto","counter":"","maxlength":"60","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"label":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo'),"label":_vm.translate('table.' + _vm.entity + '.field.codigo'),"items":_vm.translate('value.rend_tributacao_codigo')},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}}),_vm._v(" "),(_vm.sequencia_ir_duplicated)?_c('div',{staticStyle:{"color":"#ff5252","font-size":"12px !important, position: relative","margin-top":"-20px"}},[_vm._v("\n                Este valor já foi inserido anteriormente.\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cnpj","v_validate":"required"},model:{value:(_vm.editedItem.cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cnpj", $$v)},expression:"editedItem.cnpj"}})],1),_vm._v(" "),(_vm.temDependente)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.pessoa_dependente_id'),"items":_vm.dependente_items,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.pessoa_dependente_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_dependente_id", $$v)},expression:"editedItem.pessoa_dependente_id"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  "+_vm._s(this.translate("system.button.add.icon"))+"\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"valor","v_validate":'positiveNumber'},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"valor","label":_vm.translate('table.' + _vm.entity + '.field.valor'),"v_validate":'positiveNumber'},model:{value:(_vm.editedItemSum.valor),callback:function ($$v) {_vm.$set(_vm.editedItemSum, "valor", $$v)},expression:"editedItemSum.valor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoRecebidoPj_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59cd8260_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoRecebidoPj_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59cd8260"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoRecebidoPj_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59cd8260_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoRecebidoPj_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[(_vm.isCondominioMode && !_vm.isAdminAccess)?_c('v-alert',{staticClass:"mb-3",attrs:{"type":"warning","value":true}},[_c('strong',[_vm._v("Atenção:")]),_vm._v(" Apenas administradores podem adicionar, editar ou excluir registros de Rendimentos Tributáveis Recebidos de PJ em condomínios.\n  ")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create') || (_vm.isCondominioMode && !_vm.isAdminAccess)},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},on:{"change":_vm.updateSum},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{ref:"RendimentoRecebidoPJTable",staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.sequencia_ir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(props.item.cpf_cnpj)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_recebido_pj))+"\n          ")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_contribuicao_previdenciaria))+"\n          ")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_imposto_retido))+"\n          ")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_salary_13))+"\n          ")]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")(props.item.total_irrf_salary_13))+"\n          ")]),_vm._v(" "),(_vm.temDependente)?_c('td',[_vm._v("\n            "+_vm._s(props.item.dependente ? props.item.dependente.id_texto : "")+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update') || (_vm.isCondominioMode && !_vm.isAdminAccess)},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete') || (_vm.isCondominioMode && !_vm.isAdminAccess)},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"3"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total.total_recebido_pj)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v("\n              "+_vm._s(_vm._f("formatCurrency")(_vm.total.total_contribuicao_previdenciaria))+"\n            ")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total.total_imposto_retido)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total.total_salary_13)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total.total_irrf_salary_13)))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n          "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-right":"","align-right":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"id_texto","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"label":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"sequencia_ir","data-vv-validate-on":"blur","counter":"","maxlength":"19","error-messages":_vm.errors.collect('sequencia_ir'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir'),"label":_vm.translate('table.' + _vm.entity + '.field.sequencia_ir')},on:{"blur":function($event){return _vm.checkDuplicate(_vm.items, 'sequencia_ir', _vm.editedItem.sequencia_ir)}},model:{value:(_vm.editedItem.sequencia_ir),callback:function ($$v) {_vm.$set(_vm.editedItem, "sequencia_ir", $$v)},expression:"editedItem.sequencia_ir"}}),_vm._v(" "),(_vm.sequencia_ir_duplicated)?_c('div',{staticStyle:{"color":"#ff5252","font-size":"12px !important","position":"relative","margin-top":"-20px"}},[_vm._v("\n                Este valor já foi inserido anteriormente.\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf_cnpj","v_validate":"required"},model:{value:(_vm.editedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj", $$v)},expression:"editedItem.cpf_cnpj"}})],1),_vm._v(" "),(_vm.temDependente)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.pessoa_dependente_id'),"items":_vm.dependente_items,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.pessoa_dependente_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_dependente_id", $$v)},expression:"editedItem.pessoa_dependente_id"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  "+_vm._s(this.translate("system.button.add.icon"))+"\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.sub_headers,"items":_vm.editedItem.sub_items,"id":"sub_items_table","hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('p-date',{attrs:{"limitPreviousYears":""},model:{value:(props.item.data),callback:function ($$v) {_vm.$set(props.item, "data", $$v)},expression:"props.item.data"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"recebido_pj","v_validate":'positiveNumber',"data_vv_as":"Rendimento Recebido de PJ"},model:{value:(props.item.recebido_pj),callback:function ($$v) {_vm.$set(props.item, "recebido_pj", $$v)},expression:"props.item.recebido_pj"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"contribuicao_previdenciaria","v_validate":'positiveNumber',"data_vv_as":"Contribuição Previdenciária"},model:{value:(props.item.contribuicao_previdenciaria),callback:function ($$v) {_vm.$set(props.item, "contribuicao_previdenciaria", $$v)},expression:"props.item.contribuicao_previdenciaria"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"imposto_retido","v_validate":'positiveNumber',"data_vv_as":"Imposto Retido na Fonte"},model:{value:(props.item.imposto_retido),callback:function ($$v) {_vm.$set(props.item, "imposto_retido", $$v)},expression:"props.item.imposto_retido"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"salary_13","v_validate":'positiveNumber',"data_vv_as":"13º Salário"},model:{value:(props.item.salary_13),callback:function ($$v) {_vm.$set(props.item, "salary_13", $$v)},expression:"props.item.salary_13"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"irrf_salary_13","v_validate":'positiveNumber',"data_vv_as":"IRRF 13º Salário"},model:{value:(props.item.irrf_salary_13),callback:function ($$v) {_vm.$set(props.item, "irrf_salary_13", $$v)},expression:"props.item.irrf_salary_13"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.recebido_pj'),"value":_vm.editedItemSum.recebido_pj}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.contribuicao_previdenciaria'),"value":_vm.editedItemSum.contribuicao_previdenciaria}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.imposto_retido'),"value":_vm.editedItemSum.imposto_retido}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.salary_13'),"value":_vm.editedItemSum.salary_13}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('p-money',{attrs:{"disabled":"","label":_vm.translate('table.' + _vm.entity + '.field.irrf_salary_13'),"value":_vm.editedItemSum.irrf_salary_13}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px","persistent":""},model:{value:(_vm.confirmDialogCondominio),callback:function ($$v) {_vm.confirmDialogCondominio=$$v},expression:"confirmDialogCondominio"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Confirmação de Uso")])]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{staticClass:"mb-3",attrs:{"type":"warning","value":true}},[_vm._v("\n          Você está acessando a aba de "),_c('strong',[_vm._v("Rendimentos Tributáveis Recebidos de PJ")]),_vm._v(" em um "),_c('strong',[_vm._v("Condomínio")]),_vm._v(".\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Esta funcionalidade é normalmente utilizada apenas para "),_c('strong',[_vm._v("Contribuintes (Particulares)")]),_vm._v(".\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Deseja realmente continuar utilizando esta aba para o condomínio?\n        ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","flat":""},on:{"click":function($event){_vm.confirmDialogCondominio = false}}},[_vm._v("\n          Sim, continuar\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MovimentacaoFinanceira_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc3d82c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MovimentacaoFinanceira_vue__ = __webpack_require__(404);
function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dc3d82c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MovimentacaoFinanceira_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc3d82c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MovimentacaoFinanceira_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */,
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('span',{staticClass:"headline"},[_vm._v("Receitas e Despesas da Atividade Rural")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":function($event){return _vm.openModal(1)}}},[_vm._v("\n            "+_vm._s(this.translate("system.button.manage.title"))+"\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v(_vm._s(this.translate("system.button.manage.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1, 'receita_despesa')}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2, 'receita_despesa')}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers.receita_despesa,"items":_vm.editedItem,"rows-per-page-text":"Registros por página","rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.meses[props.item.mes_base - 1]))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")(props.item.receita))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")(props.item.despesa))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")((props.item.receita - props.item.despesa)))+"\n              ")])]}},{key:"pageText",fn:function(props){return [_vm._v("\n              "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n            ")]}}])},[_vm._v(" "),_c('template',{slot:"footer"},[_c('td',[_c('strong',[_vm._v("Total")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_receita)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_despesa)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")((_vm.total_receita - _vm.total_despesa)))+"\n              ")])])],2)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Liberações e Pagamentos da Atividade Rural")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1, 'liberacao_pagamento')}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2, 'liberacao_pagamento')}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers.liberacao_pagamento,"items":_vm.editedItem,"rows-per-page-text":"Registros por página","rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.meses[props.item.mes_base - 1]))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")(props.item.liberacao_total))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")(props.item.pagamento_total))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")((props.item.liberacao_total - props.item.pagamento_total)))+"\n              ")])]}},{key:"pageText",fn:function(props){return [_vm._v("\n              "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n            ")]}}])},[_vm._v(" "),_c('template',{slot:"footer"},[_c('td',[_c('strong',[_vm._v("Total")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_liberacao)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.total_pagamento)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("formatCurrency")((_vm.total_liberacao - _vm.total_pagamento)))+"\n              ")])])],2)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s("Gerenciamento de Receitas e Despesas"))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":_vm.atualizarValores}},on),[_vm._v("refresh")])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n            Preencher com Controle de Caixa\n          ")])])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.form.headers,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"items":_vm.editedItem},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.meses[props.item.mes_base - 1]))]),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"liberacao","v_validate":'positiveNumber'},model:{value:(props.item.receita),callback:function ($$v) {_vm.$set(props.item, "receita", $$v)},expression:"props.item.receita"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"despesa","v_validate":'positiveNumber'},model:{value:(props.item.despesa),callback:function ($$v) {_vm.$set(props.item, "despesa", $$v)},expression:"props.item.despesa"}})],1),_vm._v(" "),_c('td',[_c('money',_vm._b({staticClass:"custom-input",attrs:{"disabled":"","value":Number(props.item.receita - props.item.despesa)}},'money',_vm.money,false))],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save('movimentacaofinanceira')}}},[_vm._v("\n          Salvar\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MovimentacaoRebanho_vue__ = __webpack_require__(113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bcbe09a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MovimentacaoRebanho_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9bcbe09a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MovimentacaoRebanho_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bcbe09a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MovimentacaoRebanho_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('span',{staticClass:"headline"},[_vm._v("Movimentações do Rebanho")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":_vm.create}},[_vm._v("\n            "+_vm._s(this.translate("system.button.manage.title"))+"\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v(_vm._s(this.translate("system.button.manage.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"rows-per-page-text":"Registros por página","rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.especie[props.item.especie - 1]))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.estoque_inicial))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.aquisicao))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.nascimento))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.consumo_e_perda))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.venda))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(props.item.estoque_inicial +
                  props.item.aquisicao +
                  props.item.nascimento -
                  props.item.consumo_e_perda -
                  props.item.venda)+"\n              ")])]}},{key:"pageText",fn:function(props){return [_vm._v("\n              "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n            ")]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v("Gerenciamento de Movimentações do Rebanho")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.editedItem,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.especie[props.item.especie - 1]))]),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"estoque_inicial","custom_precision":0,"custom-preffix":"","v_validate":'positiveNumber'},model:{value:(props.item.estoque_inicial),callback:function ($$v) {_vm.$set(props.item, "estoque_inicial", $$v)},expression:"props.item.estoque_inicial"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"aquisicao","custom_precision":0,"custom-preffix":"","v_validate":'positiveNumber'},model:{value:(props.item.aquisicao),callback:function ($$v) {_vm.$set(props.item, "aquisicao", $$v)},expression:"props.item.aquisicao"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"nascimento","custom_precision":0,"custom-preffix":"","v_validate":'positiveNumber'},model:{value:(props.item.nascimento),callback:function ($$v) {_vm.$set(props.item, "nascimento", $$v)},expression:"props.item.nascimento"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"consumo_e_perda","custom_precision":0,"custom-preffix":"","v_validate":'positiveNumber'},model:{value:(props.item.consumo_e_perda),callback:function ($$v) {_vm.$set(props.item, "consumo_e_perda", $$v)},expression:"props.item.consumo_e_perda"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"venda","custom_precision":0,"custom-preffix":"","v_validate":'positiveNumber'},model:{value:(props.item.venda),callback:function ($$v) {_vm.$set(props.item, "venda", $$v)},expression:"props.item.venda"}})],1),_vm._v(" "),_c('td',[_c('p-money',{staticClass:"custon-input",attrs:{"name":"aquisicao","custom_precision":0,"custom-preffix":"","disabled":"","value":Number(
                          props.item.estoque_inicial +
                            props.item.aquisicao +
                            props.item.nascimento -
                            props.item.consumo_e_perda -
                            props.item.venda
                        )}})],1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save('movimentacaorebanho')}}},[_vm._v("\n                Salvar\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transacao_vue__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_242acc6b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transacao_vue__ = __webpack_require__(412);
function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-242acc6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_242acc6b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Math = function () {
  function Math() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Math);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Math, null, [{
    key: 'round',
    value: function round(value) {
      var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

      return parseFloat(parseFloat(value).toFixed(places)).toFixed(places);
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var retorno = value;

      var lastDot = retorno.toString.lastIndexOf(',');

      var integerPart = retorno.substr(0, lastDot).replace(',', '');
      var decimalPart = retorno.substr(lastDot + 1);

      return integerPart + '.' + decimalPart;
    }
  }, {
    key: 'parseBD',
    value: function parseBD(value) {
      return this.round(this.normalize(value));
    }
  }]);

  return Math;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (Math);

/***/ }),
/* 411 */,
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado","pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.condominio_pessoa.pessoa.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.porcentagem))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(props.item.data)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n          "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"condominio_pessoa_id","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('condominio_pessoa_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.condominio_pessoa_id'),"label":_vm.translate('table.' + _vm.entity + '.field.condominio_pessoa_id'),"items":_vm.translate('value.dynamic_pessoas'),"item-text":"pessoa.id_texto_porcentagem","item-value":"id"},model:{value:(_vm.editedItem.condominio_pessoa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "condominio_pessoa_id", $$v)},expression:"editedItem.condominio_pessoa_id"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.condominio_pessoa_id'),"items":_vm.dynamic_pessoas,"item-text":"pessoa.id_texto_porcentagem","item-value":"id"},model:{value:(_vm.editedItem.condominio_pessoa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "condominio_pessoa_id", $$v)},expression:"editedItem.condominio_pessoa_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"porcentagem","label":"Porcentagem a ser vendida","v_validate":'positiveNumber|max_value:100',"custom_preffix":""},model:{value:(_vm.editedItem.porcentagem),callback:function ($$v) {_vm.$set(_vm.editedItem, "porcentagem", $$v)},expression:"editedItem.porcentagem"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-date',{attrs:{"name":"data","label":_vm.translate('table.' + _vm.entity + '.field.data'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('data'),"v_validate":'required',"data_vv_as":_vm.translate('table.' + _vm.entity + '.field.data')},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.editedItem.porcentagem > 0)?_c('span',{staticClass:"title"},[_vm._v("\n                Porcentagem restante: "+_vm._s(_vm.porcentagemRestante.toFixed(15))+"%\n              ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('span',{staticClass:"headline"},[_vm._v("Distribuições")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","md4":""}},[_c('v-btn',{staticClass:"my-1",attrs:{"color":"primary"},on:{"click":function($event){return _vm.createSubItem()}}},[_vm._v("\n                "+_vm._s(this.translate("system.button.add.title"))+"\n                "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                  "+_vm._s(this.translate("system.button.add.icon"))+"\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers_items,"items":_vm.editedItem.items,"hide-actions":"","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-autocomplete',{attrs:{"items":_vm.dynamic_pessoas,"item-text":"pessoa.id_texto","item-value":"id"},model:{value:(props.item.condominio_pessoa_id),callback:function ($$v) {_vm.$set(props.item, "condominio_pessoa_id", $$v)},expression:"props.item.condominio_pessoa_id"}})],1),_vm._v(" "),_c('td',[_c('p-money',{attrs:{"name":"porcentagem","v_validate":'positiveNumber|max_value:100',"custom_precision":15,"custom_preffix":""},model:{value:(props.item.porcentagem),callback:function ($$v) {_vm.$set(props.item, "porcentagem", $$v)},expression:"props.item.porcentagem"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSubItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"footer"},[_c('td',{staticClass:"body-2",attrs:{"colspan":"1"}},[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"body-2",attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.getSum().toFixed(15))+"%")])])],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_vue__ = __webpack_require__(115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c09d1e6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_vue__ = __webpack_require__(415);
function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c09d1e6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c09d1e6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary"},on:{"click":function($event){return _vm.refreshEmpresas(2)}}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"justify-space-between":"","align-left":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Apenas Ativos"},on:{"change":_vm.filtrarItens},model:{value:(_vm.apenasAtivos),callback:function ($$v) {_vm.apenasAtivos=$$v},expression:"apenasAtivos"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.user ? props.item.user.name : ""))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acesso ? props.item.acesso.id_texto : ""))]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.editValue(_vm.entity, props.item.id, props.item)}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.refreshEmpresas(3, props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"user_id","label":_vm.translate('table.' + _vm.entity + '.field.user_id'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('user_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.user_id'),"items":_vm.dynamicUsers,"item-text":"name","item-value":"id"},model:{value:(_vm.editedItem.user_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "user_id", $$v)},expression:"editedItem.user_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"acesso_id","label":_vm.translate('table.' + _vm.entity + '.field.acesso_id'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('acesso_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.acesso_id'),"items":_vm.acessos,"item-text":"id_texto","item-value":"id"},model:{value:(_vm.editedItem.acesso_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "acesso_id", $$v)},expression:"editedItem.acesso_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"color":"primary","label":_vm.translate('table.' + _vm.entity + '.field.ativo')},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControleCaixa_vue__ = __webpack_require__(116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110946b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControleCaixa_vue__ = __webpack_require__(418);
function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-110946b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControleCaixa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_110946b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControleCaixa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","align-content-space-between":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('p-date',{attrs:{"name":"dataI","label":_vm.translate('table.' + _vm.entity + '.field.data') + ' Início'},on:{"input":_vm.mudarFiltros},model:{value:(_vm.filtros.dataInicio),callback:function ($$v) {_vm.$set(_vm.filtros, "dataInicio", $$v)},expression:"filtros.dataInicio"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('p-date',{attrs:{"name":"dataF","label":_vm.translate('table.' + _vm.entity + '.field.data') + ' Fim'},on:{"input":_vm.mudarFiltros},model:{value:(_vm.filtros.dataFim),callback:function ($$v) {_vm.$set(_vm.filtros, "dataFim", $$v)},expression:"filtros.dataFim"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},on:{"change":_vm.updateSum},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{ref:"ControleCaixaTable",staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm._f("formatDate")(props.item.data)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.getCodigoImovelText(props.item.codigo_imovel)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.getCodigoContaText(props.item.codigo_conta)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.numero))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.getTipoDocumentoText(props.item.tipo_documento)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.historico))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.cpf_cnpj))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.getTipoLancamentoText(props.item.tipo_lancamento)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.entrada)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.saida)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v("\n            "+_vm._s(_vm._f("formatCurrency")((props.item.entrada - props.item.saida)))+"\n          ")]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v("\n            "+_vm._s(props.item.entrada - props.item.saida > 0 ? "Positivo" : "Negativo")+"\n          ")]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"8"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.entrada)))])]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.saida)))])]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")((_vm.sum.entrada - _vm.sum.saida))))])])]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"data","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('data'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.data'),"label":_vm.translate('table.' + _vm.entity + '.field.data'),"v_validate":'required',"as":_vm.translate('table.' + _vm.entity + '.field.data'),"limitPreviousYears":""},model:{value:(_vm.editedItem.data),callback:function ($$v) {_vm.$set(_vm.editedItem, "data", $$v)},expression:"editedItem.data"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo_imovel","label":_vm.translate('table.' + _vm.entity + '.field.codigo_imovel'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo_imovel'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo_imovel'),"items":_vm.itemsCodigoImovel,"item-text":"id_texto","item-value":"id"},on:{"change":function($event){_vm.editedItem.codigo = null}},model:{value:(_vm.editedItem.codigo_imovel),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo_imovel", $$v)},expression:"editedItem.codigo_imovel"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"codigo_conta","label":_vm.translate('table.' + _vm.entity + '.field.codigo_conta'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('codigo_conta'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.codigo_conta'),"items":_vm.itemsCodigoConta,"item-text":"id_texto","item-value":"id"},on:{"change":function($event){_vm.editedItem.codigo = null}},model:{value:(_vm.editedItem.codigo_conta),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo_conta", $$v)},expression:"editedItem.codigo_conta"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:30'),expression:"'required|max:30'"}],attrs:{"name":"numero","label":_vm.translate('table.' + _vm.entity + '.field.numero'),"counter":"","maxlength":"30","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('numero'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.numero')},model:{value:(_vm.editedItem.numero),callback:function ($$v) {_vm.$set(_vm.editedItem, "numero", $$v)},expression:"editedItem.numero"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"tipo_documento","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('tipo_documento'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.tipo_documento'),"label":_vm.translate('table.' + _vm.entity + '.field.tipo_documento'),"items":_vm.translate('value.controlecaixa_tipo_documento')},model:{value:(_vm.editedItem.tipo_documento),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo_documento", $$v)},expression:"editedItem.tipo_documento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:512'),expression:"'required|max:512'"}],attrs:{"name":"banco","label":_vm.translate('table.' + _vm.entity + '.field.historico'),"counter":"","maxlength":"512","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('banco'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.banco')},model:{value:(_vm.editedItem.historico),callback:function ($$v) {_vm.$set(_vm.editedItem, "historico", $$v)},expression:"editedItem.historico"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf_cnpj","v_validate":"required"},model:{value:(_vm.editedItem.cpf_cnpj),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj", $$v)},expression:"editedItem.cpf_cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"tipo_documento","label":_vm.translate('table.' + _vm.entity + '.field.tipo_lancamento'),"items":_vm.translate('value.controlecaixa_tipo_lancamento'),"data-vv-validate-on":"blur","error-messages":_vm.errors.collect('tipo_documento'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.tipo_documento')},model:{value:(_vm.editedItem.tipo_lancamento),callback:function ($$v) {_vm.$set(_vm.editedItem, "tipo_lancamento", $$v)},expression:"editedItem.tipo_lancamento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-money',{attrs:{"name":"entrada","label":_vm.translate('table.' + _vm.entity + '.field.entrada'),"v_validate":_vm.editedItem.tipo_lancamento == 1 || _vm.editedItem.tipo_lancamento == 3
                    ? 'positiveNumber|requiredNumber'
                    : 'positiveNumber'},model:{value:(_vm.editedItem.entrada),callback:function ($$v) {_vm.$set(_vm.editedItem, "entrada", $$v)},expression:"editedItem.entrada"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('p-money',{attrs:{"name":"saida","label":_vm.translate('table.' + _vm.entity + '.field.saida'),"v_validate":_vm.editedItem.tipo_lancamento == 2
                    ? 'positiveNumber|requiredNumber'
                    : 'positiveNumber'},model:{value:(_vm.editedItem.saida),callback:function ($$v) {_vm.$set(_vm.editedItem, "saida", $$v)},expression:"editedItem.saida"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoAcumuladamente_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f5f8a9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoAcumuladamente_vue__ = __webpack_require__(420);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RendimentoAcumuladamente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f5f8a9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RendimentoAcumuladamente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","disabled":!_vm.hasCondominioAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_vm._v("\n        "+_vm._s(this.translate("system.button.add.title"))+"\n        "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},on:{"change":_vm.updateSum},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(1)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em PDF")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.exportReport(2)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-2"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório em Excel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{ref:"RendimentoAcumuladamenteTable",staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm.getFormaTributacaoText(props.item.forma_tributacao)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.nome_fonte_pagadora))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(props.item.cpf_cnpj_fonte_pagadora)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.getMesText(props.item.mes_recebimento)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(props.item.numero_meses))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.rendimentos_tributaveis)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.parcela_isenta_65_anos)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.contribuicao_previdenciaria_oficial)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.imposto_retido_fonte)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.valor_recebido_juros)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm._f("formatCurrency")(props.item.total_rendimentos)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.dependente ? props.item.dependente.id_texto : ""))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px"},attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasCondominioAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"footer",fn:function(){return [_c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Total Geral")])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.rendimentos_tributaveis)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.parcela_isenta_65_anos)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.contribuicao_previdenciaria_oficial)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.imposto_retido_fonte)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.valor_recebido_juros)))])]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('strong',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.sum.total_rendimentos)))])]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}})]},proxy:true},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1200px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"forma_tributacao","error-messages":_vm.errors.collect('forma_tributacao'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.forma_tributacao'),"row":""},model:{value:(_vm.editedItem.forma_tributacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "forma_tributacao", $$v)},expression:"editedItem.forma_tributacao"}},_vm._l((_vm.formaTributacaoOptions),function(opt){return _c('v-radio',{key:opt.value,attrs:{"label":opt.text,"value":opt.value}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf_cnpj_fonte_pagadora","v_validate":"required","label":_vm.translate('table.' + _vm.entity + '.field.cpf_cnpj_fonte_pagadora')},model:{value:(_vm.editedItem.cpf_cnpj_fonte_pagadora),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf_cnpj_fonte_pagadora", $$v)},expression:"editedItem.cpf_cnpj_fonte_pagadora"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"nome_fonte_pagadora","counter":"","maxlength":"60","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('nome_fonte_pagadora'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.nome_fonte_pagadora'),"label":_vm.translate('table.' + _vm.entity + '.field.nome_fonte_pagadora')},model:{value:(_vm.editedItem.nome_fonte_pagadora),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome_fonte_pagadora", $$v)},expression:"editedItem.nome_fonte_pagadora"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"name":"mes_recebimento","items":_vm.mesesOptions,"label":_vm.translate('table.' + _vm.entity + '.field.mes_recebimento')},model:{value:(_vm.editedItem.mes_recebimento),callback:function ($$v) {_vm.$set(_vm.editedItem, "mes_recebimento", $$v)},expression:"editedItem.mes_recebimento"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"name":"numero_meses","type":"number","min":"1","max":"12","label":_vm.translate('table.' + _vm.entity + '.field.numero_meses')},model:{value:(_vm.editedItem.numero_meses),callback:function ($$v) {_vm.$set(_vm.editedItem, "numero_meses", $$v)},expression:"editedItem.numero_meses"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"rendimentos_tributaveis","label":_vm.translate('table.' + _vm.entity + '.field.rendimentos_tributaveis'),"v_validate":'positiveNumber'},model:{value:(_vm.editedItem.rendimentos_tributaveis),callback:function ($$v) {_vm.$set(_vm.editedItem, "rendimentos_tributaveis", $$v)},expression:"editedItem.rendimentos_tributaveis"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"contribuicao_previdenciaria_oficial","label":_vm.translate('table.' + _vm.entity + '.field.contribuicao_previdenciaria_oficial'),"v_validate":'positiveNumber'},model:{value:(_vm.editedItem.contribuicao_previdenciaria_oficial),callback:function ($$v) {_vm.$set(_vm.editedItem, "contribuicao_previdenciaria_oficial", $$v)},expression:"editedItem.contribuicao_previdenciaria_oficial"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"parcela_isenta_65_anos","label":_vm.translate('table.' + _vm.entity + '.field.parcela_isenta_65_anos'),"v_validate":'positiveNumber'},model:{value:(_vm.editedItem.parcela_isenta_65_anos),callback:function ($$v) {_vm.$set(_vm.editedItem, "parcela_isenta_65_anos", $$v)},expression:"editedItem.parcela_isenta_65_anos"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"imposto_retido_fonte","label":_vm.translate('table.' + _vm.entity + '.field.imposto_retido_fonte'),"v_validate":'positiveNumber'},model:{value:(_vm.editedItem.imposto_retido_fonte),callback:function ($$v) {_vm.$set(_vm.editedItem, "imposto_retido_fonte", $$v)},expression:"editedItem.imposto_retido_fonte"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('p-money',{attrs:{"name":"valor_recebido_juros","label":_vm.translate('table.' + _vm.entity + '.field.valor_recebido_juros'),"v_validate":'positiveNumber'},model:{value:(_vm.editedItem.valor_recebido_juros),callback:function ($$v) {_vm.$set(_vm.editedItem, "valor_recebido_juros", $$v)},expression:"editedItem.valor_recebido_juros"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('p-money',{attrs:{"name":"total_rendimentos","value":_vm.totalRendimentos,"label":_vm.translate('table.' + _vm.entity + '.field.total_rendimentos'),"disabled":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"shrink":""}},[_c('v-tooltip',{attrs:{"bottom":"","max-width":"420"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"ml-1",attrs:{"color":"info"}},on),[_vm._v("info")])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n                      A isenção dos proventos de aposentadoria, reserva remunerada, reforma e pensão de declarante com 65 anos ou mais, até o limite da primeira faixa da tabela mensal, aplica-se apenas quando o contribuinte optar pela forma de tributação "),_c('strong',[_vm._v("Ajuste Anual")]),_vm._v(" para os rendimentos recebidos acumuladamente. Ao marcar a forma de tributação "),_c('strong',[_vm._v("Exclusiva de Fonte")]),_vm._v(", o valor informado em \"Parcela Isenta 65 anos\" será somado a \"Rendimentos tributáveis\".\n                    ")])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":_vm.translate('table.' + _vm.entity + '.field.pessoa_dependente_id'),"items":_vm.dependente_items,"item-text":"id_texto","item-value":"id","clearable":""},model:{value:(_vm.editedItem.pessoa_dependente_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_dependente_id", $$v)},expression:"editedItem.pessoa_dependente_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary darken-2","disabled":_vm.saving,"loading":_vm.saving},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-1",nativeOn:{"click":function($event){return _vm.close(400)}}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finished)?_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog_dbk),callback:function ($$v) {_vm.dialog_dbk=$$v},expression:"dialog_dbk"}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Atenção")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":""},on:{"click":function($event){_vm.dialog_dbk = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n          O sistema encontrou algumas inconsistências durante o processo de geração das\n          informações.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Deseja prosseguir e gerar o arquivo DBK mesmo assim, ou prefere visualizar o arquivo de\n          log para verificar as inconsistências encontradas?\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.downloadDBK}},[_vm._v("Gerar DBK")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":_vm.viewLOG}},[_vm._v("Visualizar Arquivo de Log")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog_log),callback:function ($$v) {_vm.dialog_log=$$v},expression:"dialog_log"}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Atenção")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","icon":""},on:{"click":function($event){_vm.dialog_log = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n          O sistema identificou algumas inconsistências durante o processo de validação dos dados.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Gostaria de visualizar o arquivo de log para verificar as inconsistências encontradas?\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.viewLOG}},[_vm._v("Visualizar Arquivo de Log")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.dialog_log = false}}},[_vm._v("Fechar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-checkbox',{attrs:{"true-value":1,"false-value":0,"label":"Enviar o Relatório por e-mail ao final do processamento?"},model:{value:(_vm.report.sendEmail),callback:function ($$v) {_vm.$set(_vm.report, "sendEmail", $$v)},expression:"report.sendEmail"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.downloadItem}},[_vm._v("Confirmar")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showDialog = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),(!_vm.dialog)?_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"hide-details":"","append-icon":"search","label":"Pesquisar"},nativeOn:{"keyup":function($event){return _vm.keyupSearch($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"hide-actions":"","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.sigla))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.razao_social))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatCpfCnpj")(props.item.cpf)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.cidade ? props.item.cidade.id_texto : " "))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.endereco))]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.responsavel ? props.item.responsavel.id_texto : " ")+"\n          ")]),_vm._v(" "),_c('td',[_c('v-checkbox',{attrs:{"disabled":!_vm.hasAccess(_vm.entity, 'enabled')},on:{"change":function($event){return _vm.toggleAtivo(props.item)}},model:{value:(props.item.ativo),callback:function ($$v) {_vm.$set(props.item, "ativo", $$v)},expression:"props.item.ativo"}})],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","disabled":!_vm.hasAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItemProcess(props.item['id'])}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('span',[_vm._v("Editar")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","disabled":!_vm.hasAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item, props.item.id, true)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v("Excluir")])],1),_vm._v(" "),(_vm.entity == 'contribuinte')?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","disabled":!_vm.hasAccess(_vm.entity, 'dbk')},on:{"click":function($event){return _vm.openDialogDBK(props.item, $event)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"purple"}},[_vm._v("share")])],1),_vm._v(" "),_c('span',[_vm._v("Exportar DBK")])],1):_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","disabled":!_vm.hasAccess(_vm.entity, 'dbk')},on:{"click":function($event){return _vm.openDialogLog(props.item, $event)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("search")])],1),_vm._v(" "),_c('span',[_vm._v("Validar DBK")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.resumoCaixa(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"color":"orange"}},[_vm._v("library_books")])],1),_vm._v(" "),_c('span',[_vm._v("Resumo do Caixa")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-menu',{attrs:{"slot":"activator","offset-y":""},slot:"activator"},[_c('v-btn',{staticClass:"ml-2",attrs:{"slot":"activator","icon":"","title":"Relatórios"},slot:"activator"},[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("library_books")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.handleClick(props.item, 0)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório Simples")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Apresentar apenas os bens rurais que sofreram alteração no ano-calendário")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.handleClick(props.item, 1)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Relatório Completo")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Apresentar todos os bens rurais, independentemente de alteração no ano")])],1)],1),_vm._v(" "),(props.item.has_report)?_c('v-list-tile',{attrs:{"href":(_vm.api + "reports/" + (props.item.id_texto) + ".pdf"),"target":"_blank"}},[_c('v-list-tile-title',[_vm._v("Visualizar o último Relatório gerado")])],1):_vm._e()],1)],1),_vm._v(" "),_c('span',[_vm._v("Relatório para Declaração de Ajuste")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}],null,false,3547373086)}),_vm._v(" "),_c('div',{staticClass:"v-datatable v-table theme--light",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.12) !important","border-left":"1px solid rgba(0, 0, 0, 0.12) !important","border-right":"1px solid rgba(0, 0, 0, 0.12) !important"}},[_c('div',{staticClass:"v-datatable__actions"},[_c('div',{staticClass:"v-datatable__actions__select"},[_vm._v("\n            Registros por página\n            "),_c('v-select',{staticClass:"v-select__selection v-select__selection--comma",attrs:{"items":[25, 50, 75, 100]},on:{"change":function($event){return _vm.changePage(_vm.pagination['current_page'])}},model:{value:(_vm.pagination['rowsPerPage']),callback:function ($$v) {_vm.$set(_vm.pagination, 'rowsPerPage', $$v)},expression:"pagination['rowsPerPage']"}})],1),_vm._v(" "),_c('div',{staticClass:"v-datatable__actions__range-controls"},[_c('div',{staticClass:"v-datatable__actions__pagination"},[_vm._v("\n              "+_vm._s(((this.pagination.from) + " - " + (this.pagination.to) + " de " + (this.pagination.total)))+"\n            ")]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === 1
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === 1,"type":"button","aria-label":"Previous page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] - 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_left")])])]),_vm._v(" "),_c('button',{class:_vm.pagination['current_page'] === _vm.pagination.last_page
                  ? 'v-btn v-btn--disabled v-btn--flat v-btn--icon theme--light'
                  : 'v-btn v-btn--flat v-btn--icon theme--light',attrs:{"disabled":_vm.pagination['current_page'] === _vm.pagination.last_page,"type":"button","aria-label":"Next page"},on:{"click":function($event){return _vm.changePage(_vm.pagination['current_page'] + 1)}}},[_c('div',{staticClass:"v-btn__content"},[_c('i',{staticClass:"v-icon material-icons theme--light",attrs:{"aria-hidden":"true"}},[_vm._v("chevron_right")])])])])])])],1)],1):_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"id_texto","label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"maxlength":"67","counter":"","data-vv-validate-on":"blur","required":"","error-messages":_vm.errors.collect('id_texto'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.id_texto')},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.particular ? '' : 'required'),expression:"particular ? '' : 'required'"}],attrs:{"name":"sigla","label":_vm.translate('table.' + _vm.entity + '.field.sigla'),"maxlength":"3","counter":"","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('sigla'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.sigla')},model:{value:(_vm.editedItem.sigla),callback:function ($$v) {_vm.$set(_vm.editedItem, "sigla", $$v)},expression:"editedItem.sigla"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:67'),expression:"'max:67'"}],attrs:{"name":"razao_social","label":_vm.translate('table.' + _vm.entity + '.field.razao_social'),"maxlength":"67","counter":"","data-vv-validate-on":"blur","required":"","error-messages":_vm.errors.collect('razao_social'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.razao_social')},model:{value:(_vm.editedItem.razao_social),callback:function ($$v) {_vm.$set(_vm.editedItem, "razao_social", $$v)},expression:"editedItem.razao_social"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","lg3":""}},[_c('p-cpf-cnpj',{attrs:{"name":"cpf","v_validate":"reqSeriauired","data_vv_as":_vm.translate('table.' + _vm.entity + '.field.cpf')},model:{value:(_vm.editedItem.cpf),callback:function ($$v) {_vm.$set(_vm.editedItem, "cpf", $$v)},expression:"editedItem.cpf"}})],1),_vm._v(" "),(!_vm.particular)?_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"responsavel","label":_vm.translate('table.' + _vm.entity + '.field.pessoa_id'),"required":"","items":_vm.full_pessoas,"item-text":"id_texto","item-value":"id","error-messages":_vm.errors.collect('responsavel'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.pessoa_id')},model:{value:(_vm.editedItem.pessoa_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "pessoa_id", $$v)},expression:"editedItem.pessoa_id"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{class:_vm.particular ? 'md6' : 'md4',attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"endereco","label":_vm.translate('table.' + _vm.entity + '.field.endereco'),"maxlength":"67","counter":"","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('endereco'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.endereco')},model:{value:(_vm.editedItem.endereco),callback:function ($$v) {_vm.$set(_vm.editedItem, "endereco", $$v)},expression:"editedItem.endereco"}})],1),_vm._v(" "),_c('v-flex',{class:_vm.particular ? 'md6' : 'md4',attrs:{"xs12":""}},[_c('v-autocomplete',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"cidade_id","label":_vm.translate('table.' + _vm.entity + '.field.cidade_id'),"items":_vm.cidades,"item-text":"id_texto","item-value":"id","data-vv-validate-on":"blur","error-messages":_vm.errors.collect('cidade_id'),"data-vv-as":_vm.translate('table.' + _vm.entity + '.field.cidade_id')},model:{value:(_vm.editedItem.cidade_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "cidade_id", $$v)},expression:"editedItem.cidade_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"disabled":!_vm.hasAccess(_vm.entity, 'enabled'),"name":"ativo","label":_vm.translate(("table." + _vm.entity + ".field.ativo"))},model:{value:(_vm.editedItem.ativo),callback:function ($$v) {_vm.$set(_vm.editedItem, "ativo", $$v)},expression:"editedItem.ativo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.view === 3)?_c('v-tabs',{staticClass:"elevation-1",attrs:{"color":"green lighten-4","grow":"","show-arrows":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"primary"}}),_vm._v(" "),(
            !_vm.editedItem.particular &&
            _vm.hasCondominioAccess('condominio_pessoa', 'read', _vm.editedItem.id)
          )?_c('v-tab',{key:"0",attrs:{"href":"#0"},on:{"click":function($event){return _vm.update_values(
              'condominio_pessoa',
              'condominio_pessoas',
              '?where=condominio_id=' + _vm.editedItem.id
            )}}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_pessoa.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(
            !_vm.editedItem.particular &&
            _vm.hasCondominioAccess('condominio_transacao', 'read', _vm.editedItem.id)
          )?_c('v-tab',{key:"1",attrs:{"href":"#1"},on:{"click":function($event){return _vm.update_values('condominio_transacao', '?where=condominio_id=' + _vm.editedItem.id)}}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_transacao.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_bemdireito', 'read', _vm.editedItem.id))?_c('v-tab',{key:"2",attrs:{"href":"#2"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_bemdireito.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_bemdireitorural', 'read', _vm.editedItem.id))?_c('v-tab',{key:"3",attrs:{"href":"#3"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_bemdireitorural.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_dividaonus', 'read', _vm.editedItem.id))?_c('v-tab',{key:"4",attrs:{"href":"#4"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_dividaonus.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_dividaonusrural', 'read', _vm.editedItem.id))?_c('v-tab',{key:"5",attrs:{"href":"#5"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_dividaonusrural.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_rendimentorecebidopj', 'read', _vm.editedItem.id))?_c('v-tab',{key:"6",attrs:{"href":"#6"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_rendimentorecebidopj.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_rendimentoisento', 'read', _vm.editedItem.id))?_c('v-tab',{key:"7",attrs:{"href":"#7"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_rendimentoisento.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_rendimentotributacao', 'read', _vm.editedItem.id))?_c('v-tab',{key:"8",attrs:{"href":"#8"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_rendimentotributacao.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.editedItem.particular && _vm.hasCondominioAccess('condominio_rendimentoacumuladamente', 'read', _vm.editedItem.id))?_c('v-tab',{key:"9",attrs:{"href":"#9"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_rendimentoacumuladamente.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_pagamento', 'read', _vm.editedItem.id))?_c('v-tab',{key:"10",attrs:{"href":"#10"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_pagamento.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_imovelexplorado', 'read', _vm.editedItem.id))?_c('v-tab',{key:"11",attrs:{"href":"#11"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_imovelexplorado.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_movimentacaofinanceira', 'read', _vm.editedItem.id))?_c('v-tab',{key:"12",attrs:{"href":"#12"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_movimentacaofinanceira.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_movimentacaorebanho', 'read', _vm.editedItem.id))?_c('v-tab',{key:"13",attrs:{"href":"#13"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_movimentacaorebanho.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_controlecaixa', 'read', _vm.editedItem.id))?_c('v-tab',{key:"14",attrs:{"href":"#14"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_controlecaixa.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_users', 'read', _vm.editedItem.id))?_c('v-tab',{key:"15",attrs:{"href":"#15"}},[_vm._v("\n          "+_vm._s(this.translate("table.condominio_users.title")[0])+"\n        ")]):_vm._e(),_vm._v(" "),_c('v-tabs-items',{attrs:{"touchless":"","show-arrows":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[(
              !_vm.editedItem.particular &&
              _vm.hasCondominioAccess('condominio_pessoa', 'read', _vm.editedItem.id)
            )?_c('v-tab-item',{key:"0",attrs:{"value":"0"}},[(_vm.tab == 0)?_c('v-card',[_c('v-card-text',[_c('pessoa',{attrs:{"condominio_id":_vm.editedItem.id,"values":_vm.editedItem.condominio_pessoas,"quadro_societario":_vm.editedItem.condominio_quadrosocietario,"pessoas":_vm.pessoas,"conexoes":_vm.conexoes}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(
              !_vm.editedItem.particular &&
              _vm.hasCondominioAccess('condominio_transacao', 'read', _vm.editedItem.id)
            )?_c('v-tab-item',{key:"1",attrs:{"value":"1"}},[(_vm.tab == 1)?_c('v-card',[_c('v-card-text',[_c('transacao',{attrs:{"condominio_id":_vm.editedItem.id,"values":_vm.editedItem.condominio_transacao,"pessoas":_vm.editedItem.condominio_pessoas}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_bemdireito', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"2",attrs:{"value":"2"}},[(_vm.tab == 2)?_c('v-card',[_c('v-card-text',[_c('bem-direito',{attrs:{"particular":_vm.particular,"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_bemdireito,"cidades":_vm.cidades,"paises":_vm.paises,"dependente_items":_vm.dependente_items,"temDependente":this.entity === 'contribuinte'}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_bemdireitorural', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"3",attrs:{"value":"3"}},[(_vm.tab == 3)?_c('v-card',[_c('v-card-text',[_c('bem-direito-rural',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_bemdireitorural,"cidades":_vm.cidades,"paises":_vm.paises}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_dividaonus', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"4",attrs:{"value":"4"}},[(_vm.tab == 4)?_c('v-card',[_c('v-card-text',[_c('divida-onus',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_dividaonus,"responsaveis":_vm.editedItem.condominio_pessoas,"particular":_vm.particular}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_dividaonusrural', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"5",attrs:{"value":"5"}},[(_vm.tab == 5)?_c('v-card',[_c('v-card-text',[_c('divida-onus-rural',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_dividaonusrural,"responsaveis":_vm.editedItem.condominio_pessoas}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_rendimentorecebidopj', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"6",attrs:{"value":"6"}},[(_vm.tab == 6)?_c('v-card',[_c('v-card-text',[_c('rendimento-recebido-pj',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_rendimentorecebidopj,"dependente_items":_vm.dependente_items,"temDependente":this.entity === 'contribuinte',"particular":_vm.particular}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_rendimentoisento', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"7",attrs:{"value":"7"}},[(_vm.tab == 7)?_c('v-card',[_c('v-card-text',[_c('rendimento-isento',{attrs:{"particular":_vm.particular,"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_rendimentoisento,"dependente_items":_vm.dependente_items,"temDependente":this.entity === 'contribuinte'}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_rendimentotributacao', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"8",attrs:{"value":"8"}},[(_vm.tab == 8)?_c('v-card',[_c('v-card-text',[_c('rendimento-tributacao',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_rendimentotributacao,"dependente_items":_vm.dependente_items,"temDependente":this.entity === 'contribuinte'}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.editedItem.particular && _vm.hasCondominioAccess('condominio_rendimentoacumuladamente', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"9",attrs:{"value":"9"}},[(_vm.tab == 9)?_c('v-card',[_c('v-card-text',[_c('rendimento-acumuladamente',{attrs:{"condominio_id":_vm.editedItem.id,"anobase_id":_vm.$auth.user().anobase_id,"values":_vm.editedItem.condominio_rendimentoacumuladamente,"dependente_items":_vm.dependente_items}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_pagamento', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"10",attrs:{"value":"10"}},[(_vm.tab == 10)?_c('v-card',[_c('v-card-text',[_c('pagamento',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_pagamento,"dependente_items":_vm.dependente_items,"temDependente":this.entity === 'contribuinte'}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_imovelexplorado', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"11",attrs:{"value":"11"}},[(_vm.tab == 11)?_c('v-card',[_c('v-card-text',[_c('imovel-explorado',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla,"values":_vm.editedItem.condominio_imovelexplorado}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_movimentacaofinanceira', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"12",attrs:{"value":"12"}},[(_vm.tab == 12)?_c('v-card',[_c('v-card-text',[_c('movimentacao-financeira',{attrs:{"condominio_id":_vm.editedItem.id}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_movimentacaorebanho', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"13",attrs:{"value":"13"}},[(_vm.tab == 13)?_c('v-card',[_c('v-card-text',[_c('movimentacao-rebanho',{attrs:{"condominio_id":_vm.editedItem.id,"values":_vm.editedItem.condominio_movimentacaorebanho}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_controlecaixa', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"14",attrs:{"value":"14"}},[(_vm.tab == 14)?_c('v-card',[_c('v-card-text',[_c('controle-caixa',{attrs:{"condominio_id":_vm.editedItem.id,"initials":_vm.editedItem.sigla}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCondominioAccess('condominio_users', 'read', _vm.editedItem.id))?_c('v-tab-item',{key:"15",attrs:{"value":"15"}},[(_vm.tab == 15)?_c('v-card',[_c('v-card-text',[_c('usuario',{attrs:{"condominio_id":_vm.editedItem.id,"values":_vm.editedItem.condominio_users,"users":_vm.users,"acessos":_vm.acessos}})],1)],1):_vm._e()],1):_vm._e()],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.view === 1 && _vm.particular == 0)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","fixed":"","bottom":"","right":"","disabled":!_vm.hasAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1):_vm._e(),_vm._v(" "),(_vm.view !== 1 || _vm.particular === 1)?_c('v-layout',{staticClass:"fab-container",attrs:{"align-center":""}},[(_vm.view === 2)?_c('v-speed-dial',{attrs:{"open-on-hover":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"primary","dark":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.save()}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))]),_vm._v(" "),_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save.icon")))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"secondary","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.saveNew()}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save_new.icon")))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.translate("system.button.save_new.title")))])],1),_vm._v(" "),(this.$auth.user().acesso_interno !== 'user')?_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"accent","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.saveEdit()}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save_manage.icon")))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.translate("system.button.save_manage.title")))])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.view === 3)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.save()}}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.done.icon")))])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.close.icon")))])],1)],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnoBase_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17718e80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnoBase_vue__ = __webpack_require__(424);
function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17718e80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnoBase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17718e80_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnoBase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[(!_vm.dialog)?_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":[100, 50, 25, { text: 'Todos', value: -1 }],"rows-per-page-text":"Registros por página","no-data-text":"Não existem registros","no-results-text":"Nenhum registro encontrado"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id_texto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.observacao))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'update')},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),(props.item.id_texto != _vm.$auth.user().anobase.id_texto)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!_vm.hasAccess(_vm.entity, 'delete')},on:{"click":function($event){return _vm.deleteItem(props.item, props.item.id, true)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1):_vm._e()],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n          "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n        ")]}}],null,false,2129865430)})],1)],1):_c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"id_texto","label":_vm.translate('table.' + _vm.entity + '.field.id_texto'),"error-messages":_vm.errors.collect('id_texto'),"counter":"","maxlength":"4","data-vv-as":"Ano"},model:{value:(_vm.editedItem.id_texto),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_texto", $$v)},expression:"editedItem.id_texto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:191'),expression:"'max:191'"}],attrs:{"name":"observacao","multi-line":"","label":_vm.translate('table.' + _vm.entity + '.field.observacao'),"error-messages":_vm.errors.collect('observacao'),"data-vv-as":"Observação"},model:{value:(_vm.editedItem.observacao),callback:function ($$v) {_vm.$set(_vm.editedItem, "observacao", $$v)},expression:"editedItem.observacao"}})],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":true,"right":true,"timeout":6000,"color":"error"},model:{value:(_vm.snackbar.active),callback:function ($$v) {_vm.$set(_vm.snackbar, "active", $$v)},expression:"snackbar.active"}},[_vm._v("\n    "+_vm._s(_vm.snackbar.text)+"\n    "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Fechar")])],1),_vm._v(" "),(_vm.view === 1)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","fixed":"","bottom":"","right":"","disabled":!_vm.hasAccess(_vm.entity, 'create')},on:{"click":_vm.create}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))])],1):_c('v-layout',{staticClass:"fab-container",attrs:{"align-center":""}},[(_vm.view === 2)?_c('v-speed-dial',{attrs:{"open-on-hover":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"primary","dark":"","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.save()}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.add.icon")))]),_vm._v(" "),_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save.icon")))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"secondary","disabled":_vm.saving,"loading":_vm.saving},on:{"click":function($event){return _vm.saveNew()}},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.save_new.icon")))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.translate("system.button.save_new.title")))])],1)],1):_vm._e(),_vm._v(" "),(_vm.view === 3)?_c('v-btn',{attrs:{"color":"primary","dark":"","fab":""},on:{"click":function($event){return _vm.saveAnoBase()}}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.done.icon")))])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v(_vm._s(this.translate("system.button.close.icon")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215c0209_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(429);
function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-215c0209"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215c0209_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs11":"","sm8":"","md5":""}},[_c('v-card',{staticClass:"elevation-12",staticStyle:{"border-radius":"20px"}},[_c('v-toolbar',{staticClass:"gradient",attrs:{"dark":""}},[_vm._t("header")],2),_vm._v(" "),_c('v-card-text',[_vm._t("body")],2),_vm._v(" "),_c('v-card-actions',[_vm._t("footer")],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-12",staticStyle:{"border-radius":"15px"}},[_c('v-toolbar',{staticClass:"gradient",attrs:{"dark":""}},[_c('v-toolbar-title',[_c('v-icon',[_vm._v("person")]),_vm._v("\n      Bem Vindo\n    ")],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"top"},[_c('img',{attrs:{"src":"static/img/logo.png","height":"150px","alt":"Logomarca"}})]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('v-form',[_c('v-container',{attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"login","label":"Login","type":"text","autofocus":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Password","id":"password","type":"password"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"gradient",attrs:{"loading":_vm.loading,"dark":""},on:{"click":function($event){return _vm.login()}}},[_vm._v("\n                Entrar\n              ")])],1)],1)],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4540d586_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(432);
function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4540d586"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4540d586_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_vm._t("default",[_c('v-toolbar-title',[_c('v-icon',[_vm._v("person")]),_vm._v("\n      Bem Vindo\n    ")],1)],{"slot":"header"}),_vm._v(" "),_vm._t("default",[_c('v-form',[_c('v-container',{attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"prepend-icon":"person","name":"name","label":"Nome","type":"text","autofocus":"","error-messages":_vm.errors.collect('name'),"data-vv-as":"Nome"},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email|verify_email'),expression:"'required|email|verify_email'"}],attrs:{"prepend-icon":"mail","name":"mail","label":"E-mail","type":"text","error-messages":_vm.errors.collect('mail'),"data-vv-as":"E-mail","data-vv-delay":"1000"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"prepend-icon":"lock","name":"password","label":"Senha","id":"password","type":"password","error-messages":_vm.errors.collect('password'),"data-vv-as":"Senha"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"prepend-icon":"check","name":"confirmation","label":"Confirmação","id":"confirmation","type":"password","error-messages":_vm.errors.collect('confirmation'),"data-vv-as":"Confirmação"},model:{value:(_vm.user.confirmation),callback:function ($$v) {_vm.$set(_vm.user, "confirmation", $$v)},expression:"user.confirmation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"prepend-icon":"check","name":"codigo","label":"Código","id":"codigo","type":"password","error-messages":_vm.errors.collect('codigo'),"data-vv-validate-on":"blur","data-vv-as":"Código"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.register()}},model:{value:(_vm.codigo),callback:function ($$v) {_vm.codigo=$$v},expression:"codigo"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-snackbar',{attrs:{"top":true,"right":true,"timeout":6000,"color":_vm.snackbar.color},model:{value:(_vm.snackbar.active),callback:function ($$v) {_vm.$set(_vm.snackbar, "active", $$v)},expression:"snackbar.active"}},[_vm._v("\n              "+_vm._s(_vm.snackbar.text)+"\n              "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Fechar")])],1),_vm._v(" "),_c('v-btn',{staticClass:"gradient",attrs:{"dark":"","loading":_vm.loading},on:{"click":function($event){return _vm.register()}}},[_vm._v("Registrar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","href":"#/"}},[_vm._v("Voltar")])],1)],1)],1)],1)],{"slot":"body"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673c87a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__ = __webpack_require__(435);
function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-673c87a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673c87a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_vm._t("default",[_c('v-toolbar-title',[_c('v-icon',[_vm._v("vpn_key")]),_vm._v("\n      Esqueci minhas senha\n    ")],1)],{"slot":"header"}),_vm._v(" "),_vm._t("default",[_c('v-form',[_c('v-container',{attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"email","label":"E-mail","type":"text","autofocus":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"gradient mx-auto",attrs:{"dark":""},on:{"click":_vm.reset}},[_vm._v("\n              Enviar link para redefinir senha\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","href":"#/"}},[_vm._v("Voltar")])],1)],1)],1)],1)],{"slot":"body"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1b2ad8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__(438);
function injectStyle (ssrContext) {
  __webpack_require__(437)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa1b2ad8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1b2ad8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_vm._t("default",[_c('v-toolbar-title',[_c('v-icon',[_vm._v("vpn_key")]),_vm._v("\n      Redefinir senha\n    ")],1)],{"slot":"header"}),_vm._v(" "),_vm._t("default",[_c('v-form',[_c('v-container',{attrs:{"grid-list-lg":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"required":"","prepend-icon":"lock","name":"password","label":"Senha","id":"password","type":"password","error-messages":_vm.errors.collect('password'),"data-vv-as":"Senha","required":""},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password|min:6'),expression:"'required|confirmed:password|min:6'"}],attrs:{"prepend-icon":"check","name":"confirmation","label":"Confirmação","id":"confirmation","type":"password","error-messages":_vm.errors.collect('confirmation'),"data-vv-as":"Confirmação","required":""},model:{value:(_vm.user.confirmation),callback:function ($$v) {_vm.$set(_vm.user, "confirmation", $$v)},expression:"user.confirmation"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"gradient mx-auto",attrs:{"dark":""},on:{"click":_vm.reset}},[_vm._v("\n              Redefinir\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","href":"#/"}},[_vm._v("Voltar")])],1)],1)],1)],1)],{"slot":"body"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */,
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */,
/* 442 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pt_br_pt_br__ = __webpack_require__(446);


/* harmony default export */ __webpack_exports__["a"] = ({
  default: 'pt_br',
  pt_br: __WEBPACK_IMPORTED_MODULE_0__pt_br_pt_br__["a" /* default */]
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__system__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__value__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mask__ = __webpack_require__(450);





/* harmony default export */ __webpack_exports__["a"] = ({
  system: __WEBPACK_IMPORTED_MODULE_0__system__["a" /* default */],
  table: __WEBPACK_IMPORTED_MODULE_1__table__["a" /* default */],
  value: __WEBPACK_IMPORTED_MODULE_2__value__["a" /* default */],
  mask: __WEBPACK_IMPORTED_MODULE_3__mask__["a" /* default */]
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  alert: {
    error: 'Favor prencher os campos corretamente!',
    delete: 'tem certeza que deseja deletar esse campo?'
  },
  title: {
    consult: 'Consulta de ',
    include: 'Inclusão de ',
    edit: 'Edição de ',
    delete: 'Deleção de '
  },
  field: {
    select: 'Selecione um(a) '
  },
  button: {
    add: { title: 'Adicionar', icon: 'add' },
    import: { title: 'Importar', icon: 'system_update_alt' },
    manage: { title: 'Gerenciar', icon: 'build' },
    save: { title: 'Salvar', icon: 'save' },
    save_new: { title: 'Salvar e Novo', icon: 'add' },
    save_manage: { title: 'Salvar e Gerenciar', icon: 'build' },
    edit: { title: 'Editar', icon: 'edit' },
    delete: { title: 'Deletar', icon: 'delete' },
    home: { title: 'Página Inicial', icon: 'home' },
    done: { title: 'Confirmar', icon: 'done' },
    exit: { title: 'Sair', icon: 'exit' },
    close: { title: 'Fechar', icon: 'close' }
  },
  table: {
    action: 'Ações',
    decimal: ',',
    emptyTable: 'Nenhum registro encontrado',
    info: 'Exibindo do _START_ ao _END_ de _TOTAL_ registros',
    infoEmpty: 'Exibindo do 0 ao 0 de 0 registros',
    infoFiltered: '(Filtrado a partir de _MAX_ registros)',
    infoPostFix: '',
    thousands: '.',
    lengthMenu: 'Exibir _MENU_ registros',
    loadingRecords: 'Carregando...',
    processing: 'Processando...',
    search: 'Pesquisar',
    zeroRecords: 'Nenhum registro encontrado',
    paginate: {
      first: 'Primeiro',
      last: '\xDAltimo',
      next: 'Pr\xF3ximo',
      previous: 'Anterior'
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  companies: {
    icon: 'fa fa-calendar',
    title: ['Empresa', 'Empresas'],
    field: {
      id_text: 'Nome'
    }
  },
  services: {
    icon: 'fa fa-user',
    title: ['Serviço', 'Serviços'],
    field: {
      id: 'Código',
      identifier: 'Código',
      company_id: 'Empresa',
      id_text: 'Nome',
      category: 'Categoria',
      active: 'Ativo'
    }
  },
  anobase: {
    icon: 'fa fa-calendar',
    title: ['Ano Base', 'Anos Base'],
    field: {
      id: 'Código',
      id_texto: 'Ano',
      observacao: 'Observação'
    }
  },
  users: {
    icon: 'fa fa-user',
    title: ['Usuário', 'Usuários'],
    field: {
      id: 'Código',
      name: 'Nome',
      email: 'E-mail',
      acesso_interno: 'Acesso Interno',
      acesso_id: 'Acesso de Sistema'
    }
  },
  acesso: {
    icon: 'fa fa-user',
    title: ['Acesso', 'Acessos'],
    field: {
      id: 'Código',
      empresa_id: 'Empresa',
      id_texto: 'Nome',
      tipo: 'Tipo',
      descricao: 'Discriminação',
      permissoes: 'Permissões'
    }
  },
  pessoa: {
    icon: 'fa fa-user',
    title: ['Pessoa', 'Pessoas'],
    field: {
      id: 'Código',
      ultimo_numero_recibo: 'Último Número de Recibo',
      id_texto: 'Nome',
      nome_abreviado: 'Nome Abreviado',
      tipo: 'Tipo',
      cpf_cnpj: 'C.P.F.',
      rg_ie: 'RG/IE',
      cidade_id: 'Cidade',
      uf: 'UF',
      pais_id: 'País',
      endereco: 'Logradouro',
      numero: 'Número',
      bairro: 'Bairro',
      ativo: 'Ativo',
      observacao: 'Observação',
      nascimento: 'Data de Nascimento',
      titulo_eleitoral: 'Título Eleitoral',
      doenca_deficiencia: 'Possui doença ou deficiência física ou mental',
      possui_conjuge: 'Possui cônjuge',
      cpf_conjuge: 'CPF do cônjuge',
      natureza_ocupacao: 'Natureza da Ocupação',
      ocupacao_principal: 'Ocupação Principal',
      endereco_brasil: 'Endereço no Brasil',
      mudanca: 'Houve mudança no endereço',
      cpf_procurador: 'CPF do Procurador',
      tipo_logradouro: 'Tipo de Logradouro',
      cep: 'CEP / Código Postal',
      complemento: 'Complemento',
      ddd_ddi_telefone: 'DDD/DDI',
      telefone: 'Telefone',
      ddd_celular: 'DDD',
      celular: 'Celular',
      email: 'E-mail',
      codigo_ext: 'Código Exterior',
      cidade_ext: 'Cidade Exterior',
      pessoa_id: 'Cônjuge',
      empresa_id: 'Empresa Responsável'
    }
  },
  pessoa_contato: {
    icon: 'fa fa-user',
    title: ['Contato', 'Contatos'],
    field: {
      id: 'Código',
      id_texto: 'Contato',
      tipo: 'Tipo',
      pessoa_id: 'Nome'
    }
  },
  pessoa_dependente: {
    icon: 'fa fa-user',
    title: ['Dependente', 'Dependentes'],
    field: {
      id: 'Código',
      id_texto: 'Nome',
      tipo: 'Tipo',
      nascimento: 'Nascimento',
      cpf: 'C.P.F',
      pessoa_id: 'Pessoa',
      residencia_com_titular: 'Dependentemora com o titular da declaração?',
      e_mail: 'E-mail',
      telefone: 'Telefone'
    }
  },
  pessoa_empresa: {
    icon: 'fa fa-company',
    title: ['Empresa', 'Empresas'],
    field: {
      id: 'Código',
      empresa_id: 'Empresa',
      pessoa_id: 'Pessoa',
      ativo: 'Ativo'
    }
  },
  condominio: {
    icon: 'fa fa-fax',
    title: ['Condomínio', 'Condomínios'],
    field: {
      id: 'Código',
      id_texto: 'Nome',
      sigla: 'Sigla',
      razao_social: 'Razão Social',
      cpf: 'C.P.F.',
      cidade_id: 'Cidade',
      uf: 'UF',
      endereco: 'Endereço',
      pessoa_id: 'Responsável',
      ativo: 'Ativo'
    }
  },
  contribuinte: {
    icon: 'fa fa-fax',
    title: ['Contribuinte', 'Contribuintes'],
    field: {
      id: 'Código',
      id_texto: 'Nome',
      sigla: 'Sigla',
      razao_social: 'Razão Social',
      cpf: 'C.P.F.',
      cidade_id: 'Cidade',
      uf: 'UF',
      endereco: 'Endereço',
      pessoa_id: 'Responsável',
      ativo: 'Ativo'
    }
  },
  condominio_pessoa: {
    icon: 'fa fa-user',
    title: ['Sócio', 'Sócios'],
    field: {
      id: 'Código',
      porcentagem_inicial: 'Porcentagem Inicial',
      inicialporcentagem: 'Porcentagem Inicial',
      porcentagem: 'Porcentagem',
      data: 'Data',
      ativo: 'Ativo',
      pessoa_id: 'Sócio',
      condominio_id: 'Condomínio'
    }
  },
  condominio_quadrosocietario: {
    icon: 'switch_account',
    title: ['Quadro Societário', 'Quadros Societários'],
    field: {
      id: 'Código',
      data: 'Data',
      id_texto: 'Discriminação'
    }
  },
  condominio_bemdireito: {
    icon: 'fa fa-balance-scale',
    title: ['Bem e Direito', 'Bens e Direitos'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      grupo: 'Grupo',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      data: 'Data de Aquisição/Cadastramento',
      pais_id: 'Localização (País)',
      cei_cno: 'Inscrição CEI/CNO',
      ativo: 'Ativo',
      condominio_id: 'Codomínio',
      valor_pago: 'Pagamento/Acréscimo no Ano',
      valor_liberado: 'Alienação/Redução no Ano',
      pessoa_dependente_id: 'Dependente'
    }
  },
  condominio_bemdireito_item: {
    icon: 'fa fa-money',
    title: ['Bem e Direito Item', 'Bens e Direitos Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor: 'Valor'
    }
  },
  condominio_bemdireitorural: {
    icon: 'fa fa-leaf',
    title: ['Bem da Atividade Rural', 'Bens e Direitos Rurais'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      data: 'Data de Aquisição',
      pais_id: 'País',
      ativo: 'Ativo',
      motivo_baixa: 'Motivo da Baixa',
      nome_adquirente: 'Nome do Adquirente',
      condominio_id: 'Codomínio',
      baixa: 'Baixa',
      valor_pago: 'Pagamento/Acréscimo no Ano',
      valor_liberado: 'Alienação/Redução no Ano'
    }
  },
  condominio_bemdireitorural_item: {
    icon: 'fa fa-money',
    title: ['Bem da Atividade Rural Item', 'Bens e Direitos Rurais Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor: 'Valor'
    }
  },
  condominio_movimentacaofinanceira: {
    icon: ['fa fa-leaf'],
    title: ['Movimentação Financeira', 'Movimentações Financeiras'],
    field: {
      id: 'Código',
      mes_base: 'Mês',
      receita: 'Receita',
      despesa: 'Despesa',
      liberacao: 'Liberação',
      pagamento: 'Pagamento',
      condominio_id: 'Condomínio',
      anobase_id: 'Ano Base',
      resultado: 'Resultado'
    }
  },
  condominio_movimentacaorebanho: {
    icon: 'fa fa-plus',
    title: ['Movimentação Rebanho', 'Movimentações Rebanhos'],
    field: {
      id: 'Código',
      condominio_id: 'Condomínio',
      anobase_id: 'Ano Base',
      especie: 'Espécie',
      estoque_inicial: 'Estoque Inicial',
      aquisicao: 'Aquisições',
      nascimento: 'Nascimentos',
      consumo_e_perda: 'Consumo E Perdas',
      venda: 'Vendas',
      resultado: 'Resultado'
    }
  },
  condominio_bemdireito_anobase: {
    icon: 'fa fa-calculator',
    title: ['Situação Bem Direito', 'Situações Bem Direito'],
    field: {
      condominio_bemdireito_id: 'Bem Direito',
      anobase: 'Ano',
      situacao: 'Situação'
    }
  },
  condominio_dividaonus: {
    icon: 'fa fa-money',
    title: ['Dívida e Ônus Real', 'Dívidas e Ônus Reais'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      condominio_id: 'Dívida Ônus',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      data: 'Data de Cadastro',
      ativo: 'Ativo',
      banco: 'Credor',
      contrato: 'Contrato',
      contratacao: 'Contratação',
      vencimento: 'Vencimentos',
      valor_contrato: 'Valor Contrato',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      valor_pago: 'Pago Principal no Ano',
      valor_juros: 'Pago de Juros no Ano',
      total_geral: 'Total Geral no Ano',
      valor_liberado: 'Valor Liberado no Ano',
      condominio_pessoa_id: 'Responsável'
    }
  },
  condominio_dividaonus_item: {
    icon: 'fa fa-money',
    title: ['Dívida e Ônus Real Item', 'Dívidas e Ônus Reais Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor_base: 'Pago Principal',
      juros: 'Juros e Acessórios',
      valor_total: 'Valor Total'
    }
  },
  condominio_dividaonusrural: {
    icon: 'fa fa-tree',
    title: ['Dívida da Atividade Rural', 'Dívidas das Atividades Rurais'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      condominio_id: 'Dívida Ônus',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      data: 'Data de Cadastro',
      ativo: 'Ativo',
      banco: 'Credor',
      contrato: 'Contrato',
      propriedade: 'Propriedade',
      contratacao: 'Contratação',
      vencimento: 'Vencimentos',
      valor_contrato: 'Valor Contrato',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      valor_pago: 'Pago Principal no Ano',
      valor_juros: 'Pago de Juros no Ano',
      total_geral: 'Total Geral no Ano',
      valor_liberado: 'Valor Liberado no Ano',
      condominio_pessoa_id: 'Responsável'
    }
  },
  condominio_dividaonusrural_item: {
    icon: 'fa fa-money',
    title: ['Dívida e Ônus Real Item', 'Dívidas e Ônus Reais Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor_base: 'Pago Principal',
      juros: 'Juros e Acessórios',
      valor_total: 'Valor Total'
    }
  },
  condominio_imovelexplorado: {
    icon: 'fa fa-building',
    title: ['Imóvel Explorado', 'Imóveis Explorados'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      atividade: 'Atividade',
      localizacao: 'Localização',
      nirf: 'CIB (NIRF)',
      area: 'Área',
      participacao: 'Participação (%)',
      exploracao: 'Exploração',
      cidade_id: 'Cidade',
      endereco: 'Logradouro',
      numero: 'Número',
      bairro: 'Bairro',
      cep: 'CEP / Código Postal',
      complemento: 'Complemento',
      caepf: 'C.A.E.P.F',
      inscr_estadual: 'Inscrição Estadual',
      tipo_exploracao: 'Tipo de Exploração',
      ativo: 'Ativo'
    }
  },
  condominio_imovelexplorado_terceiros: {
    icon: 'fa fa-users',
    title: ['Terceiro', 'Terceiros'],
    field: {
      id: 'Código',
      condominio_imovelexplorado_id: 'Imóvel Explorado',
      nome: 'Nome',
      cpf_cnpj: 'C.P.F./C.N.P.J.',
      tipo_participante: 'Tipo do Participante'
    }
  },
  condominio_pagamento: {
    icon: 'fa fa-dollar',
    title: ['Pagamento Efetuado', 'Pagamentos Efetuados'],
    field: {
      id: 'Código',
      condominio_id: 'Condomínio',
      codigo: 'Código',
      ano: 'Ano',
      sequencia_ir: 'Sequencia IR',
      beneficiario: 'Beneficiário',
      descricao: 'Discriminação',
      cpf_cnpj: 'C.P.F./C.N.P.J.',
      valor_pago: 'Valor Pago',
      anobase_id: 'Ano',
      pessoa_dependente_id: 'Dependente'
    }
  },

  condominio_pagamento_item: {
    icon: 'fa fa-money',
    title: ['Pagamento Efetuado Item', 'Pagamentos Efetuados Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      valor: 'Valor'
    }
  },

  condominio_rendimentorecebidopj: {
    icon: 'fa fa-bar-chart',
    title: ['Rendimento Tributável Recebido de PJ', 'Rendimentos Tributáveis Recebidos de PJ'],
    field: {
      id: 'Código',
      id_texto: 'Fonte Pagadora',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      cpf_cnpj: 'C.P.F./C.N.P.J.',
      anobase_id: 'Ano',
      pessoa_dependente_id: 'Dependente',
      valor_total: 'Valor Total'
    }
  },

  condominio_rendimentorecebidopj_item: {
    icon: 'fa fa-money',
    title: ['Rendimento Tributável Recebido de PJ Item', 'Rendimentos Tributáveis Recebidos de PJ Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      recebido_pj: 'Rendimento Recebido de PJ',
      contribuicao_previdenciaria: 'Contribuição Previdenciária',
      imposto_retido: 'Imposto Retido na Fonte',
      salary_13: '13º Salário',
      irrf_salary_13: 'IRRF 13º Salário'
    }
  },

  condominio_rendimentoisento: {
    icon: 'fa fa-bar-chart',
    title: ['Rendimento Isento Não Tributável', 'Rendimentos Isentos Não Tributáveis'],
    field: {
      id: 'Código',
      id_texto: 'Fonte Pagadora',
      codigo: 'Código',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      cnpj: 'C.P.F./C.N.P.J.',
      valor: 'Valor',
      anobase_id: 'Ano',
      valor_total: 'Valor Total',
      pessoa_dependente_id: 'Dependente',
      decimo_terceiro: '13º Salário',
      contribuicao_previdenciaria: 'Contribuição Previdenciária',
      irrf: 'IRRF',
      irrf_decimo_terceiro: 'IRRF 13º Salário'
    }
  },

  condominio_rendimentoisento_item: {
    icon: 'fa fa-money',
    title: ['Rendimento Isento Não Tributável Item', 'Rendimentos Isentos Não Tributáveis Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      valor: 'Valor',
      rendimento: 'Rendimento',
      decimo_terceiro: '13º Salário',
      irrf: 'IRRF',
      irrf_decimo_terceiro: 'IRRF sobre o 13º',
      contribuicao_previdenciaria: 'Contribuição Previdenciária'
    }
  },

  condominio_rendimentotributacao: {
    icon: 'fa fa-bank',
    title: ['Rendimento Tributação Exclusiva', 'Rendimentos Tributações Exclusivas'],
    field: {
      id: 'Código',
      id_texto: 'Fonte Pagadora',
      codigo: 'Código',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      cnpj: 'C.N.P.J.',
      valor: 'Valor',
      anobase_id: 'Ano',
      valor_total: 'Valor Total',
      pessoa_dependente_id: 'Dependente'
    }
  },

  condominio_rendimentotributacao_item: {
    icon: 'fa fa-money',
    title: ['Rendimento Tributação Exclusiva Item', 'Rendimentos Tributações Exclusivas Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      valor: 'Valor'
    }
  },

  condominio_transacao: {
    icon: 'fa fa-bank',
    title: ['Transação', 'Transações'],
    field: {
      id: 'Código',
      data: 'Data',
      porcentagem: 'Porcentagem %',
      condominio_id: 'Condomínio',
      condominio_pessoa_id: 'Sócio'
    }
  },
  condominio_transacao_item: {
    icon: 'fa fa-bank',
    title: ['Transação Item', 'Transação Itens'],
    field: {
      id: 'Código',
      porcentagem: 'Porcentagem %',
      condominio_transacao_id: 'Transação',
      condominio_pessoa_id: 'Sócio'
    }
  },
  condominio_users: {
    icon: 'fa fa-user',
    title: ['Usuário', 'Usuários'],
    field: {
      id: 'Código',
      user_id: 'Usuário',
      acesso_id: 'Acesso',
      pessoa_id: 'Pessoa',
      condominio_id: 'Condomínio',
      ativo: 'Ativo'
    }
  },
  condominio_controlecaixa: {
    icon: 'menu_book',
    title: ['Controle de Caixa', 'Controles de Caixa'],
    field: {
      'id': 'ID',
      'data': 'Data',
      'codigo_imovel': 'Código do Imóvel',
      'codigo_conta': 'Código da Conta',
      'numero': 'Número do Documento',
      'tipo_documento': 'Tipo do Documento',
      'historico': 'Histórico',
      'cpf_cnpj': 'CPF/CNPJ',
      'tipo_lancamento': 'Tipo do Lançamento',
      'entrada': 'Entrada',
      'saida': 'Saída',
      'saldo_final': 'Saldo Final',
      'natureza': 'Natureza'
    }
  },
  accesses: {
    icon: 'lock',
    title: ['Acesso', 'Acessos'],
    field: {
      id_text: 'Nome',
      description: 'Discriminação',
      permissions: 'Permissões'
    }
  },
  permissions: {
    icon: 'lock',
    title: ['Permissão', 'Permissões'],
    field: {
      id_text: 'Nome',
      view: 'Visualizar',
      create: 'Criar',
      edit: 'Editar',
      destroy: 'Deletar'
    }
  },
  condominio_rendimentoacumuladamente: {
    icon: 'fa fa-bar-chart',
    title: ['Rendimento Recebido Acumuladamente', 'Rendimentos Recebidos Acumuladamente'],
    field: {
      condominio_id: 'Condomínio',
      anobase_id: 'Ano',
      registro_tipo: 'Tipo',
      forma_tributacao: 'Opção pela forma de tributação',
      cpf_cnpj_fonte_pagadora: ' da fonte pagadora',
      nome_fonte_pagadora: 'Nome da fonte pagadora',
      rendimentos_tributaveis: 'Rendimentos tributáveis',
      parcela_isenta_65_anos: 'Parcela isenta 65 anos',
      total_rendimentos: 'Total Rendimentos tributáveis',
      valor_recebido_juros: 'Valor recebido referente a juros',
      contribuicao_previdenciaria_oficial: 'Contribuição previdenciária oficial',
      imposto_retido_fonte: 'Imposto retido na fonte',
      mes_recebimento: 'Mês do recebimento',
      numero_meses: 'Número de meses',
      pessoa_dependente_id: 'Dependente'
    }
  },

  suporte: {
    icon: 'help_outline',
    title: ['Suporte', 'Suportes'],
    field: {
      id: 'ID',
      titulo: 'Título',
      descricao: 'Descrição',
      status: 'Status',
      tipo: 'Tipo',
      urgencia: 'Urgência',
      user_id: 'Usuário',
      imagem1: 'Imagem 1',
      imagem2: 'Imagem 2',
      imagem3: 'Imagem 3',
      imagem4: 'Imagem 4',
      imagem5: 'Imagem 5',
      created_at: 'Criado em'
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  pessoa_tipo: [{ value: 1, text: 'Pessoa Física' }, { value: 2, text: 'Pessoa Jurídica' }],

  pessoa_dependente_tipo: [{ value: 11, text: '11 - Companheiro(a) com o(a) qual o(a) contribuinte tenha filho(a) ou viva há mais de 5 (cinco) anos, ou cônjuge.' }, { value: 21, text: '21 - Filho(a) ou enteado(a) até 21 (vinte e um) anos.' }, { value: 22, text: '22 - Filho(a) ou enteado(a) cursando estabelecimento de ensino superior ou escola técnica de 2º grau, até 24 (vinte e quatro) anos.' }, { value: 23, text: '23 - Filho(a) ou enteado(a) em qualquer idade, quando incapacitado física e/ou mentalmente para o trabalho.' }, { value: 24, text: '24 - Irmão(ã), neto(a) ou bisneto(a) sem arrimo dos pais, do(a) qual o contribuinte detém a guarda judicial, até 21 (vinte e um) anos.' }, { value: 25, text: '25 - Irmão(ã), neto(a) ou bisneto(a) sem arrimo dos pais, com idade até 24 anos, se ainda estiver cursando estabelecimento de ensino superior ou escola técnica de 2º grau, desde que o contribuinte tenha detido sua guarda judicial até os 21 anos.' }, { value: 26, text: '26 - Irmão(ã), neto(a) ou bisneto(a) sem arrimo dos pais, do(a) qual o contribuinte detém a guarda judicial, em qualquer idade, quando incapacitado física e/ou mentalmente para o trabalho.' }, { value: 31, text: '31 - Pais, avós e bisavós que, em 2018, receberam rendimentos, tributáveis ou não, até R$ 22.847,76.' }, { value: 41, text: '41 - Menor pobre, até 21 (vinte e um) anos, que o contribuinte crie e eduque e do qual detenha a guarda judicial.' }, { value: 51, text: '51 - A pessoa absolutamente incapaz, da qual o contribuinte seja tutor ou curador.' }],

  contato_tipo: [{ value: 1, text: 'Celular' }, { value: 2, text: 'Telefone Fixo' }, { value: 3, text: 'E-mail' }],

  usuario_acesso: [{ value: 'admin', text: 'Administrador' }, { value: 'user', text: 'Usuário' }, { value: 'dev', text: 'Desenvolvedor' }],

  bem_direito_grupo: [{ value: 1, text: '1 - Bens Imóveis' }, { value: 2, text: '2 - Bens Móveis' }, { value: 3, text: '3 - Participações Societárias' }, { value: 4, text: '4 - Aplicações e Investimentos' }, { value: 5, text: '5 - Créditos' }, { value: 6, text: '6 - Depósitos à Vista e Numerário' }, { value: 7, text: '7 - Fundos' }, { value: 8, text: '8 - Criptoativos' }, { value: 99, text: '99 - Outros Bens e Direitos' }],

  bem_direito_codigo: [{ value: 1, grupo: 1, text: '1 - Prédio Residencial' }, { value: 2, grupo: 1, text: '2 - Prédio Comercial' }, { value: 3, grupo: 1, text: '3 - Galpão' }, { value: 11, grupo: 1, text: '11 - Apartamento' }, { value: 12, grupo: 1, text: '12 - Casa' }, { value: 13, grupo: 1, text: '13 - Terreno' }, { value: 14, grupo: 1, text: '14 - Imóvel Rural' }, { value: 15, grupo: 1, text: '15 - Sala ou Conjunto' }, { value: 16, grupo: 1, text: '16 - Construção' }, { value: 17, grupo: 1, text: '17 - Benfeitorias' }, { value: 18, grupo: 1, text: '18 - Loja' }, { value: 19, grupo: 1, text: '19 - Garagem Avulsa' }, { value: 99, grupo: 1, text: '99 - Outros Bens Imóveis' }, { value: 1, grupo: 2, text: '1 - Veículo Automotor Terrestre: Caminhão, Automóvel, Moto etc.' }, { value: 2, grupo: 2, text: '2 - Aeronave' }, { value: 3, grupo: 2, text: '3 - Embarcação' }, { value: 4, grupo: 2, text: '4 - Bens Relacionados ao Exercício da Atividade Autônoma' }, { value: 5, grupo: 2, text: '5 - Quadro, objeto de arte, de coleção, de antiguidade, etc.' }, { value: 6, grupo: 2, text: '6 - Joia' }, { value: 99, grupo: 2, text: '99 - Outros Bens Móveis' }, { value: 1, grupo: 3, text: '1 - Ações (inclusive listadas em bolsa)' }, { value: 2, grupo: 3, text: '2 - Quotas ou quinhões de Capital' }, { value: 3, grupo: 3, text: '3 - Holding Patrimonial - ações ou quotas adquiridas por integralização de bens( já declarados) ao capital' }, { value: 99, grupo: 3, text: '99 - Outras participações Societárias' }, { value: 1, grupo: 4, text: '1 - Depósito em Conta Poupança' }, { value: 2, grupo: 4, text: '2 - Títulos Públicos e privados sujeitos a tributação (Tesouro Direto, CDB, RDB e outros)' }, { value: 3, grupo: 4, text: '3 - Títulos isentos de tributação (LCI, LCA, LCD, CRI, CRA, LIG, Debêntures de Infraestrutura e Outros)' }, { value: 4, grupo: 4, text: '4 - Ativos Negociados em bolsa no Brasil (BDRs, opções e outros - exeto ações e fundos)' }, { value: 5, grupo: 4, text: '5 - Ouro, Ativo Financeiro' }, { value: 99, grupo: 4, text: '99 - Outras Aplicações e Investimentos' }, { value: 1, grupo: 5, text: '1 - Empréstimos Concedidos' }, { value: 2, grupo: 5, text: '2 - Crédito Decorrente de Alienação' }, { value: 99, grupo: 5, text: '99 - Outros Créditos e Poupança Vinculados' }, { value: 1, grupo: 6, text: '1 - Depósito em Conta Corrente ou Conta Pagamento' }, { value: 2, grupo: 6, text: '2 - Conta gráfica mantida em agente operador de loterias de apostas de quota fixa - Lei 14.790/2023' }, { value: 10, grupo: 6, text: '10 - Dinheiro em Espécie - Moeda Nacional' }, { value: 11, grupo: 6, text: '11 - Dinheiro em Espécie - Moeda Estrangeira' }, { value: 99, grupo: 6, text: '99 - Outros Depósitos à Vista' }, { value: 1, grupo: 7, text: '1 - Fundo de Investimento Sujeitos à Tributação Periódica (come-cotas)' }, { value: 2, grupo: 7, text: '2 - Fundo de Investimento Nas Cadeias Produtivas Agroindustriais (Fiagro)' }, { value: 3, grupo: 7, text: '3 - Fundo de Investimento Imobiliário (FII)' }, { value: 4, grupo: 7, text: '4 - Fundo de Investimento em Ações e Fundos Mútuos de Privatização - FGTS' },
  // { value: 5, grupo: 7, text: '5 - Fundo de Investimento em Ações - Mercado de Acesso' },
  { value: 6, grupo: 7, text: '6 - FIP - Entidade de investimento, FIDC - Entidade de investimento sem tributação periódica (come-cotas), ETF - Entidade de investimentos' }, { value: 7, grupo: 7, text: '7 - Fundo de Investimento em Participações em Infraestrutura (FIP-IE) e Fybdis de Investimento em Participação na Produção Econômica Intensiva em Pesquisa Desenvolvimento e Inovação (FIP-PD&I)' }, { value: 8, grupo: 7, text: '8 - Fundo de Índice de Renda Fixa - Lei 13.043/14' },
  // { value: 9, grupo: 7, text: '9 - Fundo de Fundos de Índice de Mercado (ETFs)' },
  { value: 10, grupo: 7, text: '10 - Fundos de Infraestrutura, FIDC e outros fundos de investimento (alíquota 0%)' },
  // { value: 11, grupo: 7, text: '11- Fundo de Investimento sem Tributação Periódica' },
  { value: 12, grupo: 7, text: '12 - Fundos de Investimentos em Empresas Emergente - FIEE' }, { value: 13, grupo: 7, text: '13 - Fundo multimercado Lei 14.754/2023, art.25 e art 40' }, { value: 99, grupo: 7, text: '99 - Fundos de investimento no Exterior' }, { value: 1, grupo: 8, text: '1 - Criptoativo Bitcoin - BTC' }, { value: 2, grupo: 8, text: '2 - Outras criptomoedas, conhecidas com altcoins, por exemplo, Ether (ETH), Ripple (XRP), Bitcoin Cash (BHC) e Litecoin (LTC)' }, { value: 3, grupo: 8, text: '3 - Criptoativos conhecidos como stablecoins, por exemplo, Tether(USDT), USD coin(USDC), Brazilian Digital Token (BRZ), Binance USD (BUSD), DAI, True USD (TUSD)m Grmini USD(GUSD), Paxos USD (PAX), Paxos Gold (PAXG), etc' }, { value: 10, grupo: 8, text: '10 - Criptoativos conhecidos como NFTs (Non-Funfible Tokens)' }, { value: 99, grupo: 8, text: '99 - Outros Criptoativos' }, { value: 1, grupo: 99, text: '1 - Licença e Concessão Especiais' }, { value: 2, grupo: 99, text: '2 - Título de Clube e Assemelhado' }, { value: 3, grupo: 99, text: '3 - Direito de Autor, de Inventor e Patente' }, { value: 4, grupo: 99, text: '4 - Direito de Lavra e Assemelhado' }, { value: 5, grupo: 99, text: '5 - Consórcio Não Contemplado' }, { value: 6, grupo: 99, text: '6 - VGBL - Vida Gerador de Benefício Livre' }, { value: 7, grupo: 99, text: '7 - Juros Sobre Capital Próprio Creditado, mas não Pago' }, { value: 8, grupo: 99, text: '7 - Leasing com opção de compra a ser exercida no final do contrato' }, { value: 99, grupo: 99, text: '99 - Outros Bens e Direitos' }],

  bem_direito_banco: [{ value: 75, text: '075 - ABN AMRO' }, { value: 332, text: '332 - ACESSO SOLUCOES DE PAGAMENTO S.A.' }, { value: 117, text: '117 - ADVANCED CORRETORA DE CAMBIO LTDA' }, { value: 123, text: '123 - AGIPLAN FINANCEIRA S.A. CREDITO, FINANCIAMENTO E I' }, { value: 272, text: '272 - AGK Corretora de Cambio S.A.' }, { value: 172, text: '172 - Albatross Corretora de Cambio e Valores S.A' }, { value: 349, text: '349 - AMAGGI S.A. - CREDITO, FINANCIAMENTO E INVESTIMENT' }, { value: 188, text: '188 - Ativa Investimentos S.A. Corretora de Titulos Camb' }, { value: 280, text: '280 - Avista S.A. Credito, Financiamento e Investimento' }, { value: 654, text: '654 - BANCO A.J. RENNER S.A.' }, { value: 61, text: '061 - BANCO ABB SA' }, { value: 246, text: '246 - BANCO ABC BRASIL S.A.' }, { value: 356, text: '356 - BANCO ABN AMRO REAL S.A.' }, { value: 121, text: '121 - BANCO AGIBANK S.A.' }, { value: 25, text: '025 - BANCO ALFA S/A' }, { value: 641, text: '641 - BANCO ALVORADA S.A.' }, { value: 65, text: '065 - BANCO ANDBANK (BRASIL) S.A.' }, { value: 621, text: '621 - BANCO APLICAP S.A.' }, { value: 625, text: '625 - BANCO ARAUCARIA S.A.' }, { value: 213, text: '213 - BANCO ARBI S.A.' }, { value: 201, text: '201 - BANCO AXIAL S.A.' }, { value: 19, text: '019 - BANCO AZTECA DO BRASIL S.A.' }, { value: 239, text: '239 - BANCO BANCRED S.A.' }, { value: 67, text: '067 - BANCO BANEB SA' }, { value: 38, text: '038 - BANCO BANESTADO S.A.' }, { value: 740, text: '740 - BANCO BARCLAYS S.A.' }, { value: 330, text: '330 - Banco Bari de Investimentos e Financiamentos S.A' }, { value: 267, text: '267 - BANCO BBM-COM.C.IMOB.CFI S.A.' }, { value: 291, text: '291 - BANCO BCN S.A.' }, { value: 68, text: '068 - BANCO BEA S.A' }, { value: 34, text: '034 - BANCO BEA S.A.' }, { value: 35, text: '035 - BANCO BEC S.A.' }, { value: 31, text: '031 - BANCO BEG S.A.' }, { value: 48, text: '048 - BANCO BEMGE S.A.' }, { value: 346, text: '346 - BANCO BFB _ EM ABSORCAO' }, { value: 388, text: '388 - BANCO BMD S.A.' }, { value: 96, text: '096 - BANCO BMFBOVESPA' }, { value: 318, text: '318 - BANCO BMG S.A.' }, { value: 752, text: '752 - BANCO BNP PARIBAS BRASIL S.A' }, { value: 248, text: '248 - BANCO BOA VISTA INTERATLANTICO S.A' }, { value: 231, text: '231 - BANCO BOAVISTA INTERATLANTICO S.A-EM ABSORCAO' }, { value: 107, text: '107 - BANCO BOCOM BBM S.A.' }, { value: 262, text: '262 - BANCO BOREAL S.A.' }, { value: 36, text: '036 - BANCO BRADESCO BBI S.A.' }, { value: 204, text: '204 - BANCO BRADESCO CARTOES S.A.' }, { value: 394, text: '394 - BANCO BRADESCO FINANCIAMENTOS S.A.' }, { value: 237, text: '237 - BANCO BRADESCO S.A.' }, { value: 225, text: '225 - BANCO BRASCAN S.A.' }, { value: 282, text: '282 - BANCO BRASILEIRO COMERCIAL S.A.- BBC' }, { value: 501, text: '501 - BANCO BRASILEIRO IRAQUIANO S.A.' }, { value: 218, text: '218 - BANCO BS2 S.A.' }, { value: 44, text: '044 - BANCO BVA SA' }, { value: 336, text: '336 - Banco C6 S.A.' }, { value: 263, text: '263 - BANCO CACIQUE S.A.' }, { value: 199, text: '199 - BANCO CAIXA GERAL - BRASIL S.A.' }, { value: 473, text: '473 - BANCO CAIXA GERAL - BRASIL S.A.' }, { value: 236, text: '236 - BANCO CAMBIAL SA' }, { value: 412, text: '412 - BANCO CAPITAL S.A.' }, { value: 40, text: '040 - BANCO CARGILL S.A' }, { value: 266, text: '266 - BANCO CEDULA S.A.' }, { value: 739, text: '739 - BANCO CETELEM S.A.' }, { value: 221, text: '221 - BANCO CHASE FLEMING S.A.' }, { value: 244, text: '244 - BANCO CIDADE S.A.' }, { value: 233, text: '233 - Banco Cifra S.A.' }, { value: 713, text: '713 - BANCO CINDAM S.A.' }, { value: 745, text: '745 - BANCO CITIBANK S.A.' }, { value: 241, text: '241 - BANCO CLASSICO S.A.' }, { value: 631, text: '631 - BANCO COLUMBIA S.A.' }, { value: 215, text: '215 - BANCO COMERCIAL E DE INVESTIMENTO SUDAMERIS S.A' }, { value: 756, text: '756 - BANCO COOPERATIVO DO BRASIL S.A.' }, { value: 748, text: '748 - BANCO COOPERATIVO SICREDI S.A.' }, { value: 222, text: '222 - BANCO CREDIT AGRICOLE BRASIL S.A.' }, { value: 640, text: '640 - BANCO CREDITO METROPOLITANO S/A' }, { value: 505, text: '505 - BANCO CREDIT SUISSE (BRASIL) S.A.' }, { value: 69, text: '069 - BANCO CREFISA S.A.' }, { value: 220, text: '220 - BANCO CREFISUL S.A.' }, { value: 628, text: '628 - BANCO CRITERIUM S. A.' }, { value: 229, text: '229 - BANCO CRUZEIRO DO SUL S.A.' }, { value: 3, text: '003 - BANCO DA AMAZONIA S.A.' }, { value: 83, text: '083 - BANCO DA CHINA BRASIL S.A.' }, { value: 733, text: '733 - BANCO DAS NACOES S.A.' }, { value: 707, text: '707 - BANCO DAYCOVAL S.A.' }, { value: 240, text: '240 - BANCO DE CREDITO REAL DE MINAS GERAIS S.A' }, { value: 300, text: '300 - BANCO DE LA NACION ARGENTINA' }, { value: 494, text: '494 - BANCO DE LA REPUBLICA ORIENTAL DEL URUGUAY' }, { value: 24, text: '024 - BANCO DE PERNAMBUCO S.A.-BANDEPE' }, { value: 627, text: '627 - BANCO DESTAK S.A.' }, { value: 456, text: '456 - BANCO DE TOKYO MITSUBISHI UFJ BRASIL S.A' }, { value: 214, text: '214 - BANCO DIBENS S.A.' }, { value: 369, text: '369 - BANCO DIGIBANCO S.A.' }, { value: 335, text: '335 - BANCO DIGIO S.A.' }, { value: 649, text: '649 - BANCO DIMENSAO S.A.' }, { value: 1, text: '001 - BANCO DO BRASIL' }, { value: 635, text: '635 - BANCO DO ESTADO AMAPA S.A.' }, { value: 20, text: '020 - BANCO DO ESTADO DE ALAGOAS S.A.' }, { value: 59, text: '059 - BANCO DO ESTADO DE RONDONIA S.A.' }, { value: 645, text: '645 - BANCO DO ESTADO DE RORAIMA S.A.' }, { value: 27, text: '027 - BANCO DO ESTADO DE SANTA CATARINA S.A.' }, { value: 8, text: '008 - BANCO DO ESTADO DE SAO PAULO S.A. - BANESPA' }, { value: 47, text: '047 - BANCO DO ESTADO DE SERGIPE S.A.' }, { value: 26, text: '026 - BANCO DO ESTADO DO ACRE S.A.' }, { value: 32, text: '032 - BANCO DO ESTADO DO MATO GROSSO S.A.' }, { value: 37, text: '037 - BANCO DO ESTADO DO PARA S.A.' }, { value: 39, text: '039 - BANCO DO ESTADO DO PIAUI S.A.-BEP' }, { value: 41, text: '041 - BANCO DO ESTADO DO RIO GRANDE DO SUL S.A.' }, { value: 4, text: '004 - BANCO DO NORDESTE DO BRASIL S.A.' }, { value: 302, text: '302 - BANCO DO PROGRESSO S.A.' }, { value: 245, text: '245 - BANCO EMPRESARIAL S.A.' }, { value: 742, text: '742 - BANCO EQUATORIAL S.A.' }, { value: 242, text: '242 - BANCO EUROINVEST S.A. EUROBANCO' }, { value: 265, text: '265 - BANCO FATOR S.A.' }, { value: 375, text: '375 - BANCO FENICIA S.A.' }, { value: 224, text: '224 - BANCO FIBRA S.A.' }, { value: 200, text: '200 - BANCO FICRISA AXELRUD S.A.' }, { value: 626, text: '626 - BANCO FICSA S.A.' }, { value: 725, text: '725 - BANCO FINANSINOS S. A.' }, { value: 175, text: '175 - BANCO FINASA S.A.' }, { value: 94, text: '094 - BANCO FINAXIS S.A.' }, { value: 252, text: '252 - BANCO FININVEST S.A.' }, { value: 728, text: '728 - BANCO FITAL S.A.' }, { value: 729, text: '729 - BANCO FONTE CINDAM S.A.' }, { value: 489, text: '489 - BANCO FRANCES INTERNACIONAL-BRASIL S.A' }, { value: 624, text: '624 - BANCO GENERAL MOTORS S.A' }, { value: 734, text: '734 - BANCO GERDAU S.A.' }, { value: 612, text: '612 - BANCO GUANABARA S.A.' }, { value: 256, text: '256 - BANCO GULFINVEST S.A.' }, { value: 500, text: '500 - BANCO HABITASUL S.A.' }, { value: 497, text: '497 - BANCO HISPANO AMERICANO S.A.' }, { value: 303, text: '303 - BANCO HNF S.A.' }, { value: 228, text: '228 - BANCO ICATU S.A.' }, { value: 12, text: '012 - Banco Inbursa S.A.' }, { value: 258, text: '258 - BANCO INDUSCRED S.A.' }, { value: 604, text: '604 - BANCO INDUSTRIAL DO BRASIL S. A.' }, { value: 653, text: '653 - BANCO INDUSVAL S.A.' }, { value: 166, text: '166 - BANCO INTER-ATLANTICO S.A.' }, { value: 722, text: '722 - BANCO INTERIOR DE SAO PAULO S.A.' }, { value: 232, text: '232 - BANCO INTERPART S.A.' }, { value: 77, text: '077 - BANCO INTER S.A.' }, { value: 705, text: '705 - BANCO INVESTCORP S.A' }, { value: 249, text: '249 - BANCO INVESTCRED UNIBANCO S.A' }, { value: 499, text: '499 - BANCO IOCHPE S.A.' }, { value: 106, text: '106 - BANCO ITABANCO S.A.' }, { value: 372, text: '372 - BANCO ITAMARATI S/A' }, { value: 479, text: '479 - BANCO ITAUBANK S.A.' }, { value: 652, text: '652 - BANCO ITAU HOLDING FINANCEIRA S.A' }, { value: 376, text: '376 - BANCO J.P. MORGAN S.A.' }, { value: 42, text: '042 - BANCO J. SAFRA S.A' }, { value: 74, text: '074 - BANCO J. SAFRA S.A.' }, { value: 217, text: '217 - BANCO JOHN DEERE S.A.' }, { value: 234, text: '234 - BANCO LAVRA S.A.' }, { value: 600, text: '600 - BANCO LUSO BRASILEIRO S.A.' }, { value: 72, text: '072 - BANCO MAIS S.A' }, { value: 647, text: '647 - BANCO MARKA S.A.' }, { value: 206, text: '206 - BANCO MARTINELLI S.A.' }, { value: 656, text: '656 - BANCO MATRIX S.A.' }, { value: 243, text: '243 - BANCO MAXIMA S.A.' }, { value: 720, text: '720 - BANCO MAXINVEST S.A.' }, { value: 392, text: '392 - BANCO MERCANTIL DE SAO PAULO S.A.' }, { value: 389, text: '389 - BANCO MERCANTIL DO BRASIL S.A.' }, { value: 732, text: '732 - BANCO MINAS S.A.' }, { value: 466, text: '466 - BANCO MITSUBISHI S.A' }, { value: 746, text: '746 - BANCO MODAL S.A.' }, { value: 738, text: '738 - BANCO MORADA S.A.' }, { value: 504, text: '504 - BANCO MULTIPLIC S.A.' }, { value: 415, text: '415 - BANCO NACIONAL S.A.' }, { value: 735, text: '735 - BANCO NEON S.A.' }, { value: 165, text: '165 - BANCO NORCHEM S.A.' }, { value: 151, text: '151 - BANCO NOSSA CAIXA S.A' }, { value: 718, text: '718 - BANCO OPERADOR S.A.' }, { value: 79, text: '079 - BANCO ORIGINAL DO AGRONEGOCIO S.A.' }, { value: 212, text: '212 - BANCO ORIGINAL S/A' }, { value: 208, text: '208 - BANCO PACTUAL S.A.' }, { value: 623, text: '623 - BANCO PAN S.A.' }, { value: 602, text: '602 - BANCO PATENTE S.A.' }, { value: 611, text: '611 - BANCO PAULISTA S.A.' }, { value: 650, text: '650 - BANCO PEBB S.A.' }, { value: 643, text: '643 - BANCO PINE S.A.' }, { value: 277, text: '277 - BANCO PLANIBANC S.A.' }, { value: 304, text: '304 - BANCO PONTUAL S.A.' }, { value: 658, text: '658 - BANCO PORTO REAL S.A.' }, { value: 638, text: '638 - BANCO PROSPER S.A.' }, { value: 747, text: '747 - BANCO RABOBANK INTERNATIONAL BRASIL S.A.' }, { value: 88, text: '088 - BANCO RANDON S.A.' }, { value: 275, text: '275 - BANCO REAL S.A.' }, { value: 216, text: '216 - BANCO REGIONAL MALCON S.A.' }, { value: 633, text: '633 - BANCO RENDIMENTO S.A.' }, { value: 741, text: '741 - BANCO RIBEIRAO PRETO S.A.' }, { value: 120, text: '120 - BANCO RODOBENS S.A' }, { value: 453, text: '453 - BANCO RURAL S.A.' }, { value: 422, text: '422 - BANCO SAFRA S.A.' }, { value: 33, text: '033 - BANCO SANTANDER (BRASIL) S.A.' }, { value: 353, text: '353 - BANCO SANTANDER BRASIL S.A.' }, { value: 502, text: '502 - BANCO SANTANDER DE NEGOCIOS S.A.' }, { value: 424, text: '424 - BANCO SANTANDER NOROESTE S.A' }, { value: 351, text: '351 - BANCO SANTANDER S.A.' }, { value: 607, text: '607 - BANCO SANTOS NEVES S.A.' }, { value: 702, text: '702 - BANCO SANTOS S. A.' }, { value: 743, text: '743 - BANCO SEMEAR S.A.' }, { value: 749, text: '749 - BANCO SIMPLES S.A.' }, { value: 211, text: '211 - BANCO SISTEMA S.A.' }, { value: 630, text: '630 - BANCO SMARTBANK S.A.' }, { value: 366, text: '366 - BANCO SOCIETE GENERALE BRASIL S.A' }, { value: 637, text: '637 - BANCO SOFISA S.A.' }, { value: 347, text: '347 - BANCO SUDAMERIS DO BRASIL S.A' }, { value: 205, text: '205 - BANCO SUL AMERICA S.A.' }, { value: 464, text: '464 - BANCO SUMITOMO MITSUI BRASILEIRO S.A.' }, { value: 657, text: '657 - BANCO TECNICORP S.A.' }, { value: 618, text: '618 - BANCO TENDENCIA S.A.' }, { value: 737, text: '737 - BANCO THECA S.A.' }, { value: 634, text: '634 - BANCO TRIANGULO S.A.' }, { value: 247, text: '247 - BANCO UBS S.A' }, { value: 116, text: '116 - BANCO UNICO S.A.' }, { value: 493, text: '493 - BANCO UNION - BRASIL S.A' }, { value: 496, text: '496 - BANCO UNO-E BRASIL S.A' }, { value: 715, text: '715 - BANCO VEGA S.A.' }, { value: 711, text: '711 - BANCO VETOR S.A.' }, { value: 655, text: '655 - BANCO VOTORANTIM S.A.' }, { value: 610, text: '610 - BANCO VR S.A.' }, { value: 480, text: '480 - BANCO WACHOVIA S.A.' }, { value: 124, text: '124 - BANCO WOORI BANK DO BRASIL S.A' }, { value: 348, text: '348 - BANCO XP S.A.' }, { value: 219, text: '219 - BANCO ZOGBI S.A' }, { value: 28, text: '028 - BANEB-EM ABSORCAO' }, { value: 21, text: '021 - BANESTES S.A BANCO DO ESTADO DO ESPIRITO SANTO' }, { value: 434, text: '434 - BANFORT - BANCO FORTALEZA S.A.' }, { value: 719, text: '719 - BANIF-BANCO INTERNACIONAL DO FUNCHAL (BRASIL) S.A' }, { value: 744, text: '744 - BANKBOSTON N.A.' }, { value: 148, text: '148 - BANK OF AMERICA - BRASIL S.A. (BANCO MULTIPLO)' }, { value: 235, text: '235 - BANK OF AMERICA - LIBERAL S.A' }, { value: 755, text: '755 - BANK OF AMERICA MERRILL LYNCH BANCO MULTIPLO S.A.' }, { value: 420, text: '420 - BANORTE - BANCO NACIONAL DO NORTE S.A.' }, { value: 268, text: '268 - BARI COMPANHIA HIPOTECARIA' }, { value: 73, text: '073 - BB BANCO POPULAR DO BRASIL' }, { value: 81, text: '081 - BBN BANCO BRASILEIRO DE NEGOCIOS' }, { value: 128, text: '128 - BCam MS Bank' }, { value: 294, text: '294 - BCR/EM ABSORCAO' }, { value: 800, text: '800 - BCR BANCO DE CREDITO REAL S.A' }, { value: 250, text: '250 - BCV - Banco de Credito e Varejo S/A' }, { value: 144, text: '144 - Bexs Banco de Cambio S.A.' }, { value: 253, text: '253 - BEXS CORRETORA DE CAMBIO S/A' }, { value: 78, text: '078 - BI HAITONG DO BRASIL' }, { value: 129, text: '129 - BI UBS Brasil' }, { value: 64, text: '064 - BM Goldman Sachs' }, { value: 169, text: '169 - BM OLE BONSUCESSO CONSIGNADO S.A.' }, { value: 712, text: '712 - BM OURINVEST' }, { value: 18, text: '018 - BM TRICURY' }, { value: 7, text: '007 - BNDES' }, { value: 17, text: '017 - BNY MELLON S.A.' }, { value: 301, text: '301 - BPP Instituicao de Pagamento S.A.' }, { value: 63, text: '063 - BRADESCARD' }, { value: 122, text: '122 - BRADESCO BERJ' }, { value: 125, text: '125 - BRASIL PLURAL S.A. BANCO MULTIPLO' }, { value: 70, text: '070 - BRB - BANCO DE BRASILIA S.A.' }, { value: 173, text: '173 - BRL TRUST DISTRIBUIDORA DE TITULOS E VALORES MOBIL' }, { value: 142, text: '142 - BROKER BRASIL CORRETORA DE CAMBIO LTDA.' }, { value: 126, text: '126 - BR PARTNERS BANCO DE INVESTIMENTO S.A.' }, { value: 292, text: '292 - BS2 Distribuidora de Titulos e Valores Mobiliarios' }, { value: 80, text: '080 - BT Corretora de Cambio Ltda.' }, { value: 153, text: '153 - CAIXA ECONOMICA ESTADUAL DO RIO GRANDE DO SUL' }, { value: 104, text: '104 - CAIXA ECONOMICA FEDERAL' }, { value: 309, text: '309 - Cambionet Corretora de Cambio Ltda.' }, { value: 288, text: '288 - Carol Distribuidora de Titulos e Valores Mobiliari' }, { value: 130, text: '130 - CARUANA S.A. SOCIEDADE DE CREDITO FINANCIAMENTO E' }, { value: 159, text: '159 - Casa do Credito S.A. Sociedade de Credito ao Micro' }, { value: 320, text: '320 - CCB BRASIL' }, { value: 85, text: '085 - CC CECRED' }, { value: 97, text: '097 - CC CENTRALCREDI' }, { value: 10, text: '010 - CC CREDICOAMO' }, { value: 89, text: '089 - CC REGIAO DA MOGIANA' }, { value: 16, text: '016 - CC SICOOB CREDITRAN' }, { value: 90, text: '090 - CC SICOOB UNIMAIS' }, { value: 112, text: '112 - CC UNICRED BRASIL CENTRAL' }, { value: 91, text: '091 - CC Unicred Central RS' }, { value: 87, text: '087 - CC UNICRED CENTRAL SC/PR' }, { value: 136, text: '136 - CC UNICRED DO BRASIL' }, { value: 99, text: '099 - CC UNIPRIME CENTRAL' }, { value: 114, text: '114 - CENTRAL COOPERATIVA DE CREDITO NO ESTADO DO ESPIRI' }, { value: 498, text: '498 - CENTRO HISPANO BANCO' }, { value: 477, text: '477 - CITIBANK N.A.' }, { value: 127, text: '127 - CODEPE - CORRETORA DE VALORES S.A.' }, { value: 163, text: '163 - COMMERZBANK' }, { value: 133, text: '133 - CONFEDERACAO NACIONAL DAS COOPERATIVAS CENTRAIS DE' }, { value: 281, text: '281 - COOPERATIVA DE CREDITO RURAL COOPAVEL' }, { value: 322, text: '322 - COOPERATIVA DE CREDITO RURAL DE ABELARDO LUZ - SUL' }, { value: 286, text: '286 - Cooperativa de Credito Rural de Ouro Sulcredi/Ouro' }, { value: 279, text: '279 - COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE' }, { value: 273, text: '273 - Cooperativa de Credito Rural de Sao Miguel do Oest' }, { value: 901, text: '901 - CORRETORA SOUZA BARROS CAMBIO E TITULOS S.A.' }, { value: 98, text: '098 - CREDIALIANCA COOPERATIVA DE CREDITO RURAL' }, { value: 109, text: '109 - CREDIBANCO S.A.' }, { value: 721, text: '721 - CREDIBEL PARTICIPACOES S.A.' }, { value: 22, text: '022 - CREDIREAL -EM ABSORCAO' }, { value: 342, text: '342 - CREDITAS SOCIEDADE DE CREDITO DIRETO S.A.' }, { value: 11, text: '011 - CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES' }, { value: 321, text: '321 - CREFAZ SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E' }, { value: 182, text: '182 - Dacasa Financeira S/A - Sociedade de Credito, Fina' }, { value: 289, text: '289 - DECYSEO CORRETORA DE CAMBIO LTDA.' }, { value: 487, text: '487 - DEUTSCHE BANK S. A. - BANCO ALEMAO' }, { value: 210, text: '210 - DRESDNER BANK LATEINAMERIKA AKTIENGESELLSCHAFT' }, { value: 134, text: '134 - DTVM BGC Liquidez' }, { value: 111, text: '111 - DTVM Oliveira Trust' }, { value: 101, text: '101 - DTVM RENASCENCA' }, { value: 140, text: '140 - EASYNVEST - TíTULO CORRETORA DE VALORES SA' }, { value: 103, text: '103 - EBS CAPITAL CORRETORA DE CAMBIO S/A' }, { value: 149, text: '149 - FACTA FINANCEIRA S.A.' }, { value: 196, text: '196 - Fair Corretora de Cambio S.A.' }, { value: 343, text: '343 - FFA SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E A' }, { value: 331, text: '331 - FRAM CAPITAL DISTRIBUIDORA DE TITULOS E VALORES MO' }, { value: 285, text: '285 - Frente Corretora de Cambio Ltda.' }, { value: 278, text: '278 - GENIAL INVESTIMENTOS CORRETORA DE VALORES MOBILIAR' }, { value: 364, text: '364 - GERENCIANET PAGAMENTOS DO BRASIL LTDA' }, { value: 177, text: '177 - GUIDE INVESTIMENTOS S.A. CORRETORA DE VALORES' }, { value: 146, text: '146 - GUITTA CORRETORA DE CAMBIO LTDA' }, { value: 62, text: '062 - HIPERCARD BANCO MULTIPLO S.A' }, { value: 269, text: '269 - HSBC Brasil S.A. Banco de Investimento' }, { value: 168, text: '168 - HSBC INVESTMENT BANK BRASIL S.A.-BANCO MULTIPLO' }, { value: 750, text: '750 - HSBC REPUBLIC BANK BRASIL S.A-BANCO MULTIPLO' }, { value: 189, text: '189 - HS FINANCEIRA SA' }, { value: 271, text: '271 - IB Corretora de Cambio, Titulos e Valores Mobiliar' }, { value: 157, text: '157 - ICAP DO BRASIL CORRETORA DE TIT. VAL. MOBILIARIOS' }, { value: 132, text: '132 - ICBC DO BRASIL BANCO MúLTIPLO S.A.' }, { value: 492, text: '492 - ING BANK' }, { value: 139, text: '139 - INTESA SANPAOLO BRASIL S.A. - DTVM' }, { value: 184, text: '184 - ITAU BBA' }, { value: 29, text: '029 - Itau Consignado' }, { value: 341, text: '341 - ITAU UNIBANCO S.A.' }, { value: 488, text: '488 - JP MORGAN CHASE BANK' }, { value: 76, text: '076 - KDB DO BRASIL' }, { value: 757, text: '757 - KEB HANA DO BRASIL' }, { value: 399, text: '399 - KIRTON BANK' }, { value: 293, text: '293 - Lastro RDV Distribuidora de Titulos e Valores Mobi' }, { value: 105, text: '105 - LECCA CREDITO FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: 472, text: '472 - LLOYDS TSB BANK PLC' }, { value: 113, text: '113 - MAGLIANO S.A CORRETORA CAMBIO E VALORES MOBILIARIO' }, { value: 323, text: '323 - MERCADOPAGO.COM REPRESENTACOES LTDA.' }, { value: 255, text: '255 - MILBANCO S.A.' }, { value: 370, text: '370 - MIZUHO' }, { value: 259, text: '259 - MONEYCORP BANCO DE CAMBIO S.A.' }, { value: 274, text: '274 - MONEY PLUS SOCIEDADE DE CREDITO AO MICROEMPREENDED' }, { value: 66, text: '066 - MORGAN STANLEY' }, { value: 14, text: '014 - NATIXIS BRASIL' }, { value: 354, text: '354 - NECTON INVESTIMENTOS S.A. CORRETORA DE VALORES MOB' }, { value: 191, text: '191 - NOVA FUTURA CORRETORA DE TíTULOS E VALORES MOBILIá' }, { value: 753, text: '753 - NOVO BANCO CONTINENTAL' }, { value: 260, text: '260 - Nu Pagamentos S.A.' }, { value: 86, text: '086 - OBOE CREDITO, FINANCIAMENTO E INVESTIMENTO S.A.' }, { value: 319, text: '319 - OM DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS' }, { value: 613, text: '613 - OMNI BANCO S.A.' }, { value: 45, text: '045 - OPPORTUNITY HDF PARTICIPACOES S.A.' }, { value: 325, text: '325 - ORAMA DISTRIBUIDORA DE TITULOS E VALORES MOBILIARI' }, { value: 355, text: '355 - OTIMO SOCIEDADE DE CREDITO DIRETO S.A.' }, { value: 290, text: '290 - Pagseguro Internet S.A.' }, { value: 30, text: '030 - PARAIBAN-BANCO DA PARAIBA S.A.' }, { value: 254, text: '254 - PARANA BANCO S.A.' }, { value: 326, text: '326 - PARATI - CREDITO, FINANCIAMENTO E INVESTIMENTO S.A' }, { value: 194, text: '194 - Parmetal Distribuidora de Titulos e Valores Mobili' }, { value: 174, text: '174 - Pernambucanas Financiadora S.A. Credito, Financiam' }, { value: 315, text: '315 - PI DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS' }, { value: 108, text: '108 - PORTOCRED S A CREDITO FINANCIAMENTO E INVESTIMENTO' }, { value: 306, text: '306 - Portopar Distribuidora de Titulos e Valores Mobili' }, { value: 495, text: '495 - PROVINCIA B. AIRES' }, { value: 329, text: '329 - QI SOCIEDADE DE CREDITO DIRETO S.A.' }, { value: 283, text: '283 - RB Capital Investimentos Distribuidora de Titulos' }, { value: 147, text: '147 - RICO CORRETORA DE TITULOS E VALORES MOBILIARIOS S/' }, { value: 115, text: '115 - ROTULA S/A CREDITO, FINANCIAMENTO E INVESTIMENTOS' }, { value: 270, text: '270 - Sagitur Corretora de Cambio Ltda.' }, { value: 180, text: '180 - SC CM Capital Markets' }, { value: 60, text: '060 - SC Confidence' }, { value: 92, text: '092 - SCFI BRICKELL' }, { value: 138, text: '138 - SC Get Money' }, { value: 135, text: '135 - SC Gradual' }, { value: 145, text: '145 - SC Levycam' }, { value: 93, text: '093 - SCM Polocred' }, { value: 137, text: '137 - SC Multimoney' }, { value: 751, text: '751 - SCOTIABANK BRASIL S.A BANCO MULTIPLO' }, { value: 100, text: '100 - SC Planner' }, { value: 545, text: '545 - SC Senso' }, { value: 143, text: '143 - SC Treviso' }, { value: 131, text: '131 - SC Tullett Prebon' }, { value: 15, text: '015 - SC UBS Brasil' }, { value: 276, text: '276 - Senff S.A. - Credito, Financiamento e Investimento' }, { value: 13, text: '013 - SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS SA' }, { value: 190, text: '190 - SERVICOOP - COOPERATIVA DE CREDITO DOS SERVIDORES' }, { value: 167, text: '167 - S HAYATA CORRETORA DE CAMBIO S.A.' }, { value: 754, text: '754 - Sistema' }, { value: 183, text: '183 - Socred S.A. - Sociedade de Credito ao Microempreen' }, { value: 365, text: '365 - SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIA' }, { value: 299, text: '299 - Sorocred - Credito, Financiamento e Investimento S' }, { value: 118, text: '118 - STANDARD CHARTERED BANK BRASIL S.A. - BANCO DE INV' }, { value: 197, text: '197 - Stone Pagamentos S.A.' }, { value: 340, text: '340 - SUPER PAGAMENTOS E ADMINISTRACAO DE MEIOS ELETRONI' }, { value: 307, text: '307 - Terra Investimentos Distribuidora de Titulos e Val' }, { value: 82, text: '082 - TOPAZIO' }, { value: 352, text: '352 - TORO CORRETORA DE TITULOS E VALORES MOBILIARIOS LT' }, { value: 95, text: '095 - TRAVELEX BANCO DE CAMBIO S.A.' }, { value: 409, text: '409 - UNIBANCO - UNIAO DE BANCOS BRASILEIROS S.A.' }, { value: 230, text: '230 - UNICARD BANCO MULTIPLO S.A' }, { value: 84, text: '084 - UNIPRIME NORTE DO PARANA - COOPERATIVA DE CREDITO' }, { value: 373, text: '373 - UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.' }, { value: 298, text: "298 - Vip's Corretora de Cambio Ltda." }, { value: 296, text: '296 - Vision S.A. Corretora de Cambio' }, { value: 367, text: '367 - VITREO DISTRIBUIDORA DE TITULOS E VALORES MOBILIAR' }, { value: 310, text: '310 - Vortx Distribuidora de Titulos e Valores Mobiliari' }, { value: 119, text: '119 - WESTERN UNION' }, { value: 102, text: '102 - XP INVEST CORRETORA DE CAMBIO TIT E VALORES MOB SA    ' }],

  bem_direito_motivo_baixa: [{ value: 1, text: '1 - Venda' }, { value: 2, text: '2 - Doação' }, { value: 3, text: '3 - Permuta' }, { value: 4, text: '4 - Inutilização' }, { value: 5, text: '5 - Roubo' }, { value: 6, text: '6 - Sinistro' }, { value: 7, text: '7 - Transferido' }, { value: 8, text: '8 - Devolução' }, { value: 9, text: '9 - Outros' }],

  bem_direito_rural_codigo: [{ value: 11, text: '11 - Prédios/Galpões/Estábulos/Mangueiras/Currais/Aviários/Comportas/Canais/Açudes/Barragens' }, { value: 12, text: '12 - Cercas e Instalações para Abrigo e/ou Tratamento de Animais' }, { value: 13, text: '13 - Eletrificação Rural, Telefone, Rádio, Bússula, Sonda, Radares' }, { value: 14, text: '14 - Culturas Permanentes, Essências Florestais/Pastagens Artificiais' }, { value: 15, text: '15 - Produtos Estocados' }, { value: 16, text: '16 - Tratores/Veículos de Carga/Utilitários Rurais/Embarcações/Aeronaves de Uso Agrícola' }, { value: 17, text: '17 - Motores e Implementos Agrícolas em Geral' }, { value: 18, text: '18 - Equipamentos e Veículos de Tração Animal' }, { value: 19, text: '19 - Outros Bens Móveis/Imóveis/Equipamentos da Atividade Rural' }, { value: 20, text: '20 - Poupança p/ Aquisição Bens Móveis por Intermédio de Consórcio' }, { value: 99, text: '99 - Outros Bens Vinculados à Atividade Rural' }],

  bem_direito_rural_motivo_baixa: [{ value: 1, text: '1 - Venda' }, { value: 2, text: '2 - Doaçoão' }, { value: 3, text: '3 - Permuta' }, { value: 4, text: '4 - Inutilização' }, { value: 5, text: '5 - Roubo' }, { value: 6, text: '6 - Sinistro' }],

  divida_onus_codigo: [{ value: 11, text: '11 - Estabelecimento Bancário Comercial' }, { value: 12, text: '12 - Sociedade de Crédito, Financiamento e Investimento' }, { value: 13, text: '13 - Outras Pessoas Jurídicas' }, { value: 14, text: '14 - Pessoas Físicas' }, { value: 15, text: '15 - Empréstimos Contraídos no Exterior' }, { value: 16, text: '16 - Outras Dívidas e Ônus Reais' }],

  pagamento_codigo: [{ value: 1, text: '1 - Instrução no Brasil' }, { value: 2, text: '2 - Instrução no Exterior' }, { value: 9, text: '9 - Fonoaudiólogos no Brasil' }, { value: 10, text: '10 - Médicos no Brasil' }, { value: 11, text: '11 - Dentistas no Brasil' }, { value: 12, text: '12 - Psicólogos no Brasil' }, { value: 13, text: '13 - Fisioterapeutas no Brasil' }, { value: 14, text: '14 - Terapeutas Ocupacionais no Brasil' }, { value: 15, text: '15 - Médicos no Exterior' }, { value: 16, text: '16 - Dentistas no Exterior' }, { value: 17, text: '17 - Psicólogos no Exterior' }, { value: 18, text: '18 - Fisioterapeutas no Exterior' }, { value: 19, text: '19 - Terapeutas Ocupacionais no Exterior' }, { value: 20, text: '20 - Fonoaudiólogos no Exterior' }, { value: 21, text: '21 - Hospitais, Clínicas e Laboratórios no Brasil' }, { value: 22, text: '22 - Hospitais, Clínicas e Laboratórios no Exterior' }, { value: 26, text: '26 - Planos de Saúde no Brasil' }, { value: 30, text: '30 - Pensão Alimentícia Judicial Paga a Residente no Brasil' }, { value: 31, text: '31 - Pensão Alimentícia Judicial Paga a Não Residente no Brasil' }, { value: 33, text: '33 - Pensão Alimentícia - Separação/Divórcio Por Escritura Pública Paga a Residente no Brasil' }, { value: 34, text: '34 - Pensão alimentícia - Separação/Divórcio Por Escritura Pública Paga a Não Residente no Brasil' }, { value: 36, text: '36 - Previdência Complementar' }, { value: 37, text: '37 - Contribuições Para as Entidades de Previdência Complementar Fechadas de Natureza Pública' },
  // 38 e 50 foram removidos no 2026
  // { value: 38, text: '38 - Fapi - Fundo de Aposentadoria Programada Individual' },
  // { value: 50, text: '50 - Contribuição patronal paga à Previdência Social pelo empregador doméstico' },
  { value: 60, text: '60 - Advogados (Honorários Relativos a Ações Judiciais, Exceto Trabalhistas)' }, { value: 61, text: '61 - Advogados (Honorários Relativos a Ações Judiciais Trabalhistas)' }, { value: 62, text: '62 - Advogados (Demais Honorários)' }, { value: 66, text: '66 - Engenheiros, Arquitetos e Demais Profissionais Liberais, Exceto Advogados, Administrador de Imóveis ou Corretor de Imóveis.' }, { value: 70, text: '70 - Aluguéis de Imóveis' }, { value: 71, text: '71 - Administrador de Imóveis' }, { value: 72, text: '72 - Corretor de Imóveis' }, { value: 76, text: '76 - Arrendamento Rural' }, { value: 99, text: '99 - Outros' }],

  rend_isento_codigo_particular: [{
    value: 1,
    text: '1 - Bolsas de estudo e de pesquisa caracterizadas como doação, exceto médico-residente ou Pronatec, exclusivamente para proceder a estudos ou pesquisas e desde que os resultados dessas atividades não representem vantagem para o doador, nem importem contraprestação de serviços'
  }, {
    value: 2,
    text: '2 - Bolsas de estudo e de pesquisa caracterizadas como doação, quando recebidas exclusivamente para proceder a estudos ou pesquisas, recebidas por médico-residente e por servidor da rede pública de educação profissional, científica e tecnológica que participe das atividades do Pronatec'
  }, {
    value: 3,
    text: '3 - Capital das apólices de seguro ou pecúlio pago por morte do segurado, prêmio de seguro restituído em qualquer caso e pecúlio recebido de entidades de previdência privada em decorrência de morte ou invalidez permanente'
  }, {
    value: 4,
    text: '4 - Indenizações por rescisão de contrato de trabalho, inclusive a título de PDV, e por acidente de trabalho; e FGTS'
  }, {
    value: 5,
    text: '5 - Ganho de capital na alienação de bem, direito ou conjunto de bens ou direitos da mesma natureza, alienados em um mesmo mês, de valor total de alienação até R$ 20.000,00, para ações alienadas no mercado de balcão, e R$ 35.000,00, nos demais casos'
  }, {
    value: 6,
    text: '6 - Ganho de capital na alienação do único imóvel por valor igual ou inferior a R$ 440.000,00 e que, nos últimos 5 anos, não tenha efetuado nenhuma outra alienação de imóvel'
  }, {
    value: 7,
    text: '7 - Ganho de capital na venda de imóveis residenciais para aquisição, no prazo de 180 dias, de imóveis residenciais localizados no Brasil e redução sobre o ganho de capital'
  }, {
    value: 8,
    text: '8 - Ganho de capital na alienação de moeda estrangeira mantida em espécie cujo total de alienações, no ano-calendário, seja igual ou inferior ao equivalente a US$ 5,000.00'
  }, { value: 9, text: '9 - Lucros e dividendos recebidos' }, {
    value: 10,
    text: '10 - Parcela isenta de proventos de aposentadoria, reserva remunerada, reforma e pensão de declarante com 65 anos ou mais'
  }, {
    value: 11,
    text: '11 - Pensão, proventos de aposentadoria ou reforma por moléstia grave ou aposentadoria ou reforma por acidente  em serviço'
  }, {
    value: 12,
    text: '12 - Rendimentos de cadernetas de poupança, letras hipotecárias, letras de crédito do agronegócio e imobiliário (LCA e LCI) e certificados de recebíveis do agronegócio e imobiliários (CRA e CRI)'
  }, {
    value: 13,
    text: '13 - Rendimento de sócio ou titular de microempresa ou empresa de pequeno porte optante pelo Simples Nacional, exceto pro labore, aluguéis e serviços prestados'
  }, { value: 14, text: '14 - Transferências patrimoniais – doações e heranças' }, {
    value: 16,
    text: '16 - Imposto sobre a renda de anos-calendário anteriores compensado judicialmente neste ano-calendário'
  }, {
    value: 17,
    text: '17 - 75% (setenta e cinco por cento) dos rendimentos do trabalho assalariado recebidos em moeda estrangeira por servidores de autarquias ou repartições do Governo Brasileiro situadas no exterior, convertidos em reais'
  }, { value: 18, text: '18 - Incorporação de reservas ao capital / Bonificações em ações' }, {
    value: 19,
    text: '19 - Transferências patrimoniais – meação e dissolução da sociedade conjugal e da unidade familiar'
  }, {
    value: 20,
    text: '20 - Ganhos líquidos em operações no mercado à vista de ações negociadas em bolsas de valores nas alienações realizadas até R$ 20.000,00 em cada mês, para o conjunto de ações'
  }, {
    value: 21,
    text: '21 - Ganhos líquidos em operações com ouro, ativo financeiro, nas alienações realizadas até R$ 20.000,00 em cada mês'
  }, {
    value: 23,
    text: '23 - Rendimento bruto, até o máximo de 90%, da prestação de serviços decorrente do transporte de carga e com trator, máquina de terraplenagem, colheitadeira e assemelhados'
  }, {
    value: 24,
    text: '24 - Rendimento bruto, até o máximo de 40%, da prestação de serviços decorrente do transporte de passageiros'
  }, { value: 25, text: '25 - Restituição do imposto sobre a renda de anos-calendário anteriores' }, { value: 28, text: '28 - Pensão Alimentícia' }, { value: 99, text: '99 - Outros' }],
  rend_isento_codigo_condominio: [{
    value: 3,
    text: '3 - Capital das apólices de seguro ou pecúlio pago por morte do segurado, prêmio de seguro restituído em qualquer caso e pecúlio recebido de entidades de previdência privada em decorrência de morte ou invalidez permanente'
  }, {
    value: 9,
    text: '9 - Lucros e dividendos recebidos'
  }, {
    value: 12,
    text: '12 - Rendimentos de cadernetas de poupança, letras hipotecárias, letras de crédito do agronegócio e imobiliário (LCA e LCI) e certificados de recebíveis do agronegócio e imobiliários (CRA e CRI)'
  }, {
    value: 20,
    text: '20 - Ganhos líquidos em operações no mercado à vista de ações negociadas em bolsas de valores nas alienações realizadas até R$ 20.000,00 em cada mês, para o conjunto de ações'
  }, {
    value: 21,
    text: '21 - Ganhos líquidos em operações com ouro, ativo financeiro, nas alienações realizadas até R$ 20.000,00 em cada mês'
  }, { value: 99, text: '99 - Outros' }],

  rend_tributacao_codigo: [{ value: 6, text: '6 - Rendimentos de Aplicações Financeiras' }, { value: 10, text: '10 - Juros sobre Capital Próprio' }, { value: 11, text: '11 - Participação nos Lucros ou Resultados' }, { value: 13, text: '13 - Prêmios líquidos obtidos em loterias de apostas de quota fixa - Lei 14.790/2023' }, { value: 99, text: '99 - Outros' }],

  imovel_atividade: [{ value: 10, text: '10 - Agricultura - Cultura do Solo, Independentemente do Produto Cultivado' }, { value: 11, text: '11 - Pecuária - Criação, Recriação ou Engorda de Animais de Médio ou Grande Porte' }, { value: 12, text: '12 - Extração e Exploração Vegetal e Animal' }, {
    value: 13,
    text: '13 - Exploração da Apicultura, Avicultura, Cunicultura, Piscicultura, Sericultura, Suinocultura ETC...'
  }, { value: 14, text: '14 - Cultura de Pequenos Animais' }, { value: 15, text: '15 - Captura e Venda do Pescado in Natura' }, { value: 16, text: '16 - Transformação de Produtos Agrícolas ou Pecuários' }, { value: 17, text: '17 - Cultivo de Florestas' }, { value: 99, text: '99 - Outros' }],

  imovel_exploracao: [{ value: 1, text: '1 - Propriedade Única ou Posse' }, { value: 2, text: '2 - Condomínio' }, { value: 3, text: '3 - Parceria' }, { value: 4, text: '4 - Arrendamento' }, { value: 5, text: '5 - Propriedade Comum ao Casal' }, { value: 6, text: '6 - Outras' }],

  pessoa_natureza_ocupacao: [{ text: '1 - Empregado de empresa do setor privado, exceto de instituições financeiras', value: 1 }, { text: '2 - Empregado de instituições financeiras públicas e privadas', value: 2 }, { text: '3 - Empregado ou contratado de organismo internacional ou de organização não-governamental', value: 3 }, { text: '11 - Profissional liberal ou autônomo sem vínculo de emprego', value: 11 }, { text: '12 - Proprietário de empresa ou de firma individual ou empregador-titular', value: 12 }, { text: '13 - Capitalista, que auferiu rendimentos de capital, inclusive de aluguéis', value: 13 }, { text: '14 - Microoempreendedor individual (MEI)', value: 14 }, { text: '21 - Membro ou servidor público da administração direta federal', value: 21 }, { text: '22 - Servidor público de autarquia ou fundação federal', value: 22 }, { text: '23 - Empregado de empresa pública ou de economia mista federal, exceto de instituições financeiras', value: 23 }, { text: '31 - Membro ou servidor público da administração direta estadual e do Distrito Federal', value: 31 }, { text: '32 - Servidor público de autarquia ou fundação estadual e do Distrito Federal', value: 32 }, { text: '33 - Empregado de empresa pública ou de economia mista estadual e do Distrito Federal, exceto de instituições financeiras', value: 33 }, { text: '41 - Membro ou servidor público da administração direta municipal', value: 41 }, { text: '42 - Servidor público de autarquia ou fundação municipal', value: 42 }, { text: '43 - Empregado de empresa pública ou de economia mista municipal', value: 43 }, { text: '51 - Militar', value: 51 }, { text: '61 - Aposentado, militar da reserva ou reformado e pensionista de previdência', value: 61 }, { text: '62 - Aposentado, militar da reserva ou reformado e pensionista de previdência oficial, portador de moléstia grave', value: 62 }, { text: '71 - Beneficiário de pensão alimentícia judicial', value: 71 }, { text: '72 - Bolsista', value: 72 }, { text: '81 - Espólio', value: 81 }, { text: '91 - Natureza da ocupação não especificada anteriormente', value: 91 }],

  pessoa_ocupacao_principal: [{ text: '101 - Membro do Poder Executivo (Presidente da República, Vice-Presidente da República, Ministro de Estado, Governador, Vice-Governador, Prefeito, Vice-prefeito)', value: 101 }, { text: '102 - Membro do Poder Judiciário (Ministro, Juiz e Desembargador) e de Tribunal de Contas (Ministro e Conselheiro)', value: 102 }, { text: '103 - Membro do Poder Legislativo (Senador, Deputado Federal, Deputado Estadual e Vereador)', value: 103 }, { text: '104 - Membro do Ministério Público (Procurador e Promotor)', value: 104 }, { text: '105 - Dirigente superior da administração pública (ocupante de cargo de direção, chefia, assessoria e de natureza especial), inclusive os das fundações públicas e autarquias', value: 105 }, { text: '106 - Diplomata e afins', value: 106 }, { text: '107 - Servidor das carreiras do Poder Legislativo', value: 107 }, { text: '108 - Servidor das carreiras do Ministério Público', value: 108 }, { text: '109 - Servidor das carreiras do Poder Judiciário, Oficial de Justiça, Auxiliar, Assistente e Analista Judiciário', value: 109 }, { text: '110 - Advogado do setor público, Procurador da Fazenda, Consultor Jurídico, Procurador de autarquias e fundações públicas, Defensor Público', value: 110 }, { text: '111 - Servidor das carreiras de auditoria fiscal e de fiscalização', value: 111 }, { text: '112 - Servidor das carreiras do Banco Central, CVM e Susep', value: 112 }, { text: '113 - Delegado de Polícia e outros servidores das carreiras de polícia, exceto militar', value: 113 }, { text: '114 - Servidor das carreiras de gestão governamental, analista, gestor e técnico de planejamento', value: 114 }, { text: '115 - Servidor das carreiras de ciência e tecnologia Código Natureza da Ocupação', value: 115 }, { text: '116 - Servidor das demais carreiras da administração pública direta, autárquica e fundacional', value: 116 }, { text: '117 - Titular de Cartório', value: 117 }, { text: '118 - Dirigente ou administrador de partido político, organização patronal, sindical, filantrópica e religiosa', value: 118 }, { text: '120 - Dirigente, presidente e diretor de empresa industrial, comercial ou prestadora de serviços', value: 120 }, { text: '121 - Presidente e diretor de empresa pública e sociedade de economia mista', value: 121 }, { text: '130 - Gerente ou supervisor de empresa industrial, comercial ou prestadora de serviços', value: 130 }, { text: '131 - Gerente ou supervisor de empresa pública e sociedade de economia mista', value: 131 }, { text: '140 - Presidente, diretor, gerente e supervisor de organismo internacional e de organização não-governamental', value: 140 }, { text: '211 - Matemático, estatístico, atuário e afins', value: 211 }, { text: '212 - Analista de sistemas, desenvolvedor de software, administrador de redes e bancos de dados e outros especialistas em informática (exceto técnico)', value: 212 }, { text: '213 - Físico, químico, meteorologista, geólogo, oceanógrafo e afins', value: 213 }, { text: '214 - Engenheiro, arquiteto e afins', value: 214 }, { text: '215 - Piloto de aeronaves, comandante de embarcações e oficiais máquinas', value: 215 }, { text: '221 - Biólogo, biomédico e afins', value: 221 }, { text: '222 - Agrônomo e afins', value: 222 }, { text: '224 - Profissional da educação física (exceto professor)', value: 224 }, { text: '225 - Médico', value: 225 }, { text: '226 - Odontólogo', value: 226 }, { text: '227 - Enfermeiro de nível superior, nutricionista, farmacêutico e afins', value: 227 }, { text: '228 - Veterinário, patologista (veterinário) e zootecnista', value: 228 }, { text: '229 - Fonoaudiólogo, fisioterapeuta, terapeuta ocupacional e afins', value: 229 }, { text: '241 - Advogado', value: 241 }, { text: '250 - Sociólogo e cientista político', value: 250 }, { text: '251 - Antropólogo e arqueólogo', value: 251 }, { text: '252 - Economista, administrador, contador, auditor e afins', value: 252 }, { text: '253 - Profissional de marketing, de publicidade e de comercialização', value: 253 }, { text: '255 - Psicólogo e psicanalista', value: 255 }, { text: '256 - Geógrafo', value: 256 }, { text: '257 - Historiador', value: 257 }, { text: '258 - Assistente social e economista doméstico', value: 258 }, { text: '259 - Filósofo', value: 259 }, { text: '261 - Jornalista e repórter', value: 261 }, { text: '263 - Sacerdote ou membro de ordens ou seitas religiosas', value: 263 }, { text: '264 - Tradutor, intérprete, filólogo', value: 264 }, { text: '265 - Bibliotecário, documentalista, arquivólogo, museólogo', value: 265 }, { text: '266 - Escritor, crítico, redator', value: 266 }, { text: '271 - Locutor, comentarista', value: 271 }, { text: '272 - Ator, diretor de espetáculos', value: 272 }, { text: '273 - Cantor e compositor', value: 273 }, { text: '274 - Músico, arranjador, regente de orquestra ou coral', value: 274 }, { text: '275 - Desenhista industrial (designer), escultor, pintor artístico e afins', value: 275 }, { text: '276 - Cenógrafo, decorador de interiores', value: 276 }, { text: '277 - Empresário e produtor de espetáculos', value: 277 }, { text: '279 - Outros profissionais do espetáculo e das artes', value: 279 }, { text: '290 - Professor na educação infantil', value: 290 }, { text: '291 - Professor do ensino fundamental', value: 291 }, { text: '292 - Professor do ensino médio', value: 292 }, { text: '293 - Professor do ensino profissional', value: 293 }, { text: '294 - Professor do ensino superior', value: 294 }, { text: '295 - Instrutor e professor de escolas livres', value: 295 }, { text: '296 - Pedagogo, orientador educacional', value: 296 }, { text: '311 - Técnico em ciências físicas e químicas', value: 311 }, { text: '312 - Técnico em construção civil, de edificações e obras de infra estrutura', value: 312 }, { text: '313 - Técnico em eletro-eletrônica e fotônica', value: 313 }, { text: '314 - Técnico em metalmecânica', value: 314 }, { text: '316 - Técnico em mineralogia e geologia', value: 316 }, { text: '317 - Técnico em informática', value: 317 }, { text: '318 - Desenhista técnico e modelista', value: 318 }, { text: '319 - Outros técnicos de nível médio das ciências físicas, químicas, engenharia e afins', value: 319 }, { text: '320 - Técnico em biologia', value: 320 }, { text: '321 - Técnico da produção agropecuária', value: 321 }, { text: '322 - Técnico da ciência da saúde humana', value: 322 }, { text: '323 - Técnico da ciência da saúde animal', value: 323 }, { text: '324 - Técnico de laboratório, Raios-X e outros equipamentos e instrumentos de diagnóstico', value: 324 }, { text: '325 - Técnico de bioquímica e da biotecnologia', value: 325 }, { text: '328 - Técnico de conservação, dissecação e empalhamento de corpos', value: 328 }, { text: '341 - Técnico em navegação aérea, marítima, fluvial e metroferroviária', value: 341 }, { text: '342 - Técnico em transportes (logística)', value: 342 }, { text: '351 - Técnico das ciências administrativas e contábeis', value: 351 }, { text: '352 - Técnico de inspeção, fiscalização e coordenação administrativa', value: 352 }, { text: '353 - Agente de Bolsa de Valores, câmbio e outros serviços financeiros', value: 353 }, { text: '354 - Agente e representante comercial, corretor, leiloeiro e afins', value: 354 }, { text: '371 - Técnico de serviços culturais', value: 371 }, { text: '372 - Cinegrafista, fotógrafo e outros técnicos em operação de máquinas de tratamento de dados', value: 372 }, { text: '373 - Técnico em operação de estações de rádio e televisão', value: 373 }, { text: '374 - Técnico em operação de aparelhos de sonorização, cenografia e projeção', value: 374 }, { text: '375 - Decorador e vitrinista', value: 375 }, { text: '376 - Apresentador, artistas de artes populares e modelos', value: 376 }, { text: '377 - Atleta, desportista e afins', value: 377 }, { text: '391 - Outros técnicos de nível médio', value: 391 }, { text: '410 - Bancário, economiário, escriturário, secretário, assistente e auxiliar administrativo', value: 410 }, { text: '420 - Trabalhador de atendimento ao público, caixa, despachante, recenseador e afins', value: 420 }, { text: '511 - Comissário de bordo, guia de turismo, agente de viagens e afins', value: 511 }, { text: '512 - Trabalhador dos serviços domésticos em geral', value: 512 }, { text: '513 - Trabalhador dos serviços de hotelaria e alimentação', value: 513 }, { text: '514 - Trabalhador dos serviços de administração, conservação e manutenção de edifícios', value: 514 }, { text: '515 - Trabalhador dos serviços de saúde', value: 515 }, { text: '516 - Trabalhador dos serviços de embelezamento e cuidados pessoais', value: 516 }, { text: '517 - Trabalhador dos serviços de proteção e segurança (exceto militar)', value: 517 }, { text: '518 - Motorista e condutor do transporte de passageiros (motorista de táxi, ônibus, pequena embarcação, etc.)', value: 518 }, { text: '519 - Outros trabalhadores de serviços diversos', value: 519 }, { text: '529 - Vendedor e prestador de serviços do comércio, ambulante, caixeiro-viajante e camelô', value: 529 }, { text: '610 - Produtor na exploração agropecuária', value: 610 }, { text: '620 - Trabalhador na exploração agropecuária', value: 620 }, { text: '630 - Pescador, caçador e extrativista florestal', value: 630 }, { text: '640 - Operador de máquina agropecuária e florestal', value: 640 }, { text: '710 - Trabalhador da indústria extrativa e da construção civil', value: 710 }, { text: '720 - Trabalhador da transformação de metais e compósitos', value: 720 }, { text: '730 - Trabalhador da fabricação e instalação eletro-eletrônica', value: 730 }, { text: '740 - Montador de aparelhos e instrumentos de precisão e musicais', value: 740 }, { text: '750 - Joalheiro, vidreiro, ceramista e afins', value: 750 }, { text: '760 - Trabalhador da indústrias têxteis, do curtimento, do vestuário e das artes gráficas', value: 760 }, { text: '770 - Trabalhador das indústrias de madeira e do mobiliário', value: 770 }, { text: '780 - Condutor e operador de robôs, veículos de equipamentos de movimentação de carga e afins', value: 780 }, { text: '810 - Trabalhador das indústrias química, petroquímica, borracha e plástico e afins', value: 810 }, { text: '820 - Trabalhador de instalações siderúrgicas e de materiais de construção', value: 820 }, { text: '830 - Trabalhador de instalações e máquinas de fabricação de celulose e papel', value: 830 }, { text: '840 - Trabalhador da fabricação de alimentos, bebidas, fumo e de agroindústrias', value: 840 }, { text: '860 - Operador de instalações de produção e distribuição de energia', value: 860 }, { text: '870 - Trabalhador de outras instalações agroindustriais', value: 870 }, { text: '900 - Trabalhador de reparação e manutenção', value: 900 }, { text: '010 - Militar da Aeronáutica', value: 10 }, { text: '020 - Militar do Exército', value: 20 }, { text: '030 - Militar da Marinha', value: 30 }, { text: '040 - Policial Militar', value: 40 }, { text: '050 - Bombeiro Militar', value: 50 }, { text: '000 - Outras ocupações não especificadas anteriormente', value: 0 }],

  pessoa_tipo_logradouro: [{ value: 1, text: 'Aeroporto' }, { value: 2, text: 'Alameda' }, { value: 3, text: 'Área' }, { value: 4, text: 'Avenida' }, { value: 5, text: 'Campo' }, { value: 6, text: 'Chácara' }, { value: 7, text: 'Colônia' }, { value: 8, text: 'Condomínio' }, { value: 9, text: 'Conjunto' }, { value: 10, text: 'Distrito' }, { value: 11, text: 'Esplanada' }, { value: 12, text: 'Estação' }, { value: 13, text: 'Estrada' }, { value: 14, text: 'Favela' }, { value: 15, text: 'Fazenda' }, { value: 16, text: 'Feira' }, { value: 17, text: 'Jardim' }, { value: 18, text: 'Ladeira' }, { value: 19, text: 'Lago' }, { value: 20, text: 'Lagoa' }, { value: 21, text: 'Largo' }, { value: 22, text: 'Linha' }, { value: 23, text: 'Loteamento' }, { value: 24, text: 'Margem' }, { value: 25, text: 'Morro' }, { value: 26, text: 'Núcleo' }, { value: 27, text: 'Outros' }, { value: 28, text: 'Parque' }, { value: 29, text: 'Passagem' }, { value: 30, text: 'Passarela' }, { value: 31, text: 'Pátio' }, { value: 32, text: 'Praça ' }, { value: 33, text: 'Praia' }, { value: 34, text: 'Quadra' }, { value: 35, text: 'Recanto' }, { value: 36, text: 'Residencial' }, { value: 37, text: 'Rodovia' }, { value: 38, text: 'Rua' }, { value: 39, text: 'Setor' }, { value: 40, text: 'Sítio' }, { value: 41, text: 'Superquadra' }, { value: 42, text: 'Travessa' }, { value: 43, text: 'Trecho' }, { value: 44, text: 'Trevo' }, { value: 45, text: 'Vale' }, { value: 46, text: 'Vereda' }, { value: 47, text: 'Via' }, { value: 48, text: 'Viaduto' }, { value: 49, text: 'Viela' }, { value: 50, text: 'Vila     ' }],

  pessoa_codigo_ext: [{ value: 200, text: '200 - Abidjan, Costa do Marfim - Embaixada do Brasil' }, { value: 260, text: '260 - Abu Dhabi, Emirados Árabes Unidos - Embaixada do Brasil' }, { value: 651, text: '651 - Abuja, Nigéria - Embaixada do Brasil' }, { value: 350, text: '350 - Acra, Gana - Embaixada do Brasil' }, { value: 306, text: '306 - Adis Abeba, Etiópia - Embaixada do Brasil' }, { value: 550, text: '550 - Amã, Jordânia - Embaixada do Brasil' }, { value: 930, text: '930 - Ancara, Turquia - Embaixada do Brasil' }, { value: 40, text: '040 - Argel, Argélia - Embaixada do Brasil' }, { value: 950, text: '950 - Artigas, Uruguai - Vice-Consulado do Brasil' }, { value: 700, text: '700 - Assunção, Paraguai - Consulado-Geral do Brasil e Embaixada' }, { value: 147, text: '147 - Astana, Cazaquistão - Embaixada do Brasil' }, { value: 360, text: '360 - Atenas, Grécia - Embaixada do Brasil' }, { value: 289, text: '289 - Atlanta, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 485, text: '485 - Bagdá, Iraque - Embaixada do Brasil' }, { value: 821, text: '821 - Baku, Azerbaijão - Embaixada do Brasil' }, { value: 595, text: '595 - Bamaco, Mali - Embaixada do Brasil' }, { value: 880, text: '880 - Bangcoc, Tailândia - Embaixada do Brasil' }, { value: 280, text: '280 - Barcelona, Espanha - Consulado-Geral do Brasil' }, { value: 828, text: '828 - Basseterre, São Cristóvão e Névis - Embaixada do Brasil' }, { value: 570, text: '570 - Beirute, Líbano - Embaixada do Brasil' }, { value: 520, text: '520 - Belgrado, Sérvia - Embaixada do Brasil' }, { value: 104, text: '104 - Belmopan, Belize - Embaixada do Brasil' }, { value: 10, text: '010 - Berlim, Alemanha - Embaixada do Brasil' }, { value: 400, text: '400 - Bissau, Guiné-Bissau - Embaixada do Brasil' }, { value: 180, text: '180 - Bogotá, Colômbia - Embaixada do Brasil' }, { value: 290, text: '290 - Boston, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 274, text: '274 - Bratislava, Eslováquia - Embaixada do Brasil' }, { value: 187, text: '187 - Brazzaville, Congo - Embaixada do Brasil' }, { value: 90, text: '090 - Bridgetown, Barbados - Embaixada do Brasil' }, { value: 100, text: '100 - Bruxelas, Bélgica - Consulado-Geral do Brasil e Embaixada' }, { value: 810, text: '810 - Bucareste, Romênia - Embaixada do Brasil' }, { value: 440, text: '440 - Budapeste, Hungria - Embaixada do Brasil' }, { value: 50, text: '050 - Buenos Aires, Argentina - Consulado-Geral do Brasil e Embaixada' }, { value: 390, text: '390 - Caiena, Guiana Francesa - Consulado-Geral do Brasil' }, { value: 240, text: '240 - Cairo, Egito - Embaixada do Brasil' }, { value: 60, text: '060 - Camberra, Austrália - Embaixada do Brasil' }, { value: 163, text: '163 - Cantão, China - Consulado-Geral do Brasil' }, { value: 970, text: '970 - Caracas, Venezuela - Consulado-Geral e Embaixada' }, { value: 847, text: '847 - Cartum, Sudão - Embaixada do Brasil' }, { value: 823, text: '823 - Castries, Santa Lúcia - Embaixada do Brasil' }, { value: 291, text: '291 - Chicago, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 951, text: '951 - Chuy, Uruguai - Consulado do Brasil' }, { value: 1, text: '001 - Cidade do Cabo, África do Sul - Consulado-Geral do Brasil' }, { value: 610, text: '610 - Cidade do México, México - Consulado-Geral e Embaixada' }, { value: 960, text: '960 - Cidade do Vaticano, Vaticano - Embaixada do Brasil' }, { value: 170, text: '170 - Cingapura, Cingapura - Embaixada do Brasil' }, { value: 701, text: '701 - Ciudad Del Este, Paraguai - Consulado-Geral do Brasil' }, { value: 971, text: '971 - Ciudad Guayana, Venezuela - Consulado do Brasil' }, { value: 110, text: '110 - Cobija, Bolívia - Consulado do Brasil' }, { value: 111, text: '111 - Cochabamba, Bolívia - Consulado-Geral do Brasil' }, { value: 843, text: '843 - Colombo, Sri Lanka - Embaixada do Brasil' }, { value: 396, text: '396 - Conacri, Guiné - Embaixada do Brasil' }, { value: 702, text: '702 - Concepción, Paraguai - Vice-Consulado do Brasil' }, { value: 230, text: '230 - Copenhague, Dinamarca - Embaixada do Brasil' }, { value: 53, text: '053 - Córdoba, Argentina - Consulado-Geral do Brasil' }, { value: 107, text: '107 - Cotonou, Benin - Embaixada do Brasil' }, { value: 830, text: '830 - Dacar, Senegal - Embaixada do Brasil' }, { value: 85, text: '085 - Daca, Bangladesh - Embaixada do Brasil' }, { value: 840, text: '840 - Damasco, Síria - Embaixada do Brasil' }, { value: 893, text: '893 - Dar-Es-Salaam, Tanzânia - Embaixada do Brasil' }, { value: 900, text: '900 - Dili, Timor-Leste - Embaixada do Brasil' }, { value: 143, text: '143 - Doha, Catar - Embaixada do Brasil' }, { value: 490, text: '490 - Dublin, Irlanda - Embaixada do Brasil' }, { value: 703, text: '703 - Encarnación, Paraguai - Vice-Consulado do Brasil' }, { value: 850, text: '850 - Estocolmo, Suécia - Embaixada do Brasil' }, { value: 752, text: '752 - Faro, Portugal - Consulado-Geral do Brasil' }, { value: 11, text: '011 - Frankfurt, Alemanha - Consulado-Geral do Brasil' }, { value: 835, text: '835 - Freetown, Serra Leoa - Embaixada do Brasil' }, { value: 118, text: '118 - Gaborone, Botsuana - Embaixada do Brasil' }, { value: 862, text: '862 - Genebra, Suíça - Consulado-Geral do Brasil' }, { value: 380, text: '380 - Georgetown, Guiana - Embaixada do Brasil' }, { value: 370, text: '370 - Guatemala, Guatemala - Embaixada do Brasil' }, { value: 112, text: '112 - Guayaramerin, Bolívia - Consulado do Brasil' }, { value: 542, text: '542 - Hamamatsu, Japão - Consulado-Geral do Brasil' }, { value: 980, text: '980 - Hanói, Vietnam - Embaixada do Brasil' }, { value: 990, text: '990 - Harare, Zimbábue - Embaixada do Brasil' }, { value: 298, text: '298 - Hartford, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 220, text: '220 - Havana, Cuba - Embaixada do Brasil' }, { value: 320, text: '320 - Helsinque, Finlândia - Embaixada do Brasil' }, { value: 162, text: '162 - Hong Kong, China - Consulado-Geral do Brasil' }, { value: 292, text: '292 - Houston, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 136, text: '136 - Iaundê, Camarões - Embaixada do Brasil' }, { value: 57, text: '057 - Ierevan, Armênia - Embaixada do Brasil' }, { value: 721, text: '721 - Iquitos, Peru - Consulado do Brasil' }, { value: 690, text: '690 - Islamabade, Paquistão - Embaixada do Brasil' }, { value: 931, text: '931 - Istambul, Turquia - Consulado-Geral do Brasil' }, { value: 460, text: '460 - Jacarta, Indonésia - Embaixada do Brasil' }, { value: 635, text: '635 - Kathmandu, Nepal - Embaixada do Brasil' }, { value: 940, text: '940 - Kiev, Ucrânia - Embaixada do Brasil' }, { value: 530, text: '530 - Kingston, Jamaica - Embaixada do Brasil' }, { value: 693, text: '693 - Kingstown, São Vicente e Granadinas - Embaixada do Brasil' }, { value: 776, text: '776 - Kinshasa, Congo, República Democrática do - Embaixada do Brasil' }, { value: 560, text: '560 - Kuaite, Kuaite - Embaixada do Brasil' }, { value: 590, text: '590 - Kuala Lumpur, Malásia - Embaixada do Brasil' }, { value: 113, text: '113 - La Paz, Bolívia - Embaixada do Brasil' }, { value: 650, text: '650 - Lagos, Nigéria - Consulado-Geral do Brasil' }, { value: 381, text: '381 - Lethem, Guiana - Vice-Consulado do Brasil' }, { value: 181, text: '181 - Letícia, Colômbia - Vice-Consulado do Brasil' }, { value: 340, text: '340 - Libreville, Gabão - Embaixada do Brasil' }, { value: 593, text: '593 - Lilongwe, Malauí - Embaixada do Brasil' }, { value: 720, text: '720 - Lima, Peru - Embaixada do Brasil' }, { value: 750, text: '750 - Lisboa, Portugal - Consulado-Geral, Embaixada' }, { value: 277, text: '277 - Liubliana, Eslovênia - Embaixada do Brasil' }, { value: 906, text: '906 - Lomé, Togo - Embaixada do Brasil' }, { value: 470, text: '470 - Londres, Inglaterra - Consulado-Geral do Brasil e Embaixada' }, { value: 293, text: '293 - Los Angeles, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 20, text: '020 - Luanda, Angola - Embaixada do Brasil' }, { value: 986, text: '986 - LusaKa, Zâmbia - Embaixada do Brasil' }, { value: 281, text: '281 - Madri, Espanha - Consulado Geral do Brasil e Embaixada' }, { value: 406, text: '406 - Malabo, Guiné-Equatorial - Embaixada do Brasil' }, { value: 640, text: '640 - Manágua, Nicarágua - Embaixada do Brasil' }, { value: 310, text: '310 - Manila, Filipinas - Embaixada do Brasil' }, { value: 620, text: '620 - Maputo, Moçambique - Embaixada do Brasil' }, { value: 675, text: '675 - Mascate, Omã - Embaixada do Brasil' }, { value: 54, text: '054 - Mendoza, Argentina - Consulado-Geral do Brasil' }, { value: 294, text: '294 - Miami, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 510, text: '510 - Milão, Itália - Consulado-Geral do Brasil' }, { value: 95, text: '095 - Minsk, Belarus - Embaixada do Brasil' }, { value: 575, text: '575 - Monróvia, Libéria - Embaixada do Brasil' }, { value: 952, text: '952 - Montevidéu, Uruguai - Consulado-Geral e Embaixada' }, { value: 140, text: '140 - Montreal, Canadá - Consulado-Geral do Brasil' }, { value: 820, text: '820 - Moscou, Rússia - Embaixada do Brasil' }, { value: 451, text: '451 - Mumbai, Índia - Consulado-Geral do Brasil' }, { value: 12, text: '012 - Munique, Alemanha - Consulado-Geral do Brasil' }, { value: 540, text: '540 - Nagoia, Japão - Consulado-Geral do Brasil' }, { value: 770, text: '770 - Nairóbi, Quênia - Embaixada do Brasil' }, { value: 80, text: '080 - Nassau, Bahamas - Embaixada do Brasil' }, { value: 157, text: '157 - Nicósia, Chipre - Embaixada do Brasil' }, { value: 450, text: '450 - Nova Delhi, Índia - Embaixada do Brasil' }, { value: 295, text: '295 - Nova York, Estados Unidos da América - Consulado-Geral' }, { value: 605, text: '605 - Nouakchott, Mauritânia - Embaixada do Brasil' }, { value: 660, text: '660 - Oslo, Noruega - Embaixada do Brasil' }, { value: 141, text: '141 - Ottawa, Canadá - Embaixada do Brasil' }, { value: 680, text: '680 - Cidade do Panamá, Panamá - Embaixada do Brasil' }, { value: 870, text: '870 - Paramaribo, Suriname - Embaixada do Brasil' }, { value: 330, text: '330 - Paris, França - Consulado-Geral e Embaixada' }, { value: 51, text: '051 - Paso de Los Libres, Argentina - Consulado do Brasil' }, { value: 704, text: '704 - Pedro Juan Caballero, Paraguai - Consulado do Brasil' }, { value: 160, text: '160 - Pequim, China - Embaixada do Brasil' }, { value: 751, text: '751 - Porto, Portugal - Consulado-Geral do Brasil' }, { value: 410, text: '410 - Porto Príncipe, Haiti - Embaixada do Brasil' }, { value: 910, text: '910 - Port-of-Spain, Trinidad e Tobago - Embaixada do Brasil' }, { value: 800, text: '800 - Praga, República Tcheca - Embaixada do Brasil' }, { value: 130, text: '130 - Praia, Cabo Verde - Embaixada do Brasil' }, { value: 2, text: '002 - Pretória, África do Sul - Embaixada do Brasil' }, { value: 973, text: '973 - Puerto Ayacucho, Venezuela - Vice-Consulado do Brasil' }, { value: 52, text: '052 - Puerto Iguazu, Argentina - Consulado do Brasil' }, { value: 116, text: '116 - Puerto Quijarro, Bolívia - Consulado do Brasil' }, { value: 195, text: '195 - Pyongyang, Coréia do Norte - Embaixada do Brasil' }, { value: 270, text: '270 - Quito, Equador - Embaixada do Brasil' }, { value: 600, text: '600 - Rabat, Marrocos - Embaixada do Brasil' }, { value: 30, text: '030 - Riade, Arábia Saudita - Embaixada do Brasil' }, { value: 953, text: '953 - Rio Branco, Uruguai - Vice-Consulado do Brasil' }, { value: 954, text: '954 - Rivera, Uruguai - Consulado-Geral do Brasil' }, { value: 511, text: '511 - Roma, Itália - Consulado-Geral e Embaixada' }, { value: 237, text: '237 - Roseau, Dominica - Embaixada do Brasil' }, { value: 421, text: '421 - Roterdã, Holanda - Consulado-Geral do Brasil' }, { value: 355, text: "355 - Saint George's, Granada - Embaixada do Brasil" }, { value: 391, text: "391 - Saint Georges de L'Oyapock, Guiana Francesa - Consulado-Geral do Brasil" }, { value: 25, text: "025 - Saint John's, Antígua e Barbuda - Embaixada do Brasil" }, { value: 705, text: '705 - Saltos do Guaíra, Paraguai - Consulado do Brasil' }, { value: 115, text: '115 - Santa Cruz de La Sierra, Bolívia - Consulado-Geral do Brasil' }, { value: 972, text: '972 - Santa Elena do Uairén, Venezuela - Vice-Consulado do Brasil' }, { value: 150, text: '150 - Santiago, Chile - Consulado-Geral do Brasil e Embaixada' }, { value: 780, text: '780 - São Domingos, República Dominicana - Embaixada do Brasil' }, { value: 296, text: '296 - São Francisco, Estados Unidos da América - Consulado-Geral do Brasil' }, { value: 210, text: '210 - São José, Costa Rica - Embaixada do Brasil' }, { value: 250, text: '250 - São Salvador, El Salvador - Embaixada do Brasil' }, { value: 825, text: '825 - São Tomé, São Tomé e Principe - Embaixada do Brasil' }, { value: 125, text: '125 - Sarajevo, Bósnia e Herzegovina - Embaixada do Brasil' }, { value: 190, text: '190 - Seul, Coréia do Sul - Embaixada do Brasil' }, { value: 120, text: '120 - Sófia, Bulgária - Embaixada do Brasil' }, { value: 61, text: '061 - Sydney, Austrália - Consulado-Geral do Brasil' }, { value: 326, text: '326 - Taipé, Taiwan (Formosa) - Escritório Comercial' }, { value: 785, text: '785 - Talin, Estônia - Embaixada do Brasil' }, { value: 788, text: '788 - Tbilisi, Geórgia - Embaixada do Brasil' }, { value: 480, text: '480 - Teerã, Irã - Embaixada do Brasil' }, { value: 430, text: '430 - Tegucigalpa, Honduras - Embaixada do Brasil' }, { value: 500, text: '500 - Tel Aviv, Israel - Embaixada do Brasil' }, { value: 7, text: '007 - Tirana, Albânia - Embaixada do Brasil' }, { value: 541, text: '541 - Tóquio, Japão - Consulado-Geral do Brasil e Embaixada' }, { value: 142, text: '142 - Toronto, Canadá - Consulado-Geral do Brasil' }, { value: 580, text: '580 - Trípoli, Líbia - Embaixada do Brasil' }, { value: 920, text: '920 - Túnis, Tunísia - Embaixada do Brasil' }, { value: 127, text: '127 - Uagadugu, Burkina Faso - Embaixada do Brasil' }, { value: 139, text: '139 - Vancouver, Canadá - Consulado-Geral do Brasil' }, { value: 740, text: '740 - Varsóvia, Polônia - Embaixada do Brasil' }, { value: 70, text: '070 - Viena, Áustria - Embaixada do Brasil' }, { value: 297, text: '297 - Washington D.C., Estados Unidos da América - Consulado-Geral do Brasil e Embaixada' }, { value: 670, text: '670 - Wellington, Nova Zelândia - Embaixada do Brasil' }, { value: 630, text: '630 - Windhoek, Namíbia - Embaixada do Brasil' }, { value: 161, text: '161 - Xangai, China - Consulado-Geral do Brasil' }, { value: 608, text: '608 - Yangon, Mianmar - Embaixada do Brasil' }, { value: 216, text: '216 - Zagreb, Croácia - Embaixada do Brasil' }, { value: 861, text: '861 - Zurique, Suíça - Consulado-Geral do Brasil' }],

  controlecaixa_codigo_imovel: [{ value: 1, text: '1 - Exploração individual (Imóvel próprio)' }, { value: 2, text: '2 - Condomínio' }, { value: 3, text: '3 - Imóvel arrendado' }, { value: 4, text: '4 - Parceria' }, { value: 5, text: '5 - Comodato' }, { value: 6, text: '6 - Outros' }],

  controlecaixa_codigo_conta: [{ value: 0, text: '000 - Em espécie' }, { value: 999, text: '999 - Numerário em trânsito' }],

  controlecaixa_tipo_documento: [{ value: 1, text: '1 - Nota Fiscal' }, { value: 2, text: '2 - Fatura' }, { value: 3, text: '3 - Recibo' }, { value: 4, text: '4 - Contrato' }, { value: 5, text: '5 - Folha de Pagamento' }, { value: 6, text: '6 - Outros' }],

  controlecaixa_tipo_lancamento: [{ value: 1, text: '1 - Receita da Atividade Rural' }, { value: 2, text: '2 - Despesas de custeio e investimentos' }, { value: 3, text: '3 - Receita de produtos entregues no ano referente a adiantamento de recursos financeiros' }]

});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##'
});

/***/ }),
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 126,
	"./af.js": 126,
	"./ar": 127,
	"./ar-dz": 128,
	"./ar-dz.js": 128,
	"./ar-kw": 129,
	"./ar-kw.js": 129,
	"./ar-ly": 130,
	"./ar-ly.js": 130,
	"./ar-ma": 131,
	"./ar-ma.js": 131,
	"./ar-sa": 132,
	"./ar-sa.js": 132,
	"./ar-tn": 133,
	"./ar-tn.js": 133,
	"./ar.js": 127,
	"./az": 134,
	"./az.js": 134,
	"./be": 135,
	"./be.js": 135,
	"./bg": 136,
	"./bg.js": 136,
	"./bm": 137,
	"./bm.js": 137,
	"./bn": 138,
	"./bn.js": 138,
	"./bo": 139,
	"./bo.js": 139,
	"./br": 140,
	"./br.js": 140,
	"./bs": 141,
	"./bs.js": 141,
	"./ca": 142,
	"./ca.js": 142,
	"./cs": 143,
	"./cs.js": 143,
	"./cv": 144,
	"./cv.js": 144,
	"./cy": 145,
	"./cy.js": 145,
	"./da": 146,
	"./da.js": 146,
	"./de": 147,
	"./de-at": 148,
	"./de-at.js": 148,
	"./de-ch": 149,
	"./de-ch.js": 149,
	"./de.js": 147,
	"./dv": 150,
	"./dv.js": 150,
	"./el": 151,
	"./el.js": 151,
	"./en-SG": 152,
	"./en-SG.js": 152,
	"./en-au": 153,
	"./en-au.js": 153,
	"./en-ca": 154,
	"./en-ca.js": 154,
	"./en-gb": 155,
	"./en-gb.js": 155,
	"./en-ie": 156,
	"./en-ie.js": 156,
	"./en-il": 157,
	"./en-il.js": 157,
	"./en-nz": 158,
	"./en-nz.js": 158,
	"./eo": 159,
	"./eo.js": 159,
	"./es": 160,
	"./es-do": 161,
	"./es-do.js": 161,
	"./es-us": 162,
	"./es-us.js": 162,
	"./es.js": 160,
	"./et": 163,
	"./et.js": 163,
	"./eu": 164,
	"./eu.js": 164,
	"./fa": 165,
	"./fa.js": 165,
	"./fi": 166,
	"./fi.js": 166,
	"./fo": 167,
	"./fo.js": 167,
	"./fr": 168,
	"./fr-ca": 169,
	"./fr-ca.js": 169,
	"./fr-ch": 170,
	"./fr-ch.js": 170,
	"./fr.js": 168,
	"./fy": 171,
	"./fy.js": 171,
	"./ga": 172,
	"./ga.js": 172,
	"./gd": 173,
	"./gd.js": 173,
	"./gl": 174,
	"./gl.js": 174,
	"./gom-latn": 175,
	"./gom-latn.js": 175,
	"./gu": 176,
	"./gu.js": 176,
	"./he": 177,
	"./he.js": 177,
	"./hi": 178,
	"./hi.js": 178,
	"./hr": 179,
	"./hr.js": 179,
	"./hu": 180,
	"./hu.js": 180,
	"./hy-am": 181,
	"./hy-am.js": 181,
	"./id": 182,
	"./id.js": 182,
	"./is": 183,
	"./is.js": 183,
	"./it": 184,
	"./it-ch": 185,
	"./it-ch.js": 185,
	"./it.js": 184,
	"./ja": 186,
	"./ja.js": 186,
	"./jv": 187,
	"./jv.js": 187,
	"./ka": 188,
	"./ka.js": 188,
	"./kk": 189,
	"./kk.js": 189,
	"./km": 190,
	"./km.js": 190,
	"./kn": 191,
	"./kn.js": 191,
	"./ko": 192,
	"./ko.js": 192,
	"./ku": 193,
	"./ku.js": 193,
	"./ky": 194,
	"./ky.js": 194,
	"./lb": 195,
	"./lb.js": 195,
	"./lo": 196,
	"./lo.js": 196,
	"./lt": 197,
	"./lt.js": 197,
	"./lv": 198,
	"./lv.js": 198,
	"./me": 199,
	"./me.js": 199,
	"./mi": 200,
	"./mi.js": 200,
	"./mk": 201,
	"./mk.js": 201,
	"./ml": 202,
	"./ml.js": 202,
	"./mn": 203,
	"./mn.js": 203,
	"./mr": 204,
	"./mr.js": 204,
	"./ms": 205,
	"./ms-my": 206,
	"./ms-my.js": 206,
	"./ms.js": 205,
	"./mt": 207,
	"./mt.js": 207,
	"./my": 208,
	"./my.js": 208,
	"./nb": 209,
	"./nb.js": 209,
	"./ne": 210,
	"./ne.js": 210,
	"./nl": 211,
	"./nl-be": 212,
	"./nl-be.js": 212,
	"./nl.js": 211,
	"./nn": 213,
	"./nn.js": 213,
	"./pa-in": 214,
	"./pa-in.js": 214,
	"./pl": 215,
	"./pl.js": 215,
	"./pt": 216,
	"./pt-br": 217,
	"./pt-br.js": 217,
	"./pt.js": 216,
	"./ro": 218,
	"./ro.js": 218,
	"./ru": 219,
	"./ru.js": 219,
	"./sd": 220,
	"./sd.js": 220,
	"./se": 221,
	"./se.js": 221,
	"./si": 222,
	"./si.js": 222,
	"./sk": 223,
	"./sk.js": 223,
	"./sl": 224,
	"./sl.js": 224,
	"./sq": 225,
	"./sq.js": 225,
	"./sr": 226,
	"./sr-cyrl": 227,
	"./sr-cyrl.js": 227,
	"./sr.js": 226,
	"./ss": 228,
	"./ss.js": 228,
	"./sv": 229,
	"./sv.js": 229,
	"./sw": 230,
	"./sw.js": 230,
	"./ta": 231,
	"./ta.js": 231,
	"./te": 232,
	"./te.js": 232,
	"./tet": 233,
	"./tet.js": 233,
	"./tg": 234,
	"./tg.js": 234,
	"./th": 235,
	"./th.js": 235,
	"./tl-ph": 236,
	"./tl-ph.js": 236,
	"./tlh": 237,
	"./tlh.js": 237,
	"./tr": 238,
	"./tr.js": 238,
	"./tzl": 239,
	"./tzl.js": 239,
	"./tzm": 240,
	"./tzm-latn": 241,
	"./tzm-latn.js": 241,
	"./tzm.js": 240,
	"./ug-cn": 242,
	"./ug-cn.js": 242,
	"./uk": 243,
	"./uk.js": 243,
	"./ur": 244,
	"./ur.js": 244,
	"./uz": 245,
	"./uz-latn": 246,
	"./uz-latn.js": 246,
	"./uz.js": 245,
	"./vi": 247,
	"./vi.js": 247,
	"./x-pseudo": 248,
	"./x-pseudo.js": 248,
	"./yo": 249,
	"./yo.js": 249,
	"./zh-cn": 250,
	"./zh-cn.js": 250,
	"./zh-hk": 251,
	"./zh-hk.js": 251,
	"./zh-tw": 252,
	"./zh-tw.js": 252
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbar__ = __webpack_require__(472);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    loader: __WEBPACK_IMPORTED_MODULE_2__loader__["a" /* default */],
    snackbar: __WEBPACK_IMPORTED_MODULE_3__snackbar__["a" /* default */]
  }
}));

/***/ }),
/* 470 */,
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    view: 'loader',
    // type: 'index',
    dialog: false
  },
  getters: {
    dialog: function dialog(state) {
      return state.dialog;
    }
  },
  mutations: {
    change_dialog: function change_dialog(state, payload) {
      state.dialog = payload;
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    view: 'snackbar',
    values: { text: '', color: 'info', dialog: false, timeout: 3000 }
  },
  getters: {
    values: function values(state) {
      return state.values;
    }
  },
  mutations: {
    change_values: function change_values(state, payload) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.values, payload);
    }
  }
});

/***/ }),
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[254]);


// WEBPACK FOOTER //
// static/js/app.18dfca58504dba96e2dd.js